export interface AllDataFromSalesForce {
  results: SingleCompanyResultSalesForce[]
}

export interface SingleCompanyResultSalesForce {
  title: string
  teamId: string
  stories: StoryRawFromSalesForce[]
  metadataName: string
  metadataDescription: string
  logo: string
  fav_image: string
  contact_us: string
  account_description: string
}

export interface StoryRawFromSalesForce {
  website: string
  valueSectionsData: ValueSection[]
  trackingData: TrackingData
  topBannerData: TopBannerData
  testimonialsData: Testimonial[]
  technologiesIconSrc: string[]
  teamProfilesData: TeamProfile[]
  storypagebanner: string
  storyId: string
  storyData: StoryData
  secondaryheaderfontcolor: string
  secondaryfontcolor: string
  secondaryfont: string
  secondarycolor: string
  projectSectionData: ProjectSectionData
  projectBoundariesData: ProjectBoundariesData
  primaryfontcolor: string
  primaryfont: string
  primarycolor: string
  piHostname: string
  piCId: string
  piAId: string
  missionData: MissionData
  metadataname: string
  metadatadescription: string
  linkedinPartnerId: string
  linecolor: string
  LastModifiedDate: string
  keyMoments: KeyMoments
  isfeatured: boolean
  header: Header
  filterValues: FilterValues
  faviconimage: string
  diagramData: DiagramData
  description: string
  calendlyLink: string
  breadcrumbslabel: string | null
  bookMeetingData: BookMeetingData
  bgcolor: string
}

/**
 * Nested Interfaces
 */

export interface ValueSection {
  heading: string
  description: string
}

export interface TrackingData {
  hubSpotId: string
  hubSpotDomain: string
  clientGoogleTrackingId: string
  campaignName: string
  campaignLandingPageUrl: string
  brightrGoogleTrackingId: string
}

export interface TopBannerData {
  title: string
  table: TopBannerTableItem[]
  logoSrc: string
  layout: string
  description: string
}

export interface TopBannerTableItem {
  valueName: string
  keyName: string
}

export interface Testimonial {
  industry: string
  description: string
  author: string
}

export interface TeamProfile {
  serviceLink: string
  serviceIcon: string
  role: string
  name: string
  index: number
  dpSrc: string
}

export interface StoryData {
  title: string
  link: string
}

export interface ProjectSectionData {
  videoLink: string | null
  title: string
  teamSize: number | null
  paragraph2: string
  paragraph1: string
  listitems: unknown[] // If you know the shape, replace 'unknown[]' with the exact type
  listHeading: string
  imgSrc: string
  imgBanner: string
  heading: string
  deepdescription: string
}

export interface ProjectBoundariesData {
  rightStatus: string | null
  leftStatus: string | null
}

export interface MissionData {
  missionRichText: string
}

export interface KeyMoments {
  roiMomentImage: string
  roiMoment: string
  ribbonCuttingMomentImage: string
  ribbonCuttingMoment: string
  redMomentImage: string
  redMoment: string
  momentOfTrustImage: string
  momentOfTrust: string
  introductionMomentImage: string
  introductionMoment: string
  eurekaMomentImage: string
  eurekaMoment: string
  dealClarityMomentImage: string
  dealClarityMoment: string
}

export interface Header {
  navbarData: NavBarItem[]
  imagesSrc: {
    logoSrcDark: string
    logoSrc: string
    homeLogoSrcDark: string
    homeLogoSrc: string
  }
}

export interface NavBarItem {
  name: string
  link: string
}

export interface FilterValues {
  Testimonial: string[]
  Technologies: string[]
  Timeline: string[]
  Budget: (string | null)[]
  Industry: string[]
  Company: string[]
}

export interface DiagramData {
  diagramList: DiagramListItem[]
}

export interface DiagramListItem {
  period: string
  order: string
  imageSrc: string
  heading: string
  descriptionLine2: string
  descriptionLine1: string
  descriptionImageSrc: string
  dateDescriptionLine1: string
}

export interface BookMeetingData {
  title: string
  modalDescription: string
  headshotUrl: string
  contactName: string
  calendlyLink: string
  bannerDescription: string
}

export const allOldData: AllDataFromSalesForce = {
  results: [
    {
      title: "Third Republic",
      teamId: "001Nu00000EGHhdIAH",
      stories: [
        {
          website: "https://www.thirdrepublic.com/",
          valueSectionsData: [
            {
              heading: "Kander Consult Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Kander was at a critical juncture, facing both increased demand for services and rising pressures on profitability. The decision to partner with Third Republic’s\nTalentConnect\ncame at a pivotal moment when they needed to scale responsibly without sacrificing operational efficiency or profit margins.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Kander Transforms into a Next-Gen Salesforce Consultancy with TalentConnect",
            table: [
              {
                valueName: "Kander Consult",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Professional Services",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over a year",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "1",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BUUGsMAP_SBz6tX93o",
            layout: "Original",
            description:
              "<p>Kander, a boutique firm, identified an opportunity to scale sustainably amid rising demand. By partnering with Third Republic’s TalentConnect, they accessed top-tier Salesforce talent and expanded their global capabilities. This collaboration enabled Kander to consistently deliver exceptional value to their customers, effectively managing fluctuating project demands while maintaining the highest standards of service.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOir_9u326X_9x",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FUJ0HEAX_9GxL-Rju1",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Revenue Officer",
              name: "Brock Hubbard",
              index: 1,
              dpSrc: "",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BUTHaMAP_wKsxbTNQ3",
          storyId: "a00Nu00000EXNLxIAP",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#020203",
          secondaryfont: "Arial",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Kander Transforms into a Next-Gen Salesforce Consultancy with TalentConnect",
            teamSize: 4,
            paragraph2:
              "<p>Kander, a boutique firm, identified an opportunity to scale sustainably amid rising demand. By partnering with Third Republic’s TalentConnect, they accessed top-tier Salesforce talent and expanded their global capabilities. This collaboration enabled Kander to consistently deliver exceptional value to their customers, effectively managing fluctuating project demands while maintaining the highest standards of service.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BlIT6MAN_N3CCTZS4a",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Kander recently expanded its work with a major client while also securing its largest client to date. However, the new engagement wasn’t initially guaranteed for the long term, and they urgently needed experienced Salesforce architects and engineers. Faced with the challenge of quickly finding and vetting top-tier talent for complex implementations, Kander sought a solution that went beyond traditional recruitment.</p>\n<p>That solution was Third Republic’s TalentConnect program. Kander didn’t just need a staffing agency; they needed a strategic partner capable of helping them scale without increasing workforce overhead. TalentConnect provided access to a global talent network—fully vetted, experienced professionals ready to jump into complex projects. By leveraging this extensive talent pool at fixed, industry-leading rates, and offering discounted conversion paths to full-time roles, Third Republic empowered Kander to manage projects flexibly and efficiently.</p>\n<p>For Kander, this partnership meant they could confidently take on new, complex engagements without the risk of overextending their resources. It gave them the agility to pursue larger opportunities while maintaining cost predictability, allowing them to focus on growth without compromising on quality or speed.</p>\n<p>For Third Republic, TalentConnect wasn’t just a recruitment solution; it was a strategic response to the real challenges Salesforce SI partners face today. The model helped partners like Kander navigate margin pressures, talent gaps, and fluctuating demand by providing a global talent network that could meet their needs swiftly and effectively.</p>\n<p>This win-win partnership has become a template for how Salesforce consultancies can tackle modern challenges. Together, Kander and Third Republic have shortened project timelines, improved client satisfaction, and unlocked the potential for more complex engagements—all while keeping overhead low. Their partnership is proof that with the right strategy, consultancies can thrive, even in a fast-evolving marketplace.</p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#020203",
          primaryfont: "Arial",
          primarycolor: "#020203",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Kander is a minority, women-owned Salesforce consulting firm led by senior experts with diverse industry experience and a global footprint. It values diverse thinking, empathy, and novel problem-solving.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2025-02-27T15:32:45.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BlBPwMAN_KiRgpcUE_W",
            roiMoment:
              "TalentConnect is designed to empower Salesforce consulting partners by addressing challenges such as shrinking profit margins, fluctuating demand, and bench inefficiencies. Leveraging Third Republic’s onshore, nearshore, and offshore workforce model, it offers a scalable solution that fuels growth and provides predictability for SI partners. The model optimizes costs with fixed, industry-leading rates and discounted paths to full-time hires while ensuring access to fully vetted professionals. Partners can flexibly staff deals with on-demand talent, allowing them to pursue larger opportunities with minimal risk. With presales support and an easy process for converting talent, TalentConnect enables partners to scale efficiently, maximize profitability, and position themselves for sustainable growth.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BlKElMAN_-FmgGE2Ce2",
            redMoment:
              "The TalentConnect partnership between Kander and Third Republic evolved beyond a traditional staffing relationship, becoming strategic by aligning with Kander’s specific needs. Third Republic provided best-in-class solutions that drove profitability and scalability through core TalentConnect features: competitive rates for higher margins, fully vetted talent to minimize hiring risk, and a flexible workforce model covering onshore, nearshore, and offshore talent. When a last-minute staffing challenge arose, Third Republic quickly filled the roles within 48 hours, thanks to its global workforce model. This responsiveness highlighted the strength of TalentConnect, enabling Kander to scale efficiently while minimizing risk and maximizing profitability. The partnership’s seamless coordination empowered Kander to grow with confidence and enhanced margins, proving TalentConnect's value in driving success for Salesforce consultancies.",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000H9OarMAF_Z6jQgvh9rT",
            introductionMoment:
              "At the London World Tour, Kander co-founder Pallavi Argawal met Mat Roche, co-founder of Third Republic, sparking a bold new direction for the Salesforce consultancy world. Faced with challenges like rapid growth and talent shortages, they saw an opportunity to innovate. Together, they pioneered a new approach: combining Kander's Salesforce expertise with Third Republic's TalentConnect model. This wasn’t just about filling staffing gaps—it created a scalable, flexible system that addressed margin pressures and evolving business needs. Their partnership empowered not only their own companies but also the broader Salesforce ecosystem by enabling rapid, agile growth. United by the belief to \"never stop innovating,\" Kander and Third Republic continue to drive value and redefine the future of Salesforce consulting.",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BlMoLMAV_JHH0w79tq",
            dealClarityMoment:
              "Imagine having a partner that anticipates your needs before you even know them—a partner that helps you scale without sacrificing quality or increasing costs. That’s what TalentConnect by Third Republic brings to the table. Designed to tackle the biggest headaches Salesforce partners face—margin pressures, talent shortages, unpredictable demand, and the need for global representation—TalentConnect is more than just a service, it’s a strategic advantage.\n\nWith a simple, bundled model, you gain access to pre-sales support, top-tier global talent, fixed rates (yes, truly fixed), and the industry’s best payment terms. Plus, with discounts on converting standout talent to full-time roles, TalentConnect helps you grow responsibly without the risks of overextending your workforce. By integrating seamlessly into your team, TalentConnect ensures consistency and empowers you to scale efficiently, turning everyday challenges into opportunities for growth.",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BURFsMAP_8QFSt4Png",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce", "Slack", "Heroku", "Snowflake"],
            Timeline: ["Over a year"],
            Budget: [null],
            Industry: ["Professional Services"],
            Company: ["Third Republic"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Talent recruiting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription:
              "Discover how TalentConnect can revolutionize your workforce strategy and unlock new growth opportunities for your organization!",
            headshotUrl: "",
            contactName: "Brock Hubbard",
            calendlyLink:
              "https://calendly.com/saar-brightr/-collaboration?back=1&month=2024-09",
            bannerDescription:
              "To learn how this project applies to you, chat with us",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BURFsMAP_8QFSt4Png",
      fav_image: "",
      contact_us: "https://www.thirdrepublic.com/contact",
      account_description: "Talent recruiting",
    },
    {
      title: "Madison Ave Consulting",
      teamId: "0016g00002OCMtBAAX",
      stories: [
        {
          website: "https://www.madisonaveconsulting.com",
          valueSectionsData: [
            {
              heading: "Edison Culture",
              description:
                "Edison's culture is characterized by a blend of innovation and a practical business mindset. While never necessarily taking on significant risks - and always keeping patients top of mind - they consistently tried new things.",
            },
            {
              heading: "Why Now",
              description:
                "This story is particularly relevant now as it highlights the adaptability of a local health care services firm to use technology to not only evolve and grow but to thrive in a complex and challenging business landscape.",
            },
            {
              heading: "Other Things to Note",
              description:
                "Edison's growth from 20 to over 200 Salesforce users reflects the strength of the solutions provided but also a commitment to innovation. Edison adapted Salesforce to meet its blend of practical business decision-making and innovation.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Edison Home Health Care Uses Salesforce to Grow 10x and Get Acquired",
            table: [
              {
                valueName: "Edison",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "5",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GMZyqEAH_1XJH4eKzk",
            layout: "Original",
            description:
              "<p>This story shows the potential of comprehensive Salesforce-based digital transformation. Initially a powerful sales and marketing tool, Madison Ave Consulting and Edison partnered to make Salesforce the operating system for the entire business.</p>",
          },
          testimonialsData: [
            {
              industry: "SVP of Operations, Edison Home Health Care",
              description:
                "\"We started with these five users in this team and then we slowly rolled it out for our intake team. We had about maybe 12 people in the intake team, so we had our five-person call center, they would convert the lead to our intake team, so we built a custom outlet for them. Then we're like, wow, this is working really good, you know what, let's get this into our field market.\"",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SS2Q_r3mSZ2GRfF",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHM_JiD0eurMH",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/mitchebin/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Mitch Ebin",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005OtN5MAK_IQ84dY42z",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Business Analyst",
              name: "Damian Mosiolek",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005OmjqMAC_aiB5j__LU",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consultant",
              name: "Jisna Joseph",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005OnxaMAC_SmI3jTeN-",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Neil Mork",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005Osu3MAC_JpsBTxIwc",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Engagement Manager",
              name: "Kennedy Miller",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005OrEoMAK_wwrsuOqqj",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZZ0c_o0ma3l7sgA",
          storyId: "a006g00000xux9mAAA",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#09384A",
          secondaryfontcolor: "#003849",
          secondaryfont: "Futura",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Edison Home Health Care Uses Salesforce to Grow 10x and Get Acquired",
            teamSize: 0,
            paragraph2:
              "<p>This story shows the potential of comprehensive Salesforce-based digital transformation. Initially a powerful sales and marketing tool, Madison Ave Consulting and Edison partnered to make Salesforce the operating system for the entire business.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GMRGmEAP_JXl-zyGie",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Spanning over half a decade, the engagement between Madison Avenue Consulting and Edison has become the world&#39;s premiere success story for home healthcare services on Salesforce. The engagement went far beyond just using Salesforce as a sales and marketing CRM -  it also meant better patient care to a broader variety of patients. Edison grew 10-fold and was eventually acquired, thanks to the comprehensive expertise of Madison Avenue consulting.</p>\n<h3>The case study within the relationship</h3>\n<p>Analyzing this from the perspective of a case study - problem, solution, and outcome - reveals a remarkably broad set of problems with impressive outcomes.</p>\n<ul><li><strong>Problem:</strong> Edison&#39;s initial use of Salesforce was limited to sales and marketing - and even in this department it made little difference. Additionally, Edison faced challenges in adapting to legislative requirements, integrating patient health data, and using multiple applications, processes, and data sources in an environment where 1000s of contracts and documents needed to be distributed, executed, and organized on a constant basis.<br><br></li><li><strong>Solution:</strong> Madison Ave&#39;s first challenge was to help Edison leverage Salesforce to generate more leads. Edison already had systems and processes for lead generation and sales but they were rife with inefficiency. Madison Ave&#39;s initial Salesforce implementation let a lean business development team exploit opportunities to play a much bigger role in serving the needs of home health care in the Tri-State area.  Based on that success alone, Edison was able to expand its business and serve more patients over the first two years of their relationship. <br><br>Building on these successes, Madison Ave and Edison&#39;s SVP of Operations, decided to completely rebuild the Edison Salesforce implementation. The result was that Salesforce was used as a full-fledged business operating system, covering all key business processes. They introduced custom mobile apps, integrated Salesforce with HHA exchange, and implemented DocuSign for document management. On top of all of that, they also introduced an applicant tracking to further facilitate onboarding. Now the volume, convenience, and profitability of patient intake and management are managed in Salesforce, or applications tightly integrated with Salesforce.<br><br></li><li><strong>Outcome:</strong> From many vantage points, the outcome of the relationship between Madison Ave and Edison has been transformational: completely new revenue streams, more efficient exploitation of lead pools, better closing rate, a greater volume of patient, employee, and partner intake, and growth across the board. <br><br>Edison went from a small team with 5 people max using Salesforce to a lean but ambitious company with over 200 people using it every day. Real-time reports could be run instantly for the CEO - and all decision-makers. Observers credit this success as being part of the reason that Edison was eventually acquired by Help at Home.</li></ul>\n<p>Madison Avenue Consulting&#39;s engagement with Edison showcases a remarkable transformation from a basic CRM tool to a comprehensive business solution, resulting in substantial growth and operational efficiency in healthcare services. The accomplishments of this partnership prove beyond any doubt that an ambitious, multi-year Salesforce implementation strategy can transform a home healthcare services company from a neighborhood business to a formidable regional wing of a national healthcare company.</p>",
          },
          projectBoundariesData: {
            rightStatus: ">$1,000,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#003849",
          primaryfont: "Futura",
          primarycolor: "#48A2DA",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText: ".",
          },
          metadataname:
            "How Edison home health services used Salesforce in all parts of its business",
          metadatadescription:
            "Discover how Madison Avenue Consulting used Salesforce to completely transform Edison’s home healthcare services and grow the company 10-fold. From leveraging Salesforce for lead generation to rebuilding the implementation with custom mobile apps and DocuSign integration, this success story reveals the potential of comprehensive digital transformation.",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-11-05T21:25:14.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GMRGhEAP_R9GiyZQok0",
            roiMoment:
              'Edison experienced multiple ROI moments during their 6-year relationship with Madison Ave but the first "this changes everything" moment was when the referral count began to skyrocket - soon after completing the first major implementation of Salesforce, it had doubled.  The acquisition of Edison by Help at Home was perhaps the definitive ROI moment, showcasing the culmination of Madison Avenue Consulting\'s impact. As SVP of Operations put it: "One of the things that impressed [Help at Home] the most about us was Salesforce."',
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GMRGcEAP_Hp3D9CL9n",
            redMoment:
              "Edison faced a significant challenge when the Department of Health changed the homecare sign-up process. Unlike other agencies struggling with their existing systems, Edison, with Madison Avenue's agile response, quickly adapted Salesforce, updating the data schema, UI and automations within two days. A major highlight was the second build of Salesforce in 2019, where the system was reconfigured more elegantly and efficiently, demonstrating the evolving expertise of Madison Avenue and the growing sophistication of Edison's use of Salesforce.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GMRGNEA5_valrTith_",
            momentOfTrust:
              "The partnership started in 2018 when Edison shifted from a prior Salesforce consultancy to Madison Avenue Consulting- this turned out to be a momentous and lucrative decision for Edison. Madison Avenue was led by Mitch Ebin, formerly a Salesforce consultant at IBM Bluewolf - he was itching to prove that Salesforce could transform a healthcare services firm. This drive brought Mitch to a local home health services company, Edison. Together with Edison's SVP of Operations, Mitch and his team began by enhancing Salesforce for a 5-user marketing team. This exponentially increased lead generation. When it became clear that through Salesforce expertise, Madison Ave had made Edison 10x more efficient in lead generation, trust was born and a multi-year partnership ensued.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GMRGXEA5_5zDox0G_7",
            eurekaMoment:
              "The Eureka moment on both sides was realizing that the exact same Salesforce implementation used to manage leadflow could also be used for everythng else. This realization triggered a pivotal shift, transforming Salesforce from a basic CRM tool into a versatile, integrated operational system across various departments, laying a foundation for Edison's future growth and operational efficiency.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZUPU_LJa2fXei07",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["DocuSign", "Salesforce", "Salesforce Health Cloud"],
            Timeline: ["Over 2 Years"],
            Budget: [">$1,000,000"],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Madison Ave Consulting"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Awesome consultancy",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription:
              "Meet with Mitch, the leader of Madison Avenue and the key contributor to this engagement.",
            headshotUrl:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005OtN5MAK_IQ84dY42z",
            contactName: "Mitch Ebin",
            calendlyLink:
              "https://calendly.com/mitch222/30min?from=slack&month=2024-02",
            bannerDescription:
              "to learn more about Salesforce innovation in Home Care.",
          },
          bgcolor: "",
        },
        {
          website: "https://www.madisonaveconsulting.com",
          valueSectionsData: [
            {
              heading: "Hansen Foundation Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "The Hansen Foundation, a recovery support service provider in New Jersey, faced the challenge of launching their approved Peer Recovery Program in just two weeks to provide coaching services to patients receiving medication-assisted treatment. To track and manage the program effectively, they sought help in finding a software solution before the imminent launch date.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Revolutionizing Behavioral Health: A Look at Salesforce's Health Cloud Software",
            table: [
              {
                valueName: "Hansen Foundation",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "2-4 Weeks",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "5",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5SzqEAF_rFzcEanDI",
            layout: "Original",
            description:
              "<p>Madison Ave Consulting launched a 10 days coaching program on Salesforce Health Cloud for The Hansen Foundation using their MX1 delivery methodology. It supported 40+ patients, achieced 100+ goals, and validated the directors&#39; vision.</p>",
          },
          testimonialsData: [
            {
              industry: "CTO",
              description:
                '"Madison Ave gets the project done quickly, correctly, in a solution that\'s easy for stakeholders to understand. "',
              author: "Gerald Maida",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSGY_y5Wd-hnNi5",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHM_JiD0eurMH",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzj_AKaowdOPIz",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000STQf_3E03X8xi0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5T2kEAF_mqR_XKeRn",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5T3dEAF_P3ewDCOXT",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/mitchebin/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Mitch Ebin",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005OtN5MAK_IQ84dY42z",
            },
            {
              serviceLink: "https://www.linkedin.com/in/adam-pelc-9709279a/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Consultant",
              name: "Adam Pelc",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5HXcEAN_Mt2GlOr-B",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/krystian-czajka-a410671a1/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Krystian Czajka",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QWWEA3_Zwbq0o7ad",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Business Analyst",
              name: "Jisna Joseph",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005OnxaMAC_SmI3jTeN-",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/alejandro-garcia-b08069186/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Business Analyst",
              name: "Alex Garcia",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QXWEA3_NNARrLsdw",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZZ0c_o0ma3l7sgA",
          storyId: "a006g00000o7jm3AAA",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#09384A",
          secondaryfontcolor: "#003849",
          secondaryfont: "Futura",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Revolutionizing Behavioral Health: A Look at Salesforce's Health Cloud Software",
            teamSize: null,
            paragraph2:
              "<p>Madison Ave Consulting launched a 10 days coaching program on Salesforce Health Cloud for The Hansen Foundation using their MX1 delivery methodology. It supported 40+ patients, achieced 100+ goals, and validated the directors&#39; vision.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5SsPEAV_UHUuNSlF9",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p> The Hansen Foundation is a non-profit organization that provides affordable, long-term recovery residences and a resource center to support individuals and families affected by substance use disorders.<br><br></p>\n<p dir="ltr">The Hansen Foundation has been providing recovery support services to New Jersey families since 1999. Over the summer, they received the exciting news that the State had approved their Peer Recovery Program. They quickly realized the challenge of getting this impactful program up and running in just under two weeks. The program would provide coaching services to patients receiving medication-assisted treatment. With a launch date just two weeks away, the Hansen team needed help finding a software solution to track and manage this program effectively.</p>\n<p><strong> </strong></p>\n<p dir="ltr">The leadership team, including the Program Director and CTO, felt the pressure! They knew that without the right software in place, the program could fail before it even got started. Meanwhile, the Peer Recovery Coaches, including Sarah and Mark, were eager to get to work and help their patients on the road to recovery.</p>\n<p><strong> </strong></p>\n<p dir="ltr">That&#39;s when Madison Ave Consulting eagerly dove in head first. The Hansen Foundation was already a client of Madison Ave using their &quot;Admin On Demand&quot; service. When the Chief Technology Officer brought up the issue during a weekly status call, the Madison Ave team knew they had to act fast. The Madiosn Ave Team put their heads together and recommended deploying the solution on Salesforce&#39;s Health Cloud. But with just ten days until launch, the Hansen team was skeptical that the job could be completed on time.</p>\n<p><strong> </strong></p>\n<p dir="ltr">That&#39;s when Madison Ave Consulting revealed its secret weapon: MX1, a proprietary delivery methodology focused on value, simple design, and above all else, speed. The Madison Ave team worked around the clock, collaborating with three development teams across the United States, Europe, and India to deliver this solution quickly.</p>\n<p><strong> </strong></p>\n<p dir="ltr">A few of the Madison Ave team members drove down the Garden State Parkway to Atlantic City, NJ, for launch day.  In true Madison Ave fashion, some team members woke up early for a sunrise run on the beach to prepare for the big day.  The team then arrived at the Hansen Foundation headquarters armed with a trunkful of Chick-fil-A and a fully functioning software solution. They worked tirelessly to train the Peer Recovery Coaches and wrapped up the day with a meeting with the executive team to show them the final product. The project was a major success, with over 40 patients successfully moving through the program, achieving more than 100 goals, and participating in over 200 activities!</p>\n<p><strong> </strong></p>\n<p dir="ltr">But the real impact of the program went beyond the numbers. Patients like Ryan and Karen, who had struggled with addiction for years, found hope and support in this groundbreaking program with help from their Peer Recovery Coaches. Sarah and Mark, who had started as coaches, became close friends and mentors to the people they were helping. And for the Program Directors, the program&#39;s success validated their vision and hard work.</p>\n<p><strong> </strong></p>\n<p dir="ltr">Looking back on the experience, both the Hansen Foundation and Madison Ave Consulting learned much about the importance of collaboration, communication, and a shared sense of purpose. They knew there would be challenges ahead, but anything was possible with the right team in place. *Some names have been changed to protect individuals&#39; identities.</p>\n<p dir="ltr"> </p>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#003849",
          primaryfont: "Futura",
          primarycolor: "#48A2DA",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "The Hansen Foundation offers recovery support for individuals with substance use disorders and their loved ones. They provide affordable and comfortable long-term residences through Serenity Estates and Serenity Houses, alongside necessary recovery assistance. Additionally, they operate Enlightened Farm, an organic farm promoting sustainable and healing environments, and The Hansen Foundation Resource Center, offering programs to improve life skills and help individuals plan and create positive change in their lives.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment:
              "The program's success extended beyond quantitative metrics. Individuals who had been battling addiction for years found hope and support through their Peer Recovery Coaches, while some coaches developed close relationships with the people they were aiding. Additionally, the program's triumph affirmed the Program Directors' vision and dedication.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust:
              "Even with such a tight timeline, the Hansen team trusted that Madison Ave would deliver. As an existing client, they knew they could trust the capable and trustworthy team at Madison Ave Consulting. They’ve done so repeatedly, and this time was no different.",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5U0HEAV_7ooxynpZS8",
            introductionMoment:
              "During a status call with an existing client, the Hansen Foundation, Madison Ave Consulting was presented with a new project that required immediate attention. Recognizing the urgency, the Madison Ave team quickly collaborated and recommended deploying the solution to Salesforce's Health Cloud platform.",
            eurekaMomentImage: "",
            eurekaMoment:
              "Madison Ave Consulting unveiled its unique approach, MX1, which prioritizes value, streamlined design, and speed. The team worked tirelessly, partnering with three global development teams from the United States, Europe, and India to deliver the solution swiftly.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZUPU_LJa2fXei07",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Conga",
              "Salesforce Health Cloud",
              "Field Service Lightning",
              "Salesforce Experience Cloud",
              "KIPU",
              "Mobile Publisher",
            ],
            Timeline: ["2-4 Weeks"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Madison Ave Consulting"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Awesome consultancy",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZUPU_LJa2fXei07",
      fav_image: "",
      contact_us: "https://www.madisonaveconsulting.com/contact/",
      account_description: "Awesome consultancy",
    },
    {
      title: "Wise Wolves Consultancy",
      teamId: "0016g00000LP6yhAAD",
      stories: [
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "Sage Health Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "As a startup, Sage Health needed a solid technical foundation in order to hit their rapid growth goals. They needed a scalable HIPAA-compliant patient acquisition and admissions process that also accurately calculated commissions for new sales team. With Salesforce and Wise Wolves, the Sage Health team went from tracking in Excel spreadsheets to tracking patient engagement over time by sales rep.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "How Sage Health Tripled its Sales Team with Salesforce Sales Cloud & AthenaOne",
            table: [
              {
                valueName: "Sage Health",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "3-4 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000A8SHWMA3_dVH3KNc2y",
            layout: "Original",
            description:
              '<p dir="ltr">Sage Health is a healthcare provider focused on improving health and quality of life for private-pay Medicare patients and seniors. The company now operates 11 neighborhood health centers spread across four states.</p>',
          },
          testimonialsData: [
            {
              industry: "Director of Sales Operations",
              description:
                '"They have helped us scale our business, allowed us to streamlined processes. In fact, they helped us in ways similar to how our company helps our patients - WiseWolves has been a concierge service for Sage Health."',
              author: "Danielle Pratola",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AATRBMA5_TS-7t3JmN",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/michael-vukovich-a5904920/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Executive Officer",
              name: "Michael Vukovich",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005XJiZMAW__OM7_gmkP",
            },
            {
              serviceLink: "https://www.linkedin.com/in/samlee-salesforce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Sam Lee",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0w_C2yNGH-OkA",
            },
            {
              serviceLink: "https://www.linkedin.com/in/rodolfohdezponce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Rodolfo Hernández Ponce",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0r_FUHAxVXG1",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a00Nu00000D3qVdIAJ",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: "https://youtu.be/jSpGkURqiQg?si=_G5Z9hVrw62j8sXT",
            title:
              "How Sage Health Tripled its Sales Team with Salesforce Sales Cloud & AthenaOne",
            teamSize: 0,
            paragraph2:
              '<p dir="ltr">Sage Health is a healthcare provider focused on improving health and quality of life for private-pay Medicare patients and seniors. The company now operates 11 neighborhood health centers spread across four states.</p>',
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000009ufUlMAI_mkjcUdMPN",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">As a startup of under 50 employees, Sage Health knew that reaching their lofty growth goals – going from no in-person clinics to 15 in two years – would require partner support. Danielle Pratola, Sage Health’s Director of Sales Operations and Salesforce, was operating as a team of one and the only Salesforce admin at the company. She needed a partner who could quickly allocate resources to configure Salesforce and its features – a tall order for only one person.</p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Sage Health is a healthcare provider focused on improving health and quality of life for private-pay Medicare patients/seniors. The company operates 11 neighborhood health centers spread across four states. Each of these centers offers affordable, high-quality primary care, cardiology, and wellness services, plus access to social activities and senior-care specialists trained to help meet the complex medical and social needs of senior citizens.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-10-08T00:32:31.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000A8gUFMAZ_vQGccx_mK",
            roiMoment:
              "Since launching Salesforce with Wise Wolves, the Sage Health sales team has tripled in size, allowing them to bring on more patients and open 15 clinics as of this year.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BFzfxMAD_aYtHfeTcpQ",
            ribbonCuttingMoment:
              "The initial Salesforce Sales Cloud go-live went smoothly. Post implementation, the Sage Health and Wise Wolves teams waited eight weeks to optimize the buildout, then rolled it out to their new sales team. With Wise Wolves by their side, the Operations team was able to quickly scale and release bidirectional features between Salesforce and AthenaOne, like patient syncing and pulling patient status and appointments into Salesforce.",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000009ujy9MAA_KXaeb5aQ9S",
            redMoment:
              "Wise Wolves stood up Salesforce Sales Cloud while production stalled on the AthenaOne integration. Wise Wolves ultimately took over the AthenaOne integration project once Sage Health saw how well they implemented Sales Cloud, putting together a plan that integrated the AthenaOne developer to ensure coordinated development.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BFzT3MAL_u2gVICpwD",
            momentOfTrust:
              "Sage Health was looking for a partner who understood how healthcare works and what their team was trying to accomplish by integrating Salesforce Sales Cloud and Athena One – and who had the skills to successfully navigate a rigorous security review and approval process. Wise Wolves, a certified Salesforce partner, checked all the boxes. With Salesforce’s backing, Sage Health felt confident in their choice of partner.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce Sales Cloud", "AthenaOne"],
            Timeline: ["3-4 Months"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription:
              "Book a meeting with Scott for a quick intro session. Let’s discuss how we can help your organization enhance its sales process, streamline operations, and create a lasting impact for the communities it serves.",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "https://calendly.com/scottr-wisewolves",
            bannerDescription:
              "to learn why we are a top HLS Salesforce consultancy",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "Million Dollar Round Table Culture",
              description:
                "MDRT fosters a high-standard, professional approach to life insurance sales and service to best service their members. The company values insurance and investment financial services professionals to provide an enjoyable experience for their clients and hold their employees to the highest standard of ethics, knowledge, service, and productivity.",
            },
            {
              heading: "Why Now",
              description:
                "MDRT needed a solution to improve their business processes to best support their members and track business goals. MDRT chose Wise Wolves as they have experience with creating custom integrations and recommend best practices for achieving the team’s objectives.",
            },
            {
              heading: "Other Things to Note",
              description:
                "MDRT continues to invest in Salesforce due to their work with Wise Wolves.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "MDRT Increased Financial Advisory Clients’ Adoption of its Platform with Aptify",
            table: [
              {
                valueName: "Million Dollar Round Table",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Financial Services",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FErqhEAD_0oVe4K2Ih",
            layout: "Layout 1",
            description:
              "<p>MDRT leverages the powerful combo of Salesforce Sales Cloud and Aptify membership data to empower their sales team with insights and streamlined workflows. The result? A sharp surge in financial advisory clients adopting the company&#39;s cutting-edge tools and services.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvUs8EAF_uXdeG0AeF",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/alli-knothe-b383aa4b/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Alli Knothe",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0D_766DoinFG",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/carlos-torres-77aa89132/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Carlos Torres",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0I_Rpap1kQfe",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000jgbz7AAA",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title:
              "MDRT Increased Financial Advisory Clients’ Adoption of its Platform with Aptify",
            teamSize: 0,
            paragraph2:
              "<p>MDRT leverages the powerful combo of Salesforce Sales Cloud and Aptify membership data to empower their sales team with insights and streamlined workflows. The result? A sharp surge in financial advisory clients adopting the company&#39;s cutting-edge tools and services.</p>",
            paragraph1: "Build a stronger customer relationship",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvlTWEAZ_gJSIJbTOXv",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr"><strong>Challenge</strong></p>\n<p dir="ltr">MDRT&#39;s sales team lacked visibility into company membership data, which made it challenging for them to understand how clients were utilizing MDRT&#39;s tools and services. This made it almost impossible to take proactive action to increase adoption. If members failed to leverage MDRT tools and services, there was a distinct risk of long-term membership churn. More importantly, MDRT wanted to be sure that its members were thriving. </p>\n<p dir="ltr"> </p>\n<p dir="ltr"><strong>Solution</strong></p>\n<p dir="ltr">Wise Wolves recognized that an &quot;end-user focused&quot; solution was needed on behalf of MDRT for its members. They then designed MDRT a custom Sales Cloud implementation and built a custom integration with Aptify, MDRT’s membership database, that let the MDRT membership success team view membership information and track adoption metrics in Salesforce. The solution also utilized automation to flag clients at high risk of attrition - and to enroll them into workflows that support the engagement efforts of MDRT&#39;s membership success team.</p>\n<p dir="ltr"> </p>\n<p dir="ltr"><strong>Outcome</strong></p>\n<p dir="ltr">MDRT’s sales team is now getting insight into client adoption and is able to proactively engage with high-risk clients. As a result, the company is seeing improvement in the adoption of its tools and services.</p>\n<p dir="ltr">Best of all is that MDRT members are more likely to integrate MDRT tools and services into their workflow - thus they&#39;re now able to become more capable providers of financial services.</p>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Million Dollar Round Table (MDRT) is a global, independent association of the world's leading life insurance and financial services professionals from more than 500 companies in 70 nations and territories.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-09-05T14:55:13.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvlTgEAJ_6rZ1A6ZgH",
            redMoment:
              "One week before the planned go-live date, we hit an unexpected snag when Aptify updated its integration protocol. But we were committed to delivering on our promise to the MDRT team not to let the project timeline slip. Our team dedicated the entire night to quickly adapting our integration logic to accommodate the changes. And we went live successfully the next week!",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvlU0EAJ_Qz5LYT-I9",
            introductionMoment:
              "MDRT sought our expertise based on glowing recommendations from Salesforce AEs, attesting to the exceptional quality of our work. As a testament to our prowess, we were handpicked to be part of their Salesforce implementation. \nAfter a competitive evaluation, MDRT reached an astute decision: they chose us as their trusted partner due to our unparalleled organizational finesse and unwavering professionalism. Our proposal exuded value and promise, making us the clear choice for their invaluable investment.",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvlTqEAJ_IxTbnXjO9",
            dealClarityMoment:
              "During the initial sales cycle, we researched different ways to integrate Salesforce with Aptify and provide adoption insights within Salesforce. We looked into different options, including custom solutions and third-party tools, and weighed their pros and cons, as well as the cost involved. \nAfter careful deliberation, we forged a powerful recommendation and a visionary scope: a bespoke integration and automation solution. It emerged as the perfect match for the client’s needs, seamlessly meeting all their requirements while ensuring optimal cost-effectiveness.",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce Sales Cloud", "Aptify"],
            Timeline: ["5-7 Months"],
            Budget: [null],
            Industry: ["Financial Services"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "MagGas Medical Inc. Culture",
              description:
                "The team at MagGas Medical Inc. works dillegently as they focus on expanding across Canada. By implementing Field Service Lightning and Service Cloud the MagGas team has the ability to better organize and track their warehouse inventory.",
            },
            {
              heading: "Why Now",
              description:
                "MagGas Medical Inc. is rapidly expanding throughout Canada, and with that needed to leverage Salesforce to streamline their inventory upkeep process. The MagGas Medical Inc. team found Wise Wolves to be the solution to their rapid pace, as we demonstrated the required skill sets and experience to increase the likelihood of a successful deployment without compromising the tight timeline MagGas put before us.",
            },
            {
              heading: "Other Things to Note",
              description:
                "MagGas Medical Inc. has continued to invest in Salesforce due to their work with Wise Wolves.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "MagGas Medical Chooses Wise Wolves to Accurately Track Inventory",
            table: [
              {
                valueName: "MagGas Medical Inc.",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "3-4 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "4",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DPqFdEAL_9JzzVhpSP",
            layout: "Original",
            description:
              "<p>MagGas Medical Inc. needed a solution to best track inventory in their warehouse and at patient locations. Poor inventory visibility was causing major problems – including missing critical oxygen deliveries. They turned to Wise Wolves and Salesforce to solve their inventory woes and eliminate costly errors</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzj_AKaowdOPIz",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/samlee-salesforce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Sam Lee",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0w_C2yNGH-OkA",
            },
            {
              serviceLink: "https://www.linkedin.com/in/mingyangzu/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Mingyang Zu",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0h_X5APVyTZ79",
            },
            {
              serviceLink: "https://www.linkedin.com/in/rodolfohdezponce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Rodolfo Hernández Ponce",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0r_FUHAxVXG1",
            },
            {
              serviceLink: "https://www.linkedin.com/in/katelyn-katalinas/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Katelyn Katalinas",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0X_evjhn6U9yK",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000hPuOMAA0",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title:
              "MagGas Medical Chooses Wise Wolves to Accurately Track Inventory",
            teamSize: null,
            paragraph2:
              "<p>MagGas Medical Inc. needed a solution to best track inventory in their warehouse and at patient locations. Poor inventory visibility was causing major problems – including missing critical oxygen deliveries. They turned to Wise Wolves and Salesforce to solve their inventory woes and eliminate costly errors</p>",
            paragraph1: "Decrease cost",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTAAGEA5_KuPr9TgkW",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Poor inventory visibility was causing major problems – including missing critical oxygen deliveries. They turned to Wise Wolves and Salesforce to solve their inventory woes and eliminate costly errors.</p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "MagGas Medical Inc. is a medical gas supplier, as well as a registered vendor with the Assistive Devices Program. The company provides home oxygen therapy and respiratory supplies (such as CPAP machines), medical gasses (such as medical oxygen and nitrous oxide), annual inspections, and cylinder maintenance and other services to numerous medical services throughout Canada.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Field Service Lightning",
              "Salesforce Service Cloud",
            ],
            Timeline: ["3-4 Months"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "May 2022",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTAApEAP_FHOTQjLag",
                heading: "Discovery / Kickoff",
                descriptionLine2: "",
                descriptionLine1:
                  "Wise Wolves spent time with Maggas Medical Inc. to discover their business challenges and setup a plan to find a solution",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "June 2022",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTAAuEAP_IrIdt5SMN",
                heading: "Inventory Visibility to Reach Business Goals",
                descriptionLine2: "",
                descriptionLine1:
                  "Maggas needed a way to accurately track inventory in their warehouse and at patient location",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "July 2022",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTAB4EAP_8UtDiGS-7",
                heading:
                  "Customized Field Service Lightning App for Inventory Tracking",
                descriptionLine2: "",
                descriptionLine1:
                  "Built out a way for field technicians to check in and out on FSL App, as well as track inventory picked up at a location or at warehouse for better reporting",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "August 2022",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTABJEA5_8cg1laxnn",
                heading: "End User Training",
                descriptionLine2: "",
                descriptionLine1:
                  "Provided live training & recorded videos to show how to use specific functionalities for both field technicians and back end managers.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "Ray America Inc. Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "The decision to engage Wise Wolves stemmed from the consultancy's stellar reputation in working with complex, multi-cloud Salesforce implementations. Known for prioritizing client needs and delivering projects in a timely and professional manner, Wise Wolves was the ideal partner to address Ray America Inc.’s pressing operational challenges.",
            },
            {
              heading: "Other Things to Note",
              description:
                "Ray America Inc. continues to work with Wise Wolves to enhance their Salesforce experience.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Wise Wolves Help Ray America Inc. Scale Sales and Service Operations",
            table: [
              {
                valueName: "Ray America Inc.",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DPtVqEAL_CDuWNT02u",
            layout: "Original",
            description:
              "<p>Ray America Inc. was struggling to scale their U.S.-based sales and service operations. Sales, customer service, and field service weren’t collaborating effectively. As a result, customer experience suffered, customer churn increased, and costs were rising. Ray America Inc. needed a way to break down operational silos, replace manual processes, and leverage their customer data. </p>",
          },
          testimonialsData: [
            {
              industry: "Director of Business Development",
              description:
                '"Their team is highly knowledgeable and responsive, ensuring smooth implementation and ongoing support. Clients appreciate their tailored solutions that enhance business processes. Overall, WiseWolf stands out for its professionalism and dedication to client success."',
              author: "Dongyoon Kang",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzj_AKaowdOPIz",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/sinhu%C3%A9-vargas-rodriguez-066699104/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Sinhue Vargas",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E24Q9EAJ_4opY2UN8o",
            },
            {
              serviceLink: "https://www.linkedin.com/in/djoye/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Ayodeji Oye",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E24QEEAZ_TUSEbDRxe",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/michael-vukovich-a5904920/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Executive Officer",
              name: "Michael Vukovich",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005XJiZMAW__OM7_gmkP",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000hPwM5AAK",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title:
              "Wise Wolves Help Ray America Inc. Scale Sales and Service Operations",
            teamSize: 0,
            paragraph2:
              "<p>Ray America Inc. was struggling to scale their U.S.-based sales and service operations. Sales, customer service, and field service weren’t collaborating effectively. As a result, customer experience suffered, customer churn increased, and costs were rising. Ray America Inc. needed a way to break down operational silos, replace manual processes, and leverage their customer data. </p>",
            paragraph1: "Increase sales",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTACHEA5_uuCRFMcO4O",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>In a highly competitive industry, Ray America Inc. faced significant challenges in scaling sales and service operations. The synergy between sales, customer service, and field service was lacking, resulting in a compromised customer experience, increased churn, and escalating costs. Ray America Inc. recognized the need for a streamlined process, as communication gaps between departments hindered efficiency. The existing pipeline tracking system was outdated and challenging to update, while pricing management for different clients proved more intricate than necessary.</p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Ray America Inc. is a market leader in the dental & medical industry, developing and manufacturing dental 3D imaging solutions. Their digital treatment solutions allow Ray America Inc. to be there from a patient’s diagnosis to treatment. Ray America Inc. is dedicated to making a better world by providing reliable, innovative x-ray imaging solutions.",
          },
          metadataname: "",
          metadatadescription:
            "Struggling to scale their U.S.-based sales and service operations, Ray America Inc. partnered with Wise Wolves to break down silos and drive efficiency. Learn how this transformation in the healthcare & life sciences industry optimized customer experience and reduced costs.",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust:
              "Wise Wolves demonstrated an exceptional understanding of Ray America Inc.'s unique challenges in scaling their sales and service operations. With a keen ability to listen attentively and identify critical pain points, Wise Wolves built rapport with the client by presenting a comprehensive solution that not only aligned with Ray America Inc.'s goals but also highlighted their expertise in leveraging Salesforce to drive growth and enhance the customer experience. This genuine connection laid the foundation for a collaborative journey focused on breaking down operational silos, streamlining processes, and maximizing the potential of Ray America Inc.'s customer data.",
            introductionMomentImage: "",
            introductionMoment:
              "Ray America Inc. faced a critical challenge in scaling their U.S.-based sales and service operations, leading to operational inefficiencies and rising costs. Seeking a transformative solution, they engaged with Wise Wolves, a technology consulting firm specializing in healthcare & life sciences. As the partnership began, Wise Wolves delved into understanding Ray America Inc.'s pain points and identified the urgent need to enhance collaboration across sales, customer service, and field operations. It was clear from the outset that a comprehensive strategy to break down operational silos and streamline processes would be vital in improving customer experience and fueling sustainable growth.",
            eurekaMomentImage: "",
            eurekaMoment:
              "Ray America Inc. experienced a eureka moment when they realized the power of integrating Salesforce with their operations. This realization occurred as they observed the seamless flow of information between their sales, customer service, and field service teams. By centralizing their customer data and processes on a single platform, they recognized the transformative potential of breaking down operational silos and fully harnessing their resources. This pivotal moment sparked a new approach to customer engagement, paving the way for improved efficiency, customer satisfaction, and sustainable growth.",
            dealClarityMomentImage: "",
            dealClarityMoment:
              "The collaboration between Ray America Inc. and Wise Wolves resulted in a transformative journey. By breaking down operational silos, automating manual processes, and leveraging Salesforce capabilities, Ray America Inc. experienced improved collaboration across departments, heightened customer satisfaction, and a more agile approach to sales and service operations. This ongoing partnership reflects the commitment to sustaining and enhancing the Salesforce experience for continuous business growth.",
          },
          isfeatured: true,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Service Cloud",
              "Field Service Lightning",
              "Salesforce Sales Cloud",
            ],
            Timeline: ["5-7 Months"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "https://calendly.com/scottr-wisewolves",
            bannerDescription: "",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "Candid Health Culture",
              description:
                "Candid Health focuses on the relationships they hold with their customers. The sales team knew they were missing out on renewal opportunities and were missing key reports to track their sales pipeline. Candid Health turned to Wise Wolves for their quick and successful expertise.",
            },
            {
              heading: "Why Now",
              description:
                "Candid Health’s sales team knew they were missing out on renewal opportunities with current clients. The company wasn’t seeing results with Salesforce due to the lack of organization. Candid Health needed a quick solution to make Salesforce work for them to improve their sales process.",
            },
            {
              heading: "Other Things to Note",
              description:
                "Candid Health continues to work with Wise Wolves to enhance their Salesforce experience.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Wise Wolves Upgrades Sales Cloud for Candid Health",
            table: [
              {
                valueName: "Candid Health",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "4-8 weeks",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "4",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DcN94EAF_W0IUcdYip",
            layout: "Original",
            description:
              "<p>Candid Health collaborated with Wise Wolves to enhance organization and automation in their Salesforce instance, focusing on streamlining renewal opportunity management. Wise Wolves empowered Candid Health to effectively track, monitor, and close renewal opportunities, driving sales growth and improving overall performance.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/samlee-salesforce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Sam Lee",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0w_C2yNGH-OkA",
            },
            {
              serviceLink: "https://www.linkedin.com/in/rodolfohdezponce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Rodolfo Hernández Ponce",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0r_FUHAxVXG1",
            },
            {
              serviceLink: "https://www.linkedin.com/in/mingyangzu/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Mingyang Zu",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0h_X5APVyTZ79",
            },
            {
              serviceLink: "https://www.linkedin.com/in/katelyn-katalinas/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Katelyn Katalinas",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0X_evjhn6U9yK",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000o5fHBAAY",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title: "Wise Wolves Upgrades Sales Cloud for Candid Health",
            teamSize: null,
            paragraph2:
              "<p>Candid Health collaborated with Wise Wolves to enhance organization and automation in their Salesforce instance, focusing on streamlining renewal opportunity management. Wise Wolves empowered Candid Health to effectively track, monitor, and close renewal opportunities, driving sales growth and improving overall performance.</p>",
            paragraph1: "Increase sales",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DcN8BEAV_WWYMqM6fX",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>In order to improve organization and automation within their Salesforce instance, Candid Health partnered with Wise Wolves. The primary goal was to streamline the management of renewal opportunities throughout the sales pipeline. Wise Wolves successfully enhanced Candid Health&#39;s Salesforce instance by organizing and automating the renewal opportunity management process. Customizing the opportunity object, developing automation, setting up activity capture, and building informative reports and dashboards empowered Candid Health to track, monitor, and close renewal opportunities, ultimately driving sales growth and improving overall sales performance.</p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Candid Health is a medical payment platform. The platform gives healthcare providers the power to focus on delivering the best care to their patients, rather than spending that time trying to figure out how to be paid by insurance.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce Sales Cloud"],
            Timeline: ["4-8 weeks"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "June 2022",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DcN8aEAF_sbg3cMO5W",
                heading: "Discovery/ Kickoff",
                descriptionLine2: "",
                descriptionLine1:
                  "Through collaborative efforts, the teams from Wise Wolves and Candid Health identified the requirement for improved organization & automation in their Salesforce instance.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "June 2022",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DcN8aEAF_sbg3cMO5W",
                heading: "Modification & Automation of the Opportunity Object",
                descriptionLine2: "",
                descriptionLine1:
                  "Wise Wolves enhanced the opportunity object by implementing new custom fields, page layouts, & record types. Additionally, they developed an automation that improved the probability of closing renewal opportunities for existing accounts.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "June 2022",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DcN8kEAF_3A_L532Z6",
                heading: "Activity Capture",
                descriptionLine2: "",
                descriptionLine1:
                  "Einstein Activity Capture was set-up to automatically pull emails & events from the client email/calendar tool into Salesforce to keep track of prior communication with clients.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "June 2022",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DcN8pEAF_PY4aTeC-H",
                heading: "Reports and Dashboards",
                descriptionLine2: "",
                descriptionLine1:
                  "Wise Wolves created dashboards containing reports to give the Candid Health team better visibility into opportunities currently in the sales pipeline.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "Clarity Guardians Culture",
              description:
                "Clarity Guardians has a very organized culture and has high expectations of integrity, organization, and communication. We enjoy working with Clarity Guardians because of their focus on achieving specific business outcomes and doing what's just necessary to achieve those.",
            },
            {
              heading: "Why Now",
              description:
                "Leadership at Clarity Guardians was looking for a way to improve field, dispatch, and back office operations to reduce the time and costs associated with entering data in multiple places, or sending Guardians on inefficient routes. They wanted to put technology in place that will help them scale.",
            },
            {
              heading: "Other Things to Note",
              description:
                "Clarity Guardians has continued to invest in Salesforce and in improving their field operations due to success in working with Wise Wolves.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Wise Wolves Sets Clarity Guardians Up for Growth with Field Service",
            table: [
              {
                valueName: "Clarity Guardians",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "3-4 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO6q_6qj9sVRvi",
            layout: "Original",
            description:
              "<p>As the company grows, Clarity Guardians needs an increasingly more organized, efficient way to assign patients a Guardian with the right skillset who is available when, and where, the patient is in need.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzj_AKaowdOPIz",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/alli-knothe-b383aa4b/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Alli Knothe",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0D_766DoinFG",
            },
            {
              serviceLink: "https://www.linkedin.com/in/rodolfohdezponce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Rodolfo Hernández Ponce",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0r_FUHAxVXG1",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000XEKqNAAX",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title:
              "Wise Wolves Sets Clarity Guardians Up for Growth with Field Service",
            teamSize: null,
            paragraph2:
              "<p>As the company grows, Clarity Guardians needs an increasingly more organized, efficient way to assign patients a Guardian with the right skillset who is available when, and where, the patient is in need.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5O_meEZztsS0",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Clarity Guardians was looking for a way to manage their team of Guardians who visit patients in the field. They were interested in leveraging technology to automate some back office tasks and coordinate with front office scheduling, to reduce costly mistakes, add integrity to audit trails, and enable their front office teams to handle a greater case load.</p>\n<p> </p>\n<p>Business Objectives:</p>\n<p>Record &amp; get visibility into visit summaries to better understand on-site activity and improve audit trail.</p>\n<p> </p>\n<p>Improve assignment of Guardians by matching skills, distance, and availability - in an efficient way.</p>\n<p> </p>\n<p>Reduce manual data entry and save time on tasks.</p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Clarity Guardians is a Certified Professional Guardianship Agency that provides Trust, Guardianship, Personal Representative and Fiduciary Services to families and individuals. The company is based in Washington State. ",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Field Service Lightning"],
            Timeline: ["3-4 Months"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "April 2021",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5T_t5DIBbGO-",
                heading: "Find the Why",
                descriptionLine2: "",
                descriptionLine1:
                  "Discovery to find the day-to-day challenges CG's Guardians and Dispatchers experienced.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "May 2021",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5Y_4donKssA5",
                heading: "Identify Business Outcomes & Goals",
                descriptionLine2: "",
                descriptionLine1:
                  "Identify Business Outcomes & Goals to shape how we would approach the technical solution.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "July 2021",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5d_CZTk-kT_E",
                heading:
                  "Sync EMS with Salesforce to update service agreements & patient information",
                descriptionLine2: "",
                descriptionLine1:
                  "When new patients or service agreements are added to the EMS, they will populate in Salesforce. When patients are edited in the EMS, edits will appear in Salesforce.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "September 2021",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5i_0RmucVhIZ",
                heading:
                  "Customize Field Service dispatcher w. scheduling & Guardian skill & location",
                descriptionLine2: "",
                descriptionLine1:
                  "Provide all relevant information on Guardians to Dispatchers to make scheduling visits with the right Guardian easier and more efficient.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "October 2021",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5O_meEZztsS0",
                heading: "End User Training",
                descriptionLine2: "",
                descriptionLine1:
                  "Provide live training & recorded videos to show how to use specific functionalities.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "Upward Health Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Upward Health aims to deliver a seamless scheduling experience while avoiding double bookings. They sought to create a unified system that would empower both providers and care navigators.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Upward Health leverages core, less-standard features of FSL",
            table: [
              {
                valueName: "Upward Health",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "4",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FEqKzEAL_-YWnumk6G",
            layout: "Original",
            description:
              "<p>The Wise Wolves&#39; team utilized their Salesforce expertise in FSL to uncover the lesser-known FSL core and non-standard features. By leveraging these findings, they successfully delivered the specific outcomes the Upward Health team requested.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzj_AKaowdOPIz",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHM_JiD0eurMH",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/carlos-torres-77aa89132/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Carlos Torres",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0I_Rpap1kQfe",
            },
            {
              serviceLink: "https://www.linkedin.com/in/mingyangzu/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Mingyang Zu",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0h_X5APVyTZ79",
            },
            {
              serviceLink: "https://www.linkedin.com/in/samlee-salesforce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Sam Lee",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0w_C2yNGH-OkA",
            },
            {
              serviceLink: "https://www.linkedin.com/in/rodolfohdezponce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Rodolfo Hernández Ponce",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0r_FUHAxVXG1",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000rMka1AAC",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title:
              "Upward Health leverages core, less-standard features of FSL",
            teamSize: null,
            paragraph2:
              "<p>The Wise Wolves&#39; team utilized their Salesforce expertise in FSL to uncover the lesser-known FSL core and non-standard features. By leveraging these findings, they successfully delivered the specific outcomes the Upward Health team requested.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FEqIWEA1_RXGyUBf71",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Upward Health had a distinct requirement: to achieve nationwide scalability by consolidating scheduling behavior across their two systems into a unified experience on Salesforce. This consolidation aimed to enhance efficiency in scheduling procedures and facilitate scalability across the care specialists team. By utilizing restricted-use licenses (RULs), Upward Health successfully met their target price per user and achieved their desired outcome. </p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Upward Health is an in-home medical group that specializes in primary medical, behavioral, and social healthcare for individuals with complex needs.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FEqKuEAL_kL8jcdX8xL",
            roiMoment:
              "Upward Health has noticed a decrease in the total number of rescheduled appointments due to internal errors. Additionally, the average handle time to process new requests has improved, leading to better overall system adoption.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FEqKaEAL_5sf3O61YU",
            redMoment:
              "During the initial phases of the project, considerable effort was dedicated to building the backend of Salesforce in a sustainable and well-structured manner. However, comparatively less effort was allocated to the front end, which led to user feedback highlighting usability concerns during the first round of testing. This raised doubts about FSL's ability to achieve Upward Health's objective. In response, the Wise Wolves' team conducted a comprehensive review of the User Interface, offering short, medium, and long-term suggestions to enhance its usability and demonstrate the capability to ensure a user-friendly experience post-go-live, without impacting the project timeline or budget.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FEqKVEA1_cEXtMr4uV",
            momentOfTrust:
              "Upward Health had a unique use case that required substantial back-and-forth review during the initial evaluation of FSL to determine the platform's suitability in terms of cost and timeline. Wise Wolves leveraged their experience in using FSL to explore and utilize its less commonly employed core and non-standard features, effectively delivering the desired outcomes for Upward Heath. They collaborated closely with the Salesforce team to deploy restricted use licenses (RULs) that aligned with their per-user price point, optimizing the licensing based on their specific requirements. Wise Wolves utilized their expertise to engage in discussions and provide recommendations to the Salesforce team, identifying the necessary components while eliminating unnecessary ones, considering Upward Health's specific needs and goals.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "FSL - Field Service Lightning",
              "Salesforce Health Cloud",
            ],
            Timeline: ["5-7 Months"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "Vesta Healthcare Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Vesta Healthcare faced an imminent sunset of their existing CRM system, necessitating a swift transition to Health Cloud to prevent any operational disruptions. The urgency to migrate was driven by their need to maintain uninterrupted services and ensure seamless continuity in their healthcare operations.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Wise Wolves quickly enrolls Vesta Healthcare to Health Cloud",
            table: [
              {
                valueName: "Vesta Healthcare",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "3-4 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FEP55EAH_Hxqv5tg4v",
            layout: "Original",
            description:
              "<p>Vesta Healthcare faced a pressing deadline to transition to a new CRM system as their existing one was nearing its end-of-life. With the sunsetting of their old CRM, a swift migration was crucial to ensure uninterrupted and efficient management of patient records and healthcare operations. </p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHM_JiD0eurMH",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/mingyangzu/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Mingyang Zu",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0h_X5APVyTZ79",
            },
            {
              serviceLink: "https://www.linkedin.com/in/samlee-salesforce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Sam Lee",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0w_C2yNGH-OkA",
            },
            {
              serviceLink: "https://www.linkedin.com/in/rodolfohdezponce/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Rodolfo Hernández Ponce",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0r_FUHAxVXG1",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000rMmjlAAC",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title:
              "Wise Wolves quickly enrolls Vesta Healthcare to Health Cloud",
            teamSize: null,
            paragraph2:
              "<p>Vesta Healthcare faced a pressing deadline to transition to a new CRM system as their existing one was nearing its end-of-life. With the sunsetting of their old CRM, a swift migration was crucial to ensure uninterrupted and efficient management of patient records and healthcare operations. </p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FEqFbEAL_kmGaZXZgx",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<div class="group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]">\n<div class="flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto">\n<div class="relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]">\n<div class="flex flex-grow flex-col gap-3">\n<div class="min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words flex-col gap-4">\n<div class="markdown prose w-full break-words dark:prose-invert light">\n<p>Wise Wolves successfully implemented Health Cloud for Vesta Healthcare, enabling them to manage their new member acquisition pipeline effectively. Leveraging the household model in Health Cloud, Vesta Healthcare can track the individuals they are enrolling and their family members. By integrating their phone system with Salesforce, Vesta Healthcare now has a streamlined admission, service delivery, and outbound dialing process to determine relationships. Additionally, Wise Wolves built a new patient acquisition pipeline with integrated CTI, providing greater visibility, higher conversion rates, and automated actions to overcome any obstacles in the enrollment process, ultimately allowing Vesta Healthcare to enroll more members. Moreover, they implemented comprehensive reporting capabilities, including affected dates for member referrals, ensuring accurate reporting to insurance companies, and facilitating roll-up reporting.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<p> </p>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Vesta Healthcare is a technology and clinical services organization that offers personalized care to patients from the comfort of their homes. They connect caregiver insights to the rest of the care team, providing 24/7 telehealth support for high-need, frail senior populations. Vesta partners with home care, health plans, and providers to create value-based population health programs focused on clinical quality, improved health outcomes, and personalized engagement.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FEqGrEAL_TPZ-s0Ghm",
            ribbonCuttingMoment:
              "Wise Wolves achieved a successful implementation of Health Cloud for Vesta Healthcare, meeting the designated deadline without causing any disruptions to the company's operations. Their expertise and meticulous approach enabled a seamless transition, ensuring business continuity and empowering Vesta Healthcare with the benefits of Salesforce.",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FEqI5EAL_YTzFy6Y_U",
            introductionMoment:
              "Vesta Healthcare selected Wise Wolves as their Salesforce partner for implementing Health Cloud based on Wise Wolves' track record of success and positive reviews from previous clients. Given Wise Wolves' ability to swiftly implement Health Cloud without causing any disruptions, Vesta Healthcare trusted them to seamlessly transition to the new CRM system while maintaining operational efficiency. The decision was influenced by the confidence placed in Wise Wolves' expertise and their commitment to delivering a smooth and efficient implementation process.",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FEqIAEA1_KFHHGu5uK",
            eurekaMoment:
              "To scale and enhance the efficiency of their member enrollment workflow, Vesta Healthcare aimed to incorporate the B2C aspect into their existing Salesforce platform, which primarily focused on B2B interactions. By bringing the B2C aspect to Salesforce, Vesta Healthcare sought to leverage the platform's capabilities to streamline and expand their member enrollment process, ensuring scalability and increased operational efficiency. Wise Wolves recommended the implementation of Health Cloud, to leverage the client household model.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce Health Cloud"],
            Timeline: ["3-4 Months"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "GOLO Culture",
              description:
                "GOLO's customer success team already knew what they wanted to accomplish, and had an idea of how to accomplish their goals. Unfortunately, they didn't have the technical experience or the time to put together a solution. GOLO relies on Wise Wolves to provide operational strategy and technical expertise to get the most from their Salesforce investment.",
            },
            {
              heading: "Why Now",
              description:
                "GOLO's customer service department knew they needed a better way to manage customer support cases. They also knew improved customer service would lead to higher customer satisfaction - and more frequent re-orders. Unfortunately, they weren't seeing the results they wanted from their initial investment into Salesforce. They needed a solution quickly, to both justify the investment in Salesforce and to improve their sales numbers.",
            },
            {
              heading: "Other Things to Note",
              description:
                "GOLO has increased marketing qualified contacts by over 50%. They continue to invest in Salesforce and expand their partnership with Wise Wolves because our joint partnership supports their business growth.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "HLS ISSUE SPRING 2024",
            campaignLandingPageUrl:
              "https://brightr.io/brightr-magazine-hls-salesforce-2024",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "GOLO Improves Customer Service & Increases ReOrders",
            table: [
              {
                valueName: "GOLO",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "7-12 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "5",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5x_D0TyBhcwT",
            layout: "Original",
            description:
              "<p>GOLO is an e-commerce health &amp; wellness company that assists its clientelle in reaching their weight loss goals. After experiencing incredible growth, GOLO invested in a more robust CRM solution to support its Customer Support and Marketing teams, replacing ZOHO CRM with Salesforce Service Cloud &amp; Marketing Cloud</p>",
          },
          testimonialsData: [
            {
              industry: "Director of Social Media & Customer Service",
              description:
                "“You guys are the BEST we have ever had and we are so happy with your service!”",
              author: "Eden Covington",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzo_9WG7SLFgB",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzy_c6XuZDBIN",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZQfa_9HBaGOu3U",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5mohEAB_oC9brVCyb",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/alli-knothe-b383aa4b/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Alli Knothe",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0D_766DoinFG",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/carlos-torres-77aa89132/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Carlos Torres",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0I_Rpap1kQfe",
            },
            {
              serviceLink: "https://www.linkedin.com/in/jevon-shaw-8b8184155/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Jevon Shaw",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E24QJEAZ_zFvtAcSz6",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/michael-vukovich-a5904920/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Engagement Manager",
              name: "Michael Vukovich",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005XJiZMAW__OM7_gmkP",
            },
            {
              serviceLink: "https://www.linkedin.com/in/ran-michael-msc-pmp/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Ran Michael",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0m_ttjSwl6z0",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000XEKy7AAH",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title: "GOLO Improves Customer Service & Increases ReOrders",
            teamSize: 0,
            paragraph2:
              "<p>GOLO is an e-commerce health &amp; wellness company that assists its clientelle in reaching their weight loss goals. After experiencing incredible growth, GOLO invested in a more robust CRM solution to support its Customer Support and Marketing teams, replacing ZOHO CRM with Salesforce Service Cloud &amp; Marketing Cloud</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOQ9_VHBbt_5hMh",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>GOLO was becoming a proven brand in the health &amp; wellness industry, proving that their trademark GOLO Release product could sustainable result in weight loss while following the GOLO for Life plan. This recognition was resulting in 200-300% YoY revenue growth; growth that demanded that GOLO improve its legacy ZOHO CRM solution with a solution that could maintain GOLO&#39;s high customer satisfaction, and promote product compliance and customer retention. </p>\n<p>In their evaluation, they landed on Salesforce Service Cloud &amp; Marketing Cloud solutions, which they felt would enable them to drive towards the following objectives:</p>\n<ol><li>Increase in customer reorders (aka retention)</li><li>Increase in customer service CSAT</li><li>Increase in overall product usage compliance </li></ol>\n<p>Shortly after purchasing Salesforce however, GOLO uncovered that the solution they were pitched would not be as easy as they were promised, and a year after their Salesforce licenses were activated, they were still operating out of ZOHO almost exclusively, with Salesforce still lacking critical features required to successfully launch. </p>\n<p>Wise Wolves was introduced to GOLO through a common connection. Within 60 days, Wise Wolves was able to deploy critical Marketing Cloud &amp; Service Cloud related features, including but not limited to:</p>\n<ol><li><strong>Case Capture</strong><br>Logging incoming phone calls, web chats and emails within Salesforce as Cases logged against respective customers</li><li><strong>IP Warming</strong><br>Ensure email deliverability for the 100 - 200K marketing related emails</li><li><strong>New Customer Welcome Series</strong><br>After a new customer purchases, send them targeted email correspondance to ensure they are well positioned to take the fullest advantage of their purchase</li><li><strong>Validating Integration Integrity</strong><br>Confirm that the integration between Salesforce CRM &amp; Shopify Ecommerce properly synced all customers, orders, products, etc.</li></ol>\n<p>After deploying those features, Wise Wolves proposed a long term roadmap to further enable GOLO to realize all of what Salesforce has to offer. Since this date, GOLO has doubled their Salesforce licenses, increased the number of support channels to include SMS, deployed a chatbot, migrated to Mulesoft, and most recently, deployed Service Cloud Voice to manage inbound phone inqueries. </p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "GOLO is a fast growing weight loss e-commerce company that offers supplements, equipment, nutrition plans, and memberships to its customers. The team at GOLO believes in helping customers feel healthy and feel great so they can live lives they love.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5etiEAB_Dlh3ma9m3",
            roiMoment:
              "After successfully deploying Salesforce, GOLO realized immediate results in its response time to customers. \nCustomer Support: Cases were now automatically being logged, and linked to customer accounts, drastically reducing the amount of time it took to understand and act on the client's requests. \nMarketing: A year after deploying Salesforce Marketing Cloud, GOLO realized a 2x increase in returning customers, directly attributed to higher CSAT and more targeted marketing.\nOperationally: GOLO was finally able to deprecate their duplicative CRM systems, reducing overall operational costs.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5etOEAR_566bm7ynj",
            ribbonCuttingMoment:
              "After developing the final items required for GOLO to leverage Salesforce, Wise Wolves travelled onsite to train the Customer Support team on the new system, and the expectations of them. The team was excited to finally have a tool that would allow for them to properly coordinate their efforts, and distribute the workload across the broader team, increasing the likelihood that clients would be happy with their efforts and return to GOLO for all their health and wellness needs.",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5etdEAB_anzlv2zvcc",
            momentOfTrust:
              "After being overpromised and underdelivered by everyone GOLO worked with within the Salesforce ecosystem, GOLO was hinging on Wise Wolves delivering on their promises. Wise Wolves was challenged during the initial go-live to meet some of GOLO's high expectations around integration integrity given the size and scale of GOLO's clients and respective Orders. GOLO needed 100% assurances that the integration was working as expected, with no downtime to ensure all downstream automation (i.e. welcome series) and reports worked as expected.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Marketing Cloud",
              "Salesforce Service Cloud",
              "Shopify",
              "MuleSoft",
              "Service Cloud Voice",
            ],
            Timeline: ["7-12 Months"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "CEO",
            modalDescription:
              "Michael has been leading innovation in the Salesforce space for +10yrs. Book a meeting with him to get his POV on Salesforce and HLS.",
            headshotUrl:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005XJiZMAW__OM7_gmkP",
            contactName: "Michael Vukovich",
            calendlyLink:
              "https://calendly.com/mvukovich/30min?month=2024-02&date=2024-02-07",
            bannerDescription:
              "to learn more about Wise Wolves' experience in HLS",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "Retreat Behavioral Health Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                'Business leaders at Retreat recognized they weren\'t able to effectively use the Einstein licenses they purchased. Additionally, strategic decisions around where to focus efforts were difficult because their data was unclear and sometimes incomplete. It caused headaches from doing too much "guessing" and manual data entry.',
            },
            {
              heading: "Other Things to Note",
              description:
                "Retreat has continued to invest in Salesforce due to their work with Wise Wolves.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Retreat Behavioral Health Gets Data Vizualization to Make Better Decisions",
            table: [
              {
                valueName: "Retreat Behavioral Health",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "1",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO6R_48gykbiTF",
            layout: "Original",
            description:
              "<p>Retreat Behavioral Health struggled analyzing their data because it wasn&#39;t syncing properly between systems. Strategic decisions for marketing, sales, and partnerships were getting more difficult to make.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNze_6d2zI9L6rI",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO03___3gJLcwH",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/michael-vukovich-a5904920/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Engagement Manager",
              name: "Michael Vukovich",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005XJiZMAW__OM7_gmkP",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000XEKyRAAX",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title:
              "Retreat Behavioral Health Gets Data Vizualization to Make Better Decisions",
            teamSize: null,
            paragraph2:
              "<p>Retreat Behavioral Health struggled analyzing their data because it wasn&#39;t syncing properly between systems. Strategic decisions for marketing, sales, and partnerships were getting more difficult to make.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOQ4__e7w5r6OC",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Retreat needed a HIPAA compliant solution that would allow data to flow from their EMR into one centralized database. Then, they wanted clear visualization of all the data so leadership could make better strategic decisions. Wise Wolves was hired after a previous engagement took too long to complete and never achieved Retreat&#39;s implementation or business goals. Retreat needed to see value in their Salesforce investment, fast.<br><br>Business Objectives:</p>\n<ul><li>Determine which marketing &amp; sales channels bring in more patients to put more effort into those channels; Understand how often they work with insurers to put more focus on those insurers; Eliminate data transfer error between EMR &amp; Sigmund to limit manual data entry</li></ul>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Retreat Behavioral Health specializes in substance abuse and mental health treatment, counseling and other clinical services.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Einstein", "Sigmund"],
            Timeline: ["5-7 Months"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "June 2021",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO6W_SmLeTzI_lI",
                heading: 'Find the "Why"',
                descriptionLine2: "",
                descriptionLine1:
                  "We dug deep to find the day-to-day challenges Retreat dealt with to understand what problems need to be solved.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "July 2021",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO6b_RKUE3J-Eds",
                heading: "Identify Business Outcomes & Goals",
                descriptionLine2: "",
                descriptionLine1:
                  "Clearly explain how Retreat's Salesforce implementation & integrations will improve business.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "October 2021",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO6g_loDdqGzqx",
                heading: "Einstein & Sigmund Integration",
                descriptionLine2: "",
                descriptionLine1:
                  "Improve the integration between Retreat's EMR & Salesforce Einstein to reduce data loss & migration errors.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "November 2021",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO6l_FM71d9qAc",
                heading: "End User Training",
                descriptionLine2: "",
                descriptionLine1:
                  "Ensure end users have the knowledge and skills to use Salesforce & get desired value.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "PrudentRX Culture",
              description:
                "Specialty medications are used to treat complex or rare chronic conditions, which require a tailored member approach. PrudentRx is committed to providing premium service to their members, taking into consideration each member’s individual needs.",
            },
            {
              heading: "Why Now",
              description:
                "PrudentRX is a fast growing company that has gained thousands of new customers and multiple partners in a very short timespan. Their technology had to keep up and Wise Wolves has provided consistent upgrades and project direction to help PrudentRX do more with their technology investments.",
            },
            {
              heading: "Other Things to Note",
              description:
                "PrudentRX's growth soared because the executive team was able to build strategic partnerships with enterprise pharmaceutical companies to provide ongoing services.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Wise Wolves Helps PrudentRX Scale Fast with Salesforce",
            table: [
              {
                valueName: "PrudentRX",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over a year",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOCK_HAQL1Xci-s",
            layout: "Original",
            description:
              "<p>PrudentRX is a membership service that provides prescription discount programs to patients with specialty medications. With a new strategic partnership with a national drugstore, PrudentRx needed systems to quickly analyze customer data, resolve customer issues, and keep their new partner up to date with program changes.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOI4_MINn7eq2sc",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNze_6d2zI9L6rI",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOI9_nBfA6wsix",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOIE_AjHTdjrWc",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOIJ_fkLJMhbI5",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/michael-vukovich-a5904920/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Engagement Manager",
              name: "Michael Vukovich",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005XJiZMAW__OM7_gmkP",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/carlos-torres-77aa89132/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Technical Architect",
              name: "Carlos Torres",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0I_Rpap1kQfe",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000fQLxiAAG",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title: "Wise Wolves Helps PrudentRX Scale Fast with Salesforce",
            teamSize: null,
            paragraph2:
              "<p>PrudentRX is a membership service that provides prescription discount programs to patients with specialty medications. With a new strategic partnership with a national drugstore, PrudentRx needed systems to quickly analyze customer data, resolve customer issues, and keep their new partner up to date with program changes.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOBM_HFcbuqxZ5",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>At first, PrudentRX just wanted to set up a call center where agents could easily track customer communications and follow up on claims and support requests. However, they grew faster than expected and PrudentRX realized they needed a lot of data quickly and accurately integrated from multiple third party tools into their new Salesforce system to reduce the time and effort it took for call center agents to resolve cases and process claims.</p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "PrudentRx was founded to help health plans of any size manage the rising cost of specialty medications. Through customer membership plans, PrudentRX helps contain costs on specialty medications and provides support services to patients, in collaboration with national enterprises.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Service Cloud",
              "Salesforce Shield",
              "Einstein",
              "8X8 CTI",
              "Jitterbit",
              "CVS Caremark",
            ],
            Timeline: ["Over a year"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "April 2020",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOBR_kWRlzRStD",
                heading: 'Find the "Why"',
                descriptionLine2: "",
                descriptionLine1:
                  "We dug deep to find the real challenges PrudentRX would deal with  when launching a Salesforce supported call center to understand what problems need to be solved.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "June 2020",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOBb_QKnsBToMpc",
                heading: "Identify Business Outcomes & Goals",
                descriptionLine2: "",
                descriptionLine1:
                  "Clearly explain how PrudentRX's Salesforce implementation & integrations will improve customer experience with support and onboarding.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "September 2020",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOBg_LfNzeXsAV",
                heading: "Sales & Service Cloud Standup",
                descriptionLine2: "",
                descriptionLine1:
                  "Implement Sales Cloud, Service Cloud email-to-case and integrate CTIs",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "October 2020",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOBl_IC5lXozEN",
                heading: "Third Party Custom Integrations",
                descriptionLine2: "",
                descriptionLine1:
                  "Configure custom API integrations between drugstore partner, pharmaceutical companies, and PrudentRX's Salesforce system.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "November 2020",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOBq_VFFczHx0f",
                heading: "Ongoing Support",
                descriptionLine2: "",
                descriptionLine1:
                  "Ensure end users have the knowledge and skills to use Salesforce & get desired value.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#FFFFFF",
        },
        {
          website: "https://www.wisewolves.com/",
          valueSectionsData: [
            {
              heading: "Boston Tree Preservation Culture",
              description:
                "Founded by Peter Wild in the late 1970s and now operated by father and son, Boston Tree Preservation cares a lot about preserving the natural landscape in Boston and nearby municipalities with safe, organic practices that keep nature and the people that enjoy it healthy.",
            },
            {
              heading: "Why Now",
              description:
                "With the pandemic, small businesses suffered and had to find creative ways to reduce costs and improve efficiencies in their businesses. Peter Wild's son, Pete, was ready to leverage technology to create more digital operations for the company.",
            },
            {
              heading: "Other Things to Note",
              description:
                "Boston Tree Preservation was using paper for almost 100% of their invoicing and renewals. Now they are 100% digital and have automatic and self-service renewals in place that create predictability and consistency in their business.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Boston Tree Preservation Increases Daily Arborist Appointments by ~30% During Pa",
            table: [
              {
                valueName: "Boston Tree Preservation",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Agriculture & Mining",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over a year",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOCP_VfjO46rcF",
            layout: "Original",
            description:
              "<p>Boston Tree Preservation is a family-own and -run business based in Boston that provides organic arborist and landscaping services. They were operating almost completely on paper - sending invoices and renewals manually by mail and creating uncertainty in revenue and business growth.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzj_AKaowdOPIz",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOHz_xiYvLIoau",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/michael-vukovich-a5904920/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Michael Vukovich",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005XJiZMAW__OM7_gmkP",
            },
            {
              serviceLink: "https://www.linkedin.com/in/alli-knothe-b383aa4b/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Alli Knothe",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO0D_766DoinFG",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO5s_29oJR-_my",
          storyId: "a006g00000fQLyMAAW",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#87899F",
          secondaryfont: "Montserrat",
          secondarycolor: "#B4DFE6",
          projectSectionData: {
            videoLink: null,
            title:
              "Boston Tree Preservation Increases Daily Arborist Appointments by ~30% During Pa",
            teamSize: null,
            paragraph2:
              "<p>Boston Tree Preservation is a family-own and -run business based in Boston that provides organic arborist and landscaping services. They were operating almost completely on paper - sending invoices and renewals manually by mail and creating uncertainty in revenue and business growth.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOBv_4IC-rTpw-",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Boston Tree Preservation originally came to Wise Wolves looking for a way to efficiently schedule arborists on daily routes so they could fit more visits into a day, and increase the number of customers they could help. Along the way, we discovered that they were using paper invoices and renewal notices, sent by mail, to customers to encourage renewing services on a seasonal basis. Wise Wolves helped Boston Tree Preservation digitize their operations to make everything faster and more predictable- from scheduling arborists for efficient, time-saving routes to providing customers with email reminders for renewals.</p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#312D59",
          primaryfont: "Montserrat",
          primarycolor: "#02BBA7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Boston Tree Preservation provides professional arborist and seasonal landscaping services to Boston and the surrounding area, with a focus on natural, organic, nutritional support for trees and shrubs and educational services that help homeowners keep their land healthy.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#02BBA7",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Service Cloud",
              "QuickBooks",
              "Field Service Lightning",
            ],
            Timeline: ["Over a year"],
            Budget: [null],
            Industry: ["Agriculture & Mining"],
            Company: ["Wise Wolves Consultancy"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "September 2020",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOC0_NfcDlLV_T",
                heading: 'Find the "Why"',
                descriptionLine2: "",
                descriptionLine1:
                  "We dug deep to find the real challenges Boston Tree Preservation deals with on a daily basis, which led us to discover their paper renewals process.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "October 2020",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOC5_LfSlJ7itZ",
                heading: "Identify Business Outcomes & Goals",
                descriptionLine2: "",
                descriptionLine1:
                  "Clearly explain how Salesforce Field Service & Sales Cloud will improve sales and field operations and efficiency.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "November 2020",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOCA_YuT0SRAk8i",
                heading: "Sales Cloud, Field Service, & Quickbooks Integration",
                descriptionLine2: "",
                descriptionLine1:
                  "Implement Sales Cloud & Field Service to schedule Arborists more effectively & connect Quickbooks with a website landing page for fast renewals.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "May 2021",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOCF_rgm_sB7tu",
                heading: "Ongoing Support",
                descriptionLine2: "",
                descriptionLine1:
                  "Provide training to dispatching operations and sales users, and ongoing managed services support.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
          calendlyLink: "https://calendly.com/scottr-wisewolves",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#FFFFFF",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO7Z_DWr2bPDmG",
      fav_image: "",
      contact_us: "https://www.wisewolves.com/contact-us",
      account_description:
        "Wise Wolves Consultancy (WWC) is a Salesforce consulting firm focused on delivering solutions on Service, Field Service Lightning, Sales & Community Cloud. We specialize in understanding what our clients need & what they are trying to accomplish with their investment,  using that as a guide to ensure we maximize their investments in Salesforce.",
    },
    {
      title: "Coastal",
      teamId: "0016g00002OBWlgAAH",
      stories: [
        {
          website: "https://coastalcloud.us",
          valueSectionsData: [
            {
              heading: "Baptist Health Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "It’s no secret: people want healthcare that’s convenient, personalized, and meets their unique needs. However, navigating complex systems and processes can feel anything but seamless. \n\nBaptist Health, known for their dedication to patient satisfaction, understood this disconnect. They set out to transform the consumer experience and deliver the same quality support in consumers’ pre- and post-care journeys that they experience in their care appointments. It's not just a success story; it's a blueprint for the entire healthcare industry.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "G-0ZWE9HQLPQ",
            campaignName: "HLS ISSUE SPRING 2024",
            campaignLandingPageUrl:
              "https://brightr.io/brightr-magazine-hls-salesforce-2024",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Baptist Health Transforms Consumer Care with Health Cloud and Data Cloud",
            table: [
              {
                valueName: "Baptist Health",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Managed Service",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005Phi5MAC_tqVcstE-M",
            layout: "Layout 1",
            description:
              "<p>In a world where healthcare costs are soaring and consumers expect more than ever, Baptist Health took a bold step. Teaming up with Coastal, they embraced cutting-edge technology to make healthcare more effective, efficient, and proactive. They shifted to a consumer-centered approach, broke down departmental silos, and put prevention at the forefront. The outcome? Consumers are more engaged, operations run smoother, and providing quality care is easier and more proactive, which helps prevent more serious health issues down the road.</p>",
          },
          testimonialsData: [
            {
              industry: "Chief Consumer Officer",
              description:
                "“Coastal is not just a team of Salesforce Experts; they are true partners who understand our challenges and are working side-by-side with us to create the future of customer experiences in healthcare.”",
              author: "Melanie Husk",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzo_9WG7SLFgB",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHM_JiD0eurMH",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005QGPfMAO_2953YKmfY",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Managing Director",
              name: "Milissa Holland",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005GNQuMAO_B4sBPQmus",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Client Advisor",
              name: "Jacqueline Hebert",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005Ot5MMAS_xE2gw68Dz",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRmX_ogFIp3Q_H",
          storyId: "a00Nu000007GvXpIAK",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#323B52",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Baptist Health Transforms Consumer Care with Health Cloud and Data Cloud",
            teamSize: 10,
            paragraph2:
              "<p>In a world where healthcare costs are soaring and consumers expect more than ever, Baptist Health took a bold step. Teaming up with Coastal, they embraced cutting-edge technology to make healthcare more effective, efficient, and proactive. They shifted to a consumer-centered approach, broke down departmental silos, and put prevention at the forefront. The outcome? Consumers are more engaged, operations run smoother, and providing quality care is easier and more proactive, which helps prevent more serious health issues down the road.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005VYP7MAO_agTJ_VxJq",
            imgBanner:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005QUHJMA4_pspnGMzKw",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">Coastal partnered with Baptist Health to put consumers at the center of their pre- and post-care services to make healthcare more accessible and consumer-focused. Our solution? An integrated, multi-cloud Salesforce platform that helps Baptist connect and guide consumers to the right care at the right time over the lifetime of their healthcare journey. </p>\n<ul><li dir="ltr">\n<p dir="ltr"><strong>Health Cloud</strong>: Baptist Health leverages Health Cloud to deliver personalized care on consumers&#39; terms. Their omnichannel communication adapts to individual preferences for channels and timing, enhancing pre- and post-care experiences. Contact center and service line teams use these tools to speed up access to care, provide timely reminders, and deliver valuable health resources.</p>\n</li></ul>\n<ul><li dir="ltr">\n<p dir="ltr"><strong>Marketing Cloud</strong>: Baptist Health understands the importance of connecting with consumers on their terms. Through Marketing Cloud, they craft personalized campaigns and employ automated outreach across various channels, nurturing strong patient connections. Each campaign acts as a supportive guide, helping consumers navigate their healthcare journey and stay on course with their care plans. </p>\n</li></ul>\n<ul><li dir="ltr">\n<p dir="ltr"><strong>Data Cloud and MuleSoft</strong>: Coastal connected multiple data sources (electronic medical record (EMR) systems, Salesforce, consumer surveys) to reduce duplicates and build complete consumer profiles. This enables personalized communication and better coordination of care. </p>\n</li></ul>\n<ul><li dir="ltr">\n<p dir="ltr"><strong>Analytics</strong>: Baptist Health utilizes analytics to discover new segments of the consumer population, understand the effectiveness of their strategies, and track progress toward consumer goals.</p>\n</li></ul>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#000000",
          primaryfont: "Montserrat",
          primarycolor: "#FF895A",
          piHostname: "go.coastalcloud.us",
          piCId: "110521",
          piAId: "862531",
          missionData: {
            missionRichText:
              "Baptist Health is a not-for-profit organization owned by the community – not by shareholders. They are guided by a volunteer board of more than 85 engaged community leaders. Currently ranked as the “most preferred” health care provider in the Jacksonville area, Baptist Health is deeply honored to serve the community through a growing circle of care that includes five nationally accredited hospitals (including the region’s only children’s hospital) plus more than 200 primary care and specialty physician practices, children’s specialty clinics, home health care, behavioral health, occupational health, pharmacies, rehabilitation services and urgent care.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-09-26T15:54:43.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000007CIy2MAG_FFTwXUt_k",
            roiMoment:
              "With the new system humming, we tracked KPIs to measure the impact of the Salesforce implementation, with compelling results. Personalized messages sent at convenient times on consumers’ preferred channels increased patient visits, appointments, and loyalty. Automated tasks and unified systems streamlined workflows and slashed manual work. Appointment scheduling became faster, operations smoother, and overall efficiency soared. Baptist saw a 25% decrease in average wait time for bariatric surgery and a 200% increase in follow-up primary care appointment conversion rates. This data paints a clear picture: investing in the consumer experience delivers a measurable return on investment, benefiting both patients and Baptist Health. This success story wasn't an ending—it was a beginning. By laying a robust platform, Baptist Health and Coastal now have a springboard to explore new initiatives and make hope, healing, and well-being accessible to every person.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000007CJ65MAG_0MeqU9fFB",
            momentOfTrust:
              "Coastal is passionate about user adoption, but even the best-laid plans can encounter roadblocks. In Baptist Health’s comprehensive care model, stakeholders and users weren’t aligned around planned functionalities. We faced the delicate task of balancing intricate user workflows to ensure successful adoption while staying on track with the project's timeline and strategic goals. \n\nRecognizing the need for immediate action, Coastal proactively realigned the project. We revisited the scope, conducted additional user feedback sessions, and established clear communication channels among all stakeholders: users, Baptist Health leadership, and the Coastal team.\n\nOur flexible approach allowed us to adapt to user feedback and revise the plan. We collaborated closely with Baptist Health to create a revised roadmap that addressed everyone's needs while staying true to the strategic vision.",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000007CJAvMAO_pTdv1-hXC",
            introductionMoment:
              'Instead of a one-sided pitch, our initial meeting with Baptist Health was a collaborative spark that led to a trusted, long-term partnership. We listened deeply to stakeholders across the entire organization to understand their unique goals, challenges, and vision for a consumer-centered future. \n\nOur team translated their needs into an achievable roadmap that aligned multiple initiatives, systems, and departments. We didn\'t just talk possibilities; we showed them how Salesforce could deliver real results directly tied to their strategic objectives. We kept asking "why?" and focused on the impact, ensuring everything we delivered aligned with their vision.\n\nThis approach fostered trust and collaboration, setting the stage for a successful partnership to redefine consumer healthcare engagement for Baptist Health.',
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000007CJ9JMAW_G3H8IUwn_",
            eurekaMoment:
              "Imagine transforming how you interact with consumers—not just informing them but supporting them throughout their healthcare journey. That’s what we achieved with Campaign2Care, a groundbreaking approach that goes beyond awareness, connecting data seamlessly to personalize connection and engagement. By integrating multiple data sources (EMRs, insurance data, and more), we create a full patient profile, including their medical history, communication preferences, and even potential health risks. Baptist uses this data to understand consumers’ needs and preferences. They connect via people’s chosen platforms at their preferred times to reach them at the right moment in their care journey. Instead of raising awareness via general outreach, Baptist nurtures, qualifies, and supports consumers at every step from pre-care to post-care. Campaign2Care proves that innovative marketing can be integrated with healthcare, driving engagement, informed decision-making, and better healthcare outcomes.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu0000072a6dMAA_hvkOWNuGxO",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Health Cloud",
              "Marketing Cloud",
              "Data Cloud",
            ],
            Timeline: ["Managed Service"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Coastal"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Tech Consulting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription:
              "Book a meeting with Jacqueline Hebert, a Coastal Client Advisor for a quick intro session. We're keen on understanding your existing challenges and strategizing how our services can effectively align with your goals.",
            headshotUrl:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005Ot5MMAS_xE2gw68Dz",
            contactName: "Jacqueline Hebert",
            calendlyLink:
              "https://calendly.com/jacqueline-hebert/explore-salesforce-heathcare-solutions-w-coastal-cloud",
            bannerDescription:
              "to learn more about Salesforce innovation in Health Care",
          },
          bgcolor: "",
        },
        {
          website: "https://coastalcloud.us",
          valueSectionsData: [
            {
              heading: "Wounded Warrior Project Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "WWP's fundraising team is relentless in their pursuit of supporting veterans, but their previous systems couldn’t keep up with their vision. Despite their best efforts, siloed systems, and manual processes slowed them down. The team recognized that enhancing their systems would empower them to focus on what truly mattered—building relationships and securing the vital funding needed to amplify their impact on veterans' lives.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Amplifying Impact at Wounded Warrior Project",
            table: [
              {
                valueName: "Wounded Warrior Project",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Nonprofit",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "4",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AxjL9MAJ_BPcAy6VlO-",
            layout: "Original",
            description:
              "<p>Wounded Warrior Project® (WWP) is unwavering in its dedication to our nation&#39;s heroes. However, outdated systems were holding back WWP&#39;s fundraising potential and limiting the support it could provide to veterans. They turned to Coastal to transform it&#39;s fundraising operations.</p>",
          },
          testimonialsData: [
            {
              industry: "Chief Development Officer",
              description:
                '“Major gifts and planned giving are the most vital revenue channels for our future, and we needed to streamline our donor relationship management processes to maximize those relationships."',
              author: "Chris Needles",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4zYyEAJ_fXUbvASgkQ",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Carla Estey",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000B6AHoMAN_R33kUWonuJ",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Director",
              name: "Jen Malhotra",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000Ay4KkMAJ_Gj60ddwicO",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Managing Director",
              name: "Kathy Brown",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nryEAB_hpTimF7v_5",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Engagement Manager",
              name: "Brit Duhrkoff",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000B6AkjMAF_MPWSsN1rR",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRmX_ogFIp3Q_H",
          storyId: "a00Nu00000ENcpKIAT",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#323B52",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "Amplifying Impact at Wounded Warrior Project",
            teamSize: 10,
            paragraph2:
              "<p>Wounded Warrior Project® (WWP) is unwavering in its dedication to our nation&#39;s heroes. However, outdated systems were holding back WWP&#39;s fundraising potential and limiting the support it could provide to veterans. They turned to Coastal to transform it&#39;s fundraising operations.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000B6B0rMAF_ONDBToaH1k",
            imgBanner:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AxqT3MAJ_4ti3sIHx1",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">Coastal partnered with WWP to implement a tailored Salesforce solution to streamline and maximize the organization’s fundraising opportunities.</p>\n<ul><li dir="ltr">\n<p dir="ltr">Nonprofit Success Pack (NPSP): We supercharged their donor management with NPSP, creating a centralized hub to track supporter contributions and  interactions, as well as campaign performance. </p>\n</li><li dir="ltr">\n<p dir="ltr">Grant Management: We streamlined the entire grant lifecycle with the Grant Management module, from application to award. This ensured transparency, accountability, and made sure every dollar went further in supporting wounded, ill and injured veterans.</p>\n</li><li dir="ltr">Data Integration and Analytics: We integrated their many data sources, including their legacy marketing system. This gave WWP a 360-degree view of their donors, fueled by real-time dashboards and powerful analytics. Now, they have the insights to make smarter decisions and build even stronger relationships.</li></ul>\n<p dir="ltr"> </p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#000000",
          primaryfont: "Montserrat",
          primarycolor: "#FF895A",
          piHostname: "go.coastalcloud.us",
          piCId: "110521",
          piAId: "862531",
          missionData: {
            missionRichText:
              "Wounded Warrior Project® (WWP)  is a nonprofit organization for veterans and active-duty service members. Since 2003, WWP has been meeting the growing needs of warriors, their families, and caregivers—honoring those who serve by helping them achieve their highest ambitions. Through WWP’s direct programs in mental health, career counseling, and long-term rehabilitative care, along with their advocacy efforts, they improve the lives of millions of warriors and their families.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-09-10T13:29:03.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BiYHTMA3_VWk35j0iL",
            roiMoment:
              "The Salesforce solution didn’t just make things easier; it transformed WWP’s entire fundraising landscape. Automation and centralized data gave the team back valuable time, allowing them to focus on what they do best—building relationships and securing crucial funding. Real-time dashboards and reports provided clarity and confidence, offering the insights needed to make data-driven decisions and implement smarter strategies. Personalized communication strengthened connections with donors, creating a community of passionate supporters. This success story goes beyond numbers; it’s about real people. It’s about empowering WWP to expand its reach, provide more comprehensive support to veterans, and ensure that its mission thrives.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BV3jGMAT_Yy1t9V-7B",
            momentOfTrust:
              "We earned WWP's trust by prioritizing what mattered most: improving donor management, optimizing fundraising campaigns, and delivering actionable insights. Our solution? Implementing Salesforce Nonprofit Success Pack—a powerful tool built for nonprofits—to supercharge WWP’s fundraising efforts.",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BV4sEMAT_QUI3KnZnp",
            introductionMoment:
              "Our journey with WWP started with a simple conversation, but it quickly became clear that we shared a passion for making a difference. We listened closely to their challenges and aspirations, understanding the heart of their mission. This connection laid the groundwork for a relationship built on trust and a shared commitment to empowering veterans and doing work that matters.",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BiPh7MAF_6a5p_-G7L",
            eurekaMoment:
              "The real magic happened when WWP's fundraising team saw Salesforce's true potential. It wasn't just about managing data; it was about building deeper, more meaningful relationships with their donors. By centralizing information and interactions, they gained a 360-degree view of each supporter, allowing for personalized communication and engagement. This newfound ability to connect on a human level sparked a wave of excitement and innovation.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu0000072a6dMAA_hvkOWNuGxO",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce NPSP"],
            Timeline: ["Over 2 Years"],
            Budget: [null],
            Industry: ["Nonprofit"],
            Company: ["Coastal"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Tech Consulting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription:
              "Empower your nonprofit to achieve more. Book a meeting with Giancarlo Susi, Coastal's nonprofit business development rep, for a quick intro session. Let’s discuss how we can help your nonprofit enhance donor management, streamline operations, and create lasting impact for the communities you serve.",
            headshotUrl:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EaDajEAF_Q3LeudI_W",
            contactName: "Giancarlo Susi",
            calendlyLink:
              "https://calendly.com/giancarlo-susi-coastalcloud/explore-salesforce-nonprofit-solutions-w-coastal",
            bannerDescription:
              "See why we're the #1 rated Salesforce consultancy.",
          },
          bgcolor: "",
        },
        {
          website: "https://coastalcloud.us",
          valueSectionsData: [
            {
              heading: "Emory Healthcare Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Emory was being forced to migrate to a different platform that was not Salesforce. This meant that Coastal Cloud had to launch the solution before the end of their contract with their previous partner.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Emory Healthcare",
            table: [
              {
                valueName: "Emory Healthcare",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "5",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E56lbEAB_edQs0s1VB",
            layout: "Original",
            description:
              "<p>Emory Healthcare was using an older version of a Salesforce Healthcare app, and needed to unlock the power of Salesforce Clouds. In just ten weeks, Coastal Cloud migrated 75 million records and in 17 weeks, they implemented Health Cloud, Marketing Cloud, CRM Analytics, and Dataroma.</p>",
          },
          testimonialsData: [
            {
              industry: "Director, Marketing Technology & Operations",
              description:
                '"Coastal Cloud has been phenomenal on a big project with a tight turnaround. Their project management processes and discipline are stellar, and they quickly grasped our requirements and goals to help us design and build our solution. Highly recommend this group.”',
              author: "Denise Davis",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzo_9WG7SLFgB",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nV9EAJ_uEIy-Jjjc",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHM_JiD0eurMH",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIU_3ooetW_xT",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Director",
              name: "Anthony Campea",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nq0EAB_7c6QgPIP9T",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Matthew Delello",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4sIZEAZ_i64EkXmgK",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Technical Architect",
              name: "Yogi Deshmukh",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4noIEAR_fDXC1bbEV",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Cristina Rodriguez",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nvHEAR_vkb3HHcXr",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Paul Proffit",
              index: 5,
              dpSrc: "",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRmX_ogFIp3Q_H",
          storyId: "a006g00000o7LchAAE",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#323B52",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "Emory Healthcare",
            teamSize: 0,
            paragraph2:
              "<p>Emory Healthcare was using an older version of a Salesforce Healthcare app, and needed to unlock the power of Salesforce Clouds. In just ten weeks, Coastal Cloud migrated 75 million records and in 17 weeks, they implemented Health Cloud, Marketing Cloud, CRM Analytics, and Dataroma.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000003FyT1_0_dd-UFWX",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p><strong>Challenge</strong></p>\n<p>For Emory Healthcare, contact information (physicians, consumers, and leads) were segmented from engagement tools. These processes were managed and stored in disparate systems, leading to duplications and inaccuracies. The Emory Healthcare Team needed to unlock the full native capabilities of Salesforce Health Cloud and Marketing Cloud all while migrating away from legacy platforms. For this, mapping and migration required expert knowledge of Health Cloud and deep experience in data migration and architecture. In addition, following migration efforts, Emory Healthcare desired to see immediate ROI and actionable insights in Datorama and CRM Analytics.</p>\n<p><strong>Solution</strong></p>\n<p>Coastal Cloud used their deep experience in Salesforce Health Cloud and their proven rapid data migration ISV applications to map, clean, and migrate all of Emory Healthcare&#39;s data. After populating Salesforce Health Cloud and directly integrating the organization’s EMR and other external data systems, analytics were launched in Datorama and CRM Analytics to visualize trends and take action. Emory Healthcare relaunched effective legacy email marketing and webform campaigns and created new journeys for newly discovered targeted, high-ROI segments. Finally, contribution Margin metrics were tracked in each service line, ensuring a full-ROI picture for leadership analysis and strategic action.</p>\n<p><strong>Results</strong></p>\n<p>Now, Emory Healthcare has consolidated platforms, providing a single source of data to drive marketing outreach and analytics. In ten weeks, Coastal Cloud migrated 75 million records. In 17 weeks, Coastal Cloud implemented Health Cloud, Marketing Cloud, CRM Analytics, and Datorama. Over 125+ marketing webforms were created and submissions are instantly matched with consumer records in Salesforce, painting a full picture of the patient. Webform submissions are categorized by service line to calculate marketing ROI, allowing business leaders to make informed decsions. Emory Healthcare has already been able to realize their goals for ROI by Campaign in actual revenue by patient and procedure, running their 1st Annual Wellness Campaign and driving 810 new appointments! </p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#000000",
          primaryfont: "Montserrat",
          primarycolor: "#FF895A",
          piHostname: "go.coastalcloud.us",
          piCId: "110521",
          piAId: "862531",
          missionData: {
            missionRichText:
              "As the only health network in Georgia that brings together a full range of hospitals, clinics, and local practices, Emory Healthcare is committed to providing patients and families with better, more collaborative care for all of their medical needs.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E57geEAB_ptTRN_sw3",
            roiMoment:
              "The ROI Moment occurred when Jenni Ellia, a Business Intelligence Architect, built a Marketing Impact Dashboard and presented it to Emory. The team was ecstatic. They couldn't believe the insights the dashboard provided and the possibilities that came with it. From there on out, the Marketing Team could make informed, data-driven decisions and adjust their tactics surrounding campaigns due to these insights. They could see in real time the efforts which were successful and the efforts that needed work, saving them valuable budget. It was then that Emory fully realized the value of Coastal Cloud's work.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E57hNEAR_h2gdX1MYs",
            redMoment:
              'The "Red Moment" in this project occurred half way through the timeline. Both parties were showing discrepancies with the hours burned and the hours that remained. Coastal Cloud diligently dug deep into the details - keeping limited budgets in mind. The full audit was successful, identifying that the project was in fact on track and the project was able to continue under budget. Both parties maintained a strong relationship throughout the entirety of the audit, and still remains strong today.',
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E57ZKEAZ_dFNZFrpfq",
            momentOfTrust:
              "The Moment of Trust between Emory Healthcare and Coastal Cloud occurred very early on - at the RFP readout. A call originally scheduled for an hour and a half, ended up being two hours due to the conversation that occurred. On the call, Coastal Cloud's very own CTO (who is a former CTO of a hospital) was able to dig into Emory's systems, actually showing the key stakeholders the unique possibilities due to his level of expertise in the industry. By diving into the solution, instead of talking about it, the CTO was able to demonstrate Coastal Cloud's competence with the solution. Rather than a demo-type presentation, the call was a strategic conversation which allowed Emory to trust Coastal Cloud before any official documents were signed. From the get-go, Coastal Cloud had Emory's trust in the massive project that was to follow.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu0000072a6dMAA_hvkOWNuGxO",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Marketing Cloud",
              "Salesforce Health Cloud",
              "Datorama",
              "Tibco Scribe - CCI for Data Migration",
            ],
            Timeline: ["5-7 Months"],
            Budget: [null],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Coastal"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Tech Consulting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
        {
          website: "https://coastalcloud.us",
          valueSectionsData: [
            {
              heading: "Pure Fishing Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Pure Fishing's outreach had grown so large, it was time for a sophisticated, robust solution.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Pure Fishing",
            table: [
              {
                valueName: "Pure Fishing",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Retail",
                keyName: "INDUSTRY",
              },
              {
                valueName: "7-12 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "9",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4mj0EAB_ZW0JL20X-",
            layout: "Original",
            description:
              '<p dir="ltr">Pure Fishing, one of the world&#39;s largest makers of fishing tackle, ultimately wanted to improve ordering usability and streamline sales &amp; order management processes in order to support the business and their more than 15,000 retailers in 20 countries. They manufacture about 30,000 different types of bait, fishing lures, rods, reels, and lines. </p>\n<p> </p>',
          },
          testimonialsData: [
            {
              industry: "Director of Customer Experience Operations",
              description:
                '"The folks at Coastal Cloud are truly top tier. They tackled this large Salesforce B2B Commerce project with experience, professionalism, and a great work ethic. They’re a great team to work with, and we trust them to deliver the best Salesforce solution available."',
              author: "Steve Harris",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZQfa_9HBaGOu3U",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHH_Z6jdSn4K2",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Seth Maxwell",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4npuEAB_VgjKOfGwQ0",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Managing Director",
              name: "Brian Gannuscio",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4sJNEAZ_y97cRSGhW",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Erica Champine",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nqOEAR_coWpKoWP6_",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Muhammad Usman",
              index: 4,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Cristina Rodriguez",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nvHEAR_vkb3HHcXr",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Consultant",
              name: "Nancy Brown",
              index: 6,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nqEEAR_d_aH8st6d",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Database Developer",
              name: "Matt Parrella",
              index: 7,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nsDEAR_R61N8BPKr",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Database Developer",
              name: "Arsee Khan",
              index: 8,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nv7EAB_RRAVzlT_p",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Rob West",
              index: 9,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nuCEAR_2e1ECCwSE",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRmX_ogFIp3Q_H",
          storyId: "a006g00000o7NYoAAM",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#323B52",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "Pure Fishing",
            teamSize: null,
            paragraph2:
              '<p dir="ltr">Pure Fishing, one of the world&#39;s largest makers of fishing tackle, ultimately wanted to improve ordering usability and streamline sales &amp; order management processes in order to support the business and their more than 15,000 retailers in 20 countries. They manufacture about 30,000 different types of bait, fishing lures, rods, reels, and lines. </p>\n<p> </p>',
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5W5eEAF_tFd5Vi3RA",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p><strong>Challenge</strong></p>\n<p dir="ltr">Ultimately, Pure Fishing wanted to improve ordering usability and streamline sales and order management processes in order to support the business and their more than 15,000 retailers in 20 countries. Pure Fishing set out to provide sales teams with insights into inventory, a simplified order entry system, and integration with downstream systems to automate order fulfillment while also providing a platform that will enable a 360 degree view of their customer.</p>\n<p><strong>Solution</strong></p>\n<p dir="ltr">Coastal Cloud replaced Pure Fishing’s legacy system with Salesforce B2B Commerce for US and Canada based customers. This provided a highly efficient user experience for this region, with plans to expand the solution to Asian and European clients. Mulesoft was introduced to streamline integration in order to form a cohesive, unified system involving tax information, freight calculations, price data and more</p>\n<p><strong>Results</strong></p>\n<p dir="ltr">As a result, the customers of Pure Fishing now enjoy a more user-friendly ordering experience entirely online via Salesforce B2B Commerce. Salesforce’s unified platform allows a massive amount of data to come together into a single, 360 degree view - no matter the size of the client. Sales Reps&#39; ordering plaform is now seperate from that of the customers&#39; which shows leadership segmented and more specific data. Coastal Cloud launched a fully functioning North American site in 4 months and continues to receive feedback from Pure Fishing to iterate new versions of the solution in order to maximize its success based on Pure Fishing’s needs. </p>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#000000",
          primaryfont: "Montserrat",
          primarycolor: "#FF895A",
          piHostname: "go.coastalcloud.us",
          piCId: "110521",
          piAId: "862531",
          missionData: {
            missionRichText:
              "Pure Fishing is one of the world's largest makers of fishing tackle. It manufactures about 30,000 different types of bait, fishing lures, rods, reels, and lines under brand names including Abu Garcia, All Star, Berkley, Mitchell, Fenwick, SpiderWire, Trilene, and Gulp!, among others.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5B3UEAV_E7nn7ajck",
            roiMoment:
              "It was clear that Coastal Cloud had delivered a valuable solution to Pure Fishing when the Sales Reps had a separate ordering platform. This meant that partners had a simplified UI for ordering, right alongside the rest of their CRM data.\n Pure Fishing also got a fully functioning site after 4 months of work, and 3 fully working sites after nearly a year of work.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5B3eEAF_DkQ0b432X",
            introductionMoment:
              "The Pure Fishing relationship emerged from a Coastal Cloud employee's personal network. A previous employer was looking for a Salesforce Partner who could implement B2B Commerce and Mulesoft. The Coastal Cloud/ Pure Fishing relationship kicked off with a simple text message and has produced four more accounts for Coastal Cloud.",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: true,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu0000072a6dMAA_hvkOWNuGxO",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Commerce Cloud - B2B",
              "Salesforce Sales Cloud",
              "Salesforce Service Cloud",
              "MuleSoft",
            ],
            Timeline: ["7-12 Months"],
            Budget: [null],
            Industry: ["Retail"],
            Company: ["Coastal"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Tech Consulting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
        {
          website: "https://coastalcloud.us",
          valueSectionsData: [
            {
              heading: "Vibrant Emotional Health Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "In response to the world's current challenges, the Substance Abuse and Mental Health Services Administration (SAMHSA) bestowed a grant upon Vibrant Health to create a unified call center and CRM specifically for 988 users.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Vibrant Emotional Health - National Suicide Hotline 988",
            table: [
              {
                valueName: "Vibrant Emotional Health",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Nonprofit",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "8",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E54tmEAB_uQBTFKeNU",
            layout: "Original",
            description:
              "<p>The end goal of this project is a fully unified CRM for the 988 National Suicide Prevention Lifeline to support daily operations and functions for crisis centers including safety assessment call flow, capturing data, safety plans, referrals, managing follow ups, tracking emergency rescues, reporting and data, and quality assurance reviews. </p>",
          },
          testimonialsData: [
            {
              industry: "",
              description:
                '"We are so grateful for Coastal Cloud. In the midst of so many moving parts, you all were the steady state-  delivering on time, thinking ahead and planning, being responsive, and always having a positive attitude. You are our chosen and recommended implementation partner for the future of all 988 implementations."',
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHM_JiD0eurMH",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Managing Director",
              name: "Kathy Brown",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nryEAB_hpTimF7v_5",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Meagan Brumbelow",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4noDEAR_wjrSG5TTO",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "April Smith",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nowEAB_ln-9LN6wTC",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Beth Williams",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nomEAB_Z92E_UrUV",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Technical Architect",
              name: "Andrew Mann",
              index: 5,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Ember Feuhrer",
              index: 6,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nocEAB_kRjwC7sP1W",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Director",
              name: "Becky Wagner",
              index: 7,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nqeEAB_N3wdFpRr3r",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Technology Officer",
              name: "Jim Stalder",
              index: 8,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4nqvEAB_uxO8VEWvy",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRmX_ogFIp3Q_H",
          storyId: "a006g00000o7NscAAE",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#323B52",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "Vibrant Emotional Health - National Suicide Hotline 988",
            teamSize: null,
            paragraph2:
              "<p>The end goal of this project is a fully unified CRM for the 988 National Suicide Prevention Lifeline to support daily operations and functions for crisis centers including safety assessment call flow, capturing data, safety plans, referrals, managing follow ups, tracking emergency rescues, reporting and data, and quality assurance reviews. </p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000003FySw_i2xKVBeL2b",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p><strong>Challenge</strong></p>\n<p>The Substance Abuse and Mental Health Services Administration granted funds to Vibrant Health to put together a unified platform for all 988 users. Previously a 1-800 number, 988 is the emergency number in the United States for suicide crisis. This was a massive challenge due to the fact that many crisis centers around the country were being operated by differing entities. Some were run by state governments, others by community centers. Additionally, each center ran their operations in different ways. Some used Salesforce, others not. A unified CRM was necessary so that the caller, the counselor, the case reviewer, and everyone in between, had access to the same platform and information. It needed to have an improved User Interface, a better way to document information, and a way to provide resources to callers in their area.</p>\n<p><strong>Solution</strong></p>\n<p>Phase I included an implementation of Salesforce Service Cloud and Salesforce Health Cloud. Service Cloud Console provides a way for counselors to receive calls, document notes, manage and schedule follow ups and provide resources. </p>\n<p><strong>Results</strong></p>\n<p>So far, counselors across the country see an intuitive and uniform User Interface. It is more streamlined than before and has significantly improved the documentation process - allowing the counselor to focus more on the callers&#39; care plan. There is more access to resources directly in Salesforce, ultimately allowing crisis counselors to do their job better and SAVE LIVES!</p>\n<p> </p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#000000",
          primaryfont: "Montserrat",
          primarycolor: "#FF895A",
          piHostname: "go.coastalcloud.us",
          piCId: "110521",
          piAId: "862531",
          missionData: {
            missionRichText:
              "For 50 years, Vibrant Emotional Health has been at the forefront of promoting emotional well-being for all people. As leaders, advocates, educators, and innovators in mental health, they have been raising awareness and offering support to everyone who is struggling. They work every single day to help save lives and assist people to get care anytime, anywhere and in any way that works for them. They are unwavering in their belief that everyone can achieve emotional wellness with the right care and support.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5B1JEAV_6xSkIOOK6",
            ribbonCuttingMoment:
              "In addition to Coastal Cloud's standard GoLive processes, the Vibrant Health 988 project team was prepared with over 7,000 test scripts. They also deployed ahead of schedule, allowing for plenty of time to iron out any bugs. They crafted intensive training sessions and provided detailed materials. The importance of this project cannot be overstated. With so many lives at stake, Coastal Cloud came to the Ribbon Cutting as prepared as possible in order to show up for those using the crisis hotline.",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5B0uEAF__2J38AUAS",
            momentOfTrust:
              'Working on an intense project where lives are at risk, it\'s natural for people to become close. Both teams were fully invested in finding the best solution due to the magnitude of people this project will impact. Considering this, the teams developed a significant amount of trust with one another through each major milestone. There was an "in the trenches" comradery that developed, but it only grew when Coastal Cloud delivered under every tight timeline and difficult circumstance. Trust peaked when the lead Solution Architect, Ember Feuhrer, showed a demo of the solution, validating that she fully grasped every single process of the 988 team. This was far more valuable than a hypothetical conversation and was a pivotal moment in the project.',
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu0000072a6dMAA_hvkOWNuGxO",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Health Cloud",
              "Salesforce Service Cloud",
            ],
            Timeline: ["5-7 Months"],
            Budget: [null],
            Industry: ["Nonprofit"],
            Company: ["Coastal"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Tech Consulting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
        {
          website: "https://coastalcloud.us",
          valueSectionsData: [
            {
              heading: "Link-Belt Excavators Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Multiple inefficiencies in the Lead to Order process required manual intervention, in turn, this drove friction into the Dealer purchasing process by lengthening deal cycles. There was no single “Source of Truth'' that aggregated Whole Goods ordering, Parts ordering and Service Request information across the enterprise making it difficult for Dealers and internal LBX resources to get a holistic view of all Dealer and Customer sales and service activities. This fragmented Dealer experience put LBX at a competitive disadvantage and drove friction into the Sales and Service experiences. Disjointed systems meant that driving analytics used for making data driven business decisions was costly, time consuming, inefficient and difficult.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Link-Belt Excavators",
            table: [
              {
                valueName: "Link-Belt Excavators",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Manufacturing",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "6",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EaCSqEAN_0JLdZcT4U",
            layout: "Original",
            description:
              "<p>Due to Coastal Cloud&#39;s experience with other manufacturing clients in the the dealer/ distributor model, LBX selected to work with Coastal Cloud to digitally transform their high-touch, disconnected system.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHH_Z6jdSn4K2",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000STQf_3E03X8xi0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIK_f96dEnyTsD",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzo_9WG7SLFgB",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Revenue Officer",
              name: "Erik Dunnigan",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EaDdxEAF_7PhKIZ4jj",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "David West",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EaDZREA3_jjZuuYvWe",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Jake Yamane",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EaDa0EAF_5Suj0nrds",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Data Engineer",
              name: "Vanessa Peters",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EaDZqEAN_4KrTh9w8wb",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Consultant",
              name: "Giancarlo Susi",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EaDajEAF_Q3LeudI_W",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consultant",
              name: "Ethan Hall",
              index: 6,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EaDbhEAF_SarWYUabkA",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRmX_ogFIp3Q_H",
          storyId: "a006g00000o8RmfAAE",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#323B52",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "Link-Belt Excavators",
            teamSize: 0,
            paragraph2:
              "<p>Due to Coastal Cloud&#39;s experience with other manufacturing clients in the the dealer/ distributor model, LBX selected to work with Coastal Cloud to digitally transform their high-touch, disconnected system.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EaCGAEA3_BbDLWas-V",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr"> </p>\n<ul><li dir="ltr">\n<p dir="ltr">Coastal Cloud&#39;s experts completed a deep-dive review of LBX&#39;s processes around Dealer acquisition and onboarding, Account Management, Lead acquisition, Sales and Service processes as well as the Dealer Online experience. A strategic roadmap was recommended which took the form of a phased implementation approach. The design outlined a  Multi-Cloud Salesforce based solution coupled with best practices to drive efficiencies into the Account Management, Lead acquisition, Sales and Service process and revamp the Dealer online experience at the same time. Today, dealer engagement has been enhanced by providing a rules-based platform that drives simplicity and accuracy into the product Ordering process. Aftermarket Parts, Machine Whole Goods orders and post-sales Service activities are being converge on to a single Salesforce platform enabling a comprehensive “single source of Truth” system of engagement for Dealer activities. Consolidated CRM, Sales and Service data will enable business leaders to quickly and easily access analytics to drive decision making across multiple segments of the business.</p>\n</li></ul>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#000000",
          primaryfont: "Montserrat",
          primarycolor: "#FF895A",
          piHostname: "go.coastalcloud.us",
          piCId: "110521",
          piAId: "862531",
          missionData: {
            missionRichText:
              "The Link-Belt brand name dates back to 1874 and is synonymous with innovative designs that incorporate the highest quality and best product support in the industry. Formerly a division of the Link-Belt Construction Equipment Company, LBX Company became a stand-alone company in 1998 representing the Link-Belt excavator, forestry, and material handling equipment lines.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EXtFmEAL_7_XaO6cCA",
            redMoment:
              'LBX and Coastal Cloud have built a true partnership. Navigating the natural challenges of "change" that come with a digital transformation such as this, brought both parties even closer together. Both teams learned that it is vital to not only communicate with the IT department, but the business teams as well. It is essential that every stakeholder is on the same page to execute a successful implementation.',
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EXtFrEAL_i8w5NNsTd",
            momentOfTrust:
              "LBX maintained a relationship with one of Coastal Cloud's previous manufacturing clients. A similar digital transformation project had been undertaken for them and resulted in efficiency gains along with cost savings across the same business segments as LBX was looking to optimize. This provided an immediate foundation for a mutual connection and trust. The results from the deep dive analysis and recommendations resonated with LBX Senior Leadership further demonstrating that Coastal Cloud was the right partner to engage in this digital transformation effort.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu0000072a6dMAA_hvkOWNuGxO",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Sales Cloud",
              "Salesforce Service Cloud",
              "Salesforce Commerce Cloud - B2B",
              "Salesforce Experience Cloud",
              "CPQ - Configure, Price, Quote",
              "Marketing Cloud",
            ],
            Timeline: ["Over 2 Years"],
            Budget: [null],
            Industry: ["Manufacturing"],
            Company: ["Coastal"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Tech Consulting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu0000072a6dMAA_hvkOWNuGxO",
      fav_image: "",
      contact_us: "https://coastalcloud.us/contact/",
      account_description: "Tech Consulting",
    },
    {
      title: "Orion Global Solutions",
      teamId: "0016g00002OC3V0AAL",
      stories: [
        {
          website: "https://www.orion-gs.com/",
          valueSectionsData: [
            {
              heading: "EG Culture",
              description:
                "In a word: teamwork. EG places a very high priority on building teams of smart innovative people that work together as a group. In that spirit, Orion is proud it was able to integrate its team so well with the remarkable team from EG.",
            },
            {
              heading: "Why Now",
              description:
                "EG had store sales and related problems it couldn't solve by just hiring more people. Or even  by making better products - they were aware that the relevant technical infrastructure was failing to the point of being partly unusable.",
            },
            {
              heading: "Other Things to Note",
              description:
                "This story is about a project that will become phase 1 of a multi-year engagement. Because that phase went well for both teams, they continue to work together. For that reason, Orion doesn't reveal \"EG's\" actual name in this story.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "A Global Vision: Orion and EG Set a New Standard for the Consumer Goods Cloud",
            table: [
              {
                valueName: "EG",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Consumer Goods",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over a year",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5kQtEAJ_SfYZsCet32",
            layout: "Original",
            description:
              "<p>Global consumer electronics giant EG faced a series of unexpected challenges to its US market share. To address them, they turned to a pioneer of the consumer goods cloud, Salesforce consultancy Orion Global Solutions.  The result was across-the-board innovation in revenue operations, as well as a transformational technology strategy that will impact EG&#39;s business for years to come. Along the way, the project teams at Orion and EG gained a deep appreciation for EG&#39;s customers, its workers, and one another.</p>",
          },
          testimonialsData: [
            {
              industry: "Senior Manager of Store Operations",
              description:
                "\"Working with Orion has been a blessing in every sense and I am frankly amazed at what they have achieved so far. I'll be honest, I was skeptical at first that a boutique firm like Orion could tackle the immensity of the problems we had. And honestly I am always skeptical of cloud transformation vendors . But their reputation in working with Panasonic and others like them was obviously well deserved. They are much more than a technology vendor, they are a strategy consultancy and there impact here has been huge - it's just made so many people's jobs easier, inside and outside of EG.\"",
              author: "- Chris N. ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSI0_f3yqA6PFOl",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzj_AKaowdOPIz",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/peter-breglio-pmp-35501227/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Business Analyst",
              name: "Peter Breglio",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZLgNEAX_pHiV0Q0pa",
            },
            {
              serviceLink: "https://www.linkedin.com/in/danfarrugia/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Dan Farrugia",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5j5LEAR_F71hF6BUuX",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/yacov-wrocherinsky-30995/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Yacov Wrocherinsky",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5j3tEAB_Jb__10slq",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZC5UEAX_4MmgbF4Mf",
          storyId: "a006g00000o7p8LAAQ",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#4F4D4D",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "A Global Vision: Orion and EG Set a New Standard for the Consumer Goods Cloud",
            teamSize: null,
            paragraph2:
              "<p>Global consumer electronics giant EG faced a series of unexpected challenges to its US market share. To address them, they turned to a pioneer of the consumer goods cloud, Salesforce consultancy Orion Global Solutions.  The result was across-the-board innovation in revenue operations, as well as a transformational technology strategy that will impact EG&#39;s business for years to come. Along the way, the project teams at Orion and EG gained a deep appreciation for EG&#39;s customers, its workers, and one another.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZAzEEAX_UQFhX6b5N",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p><span style="font-size: 10pt;">[Author&#39;s note: in honor of an NDA with the client, EG is a psuedonym as are the names of EG employees in this story]</span><br><br>EG products are marketed in almost every country worldwide. Their devices and appliances reflect the rapid changes in how millions live their lives. As the CEO of EG, North America has said: &quot;EG innovates products that customers never knew they needed&quot;. </p>\n<div class="w-full border-b border-black/10 dark:border-gray-900/50 text-gray-800 dark:text-gray-100 group bg-gray-50 dark:bg-[#444654]">\n<div class="text-base gap-4 md:gap-6 m-auto md:max-w-2xl lg:max-w-2xl xl:max-w-3xl p-4 md:py-6 flex lg:px-0">\n<div class="relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]">\n<div class="flex flex-grow flex-col gap-3">\n<div class="min-h-[20px] flex flex-col items-start gap-4 whitespace-pre-wrap">\n<div class="markdown prose w-full break-words dark:prose-invert dark">\n<p>This approach had long served EG well but in the largest market, the US, EG had lost momentum towards the end of the 2010&#39;s. Competition from rivals like Samsung and new entrants like TCL were pressuring EG market share. Product lines like flat-screen TVs had begun to falter. Then the pandemic undercut sales of EG smartphones and other handheld devices. But that wasn&#39;t all.</p>\n<p> </p>\n<p><span style="color: rgb(0, 0, 0);"><strong>The Big Problem</strong></span></p>\n<p>The bigger problem had its root in technology strategy. This became clear after a round of meetings with two senior executives at EG - Bob Lee, CSO for EG North America, and Deborah Bauman, GM of Sales Operations North America. As both Deborah and Bob hinted at, a veil of uncertainty had descended over the company. <br><br>EG had begun to struggle to answer questions it was used to mastering:</p>\n</div>\n</div>\n</div>\n<div class="flex justify-between">\n<div class="text-gray-400 flex self-end lg:self-center justify-center mt-2 gap-3 md:gap-4 lg:gap-1 lg:absolute lg:top-0 lg:translate-x-full lg:right-0 lg:mt-0 lg:pl-2 visible">\n<ul><li>How can we verify that our products are on the store shelves they&#39;re supposed to be on?</li><li>Retail CX - how do customers actually look at, touch, hold, and choose an EG device or appliance in the store?</li><li>Can we ensure (and measure) that store workers can explain EG product benefits to shoppers?</li><li>How is the way that customer shop for EG products changing?</li><li>How can EG work with stores and retail execution agencies to get the &quot;sell-through&quot; data EG executives need to make decisions?</li></ul>\nNot being able to answer questions like these was a problem for EG, as it values listening to and understanding customers.<br><br></div>\n<div class="text-gray-400 flex self-end lg:self-center justify-center mt-2 gap-3 md:gap-4 lg:gap-1 lg:absolute lg:top-0 lg:translate-x-full lg:right-0 lg:mt-0 lg:pl-2 visible"> </div>\n<div class="text-gray-400 flex self-end lg:self-center justify-center mt-2 gap-3 md:gap-4 lg:gap-1 lg:absolute lg:top-0 lg:translate-x-full lg:right-0 lg:mt-0 lg:pl-2 visible"><span style="color: rgb(0, 0, 0);"><strong>The Investigation</strong></span><br><br>The Orion team considered these issues, comparing them with their own experience with similar clients (Panasonic, Toshiba, etc). Further probing led by Orion&#39;s Dan Farrugia uncovered specific issues in the Eastern US region alone, such as:</div>\n<div class="text-gray-400 flex self-end lg:self-center justify-center mt-2 gap-3 md:gap-4 lg:gap-1 lg:absolute lg:top-0 lg:translate-x-full lg:right-0 lg:mt-0 lg:pl-2 visible">\n<ul><li>More than a hundred field service reps capturing daily activity in completely disconnected systems</li><li>An expensive voice/video/text communication solution only partially used, and poorly integrated with the rest of EG&#39;s sales operations tech stack</li><li>The people managing &quot;retail execution&quot; operations not knowing what staff was doing during the day - or even where they were, from among 100s of possible retail locations</li><li>Managers with almost no visibility into metrics being collected from staff members from in-store visits and from meetings with store representatives</li><li>Store performance and product &quot;sell-through&quot; information collected from <em>some</em> retail chains and not others, from <em>some</em> stores and not others, and in wildly incompatible data formats</li></ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n<p>Problems like these made Orion&#39;s unique expertise in cloud technology and consumer goods attractive to EG. Led by CRM pioneer Yacov Wrocherinsky and senior consultant Dan Farrugia, Orion designed and executed a transition to the consumer goods cloud that would address every single one of these issues and many more. <br><br></p>\n<p><span style="color: rgb(0, 0, 0);"><strong>Salesforce Consumer Goods Cloud (SCGC)</strong></span></p>\n<p>Specifically, this meant designing an implementation of Salesforce Consumer Goods Cloud. Orion was well equipped for this - we&#39;d had provided product design guidance on SCGC to Salesforce product managers; we knew the technology intimately. SCGC served as a foundation allowed for many optimizations and innovations for EG. Among them:</p>\n<ul><li>Better tracking of daily activities on mobile devices, so retail execution staffers in-store &quot;retail execution&quot; activities were better understood</li><li>A new approach to &quot;planograms&quot; allowing interactive and dynamic cloud-based store mapping (we call them &quot;cloud planograms&quot;)</li><li>Consolidating hundreds of reports and tools off of Excel and local computers to the  cloud, using both OOB Salesforce solutions and custom-built solutions</li></ul>\n<p>But Orion took EG deeper than improvements to daily logistics execution.<br><br>Firstly it, it helped integrate call-center software Bright Pattern with EG&#39;s new consumer goods cloud. It also helped them transition off older legacy tools like SPOT out of the EG tech stack.<br><br></p>\n<p><span style="color: rgb(0, 0, 0);"><strong>Getting Re-Acquainted With the Customer</strong></span><br><br>More importantly, Orion helped EG with the big picture: getting back in touch with the customer. It did this partly by using Einstein Analytics and Tableau CRM to evaluate retail behavior from 1000s of independent data sources - this has helped EG to make better real-time decisions and also to re-evaluate longer terms retail and product strategies.<br><br>Orion&#39;s work has already moved the needle for EG. It&#39;s also set the stage for an even deeper EG engagement, which will lean into Tableau and facilitate an full-ecosystem integration with one of the &#39;Big 3&#39; cloud providers.<br><br></p>\n<p><span style="color: rgb(0, 0, 0);"><strong>Striving For Positive Impact</strong></span><br><br>Already, this project has revealed what the concept of consumer goods cloud can do - positively impact the working lives of thousands of employees and millions of consumers around the world. From there, it can help create impact in local communities around the world where a firm like LG does business. <br><br>Orion is grateful to EG for their partnership and for letting them show the world how the industry can evolve towards this new paradigm.</p>\n<p> </p>\n<p> </p>\n<p><br><br></p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#4F4D4D",
          primaryfont: "Montserrat",
          primarycolor: "#66B6FE",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText: ".",
          },
          metadataname:
            "Global vision: How Orion is leading the consumer goods cloud revolution",
          metadatadescription:
            "From problem to solution to people: How Orion uses Salesforce Consumer Goods Cloud to one of the world's top 5 consumer goods manufacturers to finally capitalize on the transformational potential of the cloud.",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-09-26T15:53:37.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZIIzEAP_7C3fkGHRH",
            roiMoment:
              "Up above, we described the \"Ribbon Cutting Moment\" as the moment you pat yourself on the back but get back to work - that's because what the real cause for celebration is when there's proof of ROI.  We reached that moment about 3 weeks after initial deployment – after refining some minor issues, the system was running smoothly and it was obvious to EG!! For a complex initiative like this, there are lots of different kinds of ROI: proof of adoption at all levels, proof of satisfaction, proof that all the pieces are working (MAPS, territories, metrics, integrations, and more), and ultimately positive financial ROI. We look forward to many more ROI moments for EG in the years to come.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZAv6EAH_B71UfEjAw",
            ribbonCuttingMoment:
              'This was a beautiful moment but left us wanting more. Let me explain with a short anecdote/analogy from screenwriter Steven Pressfield (Legend of Bagger Vance, Above the Law) – after two years of painful struggle, Pressfield finally finished his first book. On that day he asked an elder, accomplished author what to do next. The elder author said, "Start writing your next book tomorrow." And while this wasn\'t our "first book", this was exactly how we felt. To be sure, we celebrated, we laughed, we high-fived – we thought we\'d accomplished something impressive for a firm our size. We believe this quality of work is why Orion earned a 5/5 on the Salesforce partner survey. But the long-term results weren\'t in yet and there was more to be done. So on the next day, we got to work on Phase II.',
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZAv1EAH_oEjQORpJv",
            redMoment:
              "It's one thing to get your client to adopt a new system and another to get a 3rd-party to do so. One of the toughest episodes in this engagement was telling an entire team of 100+ managers at MarketSource: 'You and your reports are using a new system now'. MarketSouce was the retail execution agency contracted by EG to actually visit stores and make sure that the product line was stocked, positioned, displayed, and priced according to agreement. There were some tough conversations here - and that helped us learn. Ultimately, we had to make sure that feedback from both managers and line-workers at MarketSource became part of the solution. This was crucial to our successful launch and we're grateful to the MarketSource team.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZAu8EAH_UVXSJwU54",
            momentOfTrust:
              'One of the most important people to this project was a senior manager in charge of EG store sales operations in the Eastern US, Chris N. We\'d interviewed Chris on the phone, relying heavily on his expertise to design our solution. Finally, we met him in person in our New York offices. The meeting lasted more than 2 hours. We walked him through our entire transformation plan in detail, from the excel migration to the newer advanced MAPS/Route planning system, to the mobile reporting system, and so on. Chris was impressed and easily understood everything we were doing. But the real moment of trust happened when he realized that at every opportunity, Orion deepy considered real human impact: "What will the impact of this solution be on the workers who actually use it day-to-day? Will it make their lives easier? Will they be happy?"',
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZEoLEAX_xhb9U3RXi",
            introductionMoment:
              'When you make a point of always trying to do amazing work, people hear about it. Thus, EG knew Orion CEO Yacov Wrocherinsky by reputation long before they approached him. Yacov had led a well-known CRM implementation for Panasonic years before - along with similar projects. With that background, introductory conversations were fluid and expansive from the get-go. These talks included project lead Dan Farrugia, who led both pre-sales and post-sales efforts for Orion. They discussed Orion\'s typical approach to working with consumer goods manufacturers - and the "consumer goods cloud" as a new paradigm for that kind of business. During larger team introductions, that same spirit characterized the conversations: understanding the big picture concerns and contrasting them against the solution model that Orion specializes in. The Orion team knew from those early conversations that they were about to do some of the best work of their lives.',
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZAuXEAX_yblpD5UJa",
            eurekaMoment:
              'We\'d like to highlight a eureka moment on the client side. Orion assumed from Day 1 that a Salesforce Consumer Goods Cloud implementation was in order. But in a complex enterprise ecosystem one platform is never the entire solution. There was a "Big 3" cloud platform to onboard, there was Bright Pattern, there was MAPS, there was a legacy datacenter full of SQL databases, and more. Like the tremors before the earthquake, small eureka moments foreshadow the big one.  Finding a way to make each piece fit was a minor victory - as when both sides realized that a Salesforce Cloud could easily serve as the "source of truth" for NIP ("unexpected" not-in-plan data). That moment foreshadowed the real eureka moment, for EG: Salesforce Consumer Goods Cloud would be the source of truth for EG\'s entire US revenue operations.',
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZAx2EAH_oZrGRpqH-",
            dealClarityMoment:
              "For this deal to work, there had to be clarity shared by more than 20 smart, critical decision makers. While Orion can't share the actual ecosystem architecture, we can say this about it: the design allows for dozens of datasources capturing inputs daily from 1000s of employees, 1000s of stores, and 10s of thousands of customers of EG's products. But at the center of everything was our \"North Star\" principle: centralize on Salesforce Consumer Goods Cloud. This approach was carefully considered to ensure future-viability as well, which Orion was also able to clarify through visual representations. In short, the deal became clear when we could depict the 10-year lifespan of an enterprise ecosystem on 2 or 3 pieces of paper.",
          },
          isfeatured: true,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GLa6SEAT_GdwtSYwtf",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Tableau CRM",
              "Salesforce",
              "Field Service Lightning",
            ],
            Timeline: ["Over a year"],
            Budget: [null],
            Industry: ["Consumer Goods"],
            Company: ["Orion Global Solutions"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Great Technology Consultancy",
          calendlyLink: "https://brightr.io/meet-with-connor-cummins",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
        {
          website: "https://www.orion-gs.com/",
          valueSectionsData: [
            {
              heading: "AffiniPay Culture",
              description:
                "Like its client base of professional services firms, AffiniPay values complex problem-solving and client services. At the same time, it values efficiency and innovation, which motivated them to bring all their software products into a unified platform.",
            },
            {
              heading: "Why Now",
              description:
                "TA Associates had recently acquired AffiniPay, which was comprised of 6 distinct software products, some acquired through its own previous acquisitions. Growth, mergers, and acquisitions meant complexities that had to be addressed.",
            },
            {
              heading: "Other Things to Note",
              description:
                'The AffiniPay project is the beginning of an ongoing digital transformation journey, that began by creating the "Better Together" platform. The success of this phase has paved the way for future growth and even more impact on the professional services industry.',
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              'Affinipay "Better Together" initiative enables growth through cross-selling',
            table: [
              {
                valueName: "AffiniPay",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Financial Services",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "9",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FF5WXEA1_-e2Z8d37Q",
            layout: "Original",
            description:
              "<p>After a series of mergers and acquisitions, AffiniPay found itself with 6 separate payment products - and 6 separate tech stacks. Behind that were dozens of data sources, applications, and processes that needed to be rewired. AffiniPay partnered with New York-based technology consultancy Orion Global Solutions to turn this challenge into a great business opportunity. This story describes how they did it.</p>",
          },
          testimonialsData: [
            {
              industry: "EVP, Corporate Development & Transformation",
              description:
                "Working with Orion has truly transformed our approach to cross-selling and business development. Their expertise and partnership have been instrumental in shortening what could have been a three-year internal project to just a matter of months. The investment we made to integrate our front-office systems the right way, leveraging Salesforce and other tools, has proven to be a game-changer. It's a testament to their commitment to excellence and our willingness to take bold steps for success.\n\nI've worked with a number of Salesforce consultant firms in my career ... but the partnership with Orion was a home run for us and we continue that partnership today through different engagements. And we're looking at potentially signing a couple more. \n\n\n\n\n\"",
              author: "Nathan Pace",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSI0_f3yqA6PFOl",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FxSuKEAV_fjGAzS73ss",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/yacov-wrocherinsky-30995/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Executive Officer",
              name: "Yacov Wrocherinsky",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5j3tEAB_Jb__10slq",
            },
            {
              serviceLink: "https://www.linkedin.com/in/danfarrugia/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Operations Officer",
              name: "Dan Farrugia",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5j5LEAR_F71hF6BUuX",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/peter-breglio-pmp-35501227/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Director, Professional Services",
              name: "Peter Breglio",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZLgNEAX_pHiV0Q0pa",
            },
            {
              serviceLink: "https://www.linkedin.com/in/connormcummins/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Sales Director",
              name: "Connor Cummins",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FxxdyEAB_OpGwr29i_",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Transformation Consultant",
              name: ".",
              index: 5,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Data Architect",
              name: ".",
              index: 6,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: ".",
              index: 7,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: ".",
              index: 8,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Program Manager",
              name: ".",
              index: 9,
              dpSrc: "",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZC5UEAX_4MmgbF4Mf",
          storyId: "a006g00000rN7miAAC",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#4F4D4D",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              'Affinipay "Better Together" initiative enables growth through cross-selling',
            teamSize: null,
            paragraph2:
              "<p>After a series of mergers and acquisitions, AffiniPay found itself with 6 separate payment products - and 6 separate tech stacks. Behind that were dozens of data sources, applications, and processes that needed to be rewired. AffiniPay partnered with New York-based technology consultancy Orion Global Solutions to turn this challenge into a great business opportunity. This story describes how they did it.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FF7NQEA1_8t_g5uwvuX",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>AffiniPay is the leading provider of professional software solutions in North America. Their commitment to deep customer understanding and vertical specialization is unique and has led to a diverse portfolio of web applications, APIs, and services.</p>\n<p>But AffiniPay&#39;s success also led to technology growing pains.</p>\n<p>After completing several acquisitions - and being acquired themselves by private equity firm TA Associates, AffiniPay recognized the need to truly merge and not just run under one legal structure. Bringing these companies&#39; processes and technologies together would open up a great opportunity to understand their clients more fully, and to offer them additional products they would find valuable.</p>\n<p>Knowing they need world-class digital transformation, AffiniPay turned to Orion Global Solutions to level up its technology infrastructure and operations.</p>\n<p>Orion&#39;s team is led with deep Salesforce-based transformation expertise.  The solution Orion discovered included Salesforce Sales Cloud, Tableau, and Workato, as well as a myriad of integrations with other platforms such as Outreach, Intercom, and Workday. Following discussions with Christian Fadel, AffiniPay&#39;s Executive Owner - it became clear that AffiniPay was facing a decision challenge. They knew they needed a unified system to manage their diverse operations, from sales and customer service to partnerships and referrals - but more importantly, they needed help deciding what steps to take next.</p>\n<p>And so the &quot;Better Together&quot; initiative set out! Orion designed and executed a transition to Salesforce that addressed AffiniPay&#39;s critical issues but went much deeper than just providing business logic. Orion also needed to design and execute multiple intensely complex integrations, consolidating tracking and reporting, streamlining workflows for sales and services teams, and centralizing data and processes. With Salesforce at the heart of AffiniPay&#39;s operations, they now have a robust, scalable solution that enables them to identify cross-sell opportunities, grow more rapidly, and support future acquisitions.</p>\n<p><em>&quot;for the first time, we now have a singular, unique set of prospects, and we leveraged a center-of-excellence approach as part of this transformation. So now everything comes into a singular funnel, and just based on business rules, gets dispersed to the appropriate teams or individuals.&quot;  Nathan Pace, EVP Corporate Development and Transformation at AffiniPay</em></p>\n<p>Orion&#39;s solution has already started to impact AffiniPay&#39;s business positively - and future collaborations are planned. With a centralized, effective platform, AffiniPay can now focus on what they do best: delivering top-tier payment solutions to US professional services.</p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#4F4D4D",
          primaryfont: "Montserrat",
          primarycolor: "#66B6FE",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText: "...",
          },
          metadataname:
            "Orion helps PE firm TA Associates transform a new acquisition",
          metadatadescription:
            "Orion helps PE firm TA Associates level up new acquisition, AffiniPay, with a Salesforce CRM-based digital  transformation, integrating Conga, Pendo, Workato, Hubspot, Zendesk, Zuora, custom MySQL and more around a centralized Salesforce CRM",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FyAJXEA3_DbUYzWjYV",
            redMoment:
              "While the project was successful, it was not without its challenges. One came with a specific marketing automation platform (which we cannot name here) - some of AffiniPay's tech stacks used it; others didn't. Some feared that integrating it into the broad ecosystem could derail Orion's \"push-button\" launch and force a retreat to a phased approach - with elements of Orion's solution deployed piecemeal. Some suggested eliminating the marketing automation platform altogether. But the Orion team, drawing on their experience in transformation, not only ensured that the platform remained part of AffiniPay's ecosystem - it even allowed it to be used in a new way.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FihfeEAB_YfkpCCOHg",
            momentOfTrust:
              "Ultimately, AffiniPay's growth is sales-led - therefore the moment of trust happened when it clicked with AffiniPay's Director of Revenue that Orion knew exactly what it was doing - that it wasn't like other Salesforce firms. AffiniPay threw the entire kitchen sink at Yacov, Dan, and the rest of the Orion team during discovery - multiple web software products, already integrated, and dozens of behind-the-scenes applications, integrations, and automation, from custom MySQL databases to Zendesk to Zapier. They saw that complexity and volume of integration points didn't scare Orion - on the contrary, they welcome the opportunity. The more complex the problem set, the more energized Orion became.",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FyA4AEAV_7xtPJfvdf",
            introductionMoment:
              'AffiniPay looked to the expertise of a technology and strategy firm that already new the financial services industry - Orion was a logical choice. When AffiniPay and Orion met, the question was, "can Salesforce do what we need - can you make it do what we need?". This gave Orion CEO Yacov Wrocherinksky the opportunity to clarify their approach - Orion is a strategic digital transformation firm first and foremost - Salesforce is the tool that helps them achieve that.',
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fw9BqEAJ_AXKvLiYnU",
            eurekaMoment:
              "The eureka moment came when Orion helped AffiniPay understand that what they faced was essentially a big-picture revenue operations challenge - that the outcome of the project would be an enterprise-wide transformation in how AffiniPay approaches business development, from the executive leadership on down to SDRs. AffiniPay had been a loose aggregate of 6 software products, each led by sales but with different systems, nomenclature, categories, and processes. Orion created a technology ecosystem that merged and unified revenue processes without compromising strategy and innovation.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GLa6SEAT_GdwtSYwtf",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce Sales Cloud", "Tableau", "Workato"],
            Timeline: ["5-7 Months"],
            Budget: [null],
            Industry: ["Financial Services"],
            Company: ["Orion Global Solutions"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Great Technology Consultancy",
          calendlyLink: "https://brightr.io/meet-with-connor-cummins",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
        {
          website: "https://www.orion-gs.com/",
          valueSectionsData: [
            {
              heading: "DentalXChange Culture",
              description:
                "Focused on simplifying the painful dental claims and billing process, DentalXChange values customer experience and innovation",
            },
            {
              heading: "Why Now",
              description:
                'A legacy "black box" IT infrastructure had started to hamper the growth of DentalXChange - and undercut new market opportunities',
            },
            {
              heading: "Other Things to Note",
              description:
                "DentalXChange, a leading solution for dental billing and patient claims processing, is majority owned by private equity firm Bregal Sagemount",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "HLS ISSUE SPRING 2024",
            campaignLandingPageUrl:
              "https://brightr.io/brightr-magazine-hls-salesforce-2024",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: 'Rebuilding the DentalXChange "Black Box" on Salesforce',
            table: [
              {
                valueName: "DentalXChange",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over a year",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "13",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005AUZpMAO_NIsE5F2CMX",
            layout: "Original",
            description:
              "<p>How DentalXChange and Orion overcame a &quot;black box&quot; legacy IT system, rebuilt DentalXChange on Salesforce, and opened up a new future for the company</p>",
          },
          testimonialsData: [
            {
              industry: "CEO, DentalXChange",
              description:
                "\"Within 2 years, we reach a break-even point. But you know, after that, it's all upside. And along the way, as we continue to scale and grow, we'll be able to add things in - we'll be able to add in AI, and we'll be able to integrate ... And so many solutions that the Salesforce platform offers that are just going to quicken our ROI opportunity, by just having a scalable platform in place that will then allow us to stack value adds over time and create more efficiencies. It's going to be huge - we could never have done that in our old world\"​​",
              author: "Paul Kaiser",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000STQf_3E03X8xi0",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/yacov-wrocherinsky-30995/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Executive Officer",
              name: "Yacov Wrocherinsky",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5j3tEAB_Jb__10slq",
            },
            {
              serviceLink: "https://www.linkedin.com/in/danfarrugia/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Operations Officer",
              name: "Dan Farrugia",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5j5LEAR_F71hF6BUuX",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/peter-breglio-pmp-35501227/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "VP, Professional Services",
              name: "Peter Breglio",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZLgNEAX_pHiV0Q0pa",
            },
            {
              serviceLink: "https://www.linkedin.com/in/connormcummins/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Sales Director",
              name: "Connor Cummins",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FxxdyEAB_OpGwr29i_",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Data Architect",
              name: "Dave .",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005JA0oMAG_bUlbjpfQM",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Delivery Manager",
              name: "Hima .",
              index: 6,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005JAOzMAO_4OKryRDmo",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Kelly .",
              index: 7,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005JASDMA4_pse-jYs4l",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Will .",
              index: 8,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005JATpMAO_c5Fl29JxtX",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Tim .",
              index: 9,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005JAVRMA4_W7_vARz1n",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Technical Architect",
              name: "Kevin .",
              index: 10,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005JAaHMAW_sOhHYlM9f",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Technical Architect",
              name: "Rahim .",
              index: 11,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005JAbtMAG_51ggg9kGA",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Engagement Manager",
              name: "Kristin .",
              index: 12,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005JAdVMAW_YnEo9AB7U",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Transformation Consultant",
              name: "Ellen .",
              index: 13,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5j3yEAB_8ceK-HNWO",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZC5UEAX_4MmgbF4Mf",
          storyId: "a00Nu0000078yHVIAY",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#4F4D4D",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: 'Rebuilding the DentalXChange "Black Box" on Salesforce',
            teamSize: 13,
            paragraph2:
              "<p>How DentalXChange and Orion overcame a &quot;black box&quot; legacy IT system, rebuilt DentalXChange on Salesforce, and opened up a new future for the company</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005PBYTMA4_EH0AlK8WM",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p>Under the leadership of CEO Paul Kaiser, DentalXChange faced the overwhelming task of modernizing its antiquated, opaque legacy systems. The company had a history of successes, alleviating the notoriously painful experience of dental billing with a blend of software innovation and a customer experience focus. </p>\n<p>But to continue down that path, it needed a bold change - and also patience.<br><br>With a string of digital transformation successes for healthcare, life sciences, and health-tech firms, Orion was the perfect match for DentalXChange.</p>\n<p dir="ltr">The primary challenge was that DentalXChange&#39;s legacy systems were a &quot;black box&quot; - a mountainous, decade-plus of technical debt. A lack of transparency and customizability handicapped the management of customer data, billing processes, and sales reporting. The entire company felt this lack, from sales to marketing to accounting to customer experience. The complexity of the digital transformation was compounded by the need to unravel these legacy systems before implementing Salesforce.</p>\n<p dir="ltr">Orion spearheaded a comprehensive Salesforce implementation, focusing on unraveling the legacy systems to pave the way for a seamless integration of Salesforce. This project involved:</p>\n<ul><li dir="ltr">\n<p dir="ltr">Reverse engineering the &quot;black box&quot; to understand and reorganize the underlying processes.</p>\n</li><li dir="ltr">\n<p dir="ltr">Implementing Salesforce Service Cloud and Sales Cloud to manage customer relationships and sales pipelines effectively.</p>\n</li><li dir="ltr">\n<p dir="ltr">Enhancing reporting capabilities to provide strategic insights to both the sales teams and executive leadership.</p>\n</li></ul>\n<p dir="ltr">The implementation fundamentally restructured DentalXChange&#39;s operational framework and created the possibility to provide not just better but entirely new categories of services to customers. Specific results included:</p>\n<ul><li dir="ltr">\n<p dir="ltr">Streamlined operations and improved efficiency in product launches and billing processes.</p>\n</li><li dir="ltr">\n<p dir="ltr">Enhanced strategic decision-making through improved reporting capabilities, providing insights into marketing campaigns, sales efforts, and customer acquisition costs.</p>\n</li><li dir="ltr">\n<p dir="ltr">A significant cultural shift towards embracing digital transformation across the organization.</p>\n</li></ul>\n<p>In the immediate aftermath of the project with Orion, the work lives of multiple DentalXChange executives in sales, marketing, customer experience, and IT, have been made easier. The same is true for their teams.  As Associates discover new opportunities to create impact, both Orion and DentalXChange anticipate that the company will as well. Meanwhile, the payoff for DentalXChange clients is already being felt.</p>',
          },
          projectBoundariesData: {
            rightStatus: ">$1,000,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#4F4D4D",
          primaryfont: "Montserrat",
          primarycolor: "#66B6FE",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText: ".",
          },
          metadataname:
            "Orion's Salesforce Transformation for Dental Billing & Claims firm DentalXChange",
          metadatadescription:
            "Orion helped DentalXChange achieve  peak digital transformation, on the Salesforce project that just might transform the entire medical billing industry for good. Read the story here.",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005BxwPMAS_YHXfctWVSj",
            roiMoment:
              "Because of the enormity of this very recent project, the tangible ROI moment sits 1-2 years out from project completion in late 2023. Confidence in projected ROI, however, happened within weeks of the completion of implementation. This confidence is shared by DentalXChange’s CEO and executive team, Orion’s leadership team, and the private equity firm that holds ownership of DentalXChange. The possibilities for reimagining the ways that DentalXChange can shake up the dental billing industry are numerous - but even just sticking to business as usual, significant ROI on the project is inevitable.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005ByduMAC_9-LYWl1yo",
            ribbonCuttingMoment:
              "Because of the universality of Orion’s solution for DentalXChange, it tied all departments and processes together in Salesforce. Everything had to be launched at once. Thus, the ribbon-cutting moment was dramatic and interconnected. Orion unleashed an entirely new system end to end. At that moment, DentalXChange became a smarter company - it changed the way DentalXChange executives did business. Insight and analysis reporting that had been impossible now happened in a few clicks. But more importantly, the three core revenue generation teams - Sales, Marketing, and Customer Success - instantly gelled in a way that had never been possible.",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005BuYhMAK_9nrVIOPlu",
            redMoment:
              "Because of the depth of the transformation, affecting operations, accounting, sales, marketing, customer service and the entirety of customer experience, there were multiple red moments related to surprise learning challenges. Ways of doing daily business that had been in place for years had to be relearned. Led by Orion principal and COO Dan Farrugia, the approach was to treat each such moment as critically important, an opportunity to deepen the transformation, and build trust.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005WhyFMAS_FqVZXOuWH",
            momentOfTrust:
              "Trust came partly out of the Eureka moment, where DentalXChange realized that Orion had deferred a substantial deal because they - thanks to the insight of Ellen Williams, \n Orion's Directory of Advisory Services - that DentalXChange wasn’t ready. Orion later built on the trust created at that moment, through the implementation work of Dan Farrugia and his team. New ways of reporting and customer management, new processes uncovered - all of these meant constantly devising new innovations. Dan and his team built and kept trust over and over again.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000005Bz6vMAC_dQ9La8wKR",
            eurekaMoment:
              "A huge realization struck CEO Paul Kaiser in a conversation with Dan Farrugia at Orion - the first step was to reverse-engineer everything. This was the defining realization at the project's inception - the need to overhaul its legacy systems by figuring out exactly how they worked, step by step, piece by piece. That detective work also called for a non-trivial Netsuite implementation - before a Salesforce implementation happened, the data had to be just right. In this way, a series of Eureka moments ensued. Each one indicated that the digital transformation of sales, marketing, support, and services would have to be postponed to be done correctly.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GLa6SEAT_GdwtSYwtf",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce",
              "Salesforce Experience Cloud",
              "Salesforce Sales Cloud",
            ],
            Timeline: ["Over a year"],
            Budget: [">$1,000,000"],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Orion Global Solutions"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Great Technology Consultancy",
          calendlyLink: "https://brightr.io/meet-with-connor-cummins",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription:
              "For a deeper understanding of Orion's work with DentalXchange, find some time on my Calendar. I look forward to meeting you and would be happy to share with you everything I know.\n~ Connor",
            headshotUrl:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FxxdyEAB_OpGwr29i_",
            contactName: "Connor Cummins",
            calendlyLink: "https://calendly.com/connorc-ixg/30min",
            bannerDescription:
              "with Orion and get a deeper understanding of the project",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GLa6SEAT_GdwtSYwtf",
      fav_image: "",
      contact_us: "https://www.orion-gs.com/contact",
      account_description: "Great Technology Consultancy",
    },
    {
      title: "Cloud Pathfinder LLC",
      teamId: "0016g000021LXINAA4",
      stories: [
        {
          website: "http://www.cloudpathfinderconsulting.com",
          valueSectionsData: [
            {
              heading: "Venbrook Culture",
              description:
                "The relationship between Venbrook and Cloud Pathfinder Consulting is one built on trust, great communication, and the consistency that only a team with a military background can provide! When Venbrook was looking for a partner to support large scale, complex projects, Cloud Pathfinder's military background was one of the primary deciding factors.",
            },
            {
              heading: "Why Now",
              description:
                "After Venbrook completed a large acquisition in 2020, they had two big problems: they needed to merge multiple orgs to get a 360 view of their new customers, and very few sales people were actually using the tool in any org to collect customer data. Opportunities were falling through the cracks and Venbrook wasn't getting the expected ROI on their Salesforce investment.",
            },
            {
              heading: "Other Things to Note",
              description:
                "Venbrook has three core philosophies for growth: organic growth through market and product expansion, client retention, and solution diversification through the acquisition of businesses. Their ultimate goal is to capture every part of the value chain, and provide a full complement of insurance solutions and services to their client base.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Enabling Venbrook's Business Continuity Through Every Acquisition",
            table: [
              {
                valueName: "Venbrook",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Financial Services",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over a year",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "1",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzEaUEAV_RDSiayxYX",
            layout: "Original",
            description:
              "<p>Venbrook&#39;s Salesforce org originally wasn&#39;t designed to track, report, and maximize visibility between all of Venbrook’s businesses. Because of that, there were major user adoption issues. But the biggest challenge for Venbrook was servicing their customer base throughout all of the acquisitions and the changes that ensued. To keep customers happy, the integration of various new businesses and all of their customer data had to be seamless.</p>",
          },
          testimonialsData: [
            {
              industry: "VP of Marketing & Communications",
              description:
                "“We used to do so many things ourselves! It would take me a month to do a small edit because I had to take so much time to learn it first. But now we’ve partnered with Cloud Pathfinder Consulting for ALL things Salesforce. Our lives have become so much easier.”",
              author: "Erika Magana",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOiX_aQ0xr8NqA",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOih_Su1_1y7U6",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOim_4E5XMOK1d",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOir_9u326X_9x",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOiw_3b4Kvy734I",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOj1_8iMpFJifk",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/judcprice/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "Jud Price",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOjB_uFnYwVb6_",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOc0_Nf93d03XF",
          storyId: "a006g00000fRwbpAAC",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#F5F7FA",
          secondaryfontcolor: "#939393",
          secondaryfont: "Arial",
          secondarycolor: "#F1F1F1",
          projectSectionData: {
            videoLink: null,
            title:
              "Enabling Venbrook's Business Continuity Through Every Acquisition",
            teamSize: 0,
            paragraph2:
              "<p>Venbrook&#39;s Salesforce org originally wasn&#39;t designed to track, report, and maximize visibility between all of Venbrook’s businesses. Because of that, there were major user adoption issues. But the biggest challenge for Venbrook was servicing their customer base throughout all of the acquisitions and the changes that ensued. To keep customers happy, the integration of various new businesses and all of their customer data had to be seamless.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOmZ_cZzlpB26k",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Venbrook has acquired a large number of various smaller businesses in a very short time frame. Venbrook’s goal for each acquisition is to maintain the best customer experience possible. A seamless transition is paramount to their ability to help employees and the client base through the acquisition process. But, with acquisitions come lots of different databases, client information, and processes for sales, marketing, and relationship management. Merging all of these together was just one of the challenges Venbrook faced.</p>\n<p>Salesforce use at Venbrook’s various divisions was also fragmented. Some had implemented Salesforce but dealt with low adoption of the tool. Some simply lacked administration and training, and other teams, who were highly specialized, had distinct requirements that weren’t available in their current instance. After one massive acquisition of a new claim services division with a substantial customer base was made at the beginning of 2020, Venbrook knew they needed help. The new division was extremely well versed in Salesforce, but with the growth of the team they needed to get serious about reporting, forecasting, and showing engagements in dashboards.</p>\n<p>Merging the orgs and getting various team members to use Salesforce regularly became Cloud Pathfinder&#39;s mission. We have a unique specialty in merging Salesforce orgs and leveraged both our Salesforce expertise and military backgrounds to effectively train the Venbrook team. Now, they&#39;re using Salesforce best practices to continuously improve the customer experience.</p>\n<p> </p>\n<p>Business Objectives:</p>\n<ul><li>Maintain the Best customer experience through each acquisition.</li><li>Improve Ability to Cross-Sell and Up-Sell across business lines</li><li>Streamline sales activities to save time and spend more time with clients.</li><li>Make Salesforce effortless so leadership had one source of truth for all sales &amp; marketing data.</li></ul>",
          },
          projectBoundariesData: {
            rightStatus: "$200,000-$300,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#170046",
          primaryfont: "Helvetica",
          primarycolor: "#008AD9",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Headquartered in Southern California with 22 locations across the country, Venbrook Group, LLC is a high growth company. It owns and operates a portfolio of privately held insurance organizations across four divisions — Retail, Wholesale, Programs MGA, and Claims Services.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "4030740",
          linecolor: "#008AD9",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOVn_kP_aF6Z6t",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Pardot",
              "Salesforce Sales Cloud",
              "Harvest",
              "Social Studio",
              "Microsoft Office 365",
              "Slack",
              "Zywave",
            ],
            Timeline: ["Over a year"],
            Budget: ["$200,000-$300,000"],
            Industry: ["Financial Services"],
            Company: ["Cloud Pathfinder LLC"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "Month 1",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000ByyXmEAJ_VpHJeC4Gl",
                heading: "Understand the business goals & objectives",
                descriptionLine2: "",
                descriptionLine1:
                  "We begin each engagement taking time to understand our clients' desired business outcomes and what the Salesforce work will do for their team, company, and customers.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Month 1",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOme_rz5jd_Wo5",
                heading: "Evaluate Sales & Marketing processes",
                descriptionLine2: "",
                descriptionLine1:
                  "To build Salesforce out for Venbrook's specific needs, we spent time with the sales and marketing teams to determine any gaps in the processes and how to align technology solutions to them.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Month 2-4",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000ByyXrEAJ_dUxxa8cWW",
                heading: "Outline requirements for main Salesforce org",
                descriptionLine2: "",
                descriptionLine1:
                  "Once we understood the primary processes, we developed requirements for the primary org that would make merging subsequent orgs seamless.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Month 5-8",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzNK3EAN_Je7oZrSRpl",
                heading: "Implement Pardot in main org",
                descriptionLine2: "",
                descriptionLine1:
                  "With so many business lines, Venbrook needed to a way to market various products and services to all of their new customers. Accurate personalization and segmentation are important to marketing suites of products, and Pardot was the perfect solution.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Month 8-14",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SPmP_Tvho9n1vE",
                heading: "Begin Org merge process",
                descriptionLine2: "",
                descriptionLine1:
                  "After careful preparation, we began merging various acquired orgs with the main Salesforce org to ensure customer data from new business lines was accessible to all teams.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Month +14",
                order: "6",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOmj_78XnddUccT",
                heading: "Train Sales & Marketing users",
                descriptionLine2: "",
                descriptionLine1:
                  "Venbrook knew that Salesforce would not provide value if marketers and sales people were not using it, so Cloud Pathfinder has provided ongoing support and training to boost adoption.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "You’ve Chosen Salesforce, now it’s time to realize maximum ROI and business processes without upending your organization or prevailing infrastructure.",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "FFFFFF",
        },
        {
          website: "http://www.cloudpathfinderconsulting.com",
          valueSectionsData: [
            {
              heading: "We Are Rosie Culture",
              description:
                'We Are Rosie focuses a lot on bringing diverse talent and experience to the table, and on providing opportunities to thrive to the people who are "doing the work". They are committed to doing business in a better way by focusing on people, celebrating diversity, and facilitating happiness. Cloud Pathfinder Consulting works closely with We Are Rosie\'s Chief of Staff and Head of People to create a solution with Salesforce that makes work a little less difficult every day.',
            },
            {
              heading: "Why Now",
              description:
                "Around 25 Fortune 500 companies are supported by Rosie's, and the team was ready to do more. However, almost 10,000 freelance marketing experts are hard to keep track of! They had to streamline their business processes to track Rosie placements and understand actual vs. projected revenue so they could make better decisions around future growth plans.",
            },
            {
              heading: "Other Things to Note",
              description:
                "We Are Rosie received funding in December 2021. The \"growth hack\" investment will allow them to invest more in proprietary tech that reduces the need to obtain and review a Rosie's resume, speeding up the process to match a Rosie to a client's project.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "We Are Rosie Uses Salesforce to Forecast Revenue of Network of 10k Freelancers",
            table: [
              {
                valueName: "We Are Rosie",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Professional Services",
                keyName: "INDUSTRY",
              },
              {
                valueName: "3-4 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOnN_Upfz2e6s2",
            layout: "Original",
            description:
              "<p>We Are Rosie&#39;s mission is to create a community for marketers of all backgrounds to find good jobs with Fortune 500 companies. Their community has grown to almost 10,000 freelance marketers, putting a strain on operations and making it difficult to accurately forecast revenue. Read the story to see how Cloud Pathfinder helped We Are Rosie use Salesforce to scale and make work easier for the whole community. </p>",
          },
          testimonialsData: [
            {
              industry: "Senior Client Partner Chief of Staff, Head of People",
              description: '"I love this so much! You are the best!"',
              author: "Sara Nikki Coleman",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOih_Su1_1y7U6",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/judcprice/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "Jud Price",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOjB_uFnYwVb6_",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/travis-grothaus-73652816a/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Travis Grothaus",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOjG_TiHde1gVF",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOc0_Nf93d03XF",
          storyId: "a006g00000fRweUAAS",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#F5F7FA",
          secondaryfontcolor: "#939393",
          secondaryfont: "Arial",
          secondarycolor: "#F1F1F1",
          projectSectionData: {
            videoLink: null,
            title:
              "We Are Rosie Uses Salesforce to Forecast Revenue of Network of 10k Freelancers",
            teamSize: null,
            paragraph2:
              "<p>We Are Rosie&#39;s mission is to create a community for marketers of all backgrounds to find good jobs with Fortune 500 companies. Their community has grown to almost 10,000 freelance marketers, putting a strain on operations and making it difficult to accurately forecast revenue. Read the story to see how Cloud Pathfinder helped We Are Rosie use Salesforce to scale and make work easier for the whole community. </p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBD3EAN_kMcHQnpE-",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>We Are Rosie&#39;s mission is to bring diverse talent to Fortune 500 brands, and to make sure the people doing the work are happy and fulfilled while they&#39;re doing it. They have a freelance workforce of almost 10,000 &quot;Rosies&quot;, and have grown significantly since they started in 2017.</p>\n<p> </p>\n<p>But We Are Rosie had a complex business process that was built out in Salesforce - and they weren&#39;t sure if it was set up the right way or if their data structure was sound enough to make the tool worth the investment. Rosies, the Freelancers that the company sources and assigns to client projects, use Harvest, an online time tracking tool, to clock in and out of projects. We Are Rosie needed to be able to track Rosies&#39; time entries against placements with specific companies and contracts for multiple types of work. Unfortunately, Salesforce was not originally configured to support this process, and data wasn&#39;t flowing well between Salesforce and Harvest, causing issues with reporting and forecasting.</p>\n<p> </p>\n<p>Cloud Pathfinder Consulting worked with the team at We Are Rosie to understand the details and nuances of tracking Rosies against project placements. Then, we created a plan for Salesforce that would allow data to flow from Harvest and accurately map to accounts and projects. From there, the data can be organized into reports that provide the leadership team information they need to make hiring, marketing, sales, and other growth decisions.</p>\n<p> </p>\n<p>Business Objectives:</p>\n<ul><li>Get a more accurate view of actual vs projected revenue.</li><li>Improve data flow between Harvest &amp; Salesforce.</li><li>Reduce amount of manual work required for a complex business process.</li></ul>",
          },
          projectBoundariesData: {
            rightStatus: "$40,000-$70,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#170046",
          primaryfont: "Helvetica",
          primarycolor: "#008AD9",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "We Are Rosie is a community of independent marketing experts, available on-demand to augment, complement, backfill, or accelerate the in-house teams and capabilities of Fortune 500 brands and agencies. Headquartered in Atlanta, GA, Rosies live and work across the US, UK, and Canada.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "4030740",
          linecolor: "#008AD9",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: true,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOVn_kP_aF6Z6t",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce Sales Cloud", "Harvest"],
            Timeline: ["3-4 Months"],
            Budget: ["$40,000-$70,000"],
            Industry: ["Professional Services"],
            Company: ["Cloud Pathfinder LLC"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "September, 2021",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBDCEA3_BZruoZJSY",
                heading: "Create Reports & Dashboards",
                descriptionLine2: "",
                descriptionLine1:
                  "Finally, we created custom reports and dashboards to provide clear visibility into forecasted revenue, actual revenue, and other Rosie metrics.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "August, 2021",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBD7EAN_l2KVCLchY",
                heading: "Sync Harvest with Salesforce",
                descriptionLine2: "",
                descriptionLine1:
                  "Next, we connected Harvest and Salesforce to allow information to flow accurately between the two tools and to ensure Salesforce would become the source of truth for Rosie data.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "July, 2021",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBD2EAN_FYzo9T4mY",
                heading: "Outline requirements for Salesforce",
                descriptionLine2: "",
                descriptionLine1:
                  "Once we understood the primary processes, we developed a plan to fix and enhance We Are Rosie's Salesforce org so the data structure was organized.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "June, 2021",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBCxEAN_uIyU43Oji",
                heading:
                  "Evaluate current Salesforce Org and Business Processes",
                descriptionLine2: "",
                descriptionLine1:
                  "To configure Salesforce in a way that saves time and provides accurate data, we had to understand the details and nuances of tracking Rosies against project placements, and dig deep into the org to see where the current configuration didn't match up.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "June, 2021",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBCiEAN_Wn__Q9PS8",
                heading: "Understand the business goals & objectives",
                descriptionLine2: "",
                descriptionLine1:
                  "We begin each engagement taking time to understand our clients' desired business outcomes and what the Salesforce work will do for their team, company, and customers.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "You’ve Chosen Salesforce, now it’s time to realize maximum ROI and business processes without upending your organization or prevailing infrastructure.",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "FFFFFF",
        },
        {
          website: "http://www.cloudpathfinderconsulting.com",
          valueSectionsData: [
            {
              heading: "Autify Culture",
              description:
                "Cloud Pathfinder takes a disciplined and strategic approach to Salesforce implementations with the future goals of the business always in mind. Autify's business is still growing, which means they needed a partner who could be flexible with an engagement. We worked with Autify to put an initial roadmap together and get them to a place where they had better visibility into the business, so they could put that worry out of mind and focus on what's really important - their customers.",
            },
            {
              heading: "Why Now",
              description:
                "Autify raised growth capital in the fall of 2021, and an edict to grow - fast. This put pressure on the team to implement a sales tech stack that could scale with them without causing friction down later on. Additionally, they were losing track of leads and having trouble upselling and cross-selling products, and losing out on easy opportunities for additional growth.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Autify Standardizes Processes with Salesforce to Increase Renewals",
            table: [
              {
                valueName: "Autify",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "High Tech",
                keyName: "INDUSTRY",
              },
              {
                valueName: "4-8 weeks",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBEZEA3_rok9eNacAS",
            layout: "Original",
            description:
              "<p>Managing Sales and Marketing teams is difficult, but for Autify, it was even more challenging. Two business units are located in different countries, and each team used different tools and processes to track and manage customers from lead to close. This made it difficult to get a wholistic view of the business&#39;s health. And, it was hard to scale. Cloud Pathfinder helped Autify get both teams on a single platform and get a clearer picture of Sales and Marketing efforts, making it easier to manage - and grow - the company&#39;s subscription model.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOiX_aQ0xr8NqA",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/judcprice/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "Jud Price",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOjB_uFnYwVb6_",
            },
            {
              serviceLink: "https://www.linkedin.com/in/john-schallau-a66ab63/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "John Schallau",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOj6_HsnjZcbDs",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOc0_Nf93d03XF",
          storyId: "a006g00000fRwfmAAC",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#F5F7FA",
          secondaryfontcolor: "#939393",
          secondaryfont: "Arial",
          secondarycolor: "#F1F1F1",
          projectSectionData: {
            videoLink: null,
            title:
              "Autify Standardizes Processes with Salesforce to Increase Renewals",
            teamSize: null,
            paragraph2:
              "<p>Managing Sales and Marketing teams is difficult, but for Autify, it was even more challenging. Two business units are located in different countries, and each team used different tools and processes to track and manage customers from lead to close. This made it difficult to get a wholistic view of the business&#39;s health. And, it was hard to scale. Cloud Pathfinder helped Autify get both teams on a single platform and get a clearer picture of Sales and Marketing efforts, making it easier to manage - and grow - the company&#39;s subscription model.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBEFEA3_NNZbSXhGa",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Growing SaaS companies often struggle with the same challenge. They start using tech tools fit for their current size, and quickly grow out of them. Autify was experiencing a similar story. The company grew so much by 2021 that their tools were no longer supporting sales and marketing processes. They were losing track of leads, and customers were not renewing their subscriptions! On top of that, Autify had expanded to the US and was now trying to manage multiple business units in two different countries - each with different sales and marketing cultures, processes, and tools. It was becoming harder and harder to understand the company&#39;s overall growth.</p>\n<p>Cloud Pathfinder has worked with many growing SaaS companies that need to combine disparate databases, processes, and tools to get a clear picture of the business health. When we started working with Autify, we first discussed what the team wanted to accomplish so we could design a Salesforce strategy to support those goals. Then, we spent time with each country&#39;s sales &amp; marketing team to learn their specific processes, and better understand how to manage the differences. Finally, we implemented Salesforce and Pardot and created custom workflows for each team.</p>\n<p>Now, each team can follow their best practices, but the data collected along the way flows up to reports that provide the vital information Autify&#39;s management needs to keep track of the the company&#39;s overall sales and marketing efforts. With one single source of truth and one view of the business, Autify can keep better track of subscription renewals and reduce contract churn with a tool that will grow with them.</p>\n<p> </p>\n<p>Business Objectives:</p>\n<ul><li>Increase the number of upgrades &amp; upsells of subscription product.</li><li>Increase total contract value per customers.</li><li>Improve Subscription management and reduce churn.</li></ul>",
          },
          projectBoundariesData: {
            rightStatus: "$40,000-$70,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#170046",
          primaryfont: "Helvetica",
          primarycolor: "#008AD9",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Autify is a no-code, ai-powered software test automation tool. It quickly creates and maintains automated tests by monitoring how a user interacts with an application. Autify is an AWS partner and has raised over $13M in growth capital, including a $10M Series A round, to expand operations globally and add mobile testing capabilities.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "4030740",
          linecolor: "#008AD9",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOVn_kP_aF6Z6t",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce Sales Cloud", "Pardot"],
            Timeline: ["4-8 weeks"],
            Budget: ["$40,000-$70,000"],
            Industry: ["High Tech"],
            Company: ["Cloud Pathfinder LLC"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "September 30, 2021",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBE5EAN_rSAoCAhMQ",
                heading:
                  "Evaluate Sales & Marketing Practices from Both Business Units",
                descriptionLine2: "",
                descriptionLine1:
                  "To build a solution that would support Autify's long-term growth plans, we first learned about their business goals, the processes each team follows, the data they collect, and the information leadership needs.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "October 2021",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBEAEA3_UxDHTqUMmV",
                heading: "Configure Custom Workflows for Sales & Marketing",
                descriptionLine2: "",
                descriptionLine1:
                  "Some of Autify's processes were kept separate to allow the teams in the US and Japan to follow best practices for each country. Others were combined or implemented as a company-wide standard.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "October 2021",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBDvEAN_PjgTdhh9h",
                heading: "Create Custom Reports & Dashboards",
                descriptionLine2: "",
                descriptionLine1:
                  "Once processes were developed in Salesforce, we set up custom reports that would show Autify's leadership business metrics that matter, like which customers were up for renewals and which customers were qualified for a cross or upsell.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "August 31, 2021",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Byva9EAB_h9JrM6s7B",
                heading: "Understand the business goals & objectives",
                descriptionLine2: "",
                descriptionLine1:
                  "We begin each engagement taking time to understand our clients' desired business outcomes and what the Salesforce work will do for their team, company, and customers.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "You’ve Chosen Salesforce, now it’s time to realize maximum ROI and business processes without upending your organization or prevailing infrastructure.",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "FFFFFF",
        },
        {
          website: "http://www.cloudpathfinderconsulting.com",
          valueSectionsData: [
            {
              heading: "MessageGears Culture",
              description:
                'MessageGears was looking for advice, best practices, and a team that could help them figure out how to improve their RevOps tech stack and then do it. Cloud Pathfinder has worked closely with MessageGears to strategically map how Salesforce will operate with the company\'s broader tech stack, and provided "boots on the groud" services such as implementation and migration to get it done.',
            },
            {
              heading: "Why Now",
              description:
                "MessageGears has just hired a new Revenue Operations Manager. Salesforce was implemented when they were 6x smaller, and now their system was way outdated. It was time to upgrade Salesforce and how it worked with their other systems to match the company's growth and to support the new Revenue Operations Manager in doing her job.",
            },
            {
              heading: "Other Things to Note",
              description:
                "During the Forward workshop, we advised MessageGears on potential ways to leverage Salesforce Sales Cloud, Pardot, and CPQ for their sales and marketing processes. The Forward workshop is an opportunity for customers to align their Salesforce use to their goals and business objectives, before committing to a larger implementation project.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Cloud Pathfinder Helped MessageGears Optimize Salesforce for 6x Growth",
            table: [
              {
                valueName: "MessageGears",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "High Tech",
                keyName: "INDUSTRY",
              },
              {
                valueName: "3-4 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBWREA3_Ut1tSba0-",
            layout: "Original",
            description:
              "<p>&quot;Salesforce just doesn&#39;t work for us anymore.&quot; That&#39;s what MessageGears was saying in 2021 when they had grown from 10 to 60 people. Over time they had developed more sophisticated processes for revenue operations, but nothing was documented, and unfortunately, no one on the team had the skills to build Salesforce to align to these processes. The disorganization that ensued in their Salesforce Org made it difficult to report on any data. It was time to bring in a partner to help.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOiX_aQ0xr8NqA",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/judcprice/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "Jud Price",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOjB_uFnYwVb6_",
            },
            {
              serviceLink: "https://www.linkedin.com/in/marisamault/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Marisa Mault",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOjL_7J_nz4wLRl",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOc0_Nf93d03XF",
          storyId: "a006g00000fRwhYAAS",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#F5F7FA",
          secondaryfontcolor: "#939393",
          secondaryfont: "Arial",
          secondarycolor: "#F1F1F1",
          projectSectionData: {
            videoLink: null,
            title:
              "Cloud Pathfinder Helped MessageGears Optimize Salesforce for 6x Growth",
            teamSize: null,
            paragraph2:
              "<p>&quot;Salesforce just doesn&#39;t work for us anymore.&quot; That&#39;s what MessageGears was saying in 2021 when they had grown from 10 to 60 people. Over time they had developed more sophisticated processes for revenue operations, but nothing was documented, and unfortunately, no one on the team had the skills to build Salesforce to align to these processes. The disorganization that ensued in their Salesforce Org made it difficult to report on any data. It was time to bring in a partner to help.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBVdEAN_JfjyPN7Op",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>For seven years, MessageGears trudged their way through using Salesforce classic, stacking Sales, Marketing, and other Revenue Operations tech on top without a clear plan or understanding of how to make it all work. The new Revenue Operations Manager, Erica, said that using these tools was &quot;very overwhelming&quot; for new people. Because of this, MessageGears was a perfect candidate for our Forward Business Process Advisory Workshop. We start by reviewing business processes, the current Salesforce org and attached tools, and getting clear on the business&#39;s future state goals and initiatives. Then, we map the business objectives to Salesforce feattures and functionality, and provide a deployment plan, cost-benefit analysis, and a solution roadmap that includes process simplification and opportunities for automation.</p>\n<p>After going through the workshop, the team at MessageGears felt relieved and hired Cloud Pathfinder&#39;s team to migrate their org from Salesforce Classic to Lightning. We ensured the best practices for sales processes were implemented in one clear approach to using Salesforce, and cleaned up the customizations to eliminate confusion for new people coming into the org. Finally, we mapped third party tools to ensure information was flowing accurately and the team could create better reports.</p>\n<p>MessageGears plans to double their size in the next year and now, thanks to Cloud Pathfinder, they have the systems in place to do it as painlessly as possible.</p>\n<p> </p>\n<p>Business Objectives:</p>\n<ul><li>Create consistency and standards for sales processes in Salesforce.</li><li>Reduce confusion and streamline tech stack.</li><li>Improve reporting for better business intelligence.</li></ul>",
          },
          projectBoundariesData: {
            rightStatus: "$20,000-$40,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#170046",
          primaryfont: "Helvetica",
          primarycolor: "#008AD9",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "MessageGears is and enterprise customer engagement platform that is used by some of the world's largest brands, including TMobile, Expedia, and WebMD. The platform enables companies to use all of their data to provide timely, personalized messaging to customers. Founded in 2010, the company raised $18.4M in venture capital in 2020.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "4030740",
          linecolor: "#008AD9",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOVn_kP_aF6Z6t",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce Sales Cloud", "Pardot"],
            Timeline: ["3-4 Months"],
            Budget: ["$20,000-$40,000"],
            Industry: ["High Tech"],
            Company: ["Cloud Pathfinder LLC"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "January 2022",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000ByvbMEAR_s2wJbFJ8Ue",
                heading: "Ongoing support & Enhancements / optimization",
                descriptionLine2: "",
                descriptionLine1:
                  "To ensure adoption of the refreshed tool and that MessageGears would see an ROI from their additional investment in Salesforce configuration, we provided additional support and optimization to make the tool as easy as possible to use.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "December 2021",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBVTEA3_s1L2FXj0h",
                heading: "Lightning Migration & Sales Cloud Configuration",
                descriptionLine2: "",
                descriptionLine1:
                  "MessageGears was still using Salesforce Classic, so we migrated their org to Salesforce Lightning and implemented the refreshed and optimized processes that were outlined during the Forward workshop.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "October 2021",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000ByvbHEAR_U4dQkB2Sc",
                heading: "Forward Business Process Advisory Workshop",
                descriptionLine2: "",
                descriptionLine1:
                  "During our workshop, we looked for ways to optimize the processes, align them to Salesforce features and functionality, and sought opportunities to reduce the tech stack or align the processes to some of the best options that integrate with Salesforce.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "September 2021",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000ByvbCEAR_9QRsbgnuR",
                heading: "Understand the Business Goals & Objectives",
                descriptionLine2: "",
                descriptionLine1:
                  "We begin each engagement taking time to understand our clients' desired business outcomes and what the Salesforce work will do for their team, company, and customers.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "You’ve Chosen Salesforce, now it’s time to realize maximum ROI and business processes without upending your organization or prevailing infrastructure.",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "FFFFFF",
        },
        {
          website: "http://www.cloudpathfinderconsulting.com",
          valueSectionsData: [
            {
              heading: "Acuity Culture",
              description:
                "For their tech-savvy marketing team, it was most important to bring in a Salesforce partner who could bounce ideas around with them, provide a strategy to achieve their goals - and then execute on the strategy with real Salesforce expertise. Cloud Pathfinder acts as the true consultants for the team, providing strategy, direction, and support in executing the plans.",
            },
            {
              heading: "Why Now",
              description:
                "Mailchimp had worked for Acuity Brands for a long time. But as the company grew they needed a more robust tool to help them create better, more personalized and targeted campaigns that would sync seamlessly with their sales tools, and reduce the silos between Sales and Marketing information.",
            },
            {
              heading: "Other Things to Note",
              description:
                "Cloud Pathfinder has also provided CPQ advisory to the Acuity Brands team, helping develop their sales process even further to reduce friction, improve consistency and decrease the information silos.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Acuity Brands Moves onto Salesforce to Improve Marketing & Sales Collaboration",
            table: [
              {
                valueName: "Acuity",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Manufacturing",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over a year",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzB7MEAV_CTnbwt_dx",
            layout: "Original",
            description:
              "<p>With Cloud Pathfinder&#39;s guidance and support, Acuity Brands now has a more robust marketing system with better analytics, lead management, and collaboration between tools &amp; teams.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOiX_aQ0xr8NqA",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOic_wTbtCzcSU",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/john-schallau-a66ab63/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "John Schallau",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOj6_HsnjZcbDs",
            },
            {
              serviceLink: "https://www.linkedin.com/in/judcprice/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "Jud Price",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOjB_uFnYwVb6_",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOc0_Nf93d03XF",
          storyId: "a006g00000fRwXxAAK",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#F5F7FA",
          secondaryfontcolor: "#939393",
          secondaryfont: "Arial",
          secondarycolor: "#F1F1F1",
          projectSectionData: {
            videoLink: null,
            title:
              "Acuity Brands Moves onto Salesforce to Improve Marketing & Sales Collaboration",
            teamSize: null,
            paragraph2:
              "<p>With Cloud Pathfinder&#39;s guidance and support, Acuity Brands now has a more robust marketing system with better analytics, lead management, and collaboration between tools &amp; teams.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzB4hEAF_0EqYIAWwZ",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>The marketing team at Acuity Brands is already highly skilled and Salesforce-savvy. But like most marketing teams, they have more to do than time to do it. Acuity Brands&#39; Director of Demand Generation wanted his marketers to focus on marketing, not on managing Salesforce and other martech. So he decided to bring in a true consultant who could help the team determine their next best steps, then do the work to get it done. Cloud Pathfinder was selected because of our experience in advising large, multi-brand companies on complex Salesforce solutions, including Pardot and other marketing tools.</p>\n<p> </p>\n<p>Business Objectives:</p>\n<ul><li>Better campaign alignment between marketing tools and Salesforce CRM.</li><li>Improve marketing analytics, lead qualification and conversion capabilities.</li><li>Increase in results from marketing efforts.</li></ul>",
          },
          projectBoundariesData: {
            rightStatus: "$70,000-$100,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#170046",
          primaryfont: "Helvetica",
          primarycolor: "#008AD9",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Acuity Brands is a market-leading industrial technology company that provides both lighting products and systems to create solutions for all spaces. Acuity Brands is headquartered in Atlanta, GA and operating throughout the US, Europe, and Asia.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "4030740",
          linecolor: "#008AD9",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "a",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOVn_kP_aF6Z6t",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Pardot", "Salesforce Sales Cloud", "Mailchimp"],
            Timeline: ["Over a year"],
            Budget: ["$70,000-$100,000"],
            Industry: ["Manufacturing"],
            Company: ["Cloud Pathfinder LLC"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "Week 1",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzB4mEAF_1ReZFudRN",
                heading: "Understand the business goals & objectives",
                descriptionLine2: "",
                descriptionLine1:
                  "We begin each engagement taking time to understand our clients' desired business outcomes and what the Salesforce work will do for their team, company, and customers.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Week 2",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzB4rEAF_9TNlZCyYI",
                heading:
                  "Evaluate Current MarTech stack & decide which tools to keep, integrate or drop",
                descriptionLine2: "",
                descriptionLine1:
                  "Acuity Brands' marketing team was still using Mailchimp, and had greatly outgrown the platform. We looked at what was working with the tool, and what needed to be changed.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Week 3-4",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzB56EAF_kLLKLsYPj",
                heading: "Set up Pardot Lightning App inside Salesforce CRM",
                descriptionLine2: "",
                descriptionLine1:
                  "Pardot is a robust B2B servicing marketing tool in the suite of Salesforce products that allows marketers to segment and target customers in multiple ways.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Week 5-6",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzB5BEAV_SHFyv3Hbw",
                heading: "Align Campaigns 1:1 within Salesforce",
                descriptionLine2: "",
                descriptionLine1:
                  "To ensure data flows accurately into Salesforce, we helped the team set up and understand the importance of consistency in campaigns.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Week 7",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzB5GEAV_s-8Vu2jpt",
                heading: "Configure B2B Marketing Analytics Dashboards",
                descriptionLine2: "",
                descriptionLine1:
                  "We worked with the marketing team to determine which information was most important, how KPIs are measured and what data needed to be captured, and then built reports to reflect the data.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Week 7",
                order: "6",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzB5LEAV_nnNoh9Kxg",
                heading:
                  "Incorporate Best Practices for Lead Qualification & Conversion",
                descriptionLine2: "",
                descriptionLine1:
                  "Our Solution Architect Chris provided the team with some best practices for determining who is a qualified lead and how to follow the lead conversion process as a marketer.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Week 8-9",
                order: "7",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzB5QEAV_MQJKdKdZi",
                heading: "Migrate Mailchimp Content into Pardot",
                descriptionLine2: "",
                descriptionLine1:
                  "We helped Acuity Brands move their content and data between systems with careful, deliberate planning and action to ensure everything was captured and moved accurately into the new tool.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "You’ve Chosen Salesforce, now it’s time to realize maximum ROI and business processes without upending your organization or prevailing infrastructure.",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "FFFFFF",
        },
        {
          website: "http://www.cloudpathfinderconsulting.com",
          valueSectionsData: [
            {
              heading: "Sentient Culture",
              description:
                "Cloud Pathfinder has proudly supported Sentient Energy through implementations of Sales Cloud and Pardot. We helped the team get started with the new platform and provide ongoing support to continuously optimize the tool to improve efficiencies and accuracy of forecasts. We have partnered closely with the Senior Manager of Systems Implementation for the past ~2 years to support Sentient's development with the Salesforce platform.",
            },
            {
              heading: "Why Now",
              description:
                "In 2019 Sentient Energy had plans to grow the sales team and exponentially increase revenue. At the time, sales used Zendesk Sell Legacy as a CRM. It wasn't capable of supporting the complexity of Sentient's sales cycles, which forced the sales team to do a lot of manual work and limited the accuracy of financial projections.",
            },
            {
              heading: "Other Things to Note",
              description:
                "To help the Sales team stay on top of client needs, Cloud Pathfinder also implemented TaskRay, a project management tool that helps teams keep track of operations within their Salesforce. This native tool eliminated the need to toggle between tools and improved the customer experience, ultimately helping Sentient retain existing customers.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Sentient Energy Reduces Manual Sales and Marketing Efforts with Salesforce",
            table: [
              {
                valueName: "Sentient",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Energy",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over a year",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzEaZEAV_ZZMFbbn6A1",
            layout: "Original",
            description:
              "<p>Cloud Pathfinder helped Sentient Energy clean up their tech stack and align Salesforce to their go-to-market operations. Now, they run coordinated sales and marketing efforts to drive leads through a funnel with minimal manual labor, freeing up their Sales team to focus on what&#39;s most important - customers.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description:
                "\"Mark's great. Love working with him. We're getting a lot done.\"",
              author: "Jeff ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOlb_csl85k20X",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/judcprice/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "Jud Price",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOjB_uFnYwVb6_",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Mark Albano",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOk9_uacCWmqLR",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOc0_Nf93d03XF",
          storyId: "a006g00000fRwa8AAC",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#F5F7FA",
          secondaryfontcolor: "#939393",
          secondaryfont: "Arial",
          secondarycolor: "#F1F1F1",
          projectSectionData: {
            videoLink: null,
            title:
              "Sentient Energy Reduces Manual Sales and Marketing Efforts with Salesforce",
            teamSize: null,
            paragraph2:
              "<p>Cloud Pathfinder helped Sentient Energy clean up their tech stack and align Salesforce to their go-to-market operations. Now, they run coordinated sales and marketing efforts to drive leads through a funnel with minimal manual labor, freeing up their Sales team to focus on what&#39;s most important - customers.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000BzBBfEAN_nDhT98ND9",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>When Cloud Pathfinder began working with Sentient Energy, we spent a lot of time understanding where they experienced challenges in their day to day work. Sentient Energy was using multiple tools to support marketing efforts, sales operations, and client projects. Additionally, the technology they were using didn&#39;t align to their actual day-to-day tasks. All the disparate tools and misalignment led to a lot of manual data entry and significant issues creating accurate sales and financial forecasts. Our first step was to provide a roadmap for consolidating the tools and aligning Sentient&#39;s technology spend to the vital sales &amp; marketing operations.</p>\n<p> </p>\n<p>Business Objectives:</p>\n<ul><li>Improve alignment of technology to actual Sales.</li><li>Process Reduce inefficiencies and manual data entry.</li><li>Increase accuracy of sales and financial forecasts.</li><li>Improve coordination between Marketing &amp; Sales.</li></ul>\n<p> </p>",
          },
          projectBoundariesData: {
            rightStatus: "$200,000-$300,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#170046",
          primaryfont: "Helvetica",
          primarycolor: "#008AD9",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Sentient Energy, a Koch Engineered Solution company, helps electric utilities deliver safe, reliable, smart power. Sentient is an energy software and hardware technology company, and a premier provider of intelligent sensing, data analytics, optimization, and control technologies for the distribution grid.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "4030740",
          linecolor: "#008AD9",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "aaa",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOVn_kP_aF6Z6t",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Sales Cloud",
              "SF Experience Cloud",
              "TaskRay",
            ],
            Timeline: ["Over a year"],
            Budget: ["$200,000-$300,000"],
            Industry: ["Energy"],
            Company: ["Cloud Pathfinder LLC"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [
              {
                period: "Month 1",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOmU__RcbeiVVN",
                heading: "Understand the business goals & objectives",
                descriptionLine2: "",
                descriptionLine1:
                  "We begin each engagement taking time to understand our clients' desired business outcomes and what the Salesforce work will do for their team, company, and customers.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Month 1",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000ByvYDEAZ_y8WG0I6TP.bin",
                heading: "Evaluate Current Sales & Marketing Tech stack",
                descriptionLine2: "",
                descriptionLine1:
                  "Once we understood which tools Sentient's Sales & Marketing team were using and compared them to the processes and activities that happened day to day, we were able to identify better tools within the Salesforce product suite that fit the team's needs.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Month 2-3",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000ByvYXEAZ_WtPswzs7x",
                heading:
                  "Implement Sales Cloud with custom Proposal & Quote Process",
                descriptionLine2: "",
                descriptionLine1:
                  "To support Sentient Energy's sales team with quoting and proposals, we created custom objects and designed the process in Sales Cloud to limit manual data entry and provide insight into how prospects move through the pipeline.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Month 4-5",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000ByvYSEAZ_ruvV5-Aax",
                heading: "Implement Pardot & Sync with Sales Cloud",
                descriptionLine2: "",
                descriptionLine1:
                  "After a successful Sales Cloud implementation, we implemented Pardot to enable marketing and sales to run a coordinated effort in driving leads through a funnel and into the sales pipeline.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Month 6",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000ByvYcEAJ_CDOU8k6mJn",
                heading: "Provide Training & Documentation",
                descriptionLine2: "",
                descriptionLine1:
                  "To ensure Sentient got the most value from their Salesforce investment, we provided training and documentation to ensure Sales, Marketing, and others were able to effectively use their new tools.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Month 7+",
                order: "6",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000ByvYmEAJ_lE2VJAKC8",
                heading: "Optimize the Org",
                descriptionLine2: "",
                descriptionLine1:
                  "Now, Cloud Pathfinder provides ongoing support to ensure Sentient's Salesforce org is well-maintained and growing in capabilities along with their business.",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description:
            "You’ve Chosen Salesforce, now it’s time to realize maximum ROI and business processes without upending your organization or prevailing infrastructure.",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "FFFFFF",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOVn_kP_aF6Z6t",
      fav_image: "",
      contact_us: "https://www.cloudpathfinderconsulting.com/contact-us/",
      account_description:
        "You’ve Chosen Salesforce, now it’s time to realize maximum ROI and business processes without upending your organization or prevailing infrastructure.",
    },
    {
      title: "HebronSoft",
      teamId: "0016g000024XmerAAC",
      stories: [
        {
          website: "https://hebronsoft.com/",
          valueSectionsData: [
            {
              heading: "Vova Trailers Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "The primary goal of implementing IoT monitoring systems in Vova trailers is to enable their owners to gain remote control over appliances or services through a tablet or mobile application. In the long run, it dramatically increases customer satisfaction and boosts the company's revenue.",
            },
            {
              heading: "Other Things to Note",
              description:
                "Considering the project requirements and the complex nature of IoT, the solution we delivered to the Vova Trailers company included:\nA mobile/tablet application for trailer owners, family members, and tenants.\nA web-based application for support.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "IoT Monitoring and Management System for Travel Trailers",
            table: [
              {
                valueName: "Vova Trailers",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Travel, Transportation, & Hospitality",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CrcnaEAB_EHVPV_Lac",
            layout: "Original",
            description:
              "<p>Vova Trailer is one of the leading US manufacturers of premium-class travel trailers, mobile homes, and other recreational vehicles. The company asked us to deliver an IoT remote monitoring system to let trailer-owning users control a hardware bundle via mobile apps across connected devices and platforms.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR0_JJ2o0aUJu0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRQv_K9-YWh1I1",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR5_Wxb1fwtXH",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZSa0_xjDiF3lra",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRRK_0h3uArj70",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/natalia-pavliv-32516b126/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "User Interface Design",
              name: "Natalya Pavliv",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWweEAH_Rbc2OoaI8o",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Anton Shpak",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXX4zEAH_0teUjA0iT",
            },
            {
              serviceLink: "https://www.linkedin.com/in/bohdan-bilas-6bb68550/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Technical Architect",
              name: "Bohdan Bilas",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWuJEAX_LFq2DX2Ex",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SR4V_axH5qYglA",
          storyId: "a006g00000hPPA8AAO",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#3E3E3E",
          secondaryfontcolor: "#7D7D7D",
          secondaryfont: "Raleway",
          secondarycolor: "#17A121",
          projectSectionData: {
            videoLink: null,
            title: "IoT Monitoring and Management System for Travel Trailers",
            teamSize: null,
            paragraph2:
              "<p>Vova Trailer is one of the leading US manufacturers of premium-class travel trailers, mobile homes, and other recreational vehicles. The company asked us to deliver an IoT remote monitoring system to let trailer-owning users control a hardware bundle via mobile apps across connected devices and platforms.</p>",
            paragraph1: "Increase value for customer",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CrcZoEAJ_t7EKYx5oM",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">The idea behind the IoT monitoring platform for Vova Trailer was the delivery of smooth interoperability between the hardware, an app, and electronically controlled systems.</p>\n<p dir="ltr">In view of that, a solution was meant to support different scenarios, like web and mobile versions for internal and external use. In other words, our goal was to provide the client with a platform accessible through the Internet via any device. Besides, it must provide instruments for managing the assets of the trailer owners and the company&#39;s representatives. So, the system should have the user roles like trailer owner, family members, rent mode, and support. Moreover, each role was supposed to have different access levels to the platform&#39;s functionality and data.</p>\n<p dir="ltr">Another aspect of the IoT solution we were asked to deliver was an option to control different types of trailer appliances remotely, like:</p>\n<ul><li dir="ltr">\n<p dir="ltr">sockets</p>\n</li><li dir="ltr">\n<p dir="ltr">lighting</p>\n</li><li dir="ltr">\n<p dir="ltr">curtains</p>\n</li><li dir="ltr">\n<p dir="ltr">cameras</p>\n</li><li dir="ltr">\n<p dir="ltr">security</p>\n</li><li dir="ltr">\n<p dir="ltr">heating system</p>\n</li><li dir="ltr">\n<p dir="ltr">multimedia</p>\n</li></ul>\n<p dir="ltr">Vova Trailer wanted the platform to send notifications about security from motion, door opening, glass break sensors as well as a GPS tracking system. Furthermore, as safety inside the trailer is also a concern, the Client had a need to enable safety alerts notifying about smoke/fire, water leaks, and electric and diesel vapor/gas issues through special sensors. Other notifications that the system was supposed to provide included water &amp; electricity levels and tire pressure.</p>\n<p dir="ltr">The possibility of collecting data for further predictions, analytics, and sending notifications was another requirement. Also, the system should be flexible regarding appliance use and offer various safety, security, lighting, and heating scenarios.</p>\n<p dir="ltr">The customer wanted the platform to be equipped with a sophisticated security system. In addition, considering the IoT system users&#39; needs, Vova Trailers requested the solution to be accessed without an Internet connection.</p>\n<h3 dir="ltr">Project Role</h3>\n<ol><li>To decrease cost and improve the UX of customers united into the community;</li><li>Unique personal experience within using the product and software;</li><li>The IoT system works in synergy with the residents, providing a new level of comfort;</li><li>To resolve construction and mobility issues.</li></ol>\n<p dir="ltr"> </p>',
          },
          projectBoundariesData: {
            rightStatus: "$700,000-$1,000,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3E3E3E",
          primaryfont: "Raleway",
          primarycolor: "#17A121",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Vova Trailers is one of the leading companies in the USA, manufacturing high-end travel trailers, mobile homes, and more. By combining proven construction practices with recent technological achievements, the company produces recreational vehicles that let travelers explore the world. without leaving their comfort zone. The trailers are equipped with electricity, water, and advanced security systems to make you feel at home, even on the other side of the continent.",
          },
          metadataname:
            "Implementation of IoT Monitoring and Management System",
          metadatadescription:
            "Here is a story of how we delivered an IoT monitoring and management system for one of the leading manufacturers of travel trailers.",
          linkedinPartnerId: "",
          linecolor: "#17A121",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "story",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SQaf_Tm8Hd_s5z",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "AWS",
              "NgRx",
              "Angular",
              "Node.js",
              "Nest.js",
              "Flutter",
            ],
            Timeline: ["5-7 Months"],
            Budget: ["$700,000-$1,000,000"],
            Industry: ["Travel, Transportation, & Hospitality"],
            Company: ["HebronSoft"],
          },
          faviconimage:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZU42_kdAbnVeCz",
          diagramData: {
            diagramList: [
              {
                period: "November, 2021",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CrcahEAB_H10yvZXJw",
                heading: "Technical Discovery & Business Analysis",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "January, 2022",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CrcpbEAB_emv3-vNdg",
                heading: "UI/UX Design",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "March, 2022",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CrcpgEAB_PTXPfR9xh",
                heading: "Back End Development Finished",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description: "Consulting",
          calendlyLink: "",
          breadcrumbslabel: null,
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#AEC7EE",
        },
        {
          website: "https://hebronsoft.com/",
          valueSectionsData: [
            {
              heading: "Volunteer Centre County Culture",
              description:
                "What Our Client Believes In\nVCC focuses on delivering inclusive services that would help volunteers and community partners communicate more effectively through an easy-to-navigate platform. Volunteer Centre County puts privacy, data protection, and operational efficiency at the core. Its mission is to help the community thrive by allowing proactive people to become involved in the commune life.",
            },
            {
              heading: "Why Now",
              description:
                "Discovering the Case Studies for Web Development in More Detail\nVCC's legacy website was hard to navigate and didn't make the cut of modern UI standards. Besides, it had limited functionality for managing volunteering projects and allowing the organization's staff to work effectively and efficiently.\n\nVCC aimed to empower a volunteering movement in Pennsylvania with easy-to-access web space for sharing and finding volunteering projects faster. Our company delivered a responsive website one could use from any device. It had straightforward navigation that allowed users to quickly find the required information. Besides, a new solution had a more appealing design, which had a huge impact on establishing a more solid reputation within the community.\n\nAs an old platform had a minimal capacity for managing the charitable organization, our custom web development company took on building a solution that would provide features for more accurate role management. As a result, VCC got an option of granting different levels of access to resources and managerial possibilities depending on the role.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Web Development and Web Design Case Study for Nonprofit",
            table: [
              {
                valueName: "Volunteer Centre County",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Nonprofit",
                keyName: "INDUSTRY",
              },
              {
                valueName: "7-12 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DRFPGEA5_ZWE2K0v0HX",
            layout: "Original",
            description:
              '<p dir="ltr">Volunteer Centre County (VCC) requested a complete redesign of the legacy platform for volunteers, a place where one can find and provide talent or humanitarian relief for a charity project</p>\n<p dir="ltr">Our team took on transforming the online space for this nonprofit organization quickly. HebronSoft fulfilled VCC’s request by implementing a new platform along with an admin panel for website management. Along with an improved interface and optimized website navigation, this solution also included features critical for VCC&#39;s successful performanc</p>',
          },
          testimonialsData: [
            {
              industry: "Founder & Managing Director VCC",
              description:
                "I enjoy working with HebronSoft because they care about me as a client. They care about the people they work with and for. HebronSoft employees take time to know their clients' personalities and needs. This relationship is very important to creating trust and confidence. I recommend HebronSoft, and look forward to many many years ahead working with their team.",
              author: "Ann Echols",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRRK_0h3uArj70",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR5_Wxb1fwtXH",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR0_JJ2o0aUJu0",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/%D0%B2%D0%B0%D1%81%D0%B8%D0%BB%D1%8C-%D0%B4%D1%8F%D1%87%D0%B8%D0%BA-b697a3a2/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Vasyl Diachyk",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWv2EAH_Nhn0zYD9N",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/natalia-pavliv-32516b126/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "User Experience and Process Design",
              name: "Natalya Pavliv",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWweEAH_Rbc2OoaI8o",
            },
            {
              serviceLink: "https://www.linkedin.com/in/olha-marko-ba90a81b/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Olha Marko",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWw5EAH__Vw6OjQRw",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SR4V_axH5qYglA",
          storyId: "a006g00000hQsI9AAK",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#3E3E3E",
          secondaryfontcolor: "#7D7D7D",
          secondaryfont: "Raleway",
          secondarycolor: "#17A121",
          projectSectionData: {
            videoLink: null,
            title: "Web Development and Web Design Case Study for Nonprofit",
            teamSize: null,
            paragraph2:
              '<p dir="ltr">Volunteer Centre County (VCC) requested a complete redesign of the legacy platform for volunteers, a place where one can find and provide talent or humanitarian relief for a charity project</p>\n<p dir="ltr">Our team took on transforming the online space for this nonprofit organization quickly. HebronSoft fulfilled VCC’s request by implementing a new platform along with an admin panel for website management. Along with an improved interface and optimized website navigation, this solution also included features critical for VCC&#39;s successful performanc</p>',
            paragraph1: "Build a stronger customer relationship",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DRF9VEAX_OUrL0c5hR",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<h2 dir="ltr">Helping a Nonprofit Organization Improve the Community&#39;s Well-Being - A Web Development Case Study</h2>\n<p dir="ltr">Volunteer Centre County (VCC) in PA is a nonprofit organization that helps volunteers and donors communicate better. It provides a single hub where volunteers and organizations can inform each other about the current inquiries for services or goods. At the same time, people using this platform learn about the demand and donate the required goods or assist in other ways.</p>\n<p dir="ltr">The delivered website provides a centralized platform for pinpointing local charities’ needs for time, talent, and usable goods. In this way, everyone willing to contribute to the community&#39;s well-being can play a part and make a difference.</p>\n<h2 dir="ltr">Web Design Case Study: Turn Challenges Into New Opportunities</h2>\n<p dir="ltr">At the outset, an existing platform could no longer meet VCC’s needs as it lacked critical functionality, was hard to maintain and had an outdated interface.</p>\n<p dir="ltr">Within the MVP stage, HebronSoft developed a website for independent volunteers and charity organizations based on the Client&#39;s input requirements. The redesigned website is user-friendly and has extended functionality, which allows for more efficient management of VCC. In addition, this platform advances independent volunteering opportunities and matches individual volunteers with charity organizations or projects that require labor or specific items. </p>\n<h2 dir="ltr">Who Benefits from This VCC Website?</h2>\n<p dir="ltr">At VCC&#39;s request, we built a responsive and user-friendly web platform for:</p>\n<p dir="ltr">1) community partners and managers to make volunteer inquiries; </p>\n<p dir="ltr">2) volunteers who have enough resources and are willing to make their contribution to the project.</p>\n<p dir="ltr">We established a long-lasting partnership with the Volunteer Centre County. That is why HebronSoft is still working on adding new functionality and developing a mobile version for this ongoing project.</p>',
          },
          projectBoundariesData: {
            rightStatus: "$300,000-$450,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3E3E3E",
          primaryfont: "Raleway",
          primarycolor: "#17A121",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Volunteer Centre County is a nonprofit organization in Port Matilda, PA. It provides a free platform for community partners to inquire about volunteering labor or items. At the same time, it allows contributors to spot opportunities for sharing their talent and other resources. This way, volunteers and organizations clarify the current needs and resources available for their fulfillment.",
          },
          metadataname: "Nonprofit Web Development and Web Design Case Study",
          metadatadescription:
            "Here is a web development and web design case study showcasing how our company redeveloped a platform for Volunteer Centre County, a nonprofit organization.",
          linkedinPartnerId: "",
          linecolor: "#17A121",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5mnOEAR_3XCsEJV4R",
            roiMoment:
              "It was Sep-Oct when we saw more Community Partners and Volunteers joining the platform.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment:
              "It was summer 2022 - dedication of the whole team and client, testing and deployments we RELEASED. It was a joy and happiness.",
            redMomentImage: "",
            redMoment:
              "In the middle of the development we realized that we are slightly behind the schedule. We got together, designed the plan how to navigate, estimated the remediation actions and communicated how to steer the project. In such moments you realize that trusted relationshops win, we agreed the process and sucessfully delivered in time.",
            momentOfTrustImage: "",
            momentOfTrust:
              "It was back 2020 when we released the very first version of VCC. We reached the level of trust that helped us build relationship forward.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5mnJEAR_10Y8Kxn5r",
            eurekaMoment:
              "After a series of tests, explorations and protorypes we drafted the concept and the architecture of the future platform. On a  call where together with our client Ann we projected the impact of this project on community and society. It was about a week before Christmas.",
            dealClarityMomentImage: "",
            dealClarityMoment:
              "In this case we used a mix of prototyping, design and solutioning to narrow down the project details. We concentrated on value and impact too, building in the key of the connectivity between Community partners and volunteers. Ease of use, high standards to UX and implementation.",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SQaf_Tm8Hd_s5z",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Angular", "Node.js", "Nest.js", "AWS"],
            Timeline: ["7-12 Months"],
            Budget: ["$300,000-$450,000"],
            Industry: ["Nonprofit"],
            Company: ["HebronSoft"],
          },
          faviconimage:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZU42_kdAbnVeCz",
          diagramData: {
            diagramList: [],
          },
          description: "Consulting",
          calendlyLink: "",
          breadcrumbslabel: null,
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#AEC7EE",
        },
        {
          website: "https://hebronsoft.com/",
          valueSectionsData: [
            {
              heading: "Under NDA Culture",
              description:
                "The healthcare company creates cardiopulmonary devices, conducts research, and provides continuing education that is evidence-based and outcome-driven. All of those have a single purpose: to help millions of people sustain or reach their cardiopulmonary potential without pharmacologicals.",
            },
            {
              heading: "Why Now",
              description:
                "The 1980s' invention was designed to improve respiratory health and should be equipped with software that provides efficiency to end-users as well as administrative capabilities for medical staff to provide quality service.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Healthcare Software Development Case Study",
            table: [
              {
                valueName: "Under NDA",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "5",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DReimEAD_Vqv4hgAqp",
            layout: "Original",
            description:
              "<p>The healthcare application is a respiratory muscle training software we created for our client that works in conjunction with the two devices. It is aimed at helping users with everyday breathing performance sessions. The custom application includes training sessions, guides users through daily respiratory muscle training exercises, and tracks users&#39; progress.</p>",
          },
          testimonialsData: [
            {
              industry: "CEO",
              description:
                "Our company contracted Hebron Soft in 2018 to do a multi-year project to build a consumer portal and a medical portal for us to use for our medical devices to monitor our patients and users around the world. They've also built a mobile interface for phones, tablets, and automobile interfaces for our end users, a coaching app to help guide our customers/users through our treatment protocols/treatments for our hospital and home health clients and their patients. For our consumers, they also built something similar for athletic coaches/trainers and their athletes. The full system they have been building for us to commercialize will serve millions of people from around the world. Very exciting times ahead. Hebron meets deadlines, stays within budget, and they truly care about our success and go the extra mile every time we ask. They take a vested interest in our success, and I can't ask for more than that from a software firm.",
              author: "Under NDA",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZSZR_kcsJxXNn0Y",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRRK_0h3uArj70",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR5_Wxb1fwtXH",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZSa0_xjDiF3lra",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR0_JJ2o0aUJu0",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/andrii-chornyi-05369a199/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Andryi Chornyi",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWuiEAH_ByXr_BcfA",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Volodymyr Nazarko",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWwPEAX_j_0Uq5bFo",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/mykhailo-nizvetskyi-393261148/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Mykhailo Nizvetskyi",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWwUEAX_3Q7Sw0Mew",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/natalia-pavliv-32516b126/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "User Interface Design",
              name: "Natalya Pavliv",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWweEAH_Rbc2OoaI8o",
            },
            {
              serviceLink: "https://www.linkedin.com/in/bohdan-bilas-6bb68550/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Bohdan Bilas",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWuJEAX_LFq2DX2Ex",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SR4V_axH5qYglA",
          storyId: "a006g00000hR7D5AAK",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#3E3E3E",
          secondaryfontcolor: "#7D7D7D",
          secondaryfont: "Raleway",
          secondarycolor: "#17A121",
          projectSectionData: {
            videoLink: null,
            title: "Healthcare Software Development Case Study",
            teamSize: null,
            paragraph2:
              "<p>The healthcare application is a respiratory muscle training software we created for our client that works in conjunction with the two devices. It is aimed at helping users with everyday breathing performance sessions. The custom application includes training sessions, guides users through daily respiratory muscle training exercises, and tracks users&#39; progress.</p>",
            paragraph1: "Increase value for customer",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DRbUqEAL_1FHpTCUqK",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">Hebron Soft faced the following challenges while developing healthcare software:</p>\n<ul><li dir="ltr">\n<p dir="ltr">To create a user-friendly interface that is appropriate for people of all ages.</p>\n</li><li dir="ltr">\n<p dir="ltr">A large amount of data must be collected and processed.</p>\n</li><li dir="ltr">\n<p dir="ltr">To create a hierarchy view for Admins/Clinicians/Coaches to manage user data (creation, viewing, editing, and deletion).</p>\n</li><li dir="ltr">\n<p dir="ltr">To implement role-based security for all Admins/Clinicians/Coaches user levels, ensuring that all users correctly view and access data.</p>\n</li><li dir="ltr">\n<p dir="ltr">To develop a Care Plan Builder for Clinicians/Coaches that provides users with an accurate visual display.</p>\n</li><li dir="ltr">\n<p dir="ltr">To allow Admins to create companies that allow them to create their own hierarchy, set permissions for each role, and create Care Plans and Care Groups for their people.</p>\n</li></ul>\n<h3 dir="ltr">Values Delivered</h3>\n<p dir="ltr">We were successful in developing a complex, multifunctional healthcare software development solution for The Client. It included a medical web portal as well as mobile health and coaching apps to assist end-users in managing their electronic clinical records effectively. So, they can get the most out of their medical devices and make other health-related tasks easier.</p>\n<ul><li dir="ltr">\n<h3 dir="ltr">Custom Application for End-Users</h3>\n</li></ul>\n<p dir="ltr">The option of subscribing to Care Plans (depending on the device) to complete each task and set of activities.</p>\n<p dir="ltr">All necessary materials related to the treatment protocol, as well as instructions regarding the breathing session, are placed in the Help section.</p>\n<p dir="ltr">Dashboards display collective results for the day, week, month, or care plan.</p>\n<p dir="ltr">The option to add Advocates, or Secondary Teams (mother, father, sister, brother, uncle, aunt, friend, etc.), to remind them if they miss 4+ Breathing Sessions.</p>\n<p dir="ltr">Quick access to the Care Team contact info. Every end-user has the responsible Care Member (clinician, doctor that can not be changed by end-users) that is placed on the tab - Team.<br><strong><br></strong></p>\n<ul><li dir="ltr">\n<h3 dir="ltr">The Custom Management System</h3>\n</li></ul>\n<p dir="ltr">It is a web-based management system that allows Care Team Members (Admins, Clinicians, and Coaches) to add users (Admins, Clinicians, and Coaches) and end-users (patients, athletes, and coaches) to their care plans and track their progress.</p>\n<p dir="ltr"><br>The healthcare software allows:<br><br></p>\n<ul><li dir="ltr">\n<p dir="ltr">Establishment of own user hierarchy.</p>\n</li><li dir="ltr">\n<p dir="ltr">Creation of a specific Care Plan for end-users.</p>\n</li><li dir="ltr">\n<p dir="ltr">Grouping end-users with a Care Group, assigning a select number of Care Plans with the possibility to create their own roles for the hierarchy.</p>\n</li><li dir="ltr">\n<p dir="ltr">Tracking the end-user&#39;s progress.</p>\n</li><li dir="ltr">\n<p dir="ltr">Using a global Care Plan created by PN Admin.</p>\n</li><li dir="ltr">\n<p dir="ltr">Administering Care Groups to manage end-users.</p>\n</li></ul>',
          },
          projectBoundariesData: {
            rightStatus: "$450,000-$700,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3E3E3E",
          primaryfont: "Raleway",
          primarycolor: "#17A121",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "The healthcare company has helped enhance respiratory health and performance since 1980. Evidence-based science and cutting-edge research have helped the corporation innovate in goods and education for 40 years. The healthcare service provider has helped almost 2 million individuals breathe better, including those who seek to reduce chronic sickness or boost performance without medicines.",
          },
          metadataname: "Custom Healthcare Software Development Case Study",
          metadatadescription:
            "Read about custom healthcare application development for breathing devices that will help patients and users all over the world recover from COVID and app",
          linkedinPartnerId: "",
          linecolor: "#17A121",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SQaf_Tm8Hd_s5z",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Angular",
              "Flutter",
              "Node.js",
              "Nest.js",
              "Mongodb",
            ],
            Timeline: ["Over 2 Years"],
            Budget: ["$450,000-$700,000"],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["HebronSoft"],
          },
          faviconimage:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZU42_kdAbnVeCz",
          diagramData: {
            diagramList: [
              {
                period: "October 2018",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DRbUwEAL_vpOpMq7P_",
                heading: "Discоvery Phase",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "November 2018",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DRbVFEA1_iAcwy15Wb",
                heading: "UI/UX Finished",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "December 2018",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DRbVPEA1_qAPlPrAT-v",
                heading: "Development Started",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "June 2019",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DRbVjEAL_HMMHFDngs",
                heading: "MVP Phase End",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Ongoing",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DRbVtEAL_kAiMiDj4q",
                heading: "Post MVP Phase",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description: "Consulting",
          calendlyLink: "",
          breadcrumbslabel: null,
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#AEC7EE",
        },
        {
          website: "https://hebronsoft.com/",
          valueSectionsData: [
            {
              heading: "Developer Media Culture",
              description:
                "DailyBuild.com connects and empowers left-brained critical thinkers, such as Engineers, Software Developers, and Scientists with the goal of helping people everywhere live safer, more vibrant, more truly connected lives. By forging close partnerships with thousands of local publishers and businesses around the country, DailyBuild.com’s priority is to help a new generation of readers find and engage with vital, locally published content and information.",
            },
            {
              heading: "Why Now",
              description:
                "HebronSoft is an exclusive tech partner of DailyBuild.com. We are responsible for end-to-end solution implementation, developing news aggregator macroservices, cloud and DevOps infrastructure, and providing continuous support.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Digital Media Case Study - News Aggregator Site",
            table: [
              {
                valueName: "Developer Media",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Media & Entertainment",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSjmLEAT__AvqZOYJG",
            layout: "Original",
            description:
              '<p dir="ltr">Our client reached out to us looking for a custom news aggregation system. As a software development company, we equipped our client with high-end digital media development to maintain a system that collects information from all over the web and posts it in one location for visitors to access. It empowers users with a full scope of functions. Their custom-built aggregator searches for all publications, analyzes them, and provides all the important news for an individual who can subscribe to different communities.</p>',
          },
          testimonialsData: [
            {
              industry: "Founder & CEO",
              description:
                "Hebronsoft has proven to be a solid and reliable software development partner. They have helped us stand up prototypes and address emerging opportunities in a way we would have been unable to do otherwise. I can't say enough good things, they are kind, responsible, professional, reasonable and technically innovative. Five stars.",
              author: "David Cunningham",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZSZR_kcsJxXNn0Y",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRRK_0h3uArj70",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR5_Wxb1fwtXH",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR0_JJ2o0aUJu0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRQv_K9-YWh1I1",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/oleh-kosar-a5877887/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Oleh Kosar",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWvWEAX_iPtDM7t6m",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/mykhailo-nizvetskyi-393261148/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Mykhailo Nizvetskyi",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWwUEAX_3Q7Sw0Mew",
            },
            {
              serviceLink: "https://www.linkedin.com/in/bohdan-bilas-6bb68550/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Bohdan Bilas",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWuJEAX_LFq2DX2Ex",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SR4V_axH5qYglA",
          storyId: "a006g00000hRl3uAAC",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#3E3E3E",
          secondaryfontcolor: "#7D7D7D",
          secondaryfont: "Raleway",
          secondarycolor: "#17A121",
          projectSectionData: {
            videoLink: null,
            title: "Digital Media Case Study - News Aggregator Site",
            teamSize: null,
            paragraph2:
              '<p dir="ltr">Our client reached out to us looking for a custom news aggregation system. As a software development company, we equipped our client with high-end digital media development to maintain a system that collects information from all over the web and posts it in one location for visitors to access. It empowers users with a full scope of functions. Their custom-built aggregator searches for all publications, analyzes them, and provides all the important news for an individual who can subscribe to different communities.</p>',
            paragraph1: "Increase value for customer",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSjlhEAD_wRQExjyhH",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<h2 dir="ltr">Digital Media Web Development Challenges</h2>\n<p dir="ltr">According to our client’s project requirements and business logic, we launched digital media design and development of the custom news aggregating system that fully complied with two usage scenarios: </p>\n<ul><li dir="ltr">\n<p dir="ltr">Web solutions for internal (admin part) </p>\n</li><li dir="ltr">\n<p dir="ltr">External (website) use. </p>\n</li></ul>\n<h2>Values Delivered</h2>\n<p dir="ltr">There can be users and administrators in the system. An Admin can manage communities and add new publishers, filter all publications, and pin important publications for users.</p>\n<p dir="ltr">The aggregation system works with RSS and Twitter publishers. in the pipeline, the aggregator searches for all new articles, analyzes all of them, attaches tags to new publications based on keywords from the article&#39;s body, attaches all publications to different communities, and collects statistics and top articles. The system automates all the processes, increasing the overall efficiency level of the aggregator. With a clean, simple design, DailyBuild.com is a great result of digital media web development and an excellent way to follow the news.</p>\n<p dir="ltr">DailyBuild.com is one of the best news aggregator websites because you can follow as many worldwide topics and publications as you want. Or, if you want to narrow down your feed to local news, you can search for news by tags, keywords, regexes, and publishers. Also, each user can add news directly to this site, attach tags and provide information to different communities.</p>\n<p dir="ltr">What’s awesome about this content aggregator is that you can go from broad topics to very specific niche topics. Search for any hobby, and you will probably find it there!</p>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3E3E3E",
          primaryfont: "Raleway",
          primarycolor: "#17A121",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "DeveloperMedia is the world's leading marketing services and advertising network focused entirely on software and App developers.",
          },
          metadataname: "Digital Media Case Study by HebronSoft",
          metadatadescription:
            "Learn details of fruitful cooperation arranged by HebronSoft in terms of a Digital Media Case Study. Click to read more!",
          linkedinPartnerId: "",
          linecolor: "#17A121",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SQaf_Tm8Hd_s5z",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "NgRx",
              "Angular",
              "Node.js",
              "Nest.js",
              "Mongodb",
              "AWS",
            ],
            Timeline: ["Over 2 Years"],
            Budget: [null],
            Industry: ["Media & Entertainment"],
            Company: ["HebronSoft"],
          },
          faviconimage:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZU42_kdAbnVeCz",
          diagramData: {
            diagramList: [
              {
                period: "August, 2020",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSjlrEAD_plvpnxqRB",
                heading: "Discоvery Phase",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "October, 2020",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSjm1EAD_utGzMCUmkD",
                heading: "UI/UX Finished",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "September, 2020",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSjm6EAD_r7ijXw-Oc",
                heading: "Development Started",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "MVP Phase End",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSjmBEAT_M35iAd3J3",
                heading: "September, 2022",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "In Progress",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSjmGEAT_DvtLbALR1",
                heading: "Post MVP Phase",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description: "Consulting",
          calendlyLink: "",
          breadcrumbslabel: null,
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#AEC7EE",
        },
        {
          website: "https://hebronsoft.com/",
          valueSectionsData: [
            {
              heading: "Flint Learning Solutions Culture",
              description:
                "Flint believes in sustained behavioral change within the organization achievable through engaging, custom learning experiences. They develop solutions for satisfying diverse learning styles and working environments. All to ensure learners apply the acquired knowledge immediately and retain it permanently to drive qualitative change within the company.",
            },
            {
              heading: "Why Now",
              description:
                "The EdTech market is rapidly gaining momentum, so it requires immediate response from companies striving to succeed in this field. As a leader in the industry, Flint couldn't lag behind emerging EdTech-related trends. \n\nThe company already had a prototype of a management development program but required a more robust solution for keeping in front of current trends and delivering custom-tailored training solutions to its clients.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "FlintLS Learning Ecosystem Case Study",
            table: [
              {
                valueName: "Flint Learning Solutions",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Education (For Profit)",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "0",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwnsEAD_t9N2Uvq4I",
            layout: "Original",
            description:
              '<p dir="ltr">As a business that transforms how companies train and upskill their staff, Flint reached us with a request to help fulfill their needs with a custom eLearning software development platform. It was supposed to be a single user-friendly ecosystem for students, managers, trainers and other people involved in the training process within the organization.</p>',
          },
          testimonialsData: [
            {
              industry: "Managing Partner, Flint Learning Solutions",
              description:
                "Their project management abilities are very strong. They’re consistently willing to take feedback and incorporate it into future iterations of prototypes. Open to transparency, they allow their partner to track progress through Jira.",
              author: "Mark Peterson",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZSa0_xjDiF3lra",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR0_JJ2o0aUJu0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZSZR_kcsJxXNn0Y",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRRK_0h3uArj70",
          ],
          teamProfilesData: [],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SR4V_axH5qYglA",
          storyId: "a006g00000n4Zb9AAE",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#3E3E3E",
          secondaryfontcolor: "#7D7D7D",
          secondaryfont: "Raleway",
          secondarycolor: "#17A121",
          projectSectionData: {
            videoLink: null,
            title: "FlintLS Learning Ecosystem Case Study",
            teamSize: null,
            paragraph2:
              '<p dir="ltr">As a business that transforms how companies train and upskill their staff, Flint reached us with a request to help fulfill their needs with a custom eLearning software development platform. It was supposed to be a single user-friendly ecosystem for students, managers, trainers and other people involved in the training process within the organization.</p>',
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwi6EAD_os4aMWuve",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">The goal of Flint&#39;s project was to create a single hub that would enable students, mentors, and admins to learn new skills, monitor performance, create and store courses, communicate, and more. In addition, the platform was supposed to have a live interactive component, which would allow the student and mentor to get in touch.</p>\n<p><strong> </strong></p>\n<p dir="ltr">Project Role:</p>\n<ul><li dir="ltr">\n<p dir="ltr">To build a platform for tracking and managing all user activities and progress;</p>\n</li><li dir="ltr">\n<p dir="ltr">To provide an interactive space for on-the-job training;</p>\n</li><li dir="ltr">\n<p dir="ltr">To develop a space for keeping and creating educational programs;</p>\n</li><li dir="ltr">\n<p dir="ltr">To create a separate yet unified account for separate users with access to necessary training assets.</p>\n</li></ul>\n<h2>Values Delivered</h2>\n<p>Flint&#39;s new educational ecosystem allowed effective optimization and streamlining of the entire business infrastructure, both for users and Flint employees. Thanks to HebronSoft’s custom solution, Flint can now be confident using an intuitive user-friendly interface, clear management system, and effective learning service.</p>\n<h3>A learner enjoys the following benefits:</h3>\n<p style="text-align: left;">- Individual and secure access to accounts.</p>\n<p style="text-align: left;">- An Individualized learning path.</p>\n<p style="text-align: left;">- Guidance through the training course.</p>\n<h3>A Flint employee enjoys the following benefits:</h3>\n<p>- Storing all data of end-users.</p>\n<p>- Comfortable and effective management.</p>\n<p>- Tracking of progress and activities.</p>\n<p>- Transparent info on users/customers.</p>\n<p>- Enhanced reporting system.</p>',
          },
          projectBoundariesData: {
            rightStatus: "$200,000-$300,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3E3E3E",
          primaryfont: "Raleway",
          primarycolor: "#17A121",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Flint is an EdTech company specializing in creating custom learning experiences for both public and private organizations within the US and Canada. They help companies integrate training and upskilling into a daily working routine so that staff could embrace the change needed for the organization's success.",
          },
          metadataname: "Custom eLearning Software Development Case Study",
          metadatadescription:
            "Check out a custom eLearning software development solution that provides students, managers, and trainers with a single educational ecosystem.",
          linkedinPartnerId: "",
          linecolor: "#17A121",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SQaf_Tm8Hd_s5z",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Nest.js", "Mongodb", "AWS", "Flutter", "Angular"],
            Timeline: ["Over 2 Years"],
            Budget: ["$200,000-$300,000"],
            Industry: ["Education (For Profit)"],
            Company: ["HebronSoft"],
          },
          faviconimage:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZU42_kdAbnVeCz",
          diagramData: {
            diagramList: [
              {
                period: "2 months",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwiLEAT_YmnDNS2EA",
                heading: "Discоvery Phase",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "3 months and ongoing",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwiQEAT_QuNVD_p-2",
                heading: "UI/UX Finished",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "January 2020",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwijEAD_CVD7lXljZ",
                heading: "Development Started",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "October 2020",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwmqEAD__j-ukBsSrj",
                heading: "MVP Phase End",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "May 2022 (finished)",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwmvEAD_8Tx_nYhk_",
                heading: "Post MVP Phase",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description: "Consulting",
          calendlyLink: "",
          breadcrumbslabel: null,
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#AEC7EE",
        },
        {
          website: "https://hebronsoft.com/",
          valueSectionsData: [
            {
              heading: "EASY Culture",
              description:
                "Easy subscribes to the idea that moving around the city should be cost-effective, convenient, and eco-friendly. They help people live more and spend less time in traffic jams, all without harm to the environment.",
            },
            {
              heading: "Why Now",
              description:
                "Electric scooters have won popularity as a fast, eco-friendly, and fun way to get around. This commuting means of transport has plenty of fans, especially in Lviv.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "IoT Software Development for Electric Scooter Rental Company",
            table: [
              {
                valueName: "EASY",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Travel, Transportation, & Hospitality",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "0",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwqrEAD_tUIflN446",
            layout: "Original",
            description:
              '<p dir="ltr">Back in 2018, Easy, a startup with a mission to make commuting in Lviv, a Ukrainian city, more eco-friendly and comfortable, approached HebronSoft. The company requested to build a scooter-sharing app that would allow riders to easily spot, rent, and use e-scooter with an Easy service. Also, there was the need for a one-page website that would represent the service and spread the word about it. </p>\n<p> </p>',
          },
          testimonialsData: [
            {
              industry: "Co-Founder, Easy",
              description:
                "HebronSoft is a very professional IoT development company! The most impressive thing about them was their ability to explain all technical things in a clear, simple language. They followed all requirements, helped us to define roadmaps and find the right solutions specifically for us. It was very much a partnership and a highly collaborative effort between us.",
              author: "Pavlo Yurchuk",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZSa0_xjDiF3lra",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR5_Wxb1fwtXH",
          ],
          teamProfilesData: [],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SR4V_axH5qYglA",
          storyId: "a006g00000n4ZclAAE",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#3E3E3E",
          secondaryfontcolor: "#7D7D7D",
          secondaryfont: "Raleway",
          secondarycolor: "#17A121",
          projectSectionData: {
            videoLink: null,
            title:
              "IoT Software Development for Electric Scooter Rental Company",
            teamSize: null,
            paragraph2:
              '<p dir="ltr">Back in 2018, Easy, a startup with a mission to make commuting in Lviv, a Ukrainian city, more eco-friendly and comfortable, approached HebronSoft. The company requested to build a scooter-sharing app that would allow riders to easily spot, rent, and use e-scooter with an Easy service. Also, there was the need for a one-page website that would represent the service and spread the word about it. </p>\n<p> </p>',
            paragraph1: "Increase value for customer",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwpUEAT_LKWQJ5YcE",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">During the project discovery stage, we agreed on the scope of the Easy project. The IoT device development solution the Hebron Soft company pledged to deliver included: </p>\n<ul><li dir="ltr">\n<p dir="ltr">Create mobile scooter-sharing apps for iOS and Android</p>\n</li><li dir="ltr">\n<p dir="ltr">Develop a web admin panel, web landing, MQTT broker, and API</p>\n</li><li dir="ltr">\n<p dir="ltr">Build a server to relay storage commands utilizing an MQTT system</p>\n</li><li dir="ltr">\n<p dir="ltr">Deliver a user-friendly design for mobile apps that would enable fast scooter rent.</p>\n</li></ul>\n<h2 dir="ltr">Values Delivered</h2>\n<div class="content">\n<h3 dir="ltr">What End-Users Love About This Solution</h3>\n<ul><li dir="ltr">\n<p dir="ltr">User-friendly one-page website enabling the customers to get the necessary information about e-scooter sharing service.</p>\n</li><li dir="ltr">\n<p dir="ltr">Compatibility of e-scooter sharing apps with iOS and Android.</p>\n</li><li dir="ltr">\n<p dir="ltr">Quick download of the app from Google Play and App Store.</p>\n</li><li dir="ltr">\n<p dir="ltr">Easy procedure of registration in the application.</p>\n</li><li dir="ltr">\n<p dir="ltr">Clear search for nearby e-scooter available at a definite time.</p>\n</li><li dir="ltr">\n<p dir="ltr">Accurate information about the scooter&#39;s state, battery level, and more.</p>\n</li><li dir="ltr">\n<p dir="ltr">Quick process of unlocking the scooter in a program and starting a ride by scanning the scooter’s QR code.</p>\n</li><li dir="ltr">\n<p dir="ltr">Payment for the use of the scooter right in the app.</p>\n</li></ul>\n<h3 dir="ltr">What Value Easy Gets </h3>\n<ul><li dir="ltr">\n<p dir="ltr">Reliable software solution enabling the company to increase income.</p>\n</li><li dir="ltr">\n<p dir="ltr">Easy-to-use web admin containing all necessary information about both customers and scooters.</p>\n</li><li dir="ltr">\n<p dir="ltr">Powerful server that relays storage commands.</p>\n</li><li dir="ltr">\n<p dir="ltr">Smoothly performing API that connects all systems controlling the scooters.</p>\n</li><li dir="ltr">\n<p dir="ltr">Opportunities to scale quickly amid the booming e-scooter sharing industry.</p>\n</li><li dir="ltr">\n<p dir="ltr">Efficient ecosystem of shared mobility technology.</p>\n</li></ul>\n<h3 dir="ltr">The Result Easy Achieved</h3>\n<p>As the IoT software development company, HebronSoft succeeded in delivering a complex solution to Easy. Our developers created an e-scooter sharing app, website, and admin panel development as well as built a server using an MQTT system and configured API for bringing all the systems together. As a result, the Easy company obtained a competitive advantage in the market offering a simple and convenient way to rent a scooter to its end users. The growing number of downloads from Google Play and App Stores proves the popularity of the e-scooter sharing service among city commuters.</p>\n</div>',
          },
          projectBoundariesData: {
            rightStatus: "$20,000-$40,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3E3E3E",
          primaryfont: "Raleway",
          primarycolor: "#17A121",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Easy is the first e-scooter-sharing service established in Lviv, Ukraine by visionary Danylo Kots. The company provides the citizens with access to environmentally friendly means of transportation, which is also cheap, fast, and convenient. With this service, scooter riders save time by avoiding traffic jams and freely moving across the city, even during busy hours.",
          },
          metadataname:
            "IoT Software Development Case Study for E-Scooter Rental",
          metadatadescription:
            "Dive into this case study to see how custom IoT software development benefited an electric scooter rental company.",
          linkedinPartnerId: "",
          linecolor: "#17A121",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: true,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SQaf_Tm8Hd_s5z",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Node.js", "Flutter"],
            Timeline: ["5-7 Months"],
            Budget: ["$20,000-$40,000"],
            Industry: ["Travel, Transportation, & Hospitality"],
            Company: ["HebronSoft"],
          },
          faviconimage:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZU42_kdAbnVeCz",
          diagramData: {
            diagramList: [
              {
                period: "1 month",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwq3EAD_0y9fzwgWVX",
                heading: "Discоvery Phase",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "2 months",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwq8EAD_CoAU7Rz1K",
                heading: "UI/UX Finished",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "July 2020",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwZUEA1_kvdE18gLt",
                heading: "Development Started",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "September 2020",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwqIEAT_NNORW8bNP",
                heading: "MVP Phase End",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "March 2021",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DSwqNEAT_LbV6Hbv7j",
                heading: "Post MVP Phase",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description: "Consulting",
          calendlyLink: "",
          breadcrumbslabel: null,
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#AEC7EE",
        },
        {
          website: "https://hebronsoft.com/",
          valueSectionsData: [
            {
              heading: "LeadMeNot Culture",
              description:
                "Studies show that peer-based support to fight unhealthy behaviors, whether online or offline, works. Don't fight on your own.\n\nThat's why we invented LeadMeNot. We believe in the power of accountability, not to induce feelings of shame or guilt, but to lead each of us towards connection and true relationship.",
            },
            {
              heading: "Why Now",
              description:
                "In today's age of fast digitization, 'digital footprints' are everywhere. This spreading footprint has boosted quality of life but also caused physical, mental, emotional, and spiritual illnesses. 21 million males claim to be hooked to pornography, 5 times as many as in 2000. Studies relate social media overuse to depression and anxiety. Our digital age has spawned a hyper-growth of dangerous digital habits. The modern era needs a proactive and holistic digital wellness program to combat detrimental digital habits.",
            },
            {
              heading: "Other Things to Note",
              description:
                "Custom app development helped to enable an app for tech-addicted or easily distracted people to break unhealthy online habits. The app would help users resist digital temptations and warn them against fraudulent online behavior.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Cross-Platform Mobile App Development Case Study",
            table: [
              {
                valueName: "LeadMeNot",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTUPnEAP_Ay4jftyl0",
            layout: "Original",
            description:
              '<p dir="ltr">The goal of the application is to help people who are addicted to technology or easily distracted by it fight and get rid of their bad online habits. The mobile app would help users resist any kind of digital temptation and alert them to any deceptive behavior they might get caught up in while browsing the Internet. Preventive measures and content blocking make it great as a parental control app because they help improve mental health and decrease addiction to social media.</p>',
          },
          testimonialsData: [
            {
              industry: "CEO, LeadMeNot",
              description:
                "HebronSoft has this alignment with faith and value but they also has the necessary technical chops and ability. HebronSoft is super communicative; they are in it with me every day. We have daily standups and telegram communication. They’re responsive and get back to me in a timely manner. Communication is awesome.",
              author: "Jason Mathew",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SRR5_Wxb1fwtXH",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZSa0_xjDiF3lra",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/bohdan-bilas-6bb68550/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Bohdan Bilas",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWuJEAX_LFq2DX2Ex",
            },
            {
              serviceLink: "https://www.linkedin.com/in/olha-marko-ba90a81b/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Olha Marko",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000CXWw5EAH__Vw6OjQRw",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SR4V_axH5qYglA",
          storyId: "a006g00000n51MaAAI",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#3E3E3E",
          secondaryfontcolor: "#7D7D7D",
          secondaryfont: "Raleway",
          secondarycolor: "#17A121",
          projectSectionData: {
            videoLink: null,
            title: "Cross-Platform Mobile App Development Case Study",
            teamSize: null,
            paragraph2:
              '<p dir="ltr">The goal of the application is to help people who are addicted to technology or easily distracted by it fight and get rid of their bad online habits. The mobile app would help users resist any kind of digital temptation and alert them to any deceptive behavior they might get caught up in while browsing the Internet. Preventive measures and content blocking make it great as a parental control app because they help improve mental health and decrease addiction to social media.</p>',
            paragraph1: "Increase value for customer",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTUHMEA5_kbFNoo-AE",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">LeadMeNot is the first digital wellness platform that fights bad digital habits by being both proactive and taking a whole-person approach. The application feature is driven by artificial intelligence to identify users’ behavioral patterns proactively and provide a hyper-personalized experience that works to understand users on a heart level to help fight destructive habits.  </p>\n<p dir="ltr">The client, Jason Mathew, aimed to create a mobile application that could provide end-users with the following benefits:</p>\n<ul><li dir="ltr">\n<p dir="ltr">User-friendly design;</p>\n</li><li dir="ltr">\n<p dir="ltr">Multiple user roles;</p>\n</li><li dir="ltr">\n<p dir="ltr">Shared profile for supervisor monitoring;</p>\n</li><li dir="ltr">\n<p dir="ltr">Event-triggered alerts and notifications;</p>\n</li><li dir="ltr">\n<p dir="ltr">Cross-platform natively compiled application.</p>\n</li></ul>\n<h3 dir="ltr">Values Delivered</h3>\n<p dir="ltr">It was decided that the LeadMeNot platform would provide end-users with free services to help a wider range of digital addicts. What’s more, Jason Mathew wanted us to build a mobile app with a great deal of customization to enable highly personalized recommendations for self-reflection and introspection. On top of that, the LeadMeNot app had to work on both Android and iOS mobile devices.</p>\n<p dir="ltr">The mobile app that was made is a great way to help people with dangerous addictions resist temptations that could endanger their lives. It could help with mental health problems and work well with parental controls and a feature that blocks content before it gets to a child. It could also make people less addicted to social media.</p>\n<p dir="ltr">The following features ensure its smooth functionality:</p>\n<ul><li dir="ltr">\n<p dir="ltr">Easy to install and set up.</p>\n</li><li dir="ltr">\n<p dir="ltr">Intuitive UI design and easy navigation</p>\n</li><li dir="ltr">\n<p dir="ltr">Quick adding of your accountability partners that help overcome your addiction</p>\n</li><li dir="ltr">\n<p dir="ltr">Timely notifications for your partners warning them that you are currently doing something wrong or inappropriate</p>\n</li><li dir="ltr">\n<p dir="ltr">Safe data collection algorithms that secure your private data safety and ensure confidentiality</p>\n</li><li dir="ltr">\n<p dir="ltr">Proactive monitoring of user online activities</p>\n</li><li dir="ltr">\n<p dir="ltr">Efficient data analytics based on Artificial Intelligence</p>\n</li><li dir="ltr">\n<p dir="ltr">Log keeping for recurring activities of self-reflection and introspection</p>\n</li><li dir="ltr">\n<p dir="ltr">Encrypted transferring of user data from a smartphone to a server, where data is analyzed. If there is a case of detecting prohibited content watching or otherwise using, the real-time alerts from the server are sent to accountability partners.</p>\n</li><li dir="ltr">\n<p dir="ltr">Completely free of charge!</p>\n</li></ul>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: "$150,000-$200,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3E3E3E",
          primaryfont: "Raleway",
          primarycolor: "#17A121",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "LeadMeNot is the first digital wellness platform that takes both a proactive and holistic approach toward fighting destructive digital habits. It uses Artificial Intelligence to identify users’ behavioral patterns proactively and provide a hyper-personalized experience that works to understand users’ on a heart level, to help fight destructive habits.",
          },
          metadataname: "Cross-Platform Mobile App Development Case Study",
          metadatadescription:
            "Learn how to create your first app and make it available on multiple platforms with our cross-platform mobile app development case study.",
          linkedinPartnerId: "",
          linecolor: "#17A121",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SQaf_Tm8Hd_s5z",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Node.js", "Flutter"],
            Timeline: ["Over 2 Years"],
            Budget: ["$150,000-$200,000"],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["HebronSoft"],
          },
          faviconimage:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZU42_kdAbnVeCz",
          diagramData: {
            diagramList: [
              {
                period: "3 months",
                order: "1",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTUGvEAP_VUlAjiGI_",
                heading: "Discоvery Phase:",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "3 months",
                order: "2",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTUDlEAP_eWxWkcy3X",
                heading: "UI/UX Finished",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "May 2020",
                order: "3",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTUIhEAP_OwR6S7la8",
                heading: "Development Started",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "June 2021",
                order: "4",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTUJ5EAP_K9WtibT9n",
                heading: "MVP Phase End",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
              {
                period: "Ongoing",
                order: "5",
                imageSrc:
                  "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000DTUKSEA5_aFqgdHv95",
                heading: "Post MVP Phase",
                descriptionLine2: "",
                descriptionLine1: "",
                descriptionImageSrc: "",
                dateDescriptionLine1: "",
              },
            ],
          },
          description: "Consulting",
          calendlyLink: "",
          breadcrumbslabel: null,
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#AEC7EE",
        },
      ],
      metadataName: "Software Development Success Stories | Hebron Soft",
      metadataDescription:
        "Read about software development success stories from Hebron Soft company. Discover how a socially responsible IT company may transoform your business!",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SQaf_Tm8Hd_s5z",
      fav_image:
        "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZU42_kdAbnVeCz",
      contact_us: "https://hebronsoft.com/contact-us",
      account_description: "Consulting",
    },
    {
      title: "Acquis Consulting Group LLC",
      teamId: "0016g000023PrfWAAS",
      stories: [
        {
          website: "https://www.acquisconsulting.com/",
          valueSectionsData: [
            {
              heading: "Isaacs Center Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "With a grant in hand to modernize operations, there was a pressing need to update Salesforce which served as a core Participant Tracking System.  By modernizing their processes that surround Salesforce, Issacs Center knew by acting quickly they would ultimately benefit more Participants.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Issacs Center Salesforce Experience Relaunch",
            table: [
              {
                valueName: "Isaacs Center",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Nonprofit",
                keyName: "INDUSTRY",
              },
              {
                valueName: "3-4 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "2",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5ZU5EAN_Lk8KMfObF",
            layout: "Original",
            description:
              "<p>The Isaacs Center is a New York City based non-profit that focuses on the needs of children and low-income families.  Acquis worked alongside the Isaacs Center to reimagine their organizational processes and the day-to-day experiences of their employees, resulting in an overhauled participant tracking system powered by Salesforce.</p>",
          },
          testimonialsData: [
            {
              industry: "Director of Advance and Earn",
              description:
                "In the time that we have had the pleasure of working with Acquis, we have been completely blown away by the customer service, follow-up and overall personalized attention that they have been providing us and this project. From their communication styles, their interactive brainstorming boards, and detailed emails, presentations and excel documents....They were able to listen to what a challenge was for us, fully dissect it to gain a better understanding, and then brainstorm with the help of our staff, how to fix the challenge, who and what it will affect and what the end result will be.",
              author: "Katherine Robles",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5c3uEAB_X5bBtyVeS",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/andrewgross2/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Engagement Manager",
              name: "Andrew Gross",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dZoEAJ_O5CJ3-pfk",
            },
            {
              serviceLink: "https://www.linkedin.com/in/ekaterinadus/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Ekaterina Dus",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dZtEAJ_MCxkszoRq",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZVRR_FO5JdRM-7",
          storyId: "a006g00000o5osLAAQ",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#f5f7fa",
          secondaryfontcolor: "#000000",
          secondaryfont: "NeurialGrotesk",
          secondarycolor: "#3B86F8",
          projectSectionData: {
            videoLink: null,
            title: "Issacs Center Salesforce Experience Relaunch",
            teamSize: null,
            paragraph2:
              "<p>The Isaacs Center is a New York City based non-profit that focuses on the needs of children and low-income families.  Acquis worked alongside the Isaacs Center to reimagine their organizational processes and the day-to-day experiences of their employees, resulting in an overhauled participant tracking system powered by Salesforce.</p>",
            paragraph1: "Increase productivity",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dbrEAB_TlCXyEMdi",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p>Their Education and Workforce team provides out-of-work and out-of-school young adults, ages 17 to 24, with intensive case management, job readiness training, and placement in sector-focused internships and employment. Participants enter or re-enter the workforce, and pursue educational opportunities that boost their hourly wage earnings and put them on a sustainable career path.   </p>\n<p>To support this important work, Issacs Center had been using Salesforce as their core Participant Tracking System.  While integral to daily operations, Salesforce had become difficult to navigate over time; it had become hard to understand where a Participant had been within their own journey engaging with Issacs Center.  For Case Managers, working on behalf of Participants had become overly complex, and business processes had become hard to follow.  Additionally, <span style="color: black;">due to a poor data model, the critical reporting to prove program efficacy took weeks to produce through manual workarounds.</span>  </p>\n<p>This ultimately led to a c<span style="color: black;">umbersome Participant enrollment processes - a lot of manual work resulting in slow and costly processing of time-sensitive Participant data.  The struggle was knowing that on the other end of this inefficiencies was a disadvantaged youth who was hoping to hear back from Isaacs and be enrolled in their programs to better their situations in life.  </span></p>\n<p><span style="color: black;">Through our custom methodology, Acquis helped Isaacs both streamline their processes to be more efficient, as well as overhauled the data model and user interface of Salesforce so that Case Managers and other employees of Isaacs Center could quickly input and access the information, they needed to help the youth they were working with.  Acquis was able to do this by working alongside Isaacs Center employees to truly understand the employee experience, to understand current processes, pain points, and bottlenecks so that we could prioritize true organizational needs while revamping Salesforce.  The result of experience relaunch not only provided the first three-dimensional view of all interactions between Issacs and their Participants in an easy to navigate system, it also cut down the processing time for onboarding Participants from weeks to hours.   </span></p>',
          },
          projectBoundariesData: {
            rightStatus: "$40,000-$70,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#000000",
          primaryfont: "NeurialGrotesk",
          primarycolor: "#0644D7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "The Stanley M. Isaacs Neighborhood Center (Isaacs Center) is a non-profit, multi-service organization located on the Upper East Side of Manhattan focused on the needs of children and low-income families, out-of-school and out-of-work youth, and aging New Yorkers, including our isolated and homebound elderly neighbors. A Meals on Wheels pioneer since 1964, the Isaacs Center promotes dignity and self-reliance across generations.",
          },
          metadataname: "Issacs Center Salesforce Experience Relaunch",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "#FFED60",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dYEEAZ_5W2ID5Wzm",
            roiMoment:
              "We knew the project would have an impact from day one, because we focused on usability and the employee experience - keeping true user needs at the forefront of our build exercises.  That said, when we learned that the project had saved processing time for for Participant onboarding from weeks to hours, we knew we had made a major difference within the organization.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dXQEAZ_IvTxsgEQIe",
            momentOfTrust:
              "Through a series of iterative virtual whiteboard scoping sessions early on in the relationship, Acquis was able to draw out information from Isaacs Center in a fun, interactive way that drove trust in the relationship.  By proving our project methodology within the sales cycle, Isaacs was able to gain trust that the delivery methodology would work for their team.",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dWiEAJ_mBvuDpAPc",
            introductionMoment:
              "Isaacs was introduced to Acquis as a go-to partner for strategic consulting in the Salesforce space for nonprofit organizations.  Through direct relationships with our consultants' historical work, the quality of our people was already known.",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dWxEAJ_tJrq8v_JJ",
            eurekaMoment:
              "The Eureka moment came when Isaacs Center described their current manual Participant on-boarding process which was slow, arduous, very manual, and had become a bottleneck for providing real support to the Participants.  From our first conversation with the client when they described their current pain points and issues, it was clear the system that was built was not designed with the end user experience in mind, and had quickly become antiquated.  We wanted to make Salesforce easy for them to use, understand, and ultimately to drive business value by expediting the throughput of work and ultimately Participants served.",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dY9EAJ_Jsld9gC2p",
            dealClarityMoment:
              "Scope became clear after a series of interactive exercises which allowed us to get to the true organizational needs, as well as a few reverse demos to understand the current usage of the system.  We were then able to understand the broad strokes that were needed to move this organization forward, utilizing our proprietary framework.",
          },
          isfeatured: true,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZTnp_3Yf6s-kWBu",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce", "Jotform"],
            Timeline: ["3-4 Months"],
            Budget: ["$40,000-$70,000"],
            Industry: ["Nonprofit"],
            Company: ["Acquis Consulting Group LLC"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Consulting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "#3B86F8",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZTnp_3Yf6s-kWBu",
      fav_image: "",
      contact_us:
        "https://www.acquisconsulting.com/salesforce/contact-salesforce-practice/",
      account_description: "Consulting",
    },
    {
      title: "Endiem",
      teamId: "0016g00002OAYsaAAH",
      stories: [
        {
          website: "https://endiem.com/",
          valueSectionsData: [
            {
              heading: "Mustang Cat Culture",
              description: "They have Cat-itude",
            },
            {
              heading: "Why Now",
              description:
                "Without digital transformation, Mustang Cat would no longer be in a position to compete",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Mustang Cat Digital Transformation",
            table: [
              {
                valueName: "Mustang Cat",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Engineering, Construction, & Real Estate",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "4",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4Nd4EAF_eQkWMQTFf",
            layout: "Original",
            description:
              "<p>Full digital transformation on the Salesforce platform </p>",
          },
          testimonialsData: [
            {
              industry: "Marketing GM",
              description:
                "The best time for any company to go down a digital transformation route is yesterday. Endiem is able to provide those solutions, be transparent with us, and partner with us as an extension of our own company, looking out for our best interests.",
              author: "Cory Birch",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHR_J213Rh5fb",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "William Nourse",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4NaUEAV_FON-than_",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Brittany Douglas",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4NaZEAV_rbznHmnm6",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Jeremy Krebbs",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4NajEAF_tGQI7Tmlf",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Geraldine Gray",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4NaPEAV_fzBJAMGP0",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5KtYEAV_dQBPoi0Qw",
          storyId: "a006g00000o79Z4AAI",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#05AED2",
          secondaryfontcolor: "#808080",
          secondaryfont: "Poppins Regular",
          secondarycolor: "",
          projectSectionData: {
            videoLink:
              '<iframe width="560" height="315" src="https://www.youtube.com/embed/geQfwRHfh9Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
            title: "Mustang Cat Digital Transformation",
            teamSize: null,
            paragraph2:
              "<p>Full digital transformation on the Salesforce platform </p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5KtYEAV_dQBPoi0Qw",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>For over 60 years, Mustang Cat has been the southeast Texas authorized sales, parts and service dealer for Caterpillar construction equipment and engines. The sector they operate in is old school and built upon relationships. But now is the time for Mustang Cat to transform and get ready for a new era of customer service, sales, and experience. Salesforce is the catalyst.</p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#232640",
          primaryfont: "Poppins Bold",
          primarycolor: "#05AED2",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "With its headquarters in Houston, Texas, Mustang Cat is a privately-held Cat dealership, at the forefront of construction and power systems",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4NcuEAF_zpYp2cDHX",
            ribbonCuttingMoment: "",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5KvtEAF_Npvvf9Y3H",
            redMoment:
              "“Customers buy the way they want to buy, not the way you want to sell.”\r\nCustomer loyalty is no longer a given. Instead, people will put their business with companies that make buying from them as easy as possible. They demand great service, which is the challenge to which all sales and service companies must rise.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4NckEAF_39LB341on",
            momentOfTrust:
              "“This is the single biggest investment that Mustang has made outside of a physical building in its 70-year history.”\r\nMustang Cat partnered with Endiem to work hand in hand on their digital transformation - a project that would span at least two years for the initial phases alone. The team had to put their trust into Endiem to make sure that this investment in their future would be a great success, taking the company to an entirely new level.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4NczEAF_poV4Y_hHo",
            eurekaMoment:
              "“Construction is old school, we rely on relationships. \r\nBut now is the time to transform. Salesforce is the catalyst.”\r\nThe team at Mustang Cat was fully aware of the challenges that lay ahead in their transformation to entirely new ways of working, but they were confident that the time was right and Salesforce was the right platform. Change was coming and this was the catalyst.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4H2nEAF_1hN83ZJCH",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Sales Cloud",
              "Salesforce",
              "Salesforce Maps",
              "Salesforce Service Cloud",
            ],
            Timeline: ["Over 2 Years"],
            Budget: [null],
            Industry: ["Engineering, Construction, & Real Estate"],
            Company: ["Endiem"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4H2nEAF_1hN83ZJCH",
      fav_image: "",
      contact_us: "https://endiem.com/contact",
      account_description: "",
    },
    {
      title: "louie inc",
      teamId: "0016g00002OBAMdAAP",
      stories: [
        {
          website: "louieinc.com",
          valueSectionsData: [
            {
              heading: "Hydrafil Culture",
              description:
                "Hydrafil was established in Detroit, Michigan in 1974 with the notion that purchasing hydraulic filtration equipment should be a seamless process so that companies can focus on their business with the assurance that their systems are running smoothly and cleanly. Since then, we’ve made it our mission to be as hard working, reliable, and efficient as the high-quality filtration equipment we sell while providing a superior customer experience. After thirty-three years as one of America’s most trusted names in hydraulic filter equipment, we launched our ecommerce platform in 2007, bringing our decades of expertise honed in the heart of the automotive industry and our top-of-the-line filter elements and more to a growing global market.",
            },
            {
              heading: "Why Now",
              description:
                "In order for Hydrafil to provide its growing customer base with the best quality service and the largest selection of replacement filters, it was essential to ramp up its ecommerce capabilities, bringing its entire 170,000-product catalog online with proper organization, descriptions, and images for each one.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Hydrafil Tech Evolution",
            table: [
              {
                valueName: "Hydrafil",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Manufacturing",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "4",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IJ5EAN_nB4lj7Fgm",
            layout: "Original",
            description:
              "<p>When a well respected company struggled to modernize their ecommerce platform, Louie Inc. stepped in. Over a two year period, we increased their online catalog from 20,000 products to 171,000 products while providing tools to automate processess, and improve the shopping and customer support experience. As a result, we helped them increase sales and expand their global customer base while reducing costs.</p>",
          },
          testimonialsData: [
            {
              industry: "Chief Operating Officer, Hydrafil Filtration Products",
              description:
                '"Amazing work louie inc! Appreciate their diligence in building the type of ecosystem we needed. Would happily work with them again. 10/10.”',
              author: "Matt Dodge",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4THDEA3_PX7l8RNjY",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOHz_xiYvLIoau",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIK_f96dEnyTsD",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzy_c6XuZDBIN",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Chris Hofstetter",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4e8pEAB_hlCeWg8aE",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consultant",
              name: "louie the mascot",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4e94EAB_MjCYW_MzN",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Mike Isham",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4e8zEAB_xXceYvXFZ",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Ben Dewhurst",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4e8uEAB_0VkDtHrkS",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IDSEA3_vOQ4XG6AO",
          storyId: "a006g00000o7Cm7AAE",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#000000",
          secondaryfont: "Verdana",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "Hydrafil Tech Evolution",
            teamSize: null,
            paragraph2:
              "<p>When a well respected company struggled to modernize their ecommerce platform, Louie Inc. stepped in. Over a two year period, we increased their online catalog from 20,000 products to 171,000 products while providing tools to automate processess, and improve the shopping and customer support experience. As a result, we helped them increase sales and expand their global customer base while reducing costs.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4TH3EAN_g9BMkUlrl",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">B A C K G R O U N D</p>\n<p dir="ltr">Hydrafil had established its ecommerce presence in 2007, but they had yet to modernize many of its processes for today’s dynamic marketplace. Orders were processed manually through Shopify&#39;s backend, and then entered into a separate shipping system. Even accounting was done by hand. Client outreach didn’t fare much better; there were no lists of current and prospective clients, and staff was relegated to sending estimates individually by fax or email.</p>\n<p dir="ltr">With the desire to simplify the shopping experience from order placement to receipt while building their customer base and improving customer service, Hydrafil contacted Louie Inc. </p>\n<p dir="ltr"><br>A P P R O A C H</p>\n<p dir="ltr">Our first step was to connect with the client to understand their unique needs. Next, we assessed their current assets and data, and pinpointed which integrations would be necessary to adopt in order to meet their goals. We also audited their existing Shopify site, which we quickly discovered wasn&#39;t built for the platform&#39;s best practices and would require a complete re-build. From there, we developed a technological roadmap to gain clarity and articulate our strategy. Working alongside the client, and taking their needs, best practices, and best in class systems into consideration, we developed our final proposal.</p>\n<p dir="ltr"><br>S O L U T I O N</p>\n<p dir="ltr">Our solution was driven by the need, best practice, and best in class systems, and was created with the client’s technological needs and budget in mind. While Salesforce B2B Commerce was out of their price range at the time, we were able to create an ecosystem for them that included Salesforce Sales Cloud, Shopify, CPQ, ShipStation, Locate, and QuickBooks for a relatively inexpensive tech stack. All together, the systems would require approximately $5K annually to maintain with no sales, order requirement, or profit sharing going forward. Over the next eight months, we built a new website with the order system through Salesforce and used CPQ as an estimator tool for custom quotes. We also revamped the brand with a new logo, messaging, and graphic design. Finally, we activated Google Ads and began to advertise all of the client’s SKUs. </p>\n<p dir="ltr"><br>R E S U L T S</p>\n<p dir="ltr">The technology ecosystem we built for Hydrafil has allowed them to run large-scale operations with minimal staffing and costs. In just two years, they have grown 5X. Since the ecosystem is scalable over time, the sky’s the limit from here on out. The client is thrilled and so are we.</p>\n<p dir="ltr"><br>P H A S E  T W O</p>\n<p dir="ltr">Now that we’ve completed phase one of our technological plan for Hydrafil, we’ve moved into phase two, which includes updating their existing ecosystem to match their growth. To that end, we’ll be replacing QuickBooks and Locate with an ERP resource that will hold inventory and accounting.  </p>\n<p dir="ltr">We’ve also recommended Salesforce Order Management or Salesforce Order Surfacing, which will allow the client to do all of their order work in just one screen, while automatically adjusting inventory and accounting. We’ve also put a tool in place to sync their Shopify site to a Google sheet to improve maintenance. On top of that, we have recently been approved to do a full website redesign. As Hydrafil continues to evolve, we look forward to being there every step of the way.</p>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: "$100,000-$150,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#000000",
          primaryfont: "Arial",
          primarycolor: "#67bf6e",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Hydrafil is a filter replacement company that provides replacement filters for all sizes of industrial equipment from small machines to gigantic wind turbines. Established in Detroit, Michigan in 1974, Hydrafil launched its ecommerce platform in 2007 to bring their decades of expertise honed in the heart of the automotive industry and our top-of-the-line filter elements and more to a growing global market. Today, Hydrafil’s customer base is as broad as their selection replacement filters, with clients ranging from small, family-run firms, large wholesalers, and federal institutions and agencies including the United States Navy and Army.",
          },
          metadataname:
            "How louie inc helped Hydrafil grow their business with technology.",
          metadatadescription:
            "When louie inc first connected with Hydrafil, the long-established filter replacement company was in dire need of modernizing their technologies.  Find out how the marketing technology firm helped them update their systems, simplify their ordering technologies, and increase sales.",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5O8CEAV_cjsa1thJB",
            roiMoment:
              "Within the first year of working with Hydrafil, we enabled them to double their sales. Now in year three, we've helped them increase sales to six times their original revenue. As we look to the future, we feel strongly that the sky is the limit for the company going forward.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5Nx9EAF_dVxlD8uSN",
            momentOfTrust:
              "Our founder Chris Hofstetter was at a meeting of his business networking group in Chicago when another member approached him about Hydrafil. \nHydrafil, a company that values diversity, was looking to connect with diverse organizations. Chris' colleague, a Black business owner who had been working with Hydrafil for years, asked if he'd like him to refer Hydrafil to Louie Inc., as a LGBTQ+ organization. Naturally, we said yes, and a connection was made.\nOur next moment of trust was when we met with the client and owner for the first time. When we realized we shared a similar work ethos and attitude toward technology, everyone was eager to get started.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5O1kEAF_sUprfOufvd",
            eurekaMoment:
              "As we spoke to the Hydrafil team and learned more about their needs, we realized that we had the know-how and skills to help them meet their goals.",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5O2dEAF_iMOSHICwT",
            dealClarityMoment:
              "We took a look at their website, looked at the number of products they wanted to upload, and decided that we would need to build a fresh Shopify website for them, as the one they were using was not built using best practices. As we shared our recommendations, the client, knowing technology himself, completely agreed with our approach and felt confident to move forward.",
          },
          isfeatured: true,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IIgEAN_hQg1i28kX",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Shopify",
              "CPQ - Configure, Price, Quote",
              "Salesforce Sales Cloud",
              "QuickBooks",
              "Ship Station",
            ],
            Timeline: ["Over 2 Years"],
            Budget: ["$100,000-$150,000"],
            Industry: ["Manufacturing"],
            Company: ["louie inc"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Awesome tech consultancy",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IIgEAN_hQg1i28kX",
      fav_image: "",
      contact_us: "https://martech.louieinc.com/contact",
      account_description: "Awesome tech consultancy",
    },
    {
      title: "CloudMasonry",
      teamId: "0016g00002OAIRbAAP",
      stories: [
        {
          website: "https://cloudmasonry.com/",
          valueSectionsData: [
            {
              heading:
                "National Roof Tile Manufacturer and Distributor Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "As our client began to grow rapidly, order accuracy and fulfillment was seeing more and more issues year over year. This was causing poor customer satisfaction, revenue leakage, and most importantly reputational damage. The client knew these problems were present, but just did not know how to get to the root cause of the underlying issues.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "National Roof Tile Manufacturer and Supplier",
            table: [
              {
                valueName: "National Roof Tile Manufacturer and Distributor",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Manufacturing",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "4",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4kWFEAZ__lMBsf0_G",
            layout: "Original",
            description:
              "<p>A national roof tile manufacturer and distributor was growing rapidly and knew that in order to better serve their ever growing customer base, they needed to address core discrepancies with their Salesforce Org, and find ways to improve it for scalability. Read the story to see how Cloudmasonry was able to understand their processes, identify the core root causes and gaps in their current Salesforce/CPQ tools, and put a plan of action in place to address these deficiencies which set them up for future scalability.  </p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIK_f96dEnyTsD",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consultant",
              name: "Eduardo Esparza",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4Y8HEAV_Xx7tjB_Rl",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Nikolaus Sappie",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4Y81EAF_UUhvUXaq_",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Engagement Manager",
              name: "Hunter Hudsmith",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E52efEAB_1CigMNDUb",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Business Analyst",
              name: "Aaron Karatas",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E52fEEAR_aqLiXMpnN",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvjwfEAB_AXUprUF7k",
          storyId: "a006g00000o7GU3AAM",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#ffffff",
          secondaryfontcolor: "#1E1B27",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "National Roof Tile Manufacturer and Supplier",
            teamSize: null,
            paragraph2:
              "<p>A national roof tile manufacturer and distributor was growing rapidly and knew that in order to better serve their ever growing customer base, they needed to address core discrepancies with their Salesforce Org, and find ways to improve it for scalability. Read the story to see how Cloudmasonry was able to understand their processes, identify the core root causes and gaps in their current Salesforce/CPQ tools, and put a plan of action in place to address these deficiencies which set them up for future scalability.  </p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4Y52EAF_HzTumf3m-",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>From small businesses to large corporations, every company comes to a point where they need a fresh set of eyes to find improvements and opportunities to expand their products and services. Our consultants at Cloud Masonry are more than just “doers”, they are visionaries; they see opportunities in unexpected places and that is exactly what happened when we started working with our Client.</p>\n<p>For the last 20 years, our client has been manufacturing premium-quality synthetic roofing that combines the authentic look of normal roofing tiles with unmatched performance. As a leading alternative to traditional roofing material, their composite roofing products last longer, are far more durable than traditional roofing tiles, and are much more aesthetically and architecturally pleasing than asphalt shingles and concrete tiles. They have established a business to business and, business to consumer product with a significant presence in the industry as well as working with contractors all over the country. Initially, we were brought in strictly to work on order management. The client already had adopted Salesforce CPQ.</p>\n<p>Like many businesses, our client didn’t realize what tools they had at their disposal. With the right configuration, they were going to be able to future-proof their business in a big way.</p>\n<p>On any given day, a salesperson contacts or fields a lead from a new or existing customer. As the company grew, it became more difficult to transfer the tribal knowledge that was not captured in a format that allowed those salespeople to step in and hit the ground running. As a result, pricing was not accurate and was a very manual process. Avoiding human error, reducing time waste and automating processes where possible was a critical improvement that was about to fundamentally change everything.</p>\n<p>Longevity is a great quality for a business but that also comes with challenges. The company was successful enough to expand their sales team to handle larger volume but that too came with challenges. We asked questions, a LOT of questions. In fact, by the end of the project the owner complimented our team on their extensive knowledge of the roofing business. It takes immersing our consultants in the intricacies of the industry to really find the opportunities that will make a difference.</p>\n<p>Through a root cause analysis, we realized that the guided selling process was bumpy. Their main need aside from giving the sales team the right tools, was to streamline the order management process for the fulfillment team to ensure accuracy in shipment. They also needed to have the ability to track return orders.</p>\n<p>Our Client has some amazing proprietary processes that are truly unmatched in the industry, you could say it’s their “secret sauce”. We found quite a few opportunities that were paramount in figuring out the RIGHT solution.</p>\n<p>After we got into the issues, we got to work to implement a more optimized version of Salesforce CPQ. As you can imagine, there is also a learning curve when things change. We took all the legacy knowledge and documented it to ensure that whoever stepped into the business would be set up for success.</p>\n<p>Our consultants spent a lot of time educating the client on the system and the capabilities it would provide them to ultimately service their customers with the level of accuracy they built their business on. They admittedly needed advice and guidance on how to best use the tools. It took some system buildout and development, but the outcome was a very efficient shiny new version of their Salesforce CPQ tools.</p>\n<p>Their team saw the value but navigating change can be hard. The client team was committed to overcoming the hurdle of the learning curve. </p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3761FF",
          primaryfont: "Montserrat",
          primarycolor: "#3761FF",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "For the last 20 years, our client has been manufacturing premium-quality synthetic roofing that combines the authentic look of normal roofing tiles with unmatched performance. As a leading alternative to traditional roofing material, their composite roofing products last longer, are far more durable than traditional roofing tiles, and are much more aesthetically and architecturally pleasing than asphalt shingles and concrete tiles.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4kfvEAB_7QqabulgJ",
            roiMoment:
              "Order accuracy improved 35-40%. Countless hours have been saved and they project a significant reduction in return orders. The success of this transformation was found in innovation.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4Y6aEAF_fVcpc7256",
            ribbonCuttingMoment:
              "To make for the successful launch that we had with the client, we made sure to facilitate a strategic pre and post go live training and support process. This process started with User Acceptance Training in which users were able to test the solutions, provide feedback, and give final sign off on the solution. Next, we made sure to facilitate up to two weeks of pre deployment training to ensure that the team was well aware of the changes coming and knew of the change in process. Lastly, once deployed to the team, we followed up with significant hypercare and training documentation to ensure that no one person's processes were being hindered and that any post go live issues were quickly addressed.",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4Y6KEAV_xPvfcQ2cL",
            momentOfTrust:
              "Any time a client is working with a new consulting firm, there is always a moment where the consulting firm needs to ensure trust in the client that they are there to help. For Cloudmasonry, this came after the first initial conversation with the client. The client had approached us about issues they were seeing in their org. Rather than put a plan together to fix those issues, our team was able to recognize that there were fundamental core processes that were deficient and ultimately the root of the surface level problems the client was seeing.\n\n“As we began working on this project, we saw a much larger opportunity. Our Client was spending a significant amount of time on order management, but we needed to get to the heart of the issue; the WHY.” - Nik Sappie (Lead Architect)",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4kXoEAJ_kXY7hDyR0",
            introductionMoment:
              "The client was introduced to Cloudmasonry after their Salesforce Account Executive recognized the client's need for a holistic view into their current processes and problems they were experiencing. With our extensive knowledge of the Salesforce platform, the client's Salesforce Account Executive made the introduction; knowing that we would be able to help the client not only solve their current problems, but also set them up for future growth and scalability.",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4Y6PEAV_Cd_6pV2vl",
            eurekaMoment:
              "After weeks of deep dive discovery sessions, the Cloudmasonry team and the client were able to come to a conclusion on the specific underlying processes that were driving the surface level issues the client had originally brought to the table. This was the moment in which the Cloudmasonry team knew what the solution was. The solution was to revamp the client's current implementation of Salesforce CPQ and scale the order fulfillment process that was in place.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4ipsEAB_x9FJPlnfc",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "CPQ - Configure, Price, Quote",
              "Salesforce Sales Cloud",
              "Salesforce Service Cloud",
            ],
            Timeline: ["5-7 Months"],
            Budget: [null],
            Industry: ["Manufacturing"],
            Company: ["CloudMasonry"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Awesome tech consulting firm",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
        {
          website: "https://cloudmasonry.com/",
          valueSectionsData: [
            {
              heading: "Global Bank's Corporate Responsibility Arm Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "The bank had been operating using disparate processes across their corporate responsibility arm and needed a system that allowed them visibility across teams in order to manage their giving effectively and produce roll-up metrics the executive team could properly segment and assess.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Streamlining a Global Bank’s Grantmaking Program on Salesforce",
            table: [
              {
                valueName: "Global Bank's Corporate Responsibility Arm",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Financial Services",
                keyName: "INDUSTRY",
              },
              {
                valueName: "12-17 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "6",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvnFVEAZ_lnwbgbAEh",
            layout: "Original",
            description:
              "<p>A global bank was struggling to track key metrics across $3 billion a year in grants and other community programs. They knew they needed a centralized repository to track organizations and contacts, their upcoming grant pipeline, and corporate responsibility programs. They turned to CloudMasonry for a solution that would tie everything together.</p>\n<p> </p>\n<p> </p>\n<p> </p>",
          },
          testimonialsData: [
            {
              industry:
                "Executive Director, Head of Business Management Corporate Responsibility, JP Morgan Chase",
              description:
                "CloudMasonry understands that it's not a transaction, it's a relationship. With their delivery methodology, nimble team, and model of constant support, I’d hire them again and again, and have recommended them for other projects across the firm.",
              author: "Vivian Inya",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000STQf_3E03X8xi0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIe_nIzXPTLoo",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PBhEAN_TIL9UICsP",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Engagement Manager",
              name: "Sofia Davis-Kos",
              index: 1,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Rachel Plowman",
              index: 2,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Jamie Patterson",
              index: 3,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Sarah Leone",
              index: 4,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Technical Architect",
              name: "Richard Blackwell",
              index: 5,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Benjamin Hersh",
              index: 6,
              dpSrc: "",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvjwfEAB_AXUprUF7k",
          storyId: "a006g00000rNOpSAAW",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#ffffff",
          secondaryfontcolor: "#1E1B27",
          secondaryfont: "Montserrat",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Streamlining a Global Bank’s Grantmaking Program on Salesforce",
            teamSize: null,
            paragraph2:
              "<p>A global bank was struggling to track key metrics across $3 billion a year in grants and other community programs. They knew they needed a centralized repository to track organizations and contacts, their upcoming grant pipeline, and corporate responsibility programs. They turned to CloudMasonry for a solution that would tie everything together.</p>\n<p> </p>\n<p> </p>\n<p> </p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvlSJEAZ_7002CSiXF",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">The organization had been using SharePoint to track pre-grant steps. Each sub-team had a separate process leaving their spreadsheets impossible to reconcile across teams, limiting roll-up metrics to executive leadership. To solve this, we implemented Salesforce for pre-grant processes, worked with each sub-team to find similarities in processes, and coached them through combining disparate processes so there were a few standardized grant pipeline processes across the organization. All grant-making sub-teams have been rolled onto Salesforce and the organization is now able to report on roll-ups by organization, by geography, and by key pillars.</p>\n<p dir="ltr">The organization had also been using a combination of SharePoint, Cybergrants, and emailing for all employee engagement and volunteerism efforts. Due to a lack of data centralization, the teams were unable to easily keep track of participants and their progress, or alumni and their feedback.</p>\n<p dir="ltr">We solved this by using Salesforce campaigns to track internal marketing efforts and responses for new programs and by using Contacts to track employee participation history and preferences. We also built an internal employee portal using Salesforce Experience Cloud to assist employee onboarding and the intake funnel. </p>\n<p dir="ltr">Their employee engagement and volunteering team is now able to work collaboratively in the cloud and new employees can self-service sign up for programs, thus boosting overall program headcount, and maximizing their impact on the community.</p>',
          },
          projectBoundariesData: {
            rightStatus: ">$1,000,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3761FF",
          primaryfont: "Montserrat",
          primarycolor: "#3761FF",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "This Global Bank is a leading global financial services firm with assets of $2.6 trillion and operations worldwide. They have over 250,000 employees world wide and give back $3 billion per year to the community in the form of grants, community development programs, and employee volunteering opportunities.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvlS9EAJ_6HCzw-AZm",
            momentOfTrust:
              "The project itself kicked off after a failed implementation of a homegrown CRM system. The client came into the project with a lack of trust and a lot of fear to commit their time and energy to another potential failure. We staffed an incredible team with the goal being to buy trust piece by piece so they could see the value of CRM and Salesforce in particular with every interaction. By month four of the engagement the primary drivers on the client side were coming to us with ideas and their thoughts on solutions in Salesforce, of course, we had to manage scope, but it became very clear that they were thinking of Salesforce in all of their internal meetings and thinking of how it could help their other work streams. We'd turned an anti-CRM team into a team that saw the value in considering the system they use in every process.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvlSEEAZ_LIo2c-2Ae",
            dealClarityMoment:
              "When we kicked off the project, we resourced the project with a single full-time person to support the build. We'd been brought in from a former Bluewolf colleague and we expected the project to be small and straightforward. We were presented with a list of user stories and in order to get a feel for who we should staff to the project, I reviewed the stories in scope and immediately realized the breadth of the project. We spent the next week talking through the stories. To demonstrate the size of the undertaking we began piecing together a high-level solution mock-up. As we presented it back to the client we made a strong effort to highlight the major gaps and the complexity of combining the disparate processes across teams. As we talked through it, the client saw what we were trying to communicate. When we got to the adjusted commercial summary the client had the clarity they needed to extend the project by 6 months and allocate the right resources.",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4ipsEAB_x9FJPlnfc",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Experience Cloud",
              "Salesforce Sales Cloud",
              "Salesforce Financial Services Cloud",
              "Salesforce Lightning",
              "Salesforce Service Cloud",
            ],
            Timeline: ["12-17 Months"],
            Budget: [">$1,000,000"],
            Industry: ["Financial Services"],
            Company: ["CloudMasonry"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Awesome tech consulting firm",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4ipsEAB_x9FJPlnfc",
      fav_image: "",
      contact_us: "https://cloudmasonry.com/contact-us/",
      account_description: "Awesome tech consulting firm",
    },
    {
      title: "Addax",
      teamId: "0016g00002QHKmvAAH",
      stories: [
        {
          website: "https://addaxcrm.com",
          valueSectionsData: [
            {
              heading: "N/A Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Custom Salesforce.com development could save you money by automating marketing, sales reports, analytics, customer support, delivery notification, and billing tasks with cloud integration. Specific types of automation are not always possible in packaged solutions.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "G-7BZ8K1TSQQ",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "G-D03Y4TD8JV",
          },
          topBannerData: {
            title:
              "Addax delivers custom Salesforce.com integration, Boosting client success by 40%",
            table: [
              {
                valueName: "N/A",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Supply Chain & Logistics",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "1",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZQuLEAX_VOCyUn58y8",
            layout: "Original",
            description:
              '<p style="text-align: justify;">With an outdated CRM system hindering growth, a medical equipment supplier turned to Addax for a Salesforce.com migration. Addax delivered a highly-customized solution that increased sales revenue by 30%, boosted cross-selling and upselling opportunities by 20%, and streamlined business processes by 40%. Client was blown away by Addax&#39;s expertise and creativity, praising them for transforming their business and setting them up for success</p>',
          },
          testimonialsData: [
            {
              industry: "",
              description:
                "Addax has cut down on our time to accomplish work tremendously. No part of our organization was left unaffected by this implementation in a positive way. This collaboration uncovered a different perspective on our business processes. We are now constantly considering how to improve and automate them",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOIE_AjHTdjrWc",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PCBEA3_mc0HaeDy4",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSGx_S1_80BqVH",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Executive Officer",
              name: "Yaroslav Shevchenko",
              index: 1,
              dpSrc: "",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fj1QiEAJ_MXNKPsuDG",
          storyId: "a006g00000o7Na6AAE",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#333333",
          secondaryfont: "Verdana",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Addax delivers custom Salesforce.com integration, Boosting client success by 40%",
            teamSize: null,
            paragraph2:
              '<p style="text-align: justify;">With an outdated CRM system hindering growth, a medical equipment supplier turned to Addax for a Salesforce.com migration. Addax delivered a highly-customized solution that increased sales revenue by 30%, boosted cross-selling and upselling opportunities by 20%, and streamlined business processes by 40%. Client was blown away by Addax&#39;s expertise and creativity, praising them for transforming their business and setting them up for success</p>',
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FU5oEEAT_e3ATd8E0L",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p style="text-align: justify;">Addax is a licensed partner of Salesforce.com, providing top-quality Salesforce implementation, customization, and integration services for businesses of all sizes. We have vast experience in data migration, software integration, and creation of customized products based on digital goals. We also deliver web development services for applications of any complexity.</p>\n<p style="text-align: justify;">A medical equipment supplier based in Jacksonville, FL, approached Addax for our services. The client had been using a custom-built CRM system for over a decade, but the system was outdated, inefficient, and incompatible with their growing business needs. They wanted to switch to Salesforce.com for more features, flexibility, and scalability.</p>\n<p style="text-align: justify;"> </p>\n<p style="text-align: justify;">Their core objectives were:</p>\n<ul style="text-align: justify;"><li>\n<p>Migration of all data from the legacy CRM system to Salesforce.com without losing any information and functionality</p>\n</li><li>\n<p>Get real-time updates for equipment maintenance and service requests across all channels and devices</p>\n</li><li>\n<p>Ability to manage complex pricing structures and services, including leasing, financing, and warranty options</p>\n</li><li>\n<p>Handling Sales Territory plan, segmenting opportunities, assigning reps</p>\n</li><li>\n<p>Integration with other applications, such as client website, e-commerce platform, inventory management systems, accounting software, etc.</p>\n</li><li>\n<p>Train client staff on how to use Salesforce.com effectively and efficiently</p>\n</li></ul>\n<p style="text-align: justify;"> </p>\n<p style="text-align: justify;">After a thorough vetting and consulting process, we proposed to build a highly-customized integration between Salesforce.com instances and required software. The project consisted of three main steps:</p>\n<ul style="text-align: justify;"><li>\n<p>Data migration: Addax used Jitterbit, a free and open-source ETL software that facilitates the data import process. We cleaned, mapped, and transferred all the relevant data from the legacy CRM system to Salesforce.com without compromising its quality or integrity</p>\n</li><li>\n<p>System integration: Addax used Salesforce&#39;s APIs to connect with other systems that client uses, such as accounting software (SAP), inventory management software, email marketing software (Hubspot), etc. This enabled data synchronization and automation across different platforms, improving efficiency and accuracy</p>\n</li><li>\n<p>System development: Addax customized Salesforce to fit clients&#39; unique business needs. We created custom fields, objects, layouts, reports, dashboards, and workflows that enhanced the functionality and usability of Salesforce for different user roles and scenarios</p>\n</li></ul>\n<p style="text-align: justify;"> </p>\n<p style="text-align: justify;">Delivered in 6 months, standard Salesforce.com UX was customized to reliably and efficiently satisfy all client’s requirements. New CRM system (Salesforce.com) resulted in the following highlights:</p>\n<ul style="text-align: justify;"><li>\n<p>Increased customer satisfaction ratings by 25%</p>\n</li><li>\n<p>Reduced customer churn rate by 15%</p>\n</li><li>\n<p>Boosted sales revenue by 30%</p>\n</li><li>\n<p>Enhanced cross-selling and upselling opportunities by 20%</p>\n</li><li>\n<p>Streamlined business processes by 40%</p>\n</li></ul>\n<p style="text-align: justify;"> </p>\n<p style="text-align: justify;">Feedback from the client was overwhelmingly positive. They praised Addax for their professionalism, expertise, and creativity. They said that Addax exceeded their expectations and delivered a high-quality solution that transformed their business: - &quot;Addax has cut down on our time to accomplish work tremendously. No part of our organization was left unaffected by this implementation in a positive way. This collaboration uncovered a different perspective on our business processes. We are now constantly considering how to improve and automate them.&quot;</p>\n<p style="text-align: justify;"> </p>',
          },
          projectBoundariesData: {
            rightStatus: "$100,000-$150,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#333333",
          primaryfont: "Verdana",
          primarycolor: "#6f49b6",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "A Jacksonville, Florida-based medical equipment supplier reached out to Addax for help. For more than a decade, the client had relied on a CRM system that had been developed specifically for them; but, as their company evolved, the system became more inadequate. As a result of Salesforce.com superior functionality, adaptability, and scalability, they desired a transition.",
          },
          metadataname:
            "Salesforce CRM migration for medical equipment manufacturer",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5morEAB_xTYmKW8vd",
            roiMoment:
              "Soon after the Salesforce.com went fully live, we realized that Addax once again delivered tremendous positive ROI for its client. The Client reported that they had seen significant improvements in their customer service and sales performance, such as: Overall decrease for sales efforts by providing better, real time information about incoming leads, leading to 25% increase in Open Sales Pipeline; Increase in conversion rate by 15% due to the improved segmentation, targeting, personalization, and tracking of marketing campaigns across multiple channels; Increase in customer satisfaction by 25% due to the reduced response time, resolution time, and error rate of service requests; Increase in revenue by 30% due to the enhanced visibility, insights, and decision-making capabilities provided by the customized dashboards and reports. The client praised Addax for their quality work and excellent service throughout the project. They said that would recommend us to others without hesitation",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZPVTEA5_TlewK0lnB",
            ribbonCuttingMoment:
              "The day had finally arrived, and everyone held their breath, watching the hard work of Addax come to life. We utilized Trailhead and other Salesforce.com training materials to develop assets such as videos, In-App Guidance,  and user guides to enable end-users to learn the new system effortlessly. This drastically helped to improve user experience, reducing the learning curve for new users. After the system went live we supported the client for another 2 weeks answering the questions, and providing on-Demand help via Office-hours. After the users were comfortable running the system, Addax stepped aside for any heavy development support",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5bBQEAZ_oDoUA-jtK",
            redMoment:
              "In the middle of the project we caught a red alert when encountered sufficient technical issues during the data migration phase. Some data from the legacy CRM system was corrupted and could not be transferred to Salesforce without manual intervention. This caused delays and frustration for both parties. Addax handled this situation by being transparent and proactive. We informed the client about the problem and its impact on the project schedule. We also proposed a contingency plan that involved hiring additional resources and working overtime to fix the data quality issues and complete the data migration as soon as possible. Conquering such obstacles and producing desirable results requires open lines of communication, teamwork, and a readiness to adjust to new circumstances. Client appreciated our dedication and agreed to extend the deadline by two weeks",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5mpGEAR_i_qfNtScU",
            momentOfTrust:
              "When we first met with the client in their office, we were greeted with a sense of apprehension. It was clear that this healthcare provider had experienced a few failed software projects before. Soon everyone started noticing a subtle but significant change in the atmosphere. We listened attentively to their pain points \nand goals, asked relevant questions, and demonstrated our expertise and professionalism. We also shared some of our previous success stories and client testimonials that supported our credibility and reputation. Addax proposed a realistic project plan outlining the scope, timeline, budget, deliverables, and expected outcomes. We also explained how we would communicate and collaborate with them throughout the project using various tools and channels",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZPbMEAX_74vILboEI",
            introductionMoment:
              "For 15 years Addax used industry best practices to meet customers' goals. We mostly get new business via personal recommendations, client referrals, product collaborations, cold calls, and online leads. Our team continuously provides new Salesforce.com custom-made platform options to help organizations succeed. We analyze customers' requirements and deliver custom-tailored solutions that work. This client came through a referral from one of their existing clients who had worked with us on a similar Salesforce project. They were delighted with our work and recommended us to this healthcare provider who were looking for a reliable partner to upgrade their CRM",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5b3lEAB_AX_vBlL3p",
            eurekaMoment:
              "Sparks began to fly as Addax investigated clients' industry-specific requests for their challenges with CRM. The Eureka moment occurred when we realized we could leverage Salesforce's APIs to align it with the rest of the client's applications. This would not only simplify the data migration process but also enable data synchronization and automation across different platforms. Entire project team felt boosting confidence after seeing the new CRM carrying out all necessary procedures already in the first testing stage. We were happy to once again experience that feeling when as a developer, you understand that eventual success considerably outpaces the original vision",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5mp1EAB_7Qi9h63IX",
            dealClarityMoment:
              "During the initial vetting and consulting process with the client, Addax used various methodologies to build project scope, including in-depth interviews and requirements gathering sessions with stakeholders, mapping out workflows and use cases, identifying clients' pain points, understanding their business needs, and defining goals. It took several weeks to develop a comprehensive project plan that included: A statement of work that described the scope, deliverables, assumptions, risks, and exclusions of the project; A project plan that outlined phases, tasks, milestones, dependencies, and roles of each team member; A budget estimate that broke down the costs by hours, resources, materials, and expenses; A contract that specified the terms and conditions of payment, ownership, warranty, liability, confidentiality, etc. We ensured client fully understood the proposed solution and the expected ROI. After resolving any doubts or concerns, they signed off on it and agreed to proceed",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dWYEAZ_Cv5_MI4Fb",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Sales Cloud",
              "Jitterbit",
              "Hubspot Marketing",
              "Salesforce Lightning Web Components",
            ],
            Timeline: ["5-7 Months"],
            Budget: ["$100,000-$150,000"],
            Industry: ["Supply Chain & Logistics"],
            Company: ["Addax"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Consultancy based in NY and Ukraine",
          calendlyLink: "https://calendly.com/crm-consultant/free-consultation",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
        {
          website: "https://addaxcrm.com",
          valueSectionsData: [
            {
              heading: "PeakFin Investments Culture",
              description:
                "PeakFin Investments is an innovation-focused company that leverages advanced technologies to enhance client experiences and streamline their workflows. Implementation of the automated Compliance Management System underscores their commitment to modernizing operations with scalable and adaptable solutions. They embraced a data-driven mindset, working with Addax to overcome challenges and optimize their operations.",
            },
            {
              heading: "Why Now",
              description:
                "Recognizing the need for a modern solution to streamline their complex compliance process, PeakFin Investments sought a tech partner capable of delivering just that. Addax's reputation for crafting custom-made technology systems that fit complex business needs resonated with them. We shared a vision that technology should serve people, and this mutual understanding formed the foundation of our partnership.",
            },
            {
              heading: "Other Things to Note",
              description:
                "This project is one of the first to apply advanced automation to financial compliance management. But it won't be the last. We see an opportunity to leverage technology for financial firms wrestling with compliance challenges, and we look forward to being a part of that transformation.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "G-7BZ8K1TSQQ",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "G-D03Y4TD8JV",
          },
          topBannerData: {
            title:
              "From Manual Mess to Automated Success: Compliance makeover with Addax Salesforce",
            table: [
              {
                valueName: "PeakFin Investments",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Financial Services",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "1",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FiiECEAZ_Z9_IeDCC2",
            layout: "Original",
            description:
              "<p>PeakFin Investments, a new investment firm, faced a severe challenge. Their compliance procedure was tedious, manual, and out-of-date. It took 6 hours daily with a 20% error rate. Addax developed a custom, intelligent, automated compliance management system that optimized PeakFin&#39;s compliance processes and improved regulatory compliance. After implementation, compliance time was reduced to less than an hour, and errors were practically eliminated!</p>",
          },
          testimonialsData: [
            {
              industry: "CEO at PeakFin Investments",
              description:
                '"Our partnership with Addax has dramatically transformed PeakFin\'s compliance management. The drop in time spent on compliance tasks and the near elimination of manual errors, combined with an overall surge in operational efficiency, has propelled our compliance management to the next level!"',
              author: "Oliver Reed",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5I9HEAV_MZpLGx4Ygz",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOI4_MINn7eq2sc",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIe_nIzXPTLoo",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Yaroslav Shevchenko",
              index: 1,
              dpSrc: "",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fj1QiEAJ_MXNKPsuDG",
          storyId: "a006g00000rMYhvAAG",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#333333",
          secondaryfont: "Verdana",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "From Manual Mess to Automated Success: Compliance makeover with Addax Salesforce",
            teamSize: null,
            paragraph2:
              "<p>PeakFin Investments, a new investment firm, faced a severe challenge. Their compliance procedure was tedious, manual, and out-of-date. It took 6 hours daily with a 20% error rate. Addax developed a custom, intelligent, automated compliance management system that optimized PeakFin&#39;s compliance processes and improved regulatory compliance. After implementation, compliance time was reduced to less than an hour, and errors were practically eliminated!</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fj1RlEAJ_3gtoIByIy",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">Author&#39;s Note: To respect the non-disclosure agreement with our esteemed client, we&#39;ve used &#39;PeakFin Investments&#39; as an alias, the same goes for their employee names.<br><br>Before Addax&#39;s involvement, PeakFin Investments struggled with several compliance issues:</p>\n<ol><li dir="ltr">\n<p dir="ltr">Their manual, outdated compliance processes made a mid-size team spend an excess of six hours of daily monitoring transactions and managing risk assessments.</p>\n</li></ol>\n<ol start="2"><li dir="ltr">\n<p dir="ltr">Manual handling resulted in frequent errors, with about 1 in 5 reports containing inaccuracies.</p>\n</li></ol>\n<ol start="3"><li dir="ltr">\n<p dir="ltr">Incorporating new regulations into their process took up to five days, risking compliance lapses.</p>\n</li></ol>\n<ol start="4"><li dir="ltr">\n<p dir="ltr">The firm spent nearly 30% of their operations budget on compliance due to timely consumption and error rates.</p>\n</li></ol>\n<p><strong> </strong></p>\n<p dir="ltr">In the face of these challenges, Oliver Reed, the CEO of PeakFin, and Grace Thompson, PeakFin Compliance Officer, decided it was time for outside help. They turned to Yaro Shevchenko and his dev team at Addax for their expertise in building compliance management systems for financial institutions.<br><br>Addax devised a custom SaaS-style solution. This consisted of a compliance management system using Python and Django for backend development, ReactJS for an intuitive frontend, PostgreSQL for robust data management, and Docker for consistent deployment across environments.<br><br>This system automated PeakFin&#39;s compliance processes, such as customer onboarding, transaction monitoring, and risk assessment. It also offered real-time insights into PeakFin&#39;s compliance posture, enabling the firm to identify and address compliance risks swiftly.</p>\n<p dir="ltr">The Addax Compliance Management system achieved remarkable results:</p>\n<ol><li dir="ltr">\n<p dir="ltr">Daily time spent on compliance processes dropped from 6 hours to just 1.</p>\n</li></ol>\n<ol start="2"><li dir="ltr">\n<p dir="ltr">Accuracy rates soared to nearly 100%, practically eliminating manual errors.</p>\n</li></ol>\n<ol start="3"><li dir="ltr">\n<p dir="ltr">New regulations were incorporated into PeakFin’s process within hours, ensuring that PeakFin always remains in sync with the regulatory compulsories.</p>\n</li></ol>\n<ol start="4"><li dir="ltr">\n<p dir="ltr">Compliance costs fell from 33% to 10%, freeing up a whopping 23% of the operating budget!</p>\n</li></ol>\n<p><strong> </strong></p>\n<p dir="ltr">Our compliance management system has transformed Peakfin&#39;s approach to compliance and opened up new possibilities for the firm. Real-time insights enhanced decision-making, and the firm could identify and manage compliance concerns, lowering the chance of regulatory infractions. Their compliance team also gained significant efficiency because of the swift collaborative capabilities newly available.<br><br>Oliver and Grace managed to cut company costs significantly. They were more than satisfied with the new system stating:</p>\n<p dir="ltr">&quot;Addax&#39;s regtech solution has been a game-changer for us. It has transformed a daunting compliance challenge into a streamlined, automated process that aligns perfectly with our commitment to regulatory adherence and operational efficiency.&quot;<br><br>This project stresses the vital function of regulatory tech in automating and improving compliance operations. It also demonstrates how the Addax &quot;custom SaaS&quot; development approach can solve messy problems in the financial industry. The tech stack was Python, Django, ReactJS, PostgreSQL, and Docker. Inquire for more information about how our technology approach fit our clients&#39; technical infrastructure.</p>\n<p> </p>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#333333",
          primaryfont: "Verdana",
          primarycolor: "#6f49b6",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "PeakFin Investments is a fast-growing player in the financial sector. They strive to utilize technology for business optimization. Offering a broad spectrum of investment services, they cater to an elite clientele.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FitAjEAJ_18stU6GCuB",
            roiMoment:
              "Just one month after launch, the 'ROI Moment' arrived for PeakFin. The newly integrated compliance management system demonstrated measurable gains: compliance processing time reduced by 83%, manual errors virtually eliminated, and operational efficiency significantly improved. This scalable system continues to grow. Addax strives toward max efficiency as PeakFin reaps the benefits of this dynamic solution.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FissCEAR_jEuSbCQsJH",
            ribbonCuttingMoment:
              "Launching the automated Compliance Management System was enlightening for both teams. We unveiled the system's capabilities, from automatic processing of compliance tasks to real-time risk monitoring and deep operational insights. The excitement on everyone's faces and the sense of a job well done and made all the intense solutioning worth it.",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fit9HEAR_xRJTR2-Bb",
            redMoment:
              "In the middle of the project, Grace announced a significant policy shift affecting the firm's compliance procedures. This shift required substantial modifications to a new system's design and created potential risks to the project timeline. We responded promptly, revisiting the project strategy and re-aligning the development, testing, and deployment processes to accommodate the new compliance requirements.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fit7LEAR_e4idYpGuC",
            momentOfTrust:
              "At Addax's first meeting with Peakfin, we listened. We learned about, and came to understand, not just one problem with compliance operations, but several interconnected and messy issues. Once we'd gained that understanding, then we showed them similar projects solving similar problems. Proposed tech stack — Python and Django for backend power, ReactJS for a user-friendly frontend, PostgreSQL for reliable data management, and Docker for seamless deployment. We we're able to assure them that we could transform their compliance workflow and processes. Ultimately, Addax CEO Yaro Shevchenko helped the Peakfin team (CEO Oliver Reed, Compliance Officer Grace Thompson) understand exactly why Addax could solve their problem.",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FisMxEAJ_1qeiIVuqD",
            introductionMoment:
              "Our journey with PeakFin began when a former client recommended us. The first consultation meeting with Yaro made an indelible impression on Grace and Oliver. His deep understanding of financial compliance processes, Addax's vast experience with custom technology solutions, and his dedication to client success set the tone for a fruitful partnership.",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fit7QEAR_mWArCVI71",
            eurekaMoment:
              "When Addax proposed a solution with a fully automated compliance system that would process tasks based on predetermined rules, effectively eliminating manual errors. It would also intelligently monitor potential compliance risks and provide comprehensive reporting capabilities. Presenting this vision to Grace and Oliver, they were eager to see us put it in motion, realizing that this solution could resolve most of their operational bottlenecks.",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FisN2EAJ_NTeqri4Qr",
            dealClarityMoment:
              "The deal crystallized when Grace and Oliver understood the scale and potential of Addax's proposal. A custom-developed solution designed to handle their complex compliance tasks with advanced automation, real-time risk monitoring, and comprehensive reporting capabilities. We also presented a roadmap demonstrating future readiness. Tech notes and diagrams captured its complexities and brought the PeakFin’s team simplicity and clarity.",
          },
          isfeatured: true,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dWYEAZ_Cv5_MI4Fb",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "React",
              "Salesforce Shield",
              "Salesforce Financial Services Cloud",
            ],
            Timeline: ["5-7 Months"],
            Budget: [null],
            Industry: ["Financial Services"],
            Company: ["Addax"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Consultancy based in NY and Ukraine",
          calendlyLink: "https://calendly.com/crm-consultant/free-consultation",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5dWYEAZ_Cv5_MI4Fb",
      fav_image: "",
      contact_us: "https://addaxcrm.com/salesforce-customization#contact-us",
      account_description: "Consultancy based in NY and Ukraine",
    },
    {
      title: "Simplus",
      teamId: "0016g00002OAJGIAA5",
      stories: [
        {
          website: "https://www.simplus.com/",
          valueSectionsData: [
            {
              heading: "Global Medical Device Manufacturer Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Prior to coming onboard, the the client sold service and equipment contracts out of two completely different systems, inhibiting a true customer 360 view across the organization. They recognized the challenges this presented and reached out to optimize their CRM and sales processes.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Global Medical Device Manufacturer Invests in Multi-Cloud Transformation",
            table: [
              {
                valueName: "Global Medical Device Manufacturer",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Manufacturing",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "18",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DW8EAN_Vl4A1plcM8",
            layout: "Original",
            description:
              "<p>Simplus worked with the client to streamline their CRM and sales processes, ultimately optimzing the overall customer experience. </p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIK_f96dEnyTsD",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHH_Z6jdSn4K2",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzj_AKaowdOPIz",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000STQf_3E03X8xi0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consultant",
              name: "Mehul Raol",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5HyUEAV_b7TqxjtYB",
            },
            {
              serviceLink: "https://www.linkedin.com/in/carlos-montejo-69395b/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Carlos Montejo",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DY9EAN_WWspQ4LTY",
            },
            {
              serviceLink: "https://www.linkedin.com/in/pete-shelton/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Pete Shelton",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DY4EAN_iZikU7a6X",
            },
            {
              serviceLink: "https://www.linkedin.com/in/kayla-wood-0365b2143/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Director",
              name: "Kayla Wood",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DXzEAN_yZow0NPm9",
            },
            {
              serviceLink: "https://www.linkedin.com/in/chrisaarmstrong/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Managing Director",
              name: "Chris Armstrong",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DXuEAN_DCny_S0EO",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/alexander-lai-9ba4b359/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Director",
              name: "Alex Lai",
              index: 6,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DXpEAN_9mAL6UaXFg",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/sandeep-karyotakalam-7800713/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Sandeep Karyotakalam",
              index: 7,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DXkEAN_2NDiNznpB",
            },
            {
              serviceLink: "https://www.linkedin.com/in/jeremybyrgesen/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Jeremy Byrgesen",
              index: 8,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DXfEAN_CxG7Av5Df",
            },
            {
              serviceLink: "https://www.linkedin.com/in/brian-dalforno/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Brian Dalforno",
              index: 9,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DXVEA3_ZPHCly2ap",
            },
            {
              serviceLink: "https://www.linkedin.com/in/ryan-m-0558133/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Ryan Mah",
              index: 10,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5HyZEAV_Hz32OoQ9n",
            },
            {
              serviceLink: "https://www.linkedin.com/in/jodilallen/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Consultant",
              name: "Jodi Allen",
              index: 11,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DXQEA3_RSJpN3hmi",
            },
            {
              serviceLink: "https://www.linkedin.com/in/chamberscaroline/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Caroline Chambers",
              index: 12,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DXLEA3_VV9nvYleS",
            },
            {
              serviceLink: "https://www.linkedin.com/in/orlando-w-0a85559/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Strategy",
              name: "Orlando White",
              index: 13,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DXGEA3_IQnxv9R5s",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Brian Vera",
              index: 14,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5HyPEAV_hTBn0yFyU",
            },
            {
              serviceLink: "https://www.linkedin.com/in/jema-britton/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Strategy",
              name: "Jema Britton",
              index: 15,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5DWDEA3_x8i0Zxr0d",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/kirsten-sherwin-1174008/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Strategy",
              name: "Kirsten Sherwin",
              index: 16,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E52cjEAB_syQNOw_4c",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/connor-lamping-mba-88b315160/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Connor Lamping",
              index: 17,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E52c5EAB_LOD8DYcgl",
            },
            {
              serviceLink: "https://www.linkedin.com/in/jonathanpmills/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Jonathan Mills",
              index: 18,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E52YMEAZ_LzV_mVq0K",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5I1gEAF_m-ukURtRUJ",
          storyId: "a006g00000o7NrKAAU",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#ffffff",
          secondaryfontcolor: "#b8b8b8",
          secondaryfont: "Urbano",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Global Medical Device Manufacturer Invests in Multi-Cloud Transformation",
            teamSize: null,
            paragraph2:
              "<p>Simplus worked with the client to streamline their CRM and sales processes, ultimately optimzing the overall customer experience. </p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E52aOEAR_CDFHIQ7qQ",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p>Simplus created a roadmap for the client for a multi-cloud solution that would streamline their front-to-back office processes. With the renewed focus on transformation the client will recognize benefits from Sales Cloud, Revenue Cloud, Service Cloud (FSL &amp; CTI), Experience Cloud, Commerce Cloud, and more. <br><br>This means opportunity management in one central place, a data driven environment providing insight into sales and growth, access to a new revenue-building quote process that allows for promotions discounts and purchase agreements to be automated for pricing purposes, as well as quote documents, dynamically generated to support multiple languages. Equipment and Service Contracts will be housed and managed in one central location across business units, the case intake process will be streamlined, Field Service for Service Orders manages appointments (ie dispatch, scheduling) and other activities (ie work orders) with mobile capabilities, and CTI will enable answering calls and querying customer information in one system - Salesforce + Service Cloud + Service Cloud Voice. Finally, customers will have more visibility and self-service options. They can<strong id="docs-internal-guid-5aa22a2c-7fff-4c08-7952-27572267d1f4"> </strong>view service contract information and invoices, upcoming scheduled maintenance, schedule new maintenance, and even order spare parts.</p>',
          },
          projectBoundariesData: {
            rightStatus: ">$1,000,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#7e7e7e",
          primaryfont: "Proxima Nova",
          primarycolor: "#007cc3",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "The client is focused on pioneering breakthroughs in healthcare for everyone, everywhere. They are at the forefront of their industry, with nearly ¾ of all critical clinical decisions being influenced by their solutions. They work with 90% of leading hospitals.",
          },
          metadataname: "Multi-Cloud Salesforce Solutions Drive Customer 360",
          metadatadescription:
            "With the renewed focus on transformation the global medical device manufacturer will recognize benefits from a host of Salesforce products.\n\nInformation will be housed in one central place, with a data driven environment providing insight into sales and growth allowing for a true customer 360.",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust:
              "People often ask how we are doing so well on the project. Everything has not been gravy, and we’re just good to go because of that. We’ve had the changes, but we’ve been able to maintain a positive attitude and adapt. We’re not the yes people. We say yes and however. We educate, it is a true partnership. We meet in the middle, they understand we are guiding them in the right direction. It didn’t happen overnight. It's open and constant communication that has gotten us where we are. We are proactive, not reactive. We try to get ahead of the curve. Even if the smallest thing raises a flag, we say let us know and we’ll handle it. We get on top of everything.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment:
              "When we heard about the challenges the client was having our team mobilized quickly and showcased our deep domain expertise on the Salesforce platform and Quote-to-Cash. After a few calls the Simplus team put together a compelling proposal to demonstrate a strong understanding of the project goals and aggressive timeline.  At first, the client was hesitant of the overall scope, but after further discussions the client recognized the need for a multi-cloud transformation to optimize their customer experience.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E55pYEAR_wCyCtaxGJ",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Sales Cloud",
              "Salesforce Experience Cloud",
              "Salesforce Service Cloud",
              "Field Service Lightning",
              "Salesforce Commerce Cloud - B2B",
              "CPQ - Configure, Price, Quote",
            ],
            Timeline: ["Over 2 Years"],
            Budget: [">$1,000,000"],
            Industry: ["Manufacturing"],
            Company: ["Simplus"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E55pYEAR_wCyCtaxGJ",
      fav_image: "",
      contact_us: "https://www.simplus.com/",
      account_description: "",
    },
    {
      title: "Avenga",
      teamId: "0016g00002OAuHPAA1",
      stories: [
        {
          website: "https://www.avenga.com",
          valueSectionsData: [
            {
              heading: "NDA Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Not many businesses would opt for a technology investment when entering a worldwide recession caused by a global pandemic. Instead, most would apply the ’wait it out’ strategy, especially when facing an unprecedented crisis. So, standing on the brink of uncertainty, the asset-management and investment domain had two choices: to wait or to act. Our client decided on the latter because the solution they wanted to build would bring operational agility and analytical efficiency amid the commercial stiffness.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "G-XC70WCKRPC",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Reinventing the competitive advantage with Salesforce data capabilities",
            table: [
              {
                valueName: "NDA",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Financial Services",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over 2 Years",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "5",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5MtKEAV_KT7mzgV9X",
            layout: "Original",
            description:
              "<p>A global asset management company is faced with an opportunity to establish long-term market dominance by revolutionizing the data they use for catering to their clients&#39; best financial interest. </p>",
          },
          testimonialsData: [
            {
              industry: "Program Director",
              description:
                "“I wanted to thank you and the entire Avenga team for being absolutely instrumental in our delivery of Project A. Overseeing development and delivery in the past three weeks has been unprecedented, and I cannot express my gratitude enough for what Avenga, as a delivery partner, has done with respect to your commitment, effort, and bravery. I am so grateful for the partnership we’ve formed over the last seven years, and I cannot speak highly enough of the team, your skill, and your commitment to your clients.”",
              author: "Scott Parker",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PBhEAN_TIL9UICsP",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PC6EAN_rIByIZPj-",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PCBEA3_mc0HaeDy4",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PCVEA3_kuVgQWB2f",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PCfEAN_835fSBJx85",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PDOEA3_gvjttA_4Y",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PDTEA3_sm7YvU2p5",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Zahar Starovoit",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5MPkEAN_-r9uQ0-gm",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Data Engineer",
              name: "Olena Popova",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5MQ9EAN__KvslujV5",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Oleksandr Tsytsiura",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5MZ9EAN_z51A2bp2_3",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Oleksandr Vlasenko",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5MPfEAN_GmK5maEsd",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Oleksandr Shumilov",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5MPFEA3__WBq3ob-T",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvCvOEAV_G4nmb5Q94",
          storyId: "a006g00000o7RXhAAM",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#000000",
          secondaryfont: "Prompt",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Reinventing the competitive advantage with Salesforce data capabilities",
            teamSize: null,
            paragraph2:
              "<p>A global asset management company is faced with an opportunity to establish long-term market dominance by revolutionizing the data they use for catering to their clients&#39; best financial interest. </p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5MZTEA3_4VCJwwhA9",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr"><strong>The Project&#39;s Essence</strong></p>\n<p dir="ltr">Preparing your business for winning the market competition is easier than hoping for the competition’s absence. With the markets&#39; volatility rising exponentially, our client knew it was the right time to leverage technology to ensure its business continuity and efficiency by stepping up their data game.</p>\n<p dir="ltr">While covering multiple markets in Europe and Asia, the company&#39;s two most significant business units operated on two separate Salesforce orgs. As a result, the operational data could not have been used to its organization’s clients&#39; advantage. With no unified data in place, the sales, marketing, and customer engagement teams literally suffered from thousands of repetitive manual tasks, inaccurate analyses, a scarce user experience, and a high tasking overhead on users.</p>\n<p dir="ltr">Leveraging Salesforce to establish omnichannel access for its business units to a unified source of truth was something they needed to do. Companies that invest in seeing a broader picture of their business context, both from inside and outside, can only outdistance their competitors. </p>\n<p dir="ltr">On the business side, they were looking for a solution to optimize internal company processes and simplify interactions between departments by introducing a common understanding and standardization of data across B2B channels. From a technological point of view, they wanted two outdated platforms with a megaton of various types of repetitive and redundant data to be merged into one Lightning-based org which would enable them to work so much more smoothly and efficiently.</p>\n<p dir="ltr"><br><strong>Solution Design and Implementation</strong></p>\n<p dir="ltr">We kicked off the project by setting up business analysis and design thinking sessions. It was instrumental to keep the client&#39;s business owners and stakeholders involved so as to synthesize the inputs and integrate them into a holistic and cohesive solution vision. An in-depth system audit showed that the marketing and sales departments could only partially drive the enhanced customer experience because of an inappropriate data leverage from distorted data capture points. Varied data processes and solutions stemming from the client&#39;s swift organic growth led the company to a cross-channel view of client interactions.  </p>\n<p dir="ltr">When all the functional and nonfunctional requirements for the new platform had been gathered, we devised a strategy for migrating the client&#39;s Salesforce Classic legacy system into a newer Lightning platform with a redesigned user experience and updated functionality. During one of the copious meetings with the client&#39;s business owners, our team came up with an idea to conceptualize Salesforce Lightning for the UX and business needs by applying Lightning custom components to the visual style book. Thus, we were able to add custom functionality that would focus on each department&#39;s and client&#39;s unique needs, while rendering workflow easy and comfortable. With this decision, we were trying to optimize the CRM&#39;s capability of stimulating the sales process, the lack of which was one of the client&#39;s major pain points.</p>\n<p dir="ltr">Close cooperation with our client helped us clearly see the solution architecture design required for successful project implementation. Our team prepared the system design (including components and dependencies), the data security model, software components, tech stack, data models and flows, integration patterns for the existing and future integrations, delivery and deployment flow, and QA processes. Before implementing the project, we ensured that there was no downtime for our client&#39;s system, as we kept the old system up and running until the new one was deployed</p>\n<p dir="ltr">The project&#39;s implementation started with redesigning one of the existing system accounts into a newly-defined UI &amp; interaction design that was based on a customized Lightning visual stylebook. For this purpose, Avenga built a migration POC to ensure the platform we were building recognized the data classes it was meant to run on, as we handpicked, sorted, and migrated the data for this part of the project. Then, the team developed a CI/CD pipeline that launched the needed data packages through Apache’s NiFi-based script, which was aimed at data flow automation between software systems. Now, the client’s users can identify and see any Salesforce package inside of Salesforce org. As the merger pattern proved successful, we embarked upon a full-scale merger of the two Salesforce Classic orgs into a unified updated Salesforce Lightning solution.<br><br><strong>Results</strong></p>\n<p dir="ltr">The client now enjoys the solution they were looking to build, as it covers all the stipulated business needs with the help of duly implemented Salesforce solutions. Refined and secure data gathering, management, and synchronization between their teams&#39; systems ensure omnipresent management and sales efficiency. With all the new functionality and an improved user interface on their side, the client&#39;s teams relish the updated individualized processes and customized features that help them cater to their customers&#39; most personalized requests. Living up to our promise of being our client&#39;s competitive advantage, we have turned the rusty data in their hands into an ability to see what their competitors can&#39;t.</p>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: ">$1,000,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#00C2FF",
          primaryfont: "Prompt",
          primarycolor: "#493AFC",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Our client is one of the world’s leading asset-management and financial services organizations. Serving 30+ million people and 25,000+ businesses, the company helps its customers enjoy financial stability and predictability.",
          },
          metadataname:
            "Reinventing data potential with the help of Salesforce",
          metadatadescription:
            "Learn how Avenga helped its client helped its client merge two outdated Salesforce Classic orgs into a Lightning-based business solution with updated functionality",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment:
              "Our client was looking to invest in a project that would free them of the tech debt dragging their business down. As one year has passed since Project A went online, vital data across the organization is coordinating operations rendering them efficient while automating many business processes. Decision-making is now, literally, Lightning-fast, as quick delivery of data analysis outcomes has been enabled by optimized and conformant data searchers with no duplicated data in the system. The client can now reach the market faster than its competitors and can innovate more freely. While having made sure the old system experienced not a single second of downtime as the new functionality was implemented, Avenga turned two Salesforce liabilities into a powerful Salesforce asset.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment:
              "You wouldn't expect your project's main bottleneck to hit you in the form of tanks, missiles, and Russian imperial ambitions. What is more, you wouldn't expect to actually deliver the project when every minute could be the last one of your life. Missile strikes and carpet bombings of civilians commenced on the third day of our ten-day-long migration exercise – February 24. Nobody believed in us and neither did we at first. Yet, we dusted ourselves off and made it; we cut the project's ribbon, launching it live within the deadline set. The team's unprecedented commitment and Avenga's Service Endurance Plan, which gave employees a safe place to reside and work from, helped us stay strong, keep calm, and work under the pressure of tomorrow's unpredictability. That week of workshops in Kyiv helped our client believe that we would come through no matter what. Little did they know that this Avenga team would stick to the task even if it literally meant putting everything on the line.",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5bGvEAJ_b6Z7V8PEM",
            redMoment:
              "After 2.5 years of incredible progress on the project, its release was planned for February-March 2022. In September 2021, the world's leading news sources warned about Russia's plan to attack Ukraine. However, there was no going back for us as we were too deep into the project, and nobody believed (wished) that Russia would really attack its peaceful neighbor. We kept working, while receiving hundreds of calls from perplexed customers, asking, \"Are you able to deliver? Are you planning to relocate?\" and so on and so forth, which was a completely understandable reaction. No company wants its projects and capital hung up in the psychologically unstable choices of a dictator. Avenga started developing its Service Endurance Plan to prepare us for any scenario and our clients’ unfolding. The solution deployment, which anticipated ten days of non-stop data migration, was planned for February 22. We started as planned. On February 24, we woke up to explosions and air raid sirens.",
            momentOfTrustImage: "",
            momentOfTrust:
              "The history of trust between Avenga and our client goes back years, as we have accomplished many smaller yet complicated projects for the company. However, Project A envisaged an entirely new budget level and thus required a qualitatively higher level of trust toward the tech partner. While there was nothing new to tell the client about our Salesforce capabilities (they knew what we were capable of), our continuous devotion and effort made them decide in our favor. Our head of Salesforce competency traveled to London more than once to showcase our project vision. As a result, the client's team was intrigued enough to visit Kyiv for a week's worth of workshops that crystallized the client's outlook on our approach. Avenga landed a project worth more than $1.5 million because the client saw the needed grit and readiness in us to overcome difficulties and barriers, which was what they precisely expected from a strong implementation partner.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment:
              "Imagine teaching a French child to sing in Mandarin. What do you do first? You teach them some Mandarin as they need to grasp the basic phonetics so they pronounce the words correctly. Merging two Salesforce Classic orgs into a Lightning-based solution ousting data redundancy was just like that.  Our critical task was making the new duplicates-free platform duly recognize, process, and distribute various types of data without creating more duplicates and lookalikes. So, we taught our kid some Mandarin: we installed some of the newly-required functionality into one of the old orgs and set it up as the basis for the future migration and merger. We made use of what the org already knew and taught it some new skills, which were necessary in order to make the data 'behave' when we  poured it into the new hierarchical infrastructure. Finally, adding an intellectual look-up tool helped the system differentiate between the cognominal files affiliated with the different organizations.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5bEoEAJ_AyGxWmCHg",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Lightning",
              "Salesforce Apex",
              "Salesforce Lightning Web Components",
              "CI/CD",
              "Selenide",
              "Salesforce Aura",
              "Automated Testing",
            ],
            Timeline: ["Over 2 Years"],
            Budget: [">$1,000,000"],
            Industry: ["Financial Services"],
            Company: ["Avenga"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Tech consultancy",
          calendlyLink: "https://meetings.hubspot.com/yuliia-hnatyk",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
        {
          website: "https://www.avenga.com",
          valueSectionsData: [
            {
              heading: "R&DIUM Capital Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "As the Radium business continues to grow, they encountered scalability issues with their legacy .NET client portal. The portal required the operations team to access multiple systems, errored out frequently, and was difficult and costly to maintain.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "G-XC70WCKRPC",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "A 50% increase in client processing capacity with Salesforce Experience Cloud",
            table: [
              {
                valueName: "R&DIUM Capital",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Financial Services",
                keyName: "INDUSTRY",
              },
              {
                valueName: "7-12 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "1",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvcM2EAJ_z5mILWEeBW",
            layout: "Original",
            description:
              '<p><strong id="docs-internal-guid-023f62b9-7fff-93f4-b999-994f70a56ff3">An Australian financial firm doubles client capacity after Avenga reinvents operations around Salesforce.</strong></p>',
          },
          testimonialsData: [
            {
              industry: "CTO",
              description:
                '"Their agility and responsiveness have been vital in delivering a tailored solution. They continually adapt the solution to meet our evolving needs, helping us to implement robust data protection mechanisms and ensuring compliance with data privacy regulations. Working with Avenga felt like having an extension of our team."',
              author: "Ron Holmes",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000STQf_3E03X8xi0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PCBEA3_mc0HaeDy4",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PDOEA3_gvjttA_4Y",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "",
              name: "Matthew Baker",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000Abz8tMAB__J7CnA23L",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FvCvOEAV_G4nmb5Q94",
          storyId: "a006g00000ot4HUAAY",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#000000",
          secondaryfont: "Prompt",
          secondarycolor: "",
          projectSectionData: {
            videoLink: "https://www.youtube.com/watch?v=tgiWn6zFI6U",
            title:
              "A 50% increase in client processing capacity with Salesforce Experience Cloud",
            teamSize: 12,
            paragraph2:
              '<p><strong id="docs-internal-guid-023f62b9-7fff-93f4-b999-994f70a56ff3">An Australian financial firm doubles client capacity after Avenga reinvents operations around Salesforce.</strong></p>',
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AbxghMAB_W3xBJwr0k",
            imgBanner:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000Ac4jKMAR_DPyjqzAzz",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr"><strong>The project’s essence</strong></p>\n<p dir="ltr">R&amp;DIUM Capital helps businesses all over Australia to qualify for the government’s R&amp;D tax incentive – a program that lets save on tax when developing ground-breaking products. As the number of applicants began to grow exponentially, R&amp;DIUM Capital faced the need for revamping their outdated platform used for processing and managing applications.</p>\n<p dir="ltr">Each of the company’s five operational cycles, from application processing to identity validation to client support, was burdened with undocumented code and constant database syncing issues. The legacy .NET solution ceased to deliver to R&amp;DIUM Capital’s business needs and became a blocker. It not only decreased the amount of processed clients, but it complicated the existing client load. Furthermore, outdated methods of gathering and processing personally identifiable information were causing legal and operational inconvenience to the company and its clients.</p>\n<p dir="ltr">Understandably, R&amp;DIUM Capital was looking to move to a more sophisticated business logic that would automate operations, enhance customer experience, and get compliant with data regulations. Given that the client’s existing platform was a part of its broader operational ecosystem, Avenga helped R&amp;DIUM Capital approach the change holistically by designing the new solution’s architecture from the ground up and then successfully implementing the platform.<br><br><br></p>\n<p dir="ltr"><strong>The way out</strong></p>\n<p dir="ltr">Salesforce has already been a part of the client’s platform. Yet it had been used only for record management – Salesforce needed to play a bigger role in company operations. Our team started with an in-depth analysis of client goals to shape a solution compatible with R&amp;DIUM vision. </p>\n<p dir="ltr">Following a one-month design phase with Avenga’s Salesforce Business Analyst and Salesforce Solution Architect, Salesforce Experience Cloud was adopted as the core technology of Avenga’s solution. As soon as we completed the data migration, we eliminated all syncing problems - with the help of Equifax, R&amp;DIUM’s credit data partner. Our experts have worked through its bugs and rendered it understandable for the final user, while cutting on the client’s infrastructure expenses. </p>\n<p dir="ltr">With the new data models aligned with the existing data processing pipelines, Avenga started automating client applications processing, identity validation, document management and storage, thus enabling clients for refined self-management with the help of a clean and simpler UI on the Salesforce Experience Cloud. Because identity validation had been one of R&amp;DIUM’s most painful problems (Australian law now forbids gathering ID scans), Avenga moved them to Green ID – a modern, compliant SMS and email-powered ID verification service. We thoroughly integrated GreenID into the new Salesforce ecosystem.  With the service’s integration connector developed simultaneously with our project, we kept communicating with Green ID’s team to prepare the integration in advance.</p>\n<p dir="ltr">Our final challenge was to put the finishing touches on the client application processing functions: more secure and efficient document creation, storage, and management. The combination of Salesforce with Conga Sign and Conga Composer worked just the way we planned. Now, R&amp;DIUM Capital’s clients can create, view, and manage their documentation instantly. Also, the Box integration allowed us to establish secure document storage. As a result, R&amp;DIUM Capital’s operations are business-efficient and 100% compatible with Australian law on personal data protection.</p>\n<p dir="ltr">Avenga finished off the project by ensuring the long-term flexibility and success of the solution. Leveraging their Salesforce DevOps expertise, Avenga designed a release system and infrastructure, letting the client continuously improve the solution through micro and major releases, which saves R&amp;DIUM time and budget.<br><br></p>\n<p dir="ltr"><strong>The output</strong></p>\n<ul><li dir="ltr">\n<p dir="ltr">A 50% increase in processed loans, as the sales team now spends 50% time less to assess applications with customer data preloaded from CBO reports.</p>\n</li><li dir="ltr">\n<p dir="ltr">A 100% improvement in client document security ensured by R&amp;DIUM Capital’s migration from email to Box – integrated with Salesforce.  </p>\n</li><li dir="ltr">\n<p dir="ltr">A 95% improvement in client data security as Green ID automatically handles identity verification.</p>\n</li><li dir="ltr">\n<p dir="ltr">A 60% increase in client satisfaction showcased with a 60% decrease in client support calls just two months since the project’s release.</p>\n</li><li dir="ltr">\n<p dir="ltr">Enhanced sales efficiency as the sales team is now more focused on working directly with customers rather than chasing documentation through email. </p>\n</li><li dir="ltr">\n<p dir="ltr">Reduction in maintenance costs with no bugs to fix and no daily operational issues.</p>\n</li><li dir="ltr">\n<p dir="ltr">Improved customer experience resulting from the smooth and automated data integration with the Australian Tax Office.<strong id="docs-internal-guid-fbfe2417-7fff-4ae4-accd-bbd00f4912a3"> </strong></p>\n</li></ul>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#00C2FF",
          primaryfont: "Prompt",
          primarycolor: "#493AFC",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Radium Capital is Australia’s market leader in advances of the R&D Tax Incentive refund. Since launching in 2017, they've helped hundreds of innovators improve their cash flow and grow their businesses.",
          },
          metadataname:
            "Avenga reinvents client-side operations for R&DIUM with Experience Cloud",
          metadatadescription:
            "Learn how a duly customized and implemented Salesforce Experience Cloud can become the basis for doubling your client base",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000Ac5FVMAZ_Bra4L1Nl-",
            roiMoment:
              "Avenga is our clients' competitive advantage. Hence, we were happy to see our project once again delivering a competitive advantage to R&DIUM Capital. Once launched, the new Client Loan Application Portal started processing each loan smoothly, and together with R&DIUM, we could see the new infrastructure, logic, and user experience doing a great job. Furthermore, three months after the initial go-live, Barbara McGirr, head of Radium Operations, estimated that the new portal had effectively reduced loan application time by 25%.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AbyVwMAJ_yB23W1Oufc",
            momentOfTrust:
              "Our story with R&DIUM commenced two years ago when Avenga took on the development of a new Loan Management System (LMS) on the Salesforce Platform. The system's purpose was the automate loan interest and fee calculations so that R&DIUM could efficiently handle a larger volume of loans. It was a complex project, indeed. However, Avenga managed to deliver the expected result, so by the time R&DIUM was ready to build a new client portal, they knew there was no need to look for a new vendor.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000Ac2MlMAJ_XuUXDrXS5",
            eurekaMoment:
              "During the previous project we worked on with R&DIUM, we got a deep insight into their challenges with their legacy .NET client portal. It required the operations team to access multiple systems, errored out frequently, and was expensive to maintain. Hence, our experts offered a solution: re-platforming the portal on Salesforce Experience Cloud. The new platform would eliminate not scalable and poorly-configured integrations, enhance the user experience for the operations team and clients, and lay a solid foundation for further scaling and business process improvement. Salesforce Experience Cloud is a fantastic, yet painfully underrated, solution to build efficient client-company-partner data and workflows.",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000Ac2XxMAJ_bEfMZJLZI",
            dealClarityMoment:
              "The project's discovery phase involved multiple design thinking sessions with participants from Australia, Ukraine, and the United States, all joining online to discuss and shape the best solution possible for R&DIUM. Having harnessed the benefits of modern team cooperation software, we created a blueprint of the ideal future-state process and mapped out the data points and automation logic. Finally, Avenga wireframed the future solution's screen, thus setting up a vision of the future user experience.",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5bEoEAJ_AyGxWmCHg",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Experience Cloud",
              "Salesforce Lightning Web Components",
              "Salesforce Aura",
            ],
            Timeline: ["7-12 Months"],
            Budget: [null],
            Industry: ["Financial Services"],
            Company: ["Avenga"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Tech consultancy",
          calendlyLink: "https://meetings.hubspot.com/yuliia-hnatyk",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription:
              "Get a free-of-charge consultation on how Avenga's custom Salesforce solutions can become your competitive advantage.",
            headshotUrl:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000Abz8tMAB__J7CnA23L",
            contactName: "Matthew Baker",
            calendlyLink: "https://calendly.com/matthew-baker-avenga",
            bannerDescription: "Salesforce can do wonders. We empower it to!",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5bEoEAJ_AyGxWmCHg",
      fav_image: "",
      contact_us: "https://www.avenga.com/contact-avenga/",
      account_description: "Tech consultancy",
    },
    {
      title: "SaltClick",
      teamId: "0016g00002OAkt9AAD",
      stories: [
        {
          website: "https://emzsaltclick.com/",
          valueSectionsData: [
            {
              heading: "U.S. Ski and Snowboard Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "With an economy that is sure to tighten donated funds, they are looking for ways to create efficiencies with technology, allowing them to do more with fewer paid staff.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "US Ski and Snowboard and SaltClick - A relationship built on shared purpose",
            table: [
              {
                valueName: "U.S. Ski and Snowboard",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Nonprofit",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Managed Service",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4zYVEAZ_bkHh63YVu",
            layout: "Original",
            description:
              "<p>SaltClick has become a trusted partner of U.S. Ski and Snowboard through a spirit of caring and shared purpose. Our goals are their goals. Our wins are their wins. Their team, both support staff and the athletes themselves, are our team. </p>",
          },
          testimonialsData: [
            {
              industry: "CTO",
              description:
                '"SaltClick knows what we do and what is important to us. The internship program for the athletes really drove buy-in from the executive sponsorship. Using a different partner wouldn\'t make sense."',
              author: "Mark Schneider",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000STQf_3E03X8xi0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4zYyEAJ_fXUbvASgkQ",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SS2Q_r3mSZ2GRfF",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzo_9WG7SLFgB",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Consultant",
              name: "Michelle Izatt",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5bFEEAZ_CFvrKC1N7",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Business Analyst",
              name: "Dan Eyring",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5bEjEAJ_FueWAIv0s",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Lisa Erickson",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5bGqEAJ_qwF2Rj1c-c",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5b6KEAR_9FP7Bc-Yh",
          storyId: "a006g00000o7VdaAAE",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#000000",
          secondaryfontcolor: "#4D4D4D",
          secondaryfont: "Nunito",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "US Ski and Snowboard and SaltClick - A relationship built on shared purpose",
            teamSize: null,
            paragraph2:
              "<p>SaltClick has become a trusted partner of U.S. Ski and Snowboard through a spirit of caring and shared purpose. Our goals are their goals. Our wins are their wins. Their team, both support staff and the athletes themselves, are our team. </p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4y1fEAB_LySz4ktUz",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Understanding their frustrations about Salesforce and their, then, partner. </p>\n<p>Building trust through small, inexpensive wins rather than trying to force large, risky, bloated projects</p>\n<p>Helping them with business process issues even if they are not &quot;Salesforce&quot; related</p>\n<p>Getting to KNOW primary stakeholders and what their jobs are rather than simply &quot;if&quot; they have requirements</p>\n<p>Never miss an opportunity to brand SaltClick as a partner who cares about their cause</p>",
          },
          projectBoundariesData: {
            rightStatus: "$300,000-$450,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#4D4D4D",
          primaryfont: "Nunito",
          primarycolor: "#4476BB",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "U.S. Ski and Snowboard is a NGB that covers multiple Winter Olympic events. Based in Park City Utah, they are in a perfect location to support the athletes as well as attract support for their program. Considered one of the larger and more recognizable NGBs, U.S. Ski and Snowboard aspires to lead the way in using technology to create efficiencies for NGBs.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4zYUEAZ_ndu-FoL3oY",
            roiMoment:
              "SaltClick was recently on a demo call with the United States Olympic & Paralympic Committee where we were given the opportunity to show some of the fantastic features we've built in Salesforce for U.S. Ski and Snowboard and National Ability Center. The demo had such a positive impact that they let us know that we were at the top of the list for a major initiative that had only gone out to one other partner. We know who that partner is. This is quite the David and Goliath situation and we're not Goliath. But due to the strong relationship we have with our current NGB clients and the quality of the work we've done for them we feel confident that we'll not only win that business, but that USOPC will be in better hands and end up spending less for a vastly superior result.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4yu4EAB_6XJ2p1XLN",
            ribbonCuttingMoment:
              "As businesses we often think that organizations have relationships. In reality, they don't. People do. Just like the strongest personal relationships, they are built over time. They are built through hard work. They are built through adversity. And the very best relationships are built on a foundation of shared purpose. We can't point to one win, one successful initiative, or one Salesforce update that is the reason for our strong relationship with U.S. Ski and Snowboard. Rather it is the slow and consistent progress towards a common goal that comes to mind when trying to define the relationship as successful.",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4ypFEAR_bPa1qb2b5",
            redMoment:
              "As a new Salesforce Partner, we were learning the ropes and not everything went smoothly. One major challenge working with tight budgets, especially in the non-profit space, is that every dollar is critical and it leaves very little room for mistakes. Early in the SaltClick/US Ski and Snowboard relationship there were outcomes that didn't meet the expectations of the client. Either through miscommunication or not clearly defining requirements, estimates were exceeded and we were at risk of becoming another partner who was expensive and didn't get the results that the client needed. Rather than finger pointing or making excuses, SaltClick credited hours to get things back on track, something that no other partner had done for them. This created a culture of accountability that persists to this day at SaltClick.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4y8zEAB_4Xa_EaCMq",
            momentOfTrust:
              "Shortly after SaltClick became a Salesforce Partner, we realized that finding customers was up to us and we could not yet rely on Salesforce AEs to even answer our communications let alone bring us business because we were unknown and thus unproven. The U.S. Ski and Snowboard team was literally in our DNA. Our company's primary investor has a son who is a member of the downhill team and we had always been very proud of that. Through persistence and networking, we finally were able to get in touch with the CTO to discuss Salesforce. Timing was on our side due to the fact that they recently had some struggles and frustration with their Salesforce partner. SaltClick determined that the best way to build trust was to first learn about how they were using Salesforce, what they were not getting from their partner, and what they wanted to be able to do with the platform. In their moment of frustration with both Salesforce and their partner, we actively listened, rather than actively sold.",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5b3wEAB_GE4Leo2PX",
            introductionMoment:
              "At SaltClick, we realize that there are many Salesforce Partners a company could chose to work with. We could get caught up in a game of hourly rates, or the number of certifications we have, or how long we've been in business. But what we've learned is that while those things are important to give exceptional results to our clients, when all of the noise is turned off, clients will do business with the partner they like and trust. We genuinely view our clients as our friends and coworkers. We've found that because of this, our clients even like to \"line us up\" with their friends which has lead to some unbelievable doors being opened for our young Salesforce practice. Recently SaltClick has been introduced through our U.S. Ski and Snowboard network to the United States Olympic & Paralympic Committee about some initiatives that could benefit all Olympic sports and the National Governing Bodies who make the Olympic and Paralympic games possible.",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E4ytzEAB_Di8LGxbYc",
            eurekaMoment:
              "The result of the multiple conversations with U.S. Ski and Snowboard may have sent many partners running for the exit. They have very tight budgets, differing levels of buy-in from leadership, and multiple siloed systems and departments that weren't communicating. Perhaps it was a combination of a brand new Salesforce Partner willing to take any work they could get and that shared sense of commitment to the organization that prompted SaltClick to lower its rates, carve off bite-sized wins, give them time with our smartest team members and really show them the art of the possible. But perhaps the most valuable thing SaltClick did had nothing to do with Salesforce or consulting. After meeting with the Director of Athlete Career and Education, we learned that there was a huge need for meaningful earning opportunities for athletes. SaltClick jumped in and started an Athlete Internship program. That one gesture still gets mentioned to this day as the reason they stick with SaltClick.",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5b53EAB_Lb5Z9p2vx",
            dealClarityMoment:
              "One of the key components to our relationship is flexibility. Many Managed Services offerings are anything but flexible. Only certain resources are available and SLAs can be all over the map. U.S. Ski and Snowboard have had the same SaltClick point of contact since day one. And that person is not a salesperson, they are a hands-on keyboard Certified Salesforce Admin who brings with her more experience and institutional knowledge about U.S. Ski and Snowboard than the vast majority of people who work there. Not only does this make her a vital resource for client, it give us peace of mind that when she makes recommendations they can be trusted. SaltClick will always allocate the best person for every task depending on the skills required. But having someone to quarterback those initiatives is an invaluable asset to both us and our client.",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5b1lEAB_FSPXntyNw",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Sales Cloud",
              "Salesforce Experience Cloud",
              "Marketing Cloud",
              "DocuSign",
              "Salesforce",
              "Salesforce NPSP",
            ],
            Timeline: ["Managed Service"],
            Budget: ["$300,000-$450,000"],
            Industry: ["Nonprofit"],
            Company: ["SaltClick"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5b1lEAB_FSPXntyNw",
      fav_image: "",
      contact_us: "https://emzsaltclick.com/contact/",
      account_description: "",
    },
    {
      title: "Valence",
      teamId: "0016g00002OBqfSAAT",
      stories: [
        {
          website: "https://valencelevel.com/",
          valueSectionsData: [
            {
              heading: "Spaceflight Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "With the growing industry of smallsats, the demand for routine, cost-effective access to space has increased exponentially. Demand, coupled with the growing number of launch vehicle providers, created an opportunity for Spaceflight to assist in identifying, booking, and managing rideshare launches.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Valence: Spaceflight Customer Story",
            table: [
              {
                valueName: "Spaceflight",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Travel, Transportation, & Hospitality",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over a year",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "5",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5CLMEA3_MqOxtPbDS",
            layout: "Original",
            description:
              '<p><a target="_blank">Spaceflight</a> is a <em><strong>premier launch services and mission management provider</strong></em>, offering routine, cost-effective access to space, <em><strong>helping customers to explore beyond our planet</strong></em>. Think Expedia - for space travel! This is a story of how Valence partnered with Spaceflight to <em><strong>identify, book, and manage rideshare launches</strong></em> leveraging their digital estate.</p>',
          },
          testimonialsData: [
            {
              industry: "Vice President, Mission Management",
              description:
                "“I appreciate that Valence was good at guiding us through the technical aspects of the project while also always treating us as equals. We felt like engaged and respected partners,” said Tony Frego, vice president of mission management, “Valence also got to know our business at a detailed level, which is not easy. It’s cool that Valence can talk about orbits with us now.” ",
              author: "Tony Frego",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5I9HEAV_MZpLGx4Ygz",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5I9gEAF_wdrEvhgMOS",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IA0EAN_bjqooXTMX",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IAFEA3_aiOZFgSvJD",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZSZM_RNMSsv3xZ",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/lindsay-cox-seattle/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Managing Director",
              name: "Lindsay Cox",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IOQEA3_p-0Q_LAnS",
            },
            {
              serviceLink: "https://www.linkedin.com/in/alice-watkins/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Alice Watkins",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IBVEA3_Qz9oDU60NN",
            },
            {
              serviceLink: "https://www.linkedin.com/in/derek-keeler-94856495/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Solution Architect",
              name: "Derek Keeler",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QSxEAN_Kx9BNkT1r",
            },
            {
              serviceLink: "https://www.linkedin.com/in/alan-luder/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "User Experience and Process Design",
              name: "Alan Luder",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QT7EAN_C5sh2Ys-C",
            },
            {
              serviceLink:
                "https://www.linkedin.com/in/trevor-farthing-6a9820108/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Trevor Farthing",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QTHEA3_pMhb7FDNr",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000003FySh_pdqbUrftI",
          storyId: "a006g00000o7bRLAAY",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#F9F9F9",
          secondaryfontcolor: "#212121",
          secondaryfont: "Inter",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "Valence: Spaceflight Customer Story",
            teamSize: null,
            paragraph2:
              '<p><a target="_blank">Spaceflight</a> is a <em><strong>premier launch services and mission management provider</strong></em>, offering routine, cost-effective access to space, <em><strong>helping customers to explore beyond our planet</strong></em>. Think Expedia - for space travel! This is a story of how Valence partnered with Spaceflight to <em><strong>identify, book, and manage rideshare launches</strong></em> leveraging their digital estate.</p>',
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FF1T6EAL_hiByDxRhN",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Spaceflight needed a platform to <em><strong>support more customers</strong></em> as the business scaled and to <em><strong>provide customers with a single source of truth to view all their mission information.</strong></em></p>\n<p><em><strong>“Our primary objective was to simplify the user experience to support the adoption of the tools,” </strong></em>said Alice Watkins, Valence Technical Project Manager, “In addition to adding features to make the system easier to use, <em><strong>we were ruthlessly focused on streamlining the experience</strong></em>. We <em><strong>improved the ease-of-use, the booking process, and functionality for Mission Control</strong></em>.”</p>",
          },
          projectBoundariesData: {
            rightStatus: ">$1,000,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#212121",
          primaryfont: "Inter",
          primarycolor: "#0AADEE",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Spaceflight is a premier launch services and mission management provider, offering routine, cost-effective access to space, helping customers to explore beyond our planet.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IJyEAN_5stB0lw9X",
            roiMoment:
              "With Book My Launch and Mission Control, Spaceflight is transforming its business and the aerospace commercial space flight industry.\nThe Mission Control tool is scalable, flexible, trackable, and provides better records, impressively advancing Spaceflight from its previous ad hoc systems. Further, the onboarding of new Mission Managers is more consistent, and Mission Managers can save time and effort compared to previous processes.\nAnd because Mission Managers can better manage customers, customers are expected to have a better experience with Spaceflight and demonstrate higher satisfaction – ultimately leading to future bookings and a stronger business.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IIvEAN_S8mGbqVw6",
            introductionMoment:
              "Valence was introduced to Spaceflight through a referral from a previous client. Valence has a strong reputation in the market for being able to solve just about anything. Spaceflight had a great idea and wanted to partner with someone who could really help bring their idea to life.",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5CUQEA3_ohoRfGmKj",
            eurekaMoment:
              "Spaceflight’s team had a strong vision for the end-product and its business impact but had not previously worked on a software development effort of this nature. Spaceflight needed a partner that could guide them through the entire process. “We could tell that Valence was excited about this project and was really engaged,” says Kristen Smithson, Spaceflight vice president of business operations, “When the whole team came to the office and gave a presentation, they spoke to all our needs, and we were impressed. Valence was able to speak to the backend setup as well as how we would design it. The end-to-end capability made a difference.” ",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000003FyH0_iDG7dsIui",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "AWS",
              "React",
              "Serverless",
              "DynamoDB",
              "Material UI",
              "Microservices",
            ],
            Timeline: ["Over a year"],
            Budget: [">$1,000,000"],
            Industry: ["Travel, Transportation, & Hospitality"],
            Company: ["Valence"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Tech consulting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000003FyH0_iDG7dsIui",
      fav_image: "",
      contact_us: "https://valencelevel.com/contact-us/",
      account_description: "Tech consulting",
    },
    {
      title: "Platinum Cubed",
      teamId: "0016g00002OCc6RAAT",
      stories: [
        {
          website: "https://www.platinumcubed.com/",
          valueSectionsData: [
            {
              heading: "Xebec Realty Trust Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Xebec had a unique opportunity in the market and needed to move quickly.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "How Platinum Cubed Managed Services Helped Xebec Overcome A Slow Start & Succeed",
            table: [
              {
                valueName: "Xebec Realty Trust",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Engineering, Construction, & Real Estate",
                keyName: "INDUSTRY",
              },
              {
                valueName: "7-12 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5D6qEAF_CC3SQtWpL",
            layout: "Original",
            description:
              "<p>After experiencing a poor implementation, Xebec needed an industry expert to partner with to transform their investor onboarding process. They needed a fast, secure, and convenient way to bring on new investors and to share sensitive information.</p>",
          },
          testimonialsData: [
            {
              industry: "CFO",
              description:
                "“Platinum Cubed is incredibly proactive in seeking creative, practical, and pragmatic solutions. The team listened to our needs and requests and then was able to provide us with alternatives well beyond what we had conceptualized.  I could not recommend the Platinum Cubed team more highly”.",
              author: "Scott Hodgkins",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000STQf_3E03X8xi0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOiX_aQ0xr8NqA",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOj1_8iMpFJifk",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOlb_csl85k20X",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Strategy",
              name: "Brittany Hart",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5D7tEAF_t5RD97p4O",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Solution Architect",
              name: "Nicholas Clemens",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5D7jEAF_5S-9NkuU1",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consultant",
              name: "David Albanese",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5D7UEAV_ugqh9uWkVH",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000003FyII_l8vRsT6ki",
          storyId: "a006g00000o7bu1AAA",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#ffffff",
          secondaryfontcolor: "#818181",
          secondaryfont: "Avenir",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "How Platinum Cubed Managed Services Helped Xebec Overcome A Slow Start & Succeed",
            teamSize: null,
            paragraph2:
              "<p>After experiencing a poor implementation, Xebec needed an industry expert to partner with to transform their investor onboarding process. They needed a fast, secure, and convenient way to bring on new investors and to share sensitive information.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5D4VEAV_O_1sDbCv-",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">The Challenge:</p>\n<p dir="ltr"> A different Salesforce partner had done a poor job of setting up Xebec’s Salesforce solution. The system was a mess, and the company wasn’t seeing any return on their initial investment. Xebec needed a partner who understood how to leverage Salesforce to get results in real estate – and who was willing to stick around and provide continued strategic and development support after the initial implementation.</p>\n<p>The investor relations team was still using spreadsheets to onboard new investors. They needed a fast, secure, and convenient way to bring on new investors and to share sensitive information such as tax documents and investment performance reports. <br><br>The investor relations, asset management, legal, capital markets, and accounting teams all needed information and status reports about the opportunities the acquisitions team was pursuing, but there was no good way to share data and keep everyone in the loop. Team members were wasting a lot of time tracking down data instead of focusing on more valuable activities.</p>\n<p>The Solution:</p>\n<p dir="ltr">Fixed the existing (failed) solution and built Xebec a solid Salesforce foundation. Our team developed &amp; implemented a customized Sales Cloud solution and rolled it out in the Lighting platform.</p>\n<p dir="ltr">Built a dynamic investor portal using Experience Cloud. Xebec operates using three distinct brands, and our solution included a custom UI/UX for the portals associated with each brand. This allowed Xebec to move their entire investor intake process from Excel to Salesforce.</p>\n<p dir="ltr">Implemented Marketing Cloud Account Engagement. This project included development work as well as post-implementation technical support and user adoption training for Xebec’s Marketing team.</p>\n<p dir="ltr">Enabled accurate cash flow projections &amp; reporting using Sales Cloud. The Platinum Cubed team built custom dashboards to allow users to quickly compare forecasts vs actual cash flow and performance data.</p>\n<p dir="ltr">Increased acquisition data visibility using Salesforce. Now other teams have easy access to the data they need to make smart decisions about investor outreach, asset management, cash flow planning, and other important aspects of commercial real estate investment.</p>\n<p>Provided fractional Salesforce admin services. We continue to provide outsourced admin services to the Xebec team, including periodic strategic planning, ongoing development, regular updates, and user support and training.</p>',
          },
          projectBoundariesData: {
            rightStatus: "$40,000-$70,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3C3C3C",
          primaryfont: "Avenir",
          primarycolor: "#FE8C68",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Xebec is a real estate investment firm specializing in acquiring, developing, redeveloping, repositioning, and managing Class A industrial assets. The company has over 30 years of experience understanding and adapting to trends in industrial real estate – and to shifting investor expectations.",
          },
          metadataname: "REIT, Real Estate Investment",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5SmvEAF_3ZyZTIAOk",
            roiMoment:
              "Cut investor intake & onboarding time by 50%\n20% faster lead conversion\nPortfolio reporting process on $1B worth of assets is 40% faster using Salesforce\nInvestor relations, legal, capital markets, and accounting teams improved communication efficiency by 60%\nCut SEC marketing material compliance reporting time by 30%\nTracked & processed 322 investments \nManaged $125M + in fundraising since Salesforce implementation",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5So3EAF_MgXKKVjPu",
            momentOfTrust:
              "It didn't take much past the first meeting to know this was going to be a long and fruitful partnership. The Platinum Cubed team came in and spoke the real estate language offering up how other in the industry had tackled the challenges Xebec was facing. Trust grew fast as the team executed and continued to speak the business language...not tech jargon.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5SoDEAV_vq1PDSXQg",
            eurekaMoment:
              "Xebec’s investor relations team now has easy access to detailed information about their investors. They’ve used this information to nurture relationships, match investors to ideal opportunities & expand the investor base.\n\nXebec’s team is now managing 3000+ leads in Salesforce, which has allowed them to dramatically improve their lead conversion process.\n\nFrom enhanced compliance & performance reporting to more targeted marketing outreach, data is making a real difference. All Xebec’s teams are getting real value from increased data access and visibility. ",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IHyEAN_Sg3p7G6s3",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Sales Cloud",
              "Salesforce Experience Cloud",
              "Pardot",
              "Microsoft Office 365",
              "TaskRay",
            ],
            Timeline: ["7-12 Months"],
            Budget: ["$40,000-$70,000"],
            Industry: ["Engineering, Construction, & Real Estate"],
            Company: ["Platinum Cubed"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Top Tech consultancy",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IHyEAN_Sg3p7G6s3",
      fav_image: "",
      contact_us: "https://www.platinumcubed.com/contact/",
      account_description: "Top Tech consultancy",
    },
    {
      title: "Agency73",
      teamId: "0016g00002OCMiaAAH",
      stories: [
        {
          website: "https://www.agency73.com/",
          valueSectionsData: [
            {
              heading: "SeaTrees Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                'SeaTrees has gained visibility in the Salesforce ecosystem after being featured in the first video of Salesforce’s "The Ecopreneurs" series, which has garnered more than 3 million views. They’re looking to broaden the impact of their work by scaling to 100 blue carbon projects by 2030, and they realized that tracking project impact requires refined data architecture within their Salesforce org.\n\nBy implementing and enhancing the team’s use of Salesforce to track project inventory, Agency73 has provided SeaTrees a solid foundation to increase their reach, generate more revenue, and advance their mission of reversing climate change.',
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Agency73 + SeaTrees: Salesforce as a tool for regenerating our ocean planet",
            table: [
              {
                valueName: "SeaTrees",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Nonprofit",
                keyName: "INDUSTRY",
              },
              {
                valueName: "3-4 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5IHWEA3_K7vrUUIgc",
            layout: "Original",
            description:
              "<p>Agency73, a Salesforce partner based in Southern California, built customized data architecture in Salesforce to help SeaTrees track inventory and advance their mission of restoring coastal ecosystems around the world.</p>",
          },
          testimonialsData: [
            {
              industry: "Partnerships Manager",
              description:
                '"We were using Salesforce to manage brand partner relationships and revenue; while SeaTrees project inventory was managed manually in a Google spreadsheet. In order to reach our goal of 100 blue carbon projects by 2030, we needed a more streamlined system. Now Salesforce allows us to manage brand partners, revenue, SeaTrees projects and inventory in one place."\n\n"This integration would not have been possible without Agency73. Their team was a pleasure to work with, they took the time to understand our organization and unique needs, and they explained Salesforce to a team that\'s relatively new to the system."',
              author: "Haley Jain Haggerstone",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PBhEAN_TIL9UICsP",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOHz_xiYvLIoau",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/emily-adamiec-5080a71/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Consultant",
              name: "Emily Adamiec",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PuUEAV_FUjGtJvyH8",
            },
            {
              serviceLink: "https://www.linkedin.com/in/bryce-cason/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consultant",
              name: "Bryce Cason",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PuZEAV_9k5wjtc-9",
            },
            {
              serviceLink: "https://www.linkedin.com/in/scott-holmen-63aa6410/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Scott Holmen",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5R9oEAF_xclPvTN-F",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5WOwEAN_sTZafvO79S",
          storyId: "a006g00000o7e3bAAA",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#2C2C2C",
          secondaryfont: "Cabin",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Agency73 + SeaTrees: Salesforce as a tool for regenerating our ocean planet",
            teamSize: null,
            paragraph2:
              "<p>Agency73, a Salesforce partner based in Southern California, built customized data architecture in Salesforce to help SeaTrees track inventory and advance their mission of restoring coastal ecosystems around the world.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QKbEAN_rF4Zv_q1F7",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p class="MsoNormal">Since 2022, <a href="https://www.agency73.com/" target="_blank">Agency73</a> has been partnering with <a href="https://sea-trees.org/" target="_blank">SeaTrees</a> to more efficiently track inventory and gather insights on project impact.</p>\n<p class="MsoNormal"><a href="https://sea-trees.org/" target="_blank">SeaTrees</a>, a program of the nonprofit <a href="http://sustainablesurf.org/" target="_blank">Sustainable Surf</a>, directly supports communities and scientists who protect and regenerate blue carbon coastal ecosystems. Together with their global brand partners, they’re working to restore coastal ecosystems by planting mangrove trees, restoring kelp forests, coral reefs, seagrass meadows, and conserving coastal watersheds.</p>\n<p class="MsoNormal">Agency73’s office is just minutes from the beach in Carlsbad, California, and our co-founders are closely tied to the surfing community there. We became personally connected to Sustainable Surf/SeaTrees, and before long our connection evolved to provide technical and strategic support for their Salesforce org.</p>\n<p class="MsoNormal">Our work together has been both process- and data-driven, including:</p>\n<p class="MsoListParagraphCxSpFirst" style="padding-left: 40px;"><span style="font-family: Symbol;">·        </span>Building complex data architecture in Salesforce using custom objects and flows to accurately track real-time, project-based inventory</p>\n<p class="MsoListParagraphCxSpMiddle" style="padding-left: 40px;"><span style="font-family: Symbol;">·        </span>Creating reports (as a foundation for future dashboards) to track accomplishments and forecast inventory needs</p>\n<p class="MsoListParagraphCxSpMiddle" style="padding-left: 40px;"><span style="font-family: Symbol;">·        </span>Cleaning data in both accounts and opportunities to support the new data structure</p>\n<p class="MsoListParagraphCxSpLast" style="padding-left: 40px;"><span style="font-family: Symbol;">·        </span>Working closely with SeaTrees to drive general operational and process improvement within the framework of the new data structure</p>',
          },
          projectBoundariesData: {
            rightStatus: "$20,000-$40,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#FFAD01",
          primaryfont: "Cabin",
          primarycolor: "#FFAD01",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "SeaTrees is a program of the 501(c)3 non-profit Sustainable Surf that plants, protects, and restores blue carbon coastal ecosystems around the world to reverse climate change. They develop coastal restoration projects, also known as blue carbon projects, across five ecosystem types: mangrove forests, kelp forests, seagrass meadows, coral reefs, and coastal watersheds.\n\nSeaTrees funds this work through donations from brands and individuals who are committed to reversing climate change, and creating sustainable livelihoods for local communities. They partner with local nonprofit organizations at each project location to manage the restoration and protection work being done, providing a vast array of critical benefits to both the people and environment.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PzNEAV_nFOn80bQRP",
            introductionMoment:
              "Agency73's background is closely connected to surfing: our office is just minutes from the beach in Southern California, and our co-founders frequently spend time our in nature, including surfing. We made a personal connection with some of the team at Sustainable Surf (www.sustainablesurf.org), an organization that uses the global appeal of Surf culture to protect ocean health and reverse climate change through two core programs, ECOBOARD (ecoboard.sustainablesurf.org) and SeaTrees (www.sea-trees.org).\n\nBoth Agency73 and Sustainable Surf are right at the intersection of surfing and business technology, and we instantly saw an opportunity to work together to advance SeaTrees' mission of reversing climate change. In addition to providing strategic consulting, as part of our commitment to environmental and social impact projects, Agency73 is now also an official brand partner of SeaTrees, pledging a portion of our project revenue and connecting the team to new opportunities in the region.",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5RA8EAN_bndW8rR5C",
            eurekaMoment:
              "As a quickly growing nonprofit, Sustainable Surf/SeaTrees approached Agency73 with a challenge. To reach their goal of 100 projects by 2030, they saw the need to create a process that integrated their tech stack and helped them manage operations more effectively at scale. They were already using Salesforce, but recognized that they needed large structural improvements toward inventory management, impact reporting, and forecasting.\n\nAgency73's Salesforce consultants, Emily Adamiec and Bryce Cason, heard their challenge and acknowledged that technology can be a powerful tool, but the business processes that lean on that technology are just as critical. We immediately saw an opportunity to audit how data is gathered from project partners, and we proposed a new process leveraging two new custom objects points: transactions and projects. Both custom objects fit into a more advanced, custom data model leveraging cleaned historical data and SeaTrees' existing Quickbooks integration.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5VN1EAN_D8stGmQ5h",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Sales Cloud",
              "Salesforce Lightning",
              "QuickBooks",
            ],
            Timeline: ["3-4 Months"],
            Budget: ["$20,000-$40,000"],
            Industry: ["Nonprofit"],
            Company: ["Agency73"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5VN1EAN_D8stGmQ5h",
      fav_image: "",
      contact_us: "https://www.agency73.com/contact",
      account_description: "",
    },
    {
      title: "Edge",
      teamId: "0016g00002QFr4EAAT",
      stories: [
        {
          website: "https://solvingit.com/salesforce-consulting/",
          valueSectionsData: [
            {
              heading: "SRW Products Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Rootstock was implemented over a 2 year time frame, thus allowing the ability to capture the data model necessary for storing Price Sheets natively to Salesforce.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "SRW Products Price Sheets",
            table: [
              {
                valueName: "SRW Products",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Manufacturing",
                keyName: "INDUSTRY",
              },
              {
                valueName: "3-4 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5k1lEAB_hiEwdB_zz2",
            layout: "Original",
            description:
              "<p>Solving IT Edge built a custom generated Price Sheet Document utilizing a native ERP (Rootstock), Salesforce, and FormStack. </p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSGn_x_ohH4aCa",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHC_0XvOIzWgr",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/meganwinterland/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Director",
              name: "Megan Winterland",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hawEAB_oOdaj0mlm",
            },
            {
              serviceLink: "https://www.linkedin.com/in/lizalemkuil/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Consultant",
              name: "Liza Lemkuil",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hb1EAB_8nAg8TqKqM",
            },
            {
              serviceLink: "https://www.linkedin.com/in/austinpappas/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Business Analyst",
              name: "Austin Pappas",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hb6EAB_dnIE0gJA7G",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hWBEAZ_lFH33I5kob",
          storyId: "a006g00000o7ns1AAA",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#0A2240",
          secondaryfont: "Sofia-pro",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "SRW Products Price Sheets",
            teamSize: null,
            paragraph2:
              "<p>Solving IT Edge built a custom generated Price Sheet Document utilizing a native ERP (Rootstock), Salesforce, and FormStack. </p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hdbEAB_kxnvSZqM4",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Our hardscape manufacturing client, SRW Products, was facing a time-consuming problem year over year. Every customer is offered a unique pricing structure annually, based on volume and group based discounts. This meant spending 100+ hours manually generating Excel spreadsheets outlining pricing per customer for a catalog of over 1,300 products. Not only was this costly from a time and resource perspective, but it also meant that customer pricing was not easily accessible to the Sales team.</p>\n<p>With the introduction of Rootstock, a Salesforce native ERP solution, we were able to capture the framework and data model for storing price sheets directly in Salesforce. Using a combination of the data model, custom development, and Formstack, we are now able to generate multiple versions of price sheets with a click of a button.</p>\n<p>As a result, both the Sales and Operations team are saving 70+ hours annually. This time is now dedicated to high-value and revenue-producing activities.</p>\n<p> </p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#EE7624",
          primaryfont: "Sofia-pro",
          primarycolor: "#0A2240",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "SRW Products is a family owned and operated business with 30 years of experience and leadership in hardscape and concrete products. We have earned a solid reputation for providing exceptional quality products and outstanding customer service. Our dealer-based company continues to grow with the commitment of our team as we remain both innovative and comprehensive in our product base.",
          },
          metadataname:
            "Streamlining Price Sheet Generation: A Success Story with SRW Products and Edge",
          metadatadescription:
            "Discover how Solving IT Edge helped SRW Products optimize their pricing process and improve efficiency with their innovative solution for price sheet generation. Read our customer success story now to learn more.",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hcsEAB_UbE4sd6Qa",
            momentOfTrust:
              "Solving IT has had a long-standing relationship with SRW, primarily focused on Sales Cloud and Pardot enhancements, strategic projects, and maintenance. The pain around price sheets had long been a topic of conversation. After the implementation of Rootstock, Solving IT invested our own time to gain a deeper understanding of the data model and overall functionality to best understand how it could be leveraged for cost savings, time savings, up-sell/cross-sell, etc. Once the solution approach was determined, we also became a certified Formstack Partner. Through this collaborative approach, coupled with a clear and easy to understand explanation of the solution + ongoing gathering of feedback, we were able to gain validation and establish the trust needed to proceed with the project. Finally, we made sure to provide excellent customer support and follow-up after the solution was implemented.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hdMEAR_9muPrh809",
            eurekaMoment:
              "Much of the hesitation around this project stemmed from the complexity of the Rootstock data model. There were unknowns around how it would be leveraged to capture price sheets in a way that would not have adverse impacts to other process(es), such as Sales Orders, Invoicing, etc. After walking through the end-to-end process in granular detail, we mapped out every aspect of the logic that would be needed in order to generate the document. A substantial amount of time up-front was spent gathering requirements in order to put together a matrix mapping out each product to the different mechanisms for capturing a specific customer's special pricing and the logic for calculating price in the document. It was in this moment that we realized the art of the possible could become reality. In walking the client through the mapping and document logic, we received confirmation that the requirements had been correctly understood and captured to fully validate our solution.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hZtEAJ_ilQO0OZAO",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Formstack", "RootStock", "Salesforce Sales Cloud"],
            Timeline: ["3-4 Months"],
            Budget: [null],
            Industry: ["Manufacturing"],
            Company: ["Edge"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Great technoligy consulting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hZtEAJ_ilQO0OZAO",
      fav_image: "",
      contact_us: "https://solvingit.com/salesforce-consulting/",
      account_description: "Great technoligy consulting",
    },
    {
      title: "Flok Consulting",
      teamId: "0016g00002ODbo2AAD",
      stories: [
        {
          website: "https://floksalesforceconsulting.com/",
          valueSectionsData: [
            {
              heading: "ODHP - OMC Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "The IDHP's OMC program needed to deliver critical services to patients but relied too many disparate systems to create a seamless integration. Staff and patients alike were frustrated.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Salesforce as the Hub of a Complex Medical Program",
            table: [
              {
                valueName: "ODHP - OMC",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Healthcare & Life Sciences",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "5",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZM8wEAH_Xlek2oKe6",
            layout: "Original",
            description:
              "<p>Flok Consulting helped the Iowa Department of Public Health automate OMC, its medical cannabidiol program, with an integrated Salesforce-based platform, achieving among other things a 90% reduction in patient registrations and a traceable, transparent supply chain</p>",
          },
          testimonialsData: [
            {
              industry: "IDPH mCBD Project Manager",
              description:
                "This week we focused on Salesforce automation of registrations and achieved a 50% reduction in labor for every application. Fantastic work with Trevor, Bobby and Kelly collaborating together. They will continue to seek optimization opportunities using the power of Salesforce workflows.”",
              author: "Doug Cretsinger",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIA_ndHJSLvMN",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJomEAH_iE0qUK4qt",
          ],
          teamProfilesData: [
            {
              serviceLink:
                "https://www.linkedin.com/in/drew-benson-pmp-58244418/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Drew Benson",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJgaEAH_W-xqsvxrFf",
            },
            {
              serviceLink: "https://www.linkedin.com/in/davidheller3/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Consultant",
              name: "David Heller",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJg6EAH_nOyvD3ioS",
            },
            {
              serviceLink: "https://www.linkedin.com/in/juliaccannon/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Project Manager",
              name: "Julia Cannon",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJgLEAX_b07FYNHsN",
            },
            {
              serviceLink: "https://www.linkedin.com/in/meganbensonflok/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Consultant",
              name: "Megan Benson",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJgQEAX_nwovcnOk7",
            },
            {
              serviceLink: "https://www.linkedin.com/in/bradwarren/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Technical Architect",
              name: "Brad Warren",
              index: 5,
              dpSrc: "",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJu6EAH_a8hyTQ4Wy",
          storyId: "a006g00000o7pDCAAY",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#494C50",
          secondaryfontcolor: "#494C50",
          secondaryfont: "PT Sans",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "Salesforce as the Hub of a Complex Medical Program",
            teamSize: null,
            paragraph2:
              "<p>Flok Consulting helped the Iowa Department of Public Health automate OMC, its medical cannabidiol program, with an integrated Salesforce-based platform, achieving among other things a 90% reduction in patient registrations and a traceable, transparent supply chain</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZK3BEAX_-ndi7PoktD",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>The Office of Medical Cannabidiol (OMC) at the Iowa Department of Public Health was faced with significant challenges in managing and tracking compliance across a complex supply chain involving multiple manufacturers, dispensaries, physicians, and patients. Patient applications and compliance tracking were manual and time-consuming, with frequent on-site audits required.<br><br>Doug Cretsinger and others at IDHP expressed frustration about the manual patient application process, the diverse systems used by manufacturers and dispensaries, and the lack of a comprehensive system for compliance tracking and oversight.</p>\n<p>After a series of conversations between Doug and Flok project leads Drew Benson and David Heller, Flok Consulting recommended the implementation of Salesforce&#39;s Sales Cloud, Sites, Ostrij integration, and Cloud4J reporting. <br><br>This architecture accomplished several things for IDPH. First, it allowed for a fully automated supply chain system for the OMC program for the first time. Using standard OOB configuration features of Salesforce, the patient registration process, compliance tracking, and program reporting were fully automated and centralized.</p>\n<p>Compliance is also important to a sensitive research area such as medical cannibidol. Leaning heavily on the expertise of Flok solutions consultant David Heller, Flow ensured that the data gathered and managed via the Salesforce implementation allowed for full &quot;lot traceability&quot; over the entire manufacturer to patient cycle. This meant that every step of the medical cannabidiol supply chain, from the manufacturer to the patient, was carefully tracked and recorded using Salesforce. </p>\n<p>Given the medical context, it was also important that the system be highly available; here Flok relied on Flok COO Megan Benson&#39;s expertise with Ostrij. Ostrij is a unique product that can &quot;monitor the heartbeat&quot;, so to speak, of a Salesforce implementation - and send text alerts in the case of downtime or significant slowdowns. </p>\n<p>When you put all the pieces of the puzzle together, the outcome was a reduction in patient registration overhead from 15-20 minutes per paper application to 2 minutes per application, a 90% reduction in time spent, and an accurate on-hand inventory as well as awareness of product diversion, virtually eliminating the need for on-site audits. The program reporting and analytics are being used to direct the future of the program.<br><br>Or as Doug Cretsinger: &quot;We have built a very powerful MFR, DISP and Registration tracking system that is now purring like a kitten.&quot;<br><br>That&#39;s not a minor accomplishment when you consider all the data sources working in sync:</p>\n<ul><li>Salesforce Sales Cloud</li><li>Salesforce Sites</li><li>Ostrij integration tool</li><li>Cloud4J reporting tool</li><li>Various Manufacturer ERPs (integrated via endpoints)</li><li>2 Dispensary POS systems (integrated via endpoints)</li><li>USBank Payment System (integrated via endpoints)</li><li>Iowa DOT (integrated via endpoints)</li><li>Box (integrated via endpoints)</li><li>AdobeSign (integrated via endpoints)</li></ul>\n<p>We&#39;re especially  proud of the reporting capacity of Cloud4J, which is equivalent in capability to Tableau but simpler to implement.<br><br>We think the core formulation - Salesforce, Ostrij, Cloud4J - can change the way that compliance-sensitive medical supply chains are managed, analyzed, and equipped to provide value to patients.<br><br></p>",
          },
          projectBoundariesData: {
            rightStatus: "$300,000-$450,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#494950",
          primaryfont: "PT Sans",
          primarycolor: "#A0B4B7",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText: ".",
          },
          metadataname: "Flok Makes Medical Research Possible for the IDPH",
          metadatadescription:
            "Flok leveraged deep expertise in Salesforce cloud and Salesforce integration to set the foundation for advanced scientific research program that finally became possible",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJrREAX_zU0d6Qhwy",
            roiMoment:
              "Objectively speaking, the ROI moment happened the instant that we deployed the platform. Sure there were bugs to work out, but we saw OMC staff work-days instantly transformed - also for patients. Rather than wading through 20 minutes of confusion, patients were registering for the program in 2 minutes. Rather than having to constantly arrange field visits to manufacturers, OMC staff had the real-time data they needed to manage supplier compliance from their laptops. Many other laborious workflows are waiting to be cut down, now that the platform is in place. The sense of satisfaction all around, at Flok, at OMC and throughout IDHP, and most of all for patients was immediately transforming and gratifying.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJrHEAX_7J0i8QtYB",
            ribbonCuttingMoment:
              'We want to highlight the role of our remarkable project manager Julia Cannon in the ribbon cutting moment. Like many PMs, Julie is mult-talented. She not only manage the progress of a half a dozen coordinated efforts but led the training efforts as well. Under her direction, the Flok Consulting team provided comprehensive training and support to the IDHP\'s OMC team prior to launch. This ensured OMC was fully prepared to use the new system. The launch was successful and the OMC reported a "a smooth, calm and seamless transition"',
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJr7EAH_JyenaxEFf",
            momentOfTrust:
              "Flok Consulting established a strong rapport with the Office of Medical Cannabidiol through open communication, active listening, and a shared commitment to achieving their goals. But that's not when the moment of trust happened - that happened when IDHP realized that not only did Flok understand how crucial this system was but they had actually created one of its core components - Ostrij. Ostrij monitors not just Salesforce, but the entire implementation. It checks to make sure that each part of the systems indicated as specified and lets stakeholders know whenever that's not the case. This is critical for patient well-being and compliance. Once IDHP fully appreciated this piece, after just a few early meetings trust was locked in.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJrCEAX_nqXo_gjH9",
            eurekaMoment:
              "Flok doesn't shy away from heavily integrated solution. And it knew it would have to integate multiple cannibinoid manufacturer ERP systems into the final solution. The original assumption was that IDHP's native supply chain management system would handle the lot-tracing duties pulling on that manufacturer data. But while speaking with a colleague  and fellow consultancy-owner in his mastermind group,  Drew realized that Salesforce had been used as the hub of multiple supply chains, from Virgin Atlantic, to Univar, to GE Aviation. The use case at GE was really the same in terms of compliance - the parts that make up a commercial airliner must be accounted for and traceable. The lightbulb went off and at the moment, Drew knew that Salesforce would be the hub of IDHP's supply chain.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJuQEAX_e9Oz2IAhi",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce", "Adobe eSign", "Cloud4J"],
            Timeline: ["5-7 Months"],
            Budget: ["$300,000-$450,000"],
            Industry: ["Healthcare & Life Sciences"],
            Company: ["Flok Consulting"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Great tech consultancy",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000EZJuQEAX_e9Oz2IAhi",
      fav_image: "",
      contact_us:
        "https://floksalesforceconsulting.com/pages/contact-flok-consulting",
      account_description: "Great tech consultancy",
    },
    {
      title: "Bigger Boat Consulting",
      teamId: "0016g00002ODNLnAAP",
      stories: [
        {
          website: "https://biggerboatconsulting.com/",
          valueSectionsData: [
            {
              heading: "Housing Connector Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Housing Connector's vision is that no unit should sit vacant while there are individuals in need of homes. Their model is different from the traditional service provider, as they tap into existing inventory to make them accessible to people in need rather than building new dedicated housing. Salesforce and Tableau provide them with the tools to manage property managers, community partners, and residents across multiple markets.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title: "Housing Connector",
            table: [
              {
                valueName: "Housing Connector",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Nonprofit",
                keyName: "INDUSTRY",
              },
              {
                valueName: "7-12 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "1",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hVDEAZ_ex1jYdF0V",
            layout: "Original",
            description:
              "<p>Salesforce and Tableau power Housing Connector&#39;s partnerships with property managers, helping to overcome barriers to housing for people exiting homelessness.</p>",
          },
          testimonialsData: [
            {
              industry: "Executive Director",
              description:
                "The Bigger Boat team is a true business partner who comes alongside your org and understands the needs and nuances to help craft solutions that are sustainable and deliver results. I can’t say enough good things about this experience. As a small startup, this was one of the best investments we have made.",
              author: "Shkelqim Kelmandi",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSI0_f3yqA6PFOl",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Consulting Team Business Leader",
              name: "Brad Struss",
              index: 1,
              dpSrc: "",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hVwEAJ_uOmtYAmzHs",
          storyId: "a006g00000o7pbHAAQ",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#ffffff",
          secondaryfontcolor: "#000000",
          secondaryfont: "Ariel",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title: "Housing Connector",
            teamSize: null,
            paragraph2:
              "<p>Salesforce and Tableau power Housing Connector&#39;s partnerships with property managers, helping to overcome barriers to housing for people exiting homelessness.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5hWVEAZ_TWglAyW8Hu",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              '<p><strong>Problem</strong></p>\n<p>At first, Housing Connector used Excel and Google Sheets copiously to capture their data relationships. Executive Director Skëlqim Kelmendi said, “Over time, these Excel books [spreadsheets] transformed into the blueprint of our current infrastructure.” Soon, they outgrew these methods. The team turned to the customer relationship management (CRM) system Salesforce.</p>\n<p>Architect Frank Lloyd Wright once said, “To know what to leave out and what to put in, just where and just how—Ah, that is to have been educated in knowledge of simplicity.” Indeed, a simple foundation is typically the result of focused choices. The elegant Salesforce architecture is the fruit of a close partnership between Housing Connector and Salesforce implementation firm Bigger Boat Consulting. Bigger Boat’s Seattle-based consultants specialize in implementing Salesforce systems for human services and affordable housing organizations. </p>\n<p>Together, the Housing Connector and Bigger Boat implementation teams mapped out both immediate Salesforce needs and future requirements to fulfill Housing Connector’s ultimate goal of a national organization with thousands of partners. </p>\n<p>Kelmendi called out some of his favorite highlights of the implementation process: keeping object relationships in the system clean and logical, a one-third focus on Salesforce training so his team could become “active participants in the solution and not merely passengers,” and putting the big, foundational rocks in place before starting on additional features.</p>\n<p>Doug Minkler, Senior Manager of Product and Technology, was brought in after the initial Salesforce implementation, in part, to help maintain and enhance the team’s system. Minkler serves as Housing Connector’s systems administrator and translator of business needs into technical requirements, as well as their data and analytics manager. He learned to navigate the Salesforce system after it was already built, adding to its design. From that vantage point, he was able to appreciate the value of its deceptively simple data architecture.</p>\n<p><strong>Lessons Learned</strong></p>\n<p>How can your organization replicate Housing Connector’s system success?</p>\n<ol><li><strong>Understand your organization’s current processes, infrastructure, and friction points.</strong> Take stock of what is vital to have and what facilitates effective business processes.</li><li><strong>Think through object and entity relationships. </strong>How do your data points relate to each other? Which are essential to track and what processes are built around them?</li><li><strong>Start simple. </strong>Get the fundamentals right before any accessories, and you can grow quickly with add-ons and automations. Those add-ons often make existing processes more efficient as opposed to being net new functions. </li><li><strong>Invest in a great consulting partner. </strong>They will help you think through these questions and get your team up to speed on the system that they and your organization designed together.</li><li><strong>Invest in both a project lead for your system and a Salesforce admin.</strong> These may be the same person or <a href="https://biggerboatconsulting.com/making-the-project-team/" target="_blank">they could be different</a>. Make sure to give the admin significant dedicated time. They will be key to your long-term success.</li></ol>\n<p><strong>Outcome</strong></p>\n<p>Housing Connector has housed and supported over 2,700 individuals while helping property owners rent out vacancies. Their system supports their daily program work and iterations to that work provide them and their partners with organized data to drive better decisions and automates labor wherever possible. </p>\n<p>Doug Minkler reflected, “Without Salesforce we would be stuck back in the days of spreadsheets and endless copying and pasting. Very little about our infrastructure two years ago could have handled the quantity and complexity of data, outputs, and partner engagements that we conduct today.” </p>',
          },
          projectBoundariesData: {
            rightStatus: "$20,000-$40,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#37393A",
          primaryfont: "Verdana",
          primarycolor: "#147C9F",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Housing Connector provides financial support and risk mitigation against losses for property owners, reducing the uncertainty of renting to tenants with blemishes on their record. In return, those owners lower or eliminate screening criteria, increasing the accessible supply of housing.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5moDEAR_Iw_lVwuNE",
            roiMoment:
              "Housing Connector has housed and supported over 2,700 individuals while helping property owners rent out vacancies. Since the start of this project they have expanded from Seattle to Tacoma, Denver, and Dallas. Their team has grown in size from 4 staff members to 19.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5gW2EAJ_ibFqxEXSK",
            ribbonCuttingMoment:
              "Seeing the impact of their work in clean and simple dashboards.",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust:
              "We selected Bigger Boat because of their commitment to social impact and their desire to help us achieve our vision, as opposed to coming into the relationship with a preconceived idea of what should be done. As part of this, they were willing and excited to not only help us design and implement our Salesforce solution but also to provide us the training and support to become self-sufficient at using and enhancing the technology.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage: "",
            eurekaMoment:
              "Bigger Boat strategically boiled down Housing Connector’s core processes to a core set of custom and standard objects in the system. This made their Salesforce foundation both easy and solid to build on top of: “It’s accounts, contacts, tenancies, cases, properties, and opportunities to track property and community partners. And really, those are the key. All features are built on the basis of those objects and their relationships. So it’s really clean to keep track of just six objects. Building analytical products, building flows, and anything, really, it’s quite simple and straightforward.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000003Fz7G_TUFW2W7S8j",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: ["Salesforce Sales Cloud", "Tableau CRM"],
            Timeline: ["7-12 Months"],
            Budget: ["$20,000-$40,000"],
            Industry: ["Nonprofit"],
            Company: ["Bigger Boat Consulting"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description:
            "Custom Salesforce program and case management solutions for human services and affordable housing nonprofits.",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000003Fz7G_TUFW2W7S8j",
      fav_image: "",
      contact_us: "https://biggerboatconsulting.com/contact/",
      account_description:
        "Custom Salesforce program and case management solutions for human services and affordable housing nonprofits.",
    },
    {
      title: "Incapsulate",
      teamId: "0016g00002IOiT1AAL",
      stories: [
        {
          website: "https://www.incapsulate.com/",
          valueSectionsData: [
            {
              heading: "Assured Partners Culture",
              description:
                "Fast paced technology focused organization that is rapidly growing via acquisitions. Determined to transform the insurance brokerage space with technology, data and repeatable business processes.",
            },
            {
              heading: "Why Now",
              description:
                "Having grown rapidly, the time was ripe for providing the broker community with a best-in-class sales platform and propel them to adopt digital in a big way and help sell more.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Assured Partners Insurance Revenue Projections Transformed on Salesforce",
            table: [
              {
                valueName: "Assured Partners",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Financial Services",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Over a year",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "12",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FwBDJEA3_Q5GAGQc5W",
            layout: "Original",
            description:
              "<p>Assured Partners had cultivated a large and unique audience of brokerage business but was not capitalizing on it. BizDev was inconsistent and disjointed - and not supported with the right technology. They turned to Incapsulate for answers and got an intuitive and highly automated revenue infrastructure, freeing up Assured Partners to focus on selling.</p>",
          },
          testimonialsData: [
            {
              industry: "",
              description: "",
              author: " ",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZQfa_9HBaGOu3U",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSHr_jB1o2br-O",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSI0_f3yqA6PFOl",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FUJ0HEAX_9GxL-Rju1",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fvju2EAB_C6AsOeke0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIe_nIzXPTLoo",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Engagement Manager",
              name: "Avik Roy",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GMdSeEAL_OYRP3141Y",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "Davis Prince",
              index: 2,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Delivery Manager",
              name: "Hema Dalwadi",
              index: 3,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Business Analyst",
              name: "Rupal Panchal",
              index: 4,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Database Developer",
              name: "Sai Pilla",
              index: 5,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Shubham Shendage",
              index: 6,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Vishal Vaghadia",
              index: 7,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "SaiKrishna Nukala",
              index: 8,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Developer",
              name: "Hetvi Shah",
              index: 9,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Technical Architect",
              name: "Tejaswini Pathak",
              index: 10,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Technical Architect",
              name: "Qamar Islam",
              index: 11,
              dpSrc: "",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Senior Business Analyst",
              name: "Sushma Tiwari",
              index: 12,
              dpSrc: "",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000GLInvEAH_pKsecmqGX",
          storyId: "a006g00000pGaoZAAS",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#000000",
          secondaryfontcolor: "#7F7F7F",
          secondaryfont: "Helvetica Neue Normal",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Assured Partners Insurance Revenue Projections Transformed on Salesforce",
            teamSize: 0,
            paragraph2:
              "<p>Assured Partners had cultivated a large and unique audience of brokerage business but was not capitalizing on it. BizDev was inconsistent and disjointed - and not supported with the right technology. They turned to Incapsulate for answers and got an intuitive and highly automated revenue infrastructure, freeing up Assured Partners to focus on selling.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fw5OqEAJ_W5OItaiEu",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p><strong>Core Problems</strong></p>\n<p>The strategic objective of Assured Partners (AP) is to offer the best tools and technology for brokerages and their end customers. Having grown through acquisitions, however, 100s of different “producers” (brokerages) were using a variety of different technology and business processes. Moreover, the organization lacked unified reporting and analytics.</p>\n<p>Some of the key challenges included ensuring that the system supports disparate agencies that operate in many different regions, sell different products, sell to different markets, and have different business processes. The core challenge was to provide a blueprint that is general enough to work for all but consistent enough to enable meaningful analytics, dashboards, and reporting.</p>\n<p> </p>\n<p><strong>Solution Design</strong></p>\n<p>The solution was a best-in-class sales &amp; marketing platform that turbocharges sales through the integration of 30 instances of 3 different Agency Management Systems as well as the integration of other key 3rd party data providers across 300 agencies. Codesigned by AP and Incapsulate, this solution brings critical data to 1500 sales producers, sales leaders, and industry specialists enabling them to provide the appropriate coverage at the appropriate cost with an outstanding user experience. Integrations enable producers to have mobile access to their most important data including policies of new business.</p>\n<p>Features include omni-channel access, Outlook integration, and dashboards. Key tools included outside of the Salesforce product line were LinkedIn Sales Navigator, Zoom Info, and MuleSoft. Other tools include Snowflake for data warehouse, Okta for SSO, and Azure DevOps for CI/CD.</p>\n<p> </p>\n<p><strong>The Results</strong></p>\n<p>With an adoption rate of virtually 100%, 1,200+ producers are using the system daily. This has resulted in increased cross-selling, an improved renewal process, and improved analytics. With a 360-degree customer view, producers can leverage industry specialists and gain deeper insights into the sales process. Improved analytics and dashboards enable sales leaders to better coach emerging producers. Risk is reduced dramatically by retiring systems and reducing technical debt. In addition, the strategy for implementation minimizes custom-coded solutions and other forms of technical debt. Operational expenses are reduced by eliminating duplicate data entry, automating key tasks, and using analytics and insights to focus business processes.</p>\n<p>Other benefits include dramatically improved forecasting, a consistent yet flexible sales process, the ability to accelerate the development of new agents, and faster onboarding of new agencies.</p>\n<p>Together these result in more sales, better service, and improved operating margins. AssuredPartners expects revenue growth of greater than $1 billion over the next several years while realizing efficiency gains and cost savings.</p>",
          },
          projectBoundariesData: {
            rightStatus: ">$1,000,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#3B3B3B",
          primaryfont: "Helvetica Neue Normal",
          primarycolor: "#FD3168",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Founded in 2011, AssuredPartners (AP) is the fastest-growing independent insurance agency in the USA. With offices in 38 states and four countries, AP is one of the largest brokers in the nation. AP has acquired approximately 50 agencies annually in recent years. This rapid growth presented business opportunities and challenges which could be best addressed by implementing a state of the art cloud-based sales and marketing system.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fw6DMEAZ_TbJSoq3d1",
            roiMoment:
              "Since its launch, users have been flocking to the platform. Seeing them manage their business and sales leaders using the system to run their day-to-day operations and making decisions based on real-time data inspires the team as they build out other enhancements. The rollout was phased and having users wanting to be part of the rollout much earlier than their scheduled date only reinforces how well the user community has received the system.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fw6CJEAZ_Mr1hkJdin",
            ribbonCuttingMoment:
              'Given the rollout challenge to over 1200 brokers, we had super champs from the user group and established a great rapport with them. Key to this was having a training ground for the super champs to see the system getting built incrementally and taking this to the broader groups through the sprint demos. Incorporating user feedback meant the implementation team was part of the more prominent family willing to listen and provide value. Post-go-live was handled through a "War Room" setup providing 24-hour support with a hotline for direct conversation with the team to troubleshoot user issues. Users felt cared for during this phase and gained trust in the solution, as we resolved issues with the urgency they deserved.',
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fw69BEAR_p6l1bLkoU",
            redMoment:
              "AP realized they needed to get policy data into Salesforce. The data was not of great quality and needed to tie back to the opportunities created by the brokers upon closure and also to the account. A MuleSoft-based solution was proposed which connected with the client's Snowflake-based data warehouse. Policy data ensured the broker's book of business gets established paving the foundations for the renewal workflow for a later day. An offshore-based data operations team was established to clean data on an ongoing basis ensuring data quality improves progressively.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fw6AmEAJ_zvCE2kq98",
            momentOfTrust:
              "Incapsulate has executed projects for a wide variety of clients in the insurance domain, from carriers to brokers to insurance platform players. This experience showed in our early conversations with AP, where from the very first moment, it was established that we understood the business model. Anecdotes from past projects broke the ice and we quickly came to appreciate what everyone could bring to this project from both sides of the table.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fw6BkEAJ_PNHFO3XkC",
            eurekaMoment:
              "​​Two particular moments come to mind. One was where AP expressed the desire to sell as a team and our minds quickly jumped to Opportunity Teams and Account Teams.v The other was where AP expressed a conflict: brokers treat their sales data with sensitivity and want to protect it, yet management wants company-wide visibility into that same data.  Incapsulate solved this by establishing the sharing model via Salesforce's “Sharing Rules” and modeling the agencies as roles in the “Role Hierarchy”. This quickly solved the issue - giving management access to what they wanted while protecting the brokers from unauthorized sales data access.",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000Fw6CsEAJ_CAXnSTlyM1",
            dealClarityMoment:
              "Aligning on scope is perhaps the most important aspect of any project.  Incaspulate has a process to address this challenge, starting with interviewing all key business and technology stakeholders during the scoping cycle.  This yields a planning document that contains the major project phases and the high-level user stories - along with assumptions, design notes, constraints, and any non-functional requirements. This document forms the basis for aligning on the scope. Incapsulate does discovery for multiple weeks and compares the scope document with the requirements from the discovery sessions. We align on the comparative analysis and chart the path forward.",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FUP40EAH_rDGjC19OtP",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Sales Cloud",
              "MuleSoft",
              "ZoomInfo",
              "Tableau CRM",
              "Snowflake",
              "LinkedIn Sales Navigator",
              "Salesforce Financial Services Cloud",
            ],
            Timeline: ["Over a year"],
            Budget: [">$1,000,000"],
            Industry: ["Financial Services"],
            Company: ["Incapsulate"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description:
            "Focused on Financial Services, Public Sector, and Commercial Enterprise we achieve a high return on investment for your digital transformation goals.",
          calendlyLink: "https://brightr.io/meet-with-davis-prince",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000FUP40EAH_rDGjC19OtP",
      fav_image: "",
      contact_us: "https://www.incapsulate.com/contact",
      account_description:
        "Focused on Financial Services, Public Sector, and Commercial Enterprise we achieve a high return on investment for your digital transformation goals.",
    },
    {
      title: "DoubleTrack",
      teamId: "001Nu00000AeiiwIAB",
      stories: [
        {
          website: "https://www.doubletrack.com/",
          valueSectionsData: [
            {
              heading: "FlexiVan Culture",
              description:
                "FlexiVan strives to stay on the leading edge of the market while continuing to disrupt the industry with innovative products and superior customer service.",
            },
            {
              heading: "Why Now",
              description:
                "With explosive growth, they needed to upgrade their entire quote-to-cash process to keep up with significant demand increases. Being a market leader demands that all customer interactions - from pre-sale to ongoing support - reflect the commitment to the customer.",
            },
            {
              heading: "Other Things to Note",
              description:
                "FlexiVan merged with American Intermodal Management (AIM) in 2020, providing added value to customers with best-in-class visibility into their entire chassis fleet and with real-time location and status monitoring.",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "FlexiVan Saved $1 Million Annually in SG&A Through Revenue Cloud",
            table: [
              {
                valueName: "FlexiVan",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Manufacturing",
                keyName: "INDUSTRY",
              },
              {
                valueName: "7-12 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "4",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000009tZ9dMAE_mfRcM5iK8",
            layout: "Original",
            description:
              "<p>The national leader in chassis leasing, FlexiVan, earned massive savings that allowed them to invest more robustly throughout its business. How? Through an optimal CPQ and Revenue Cloud insfrastructure that reduced time-to-quote by 65% and approval time by 80%, which accelerated cash flow.</p>",
          },
          testimonialsData: [
            {
              industry: "Vice President, Strategic Products & Services",
              description:
                "The onboarding process was excellent and DoubleTrack delivered Our resources are now more efficiently deployed, and we've saved $1 million annually in efficiency savings.",
              author: "Sean O'Shea",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIK_f96dEnyTsD",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzZ_QWG5BL1919",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000A6YkPMAV_Xt6_4NpEJ",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/johnsoal/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Head of Client Services",
              name: "Adam Johnson",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000009CGdKMAW_nqyks_puby",
            },
            {
              serviceLink: "https://www.linkedin.com/in/colbykamin/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Head of Innovation",
              name: "Colby Kamin",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000009CI7GMAW_iFe4wcfY3",
            },
            {
              serviceLink: "https://www.linkedin.com/in/peteryurchision/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Head of Client Services",
              name: "Pete Yurchision",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000009CMQzMAO_Dw27uZG2n",
            },
            {
              serviceLink: "https://www.linkedin.com/in/ericheine",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Executive Officer",
              name: "Eric Heine",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000009CMijMAG_Mka_Cegn2C",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000009ESldMAG_b_91SDu_-9",
          storyId: "a00Nu00000BwB6QIAV",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#000000",
          secondaryfont: "Helvetica",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "FlexiVan Saved $1 Million Annually in SG&A Through Revenue Cloud",
            teamSize: 6,
            paragraph2:
              "<p>The national leader in chassis leasing, FlexiVan, earned massive savings that allowed them to invest more robustly throughout its business. How? Through an optimal CPQ and Revenue Cloud insfrastructure that reduced time-to-quote by 65% and approval time by 80%, which accelerated cash flow.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AEAHuMAP_InGcU1Ff2",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>It was time to evolve.</p>\n<p>FlexiVan had robust growth and a healthy market, but existing processes internally were feeling the strain of added demand. They needed to revolutionize how Sales, Customer Support, Operations, and Finance all worked <em>together</em> - especially with a catalogue of 120,000+ available chassis designs for prospects and customers to choose from.</p>\n<p>As customer demands grew, underlying systems needed to keep up, starting with their quote-to-cash process. Enter: Salesforce CPQ, Revenue Cloud, and DoubleTrack.</p>\n<p>Through multiple engagements, they upgraded existing processes ranging from pricing that encompassed products, markets, and available terms to migration of legacy data into optimal formats. This allowed the right data to flow to teams that needed it in a format that was easy to understand - and made it far simpler for the Sales team to give prospects and customers exactly what they wanted.</p>\n<p> </p>\n<p> </p>",
          },
          projectBoundariesData: {
            rightStatus: "$300,000-$450,000",
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#E8C447",
          primaryfont: "Arial",
          primarycolor: "#032E4A",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "FlexiVan is the national leader in chassis leasing, with 120,000+ available chassis for a wide range of uses available at 200+ locations throughout the USA.",
          },
          metadataname:
            "Flexi-Van Upgraded Its Quote-To-Cash Process For $1 Million In SG&A Savings",
          metadatadescription:
            "Learn how Flexi-Van partnered with DoubleTrack to bolster cash flow through its Salesforce instance.",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AEDkQMAX_aIXQWjeoj",
            roiMoment:
              "After a successful implementation and ongoing Managed Services to further optimize and build upon the foundation, FlexiVan realized significant savings: $1 million in annual SG&A savings it could reinvest into other parts of the business, and also a 65% reduction in time-to-quote with greater quote accuracy. This meant more closed-won deals as Sales presented a stronger customer experience that elevated FlexiVan above competitors, while Support and Finance had accurate information anytime they needed it. All teams welcomed time savings for staff from Revenue Cloud into higher-value projects that required their full attention. Because of these gains, FlexiVan decided to continue work with DoubleTrack with additional system integrations and Managed Services to keep progress moving forward.",
            ribbonCuttingMomentImage: "",
            ribbonCuttingMoment: "",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage: "",
            momentOfTrust: "",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AEEbdMAH_rXgGa56gE",
            introductionMoment:
              "FlexiVan knew it needed to evolve. Its current quote-to-cash processes weren't able to keep up with exploding demand, and they'd locked in on Salesforce as the solution. Salesforce brought DoubleTrack in to build this right from the ground up, having extensive Revenue Cloud experience from its outset. During the initial intro call, FlexiVan appreciated the candor and willingness to speak frankly about the way to do this well and build for long-term growth, including a willingness to suggest alternatives to ideas that didn't align with their core business objectives.",
            eurekaMomentImage: "",
            eurekaMoment: "",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AECDGMA5__eWv_auWt",
            dealClarityMoment:
              "Over a span of weeks, key stakeholders from multiple teams met with DoubleTrack's team to fully map out current processes and data flows, understand what ideal use cases would be, and most importantly ... tie the project to business KPIs that mattered, a process now backed by the DoubleTrack Success Guarantee. This both aligned all times before any work began + ensured nothing was missed in the requirements stage. It also allowed for robust conversation around FlexiVan's different ideas on how to progress - and let DoubleTrack help identify what was best vs. what would detract from their goals. A client read-back of the entire process allowed final feedback and revisions by all primary stakeholders. The clarity obtained before sign-off enabled everyone to go into the project with confidence and immediately understand what was needed to move the engagement forward in their respective areas.",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000009EQAMMA4_LH_AsE-8oS",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "CPQ - Configure, Price, Quote",
              "Salesforce",
              "Salesforce Service Cloud",
              "Salesforce Revenue Cloud",
            ],
            Timeline: ["7-12 Months"],
            Budget: ["$300,000-$450,000"],
            Industry: ["Manufacturing"],
            Company: ["DoubleTrack"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "Tech Consulting",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription:
              "There's so much ROI waiting in your Salesforce instance. Prioritize the right projects and get the work done well the first time with DoubleTrack.",
            headshotUrl:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AImmnMAD_oIKiotcio",
            contactName: "Brian Dolby",
            calendlyLink:
              "https://calendly.com/doubletrack-discovery/30-min-discovery-call",
            bannerDescription:
              "See why many leave 5-star AppExchange reviews for us.",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu000009EQAMMA4_LH_AsE-8oS",
      fav_image: "",
      contact_us: "https://www.doubletrack.com/contact-us",
      account_description: "Tech Consulting",
    },
    {
      title: "StoreConnect",
      teamId: "001Nu00000CUPq8IAH",
      stories: [
        {
          website: "https://getstoreconnect.com/",
          valueSectionsData: [
            {
              heading: "Sustainable Salons Culture",
              description: "",
            },
            {
              heading: "Why Now",
              description:
                "Rewarding their paying members for recycling salon wastes is the core of the Sustainable Salons Business.  Yet, their Rewards Store was on a siloed, legacy platform and at end of life.   \n\nThey needed a new solution that would not only fill their current technology requirement, but help them grow and evolve into the future.  \n\nAfter starting their evaluation process Shopify, Magento and StoreConnect were the three solutions to make it to the final round.  \n\nUltimately StoreConnect was selected for a few reasons:  First, it worked natively with their existing CRM and rewards program logic, second it required no customised integrations and lastly, StoreConnect was the most complete and cost-effective solution presented that fulfiled both their current requirements and features they knew would assist growth in the years to come.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "How a D2C firm revitalized its rewards program on Salesforce",
            table: [
              {
                valueName: "Sustainable Salons",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "Manufacturing",
                keyName: "INDUSTRY",
              },
              {
                valueName: "5-7 Months",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "5",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BEp4LMAT_uuGLbGf-7",
            layout: "Original",
            description:
              "<p>Sustainable Salons relied on its rewards programs to maximize revenue per customer. But clunky, legacy technology wasn’t letting that happen.  Here is the story about how they changed that with StoreConnect.</p>",
          },
          testimonialsData: [
            {
              industry: "Innovation Lead, Sustainable Salons",
              description:
                "There is no way we could have done all of this in the previous platform with the same amount of human resources.\nThere is a 20-30% time saving when it comes to product set up and reporting now that we have moved our rewards stores to StoreConnect and no longer having different systems outside of Salesforce.",
              author: "Anuj Dhawan",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AJlyOMAT_GKnT-7gHw",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5PBhEAN_TIL9UICsP",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000STQf_3E03X8xi0",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SSIK_f96dEnyTsD",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000001ZQfa_9HBaGOu3U",
          ],
          teamProfilesData: [
            {
              serviceLink: "https://www.linkedin.com/in/mikellindsaar/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Executive Officer",
              name: "Mikel Lindsaar",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AHQRlMAP_q10Wlc26u",
            },
            {
              serviceLink: "https://www.linkedin.com/in/martijnrusius/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "Martijn Rusius",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000ArHOdMAN_gWp6uug6g",
            },
            {
              serviceLink: "https://www.linkedin.com/in/nickterrenzi/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "Nick Terrenzi",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BGt5TMAT_G0IZfG1mh",
            },
            {
              serviceLink: "https://www.linkedin.com/in/gavin-terpstra/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Account Manager",
              name: "Gavin Terpstra",
              index: 4,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000ArfyZMAR_86V943wi_",
            },
            {
              serviceLink: "https://www.linkedin.com/in/markzammit/",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Operations Officer",
              name: "Mark Zammit",
              index: 5,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000ArbqGMAR_bRHk22Dea",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AroKHMAZ__kY9bPc9m",
          storyId: "a00Nu00000Da4QfIAJ",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#484848",
          secondaryfont: "Helvetica",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "How a D2C firm revitalized its rewards program on Salesforce",
            teamSize: 6,
            paragraph2:
              "<p>Sustainable Salons relied on its rewards programs to maximize revenue per customer. But clunky, legacy technology wasn’t letting that happen.  Here is the story about how they changed that with StoreConnect.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000Arl9ZMAR_tbekdMZy-H",
            imgBanner:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000ArmDfMAJ_WqDFJSxqx",
            heading: "The Project",
            deepdescription:
              '<p dir="ltr">Whilst choosing StoreConnect to run their business is something we are proud of, the results the business generates has our team in complete awe.</p>\n<p dir="ltr">For example, before Sustainable Salons introduced its ponytail donation campaign in 2015, almost all hair used in medical wigs was sourced on the black market, from 3rd world countries. Today 98% of all the hair used in these wigs is donated by customers of member salons.</p>\n<p dir="ltr">Since it&#39;s inception, Sustainable Salons has been responsible for: </p>\n<p dir="ltr"> - 1,992,522 kilograms of resources diverted from landfill</p>\n<p dir="ltr"> - 329,906 meal donations to OzHarvest and KiwiHarvest</p>\n<p dir="ltr"> - 74,491 salon bookings from their #1 salon directory</p>\n<p dir="ltr">So, how does the program work?  Sustainable Salons is a profit-for-purpose organization that rescues valuable resources from landfill. They repurpose salon waste in a way that benefits the planet and gives back to the community.  </p>\n<p dir="ltr">Rewarding member salons who recycle is a cornerstone of the business. It requires a unique technology mix that is both efficient and affordable.<br><br>When Sustainable Salons were running a legacy version of Magento which required a slew of other technologies to integrate and manage their salon directory, Salesforce Communities member portal and other systems. Reporting on stock or updating member points required logging into minimally 4 systems to ensure information was properly reconciled.  </p>\n<p dir="ltr">Working with StoreConnect and their implementation partner, they replaced Magento and their other SaaS eCommerce solutions and migrated the eCommerce, rewards and in-person sales to StoreConnect.  </p>\n<p dir="ltr">Choosing to go with StoreConnect has resulted in a consolidation of the majority of Sustainable Salons technology natively onto Salesforce.  This allowed efficiencies and a simplification of technologies in use.  At the same time they increase the features available for use by using.  This also allowed automations with Salesforce flows across all customer facing operations. </p>\n<p dir="ltr">Users now had the ability to access the StoreConnect Rewards store via single sign-on from the Salesforce Community portal. By using a native solution, the transition for customers was seamless.</p>\n<p dir="ltr">In summary, many businesses would like to make a difference, but few could even dream of creating the kind of impact that Sustainable Salons has achieved over the last decade.  Their business has made sustainability into good business for salons; completely changed the way hair is sourced for medical wigs; and introduced multiple game-changing opportunities for their member salons that have resulted in 30% higher revenues and 15-20% higher margins.  This change for good is in no small part influenced by the efficiencies they generate through leveraging technology like StoreConnect and Salesforce. </p>\n<p> </p>',
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#004500",
          primaryfont: "Verdana",
          primarycolor: "#004500",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Sustainable Salons is a Social Enterprise that rewards salons and gives back to the community. Founded by Paul Frasca and Ewelina Soroko in 2015, Sustainable Salons specializes in collecting up to 95% of the salon waste bin and redirecting the materials for reuse, recycling, and repurposing. \n\nThe Sustainable Salons program began in hairdressing salons. There are now sustainable beauty salons, dermal clinics, barbers, and pet groomers. They provide consumers with an easy way to eliminate 95% of the negative impacts of their salon service at a cost less than a cup of coffee, simply by choosing a Sustainable Salons member salon.",
          },
          metadataname: "",
          metadatadescription: "",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage: "",
            roiMoment: "",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000Aro5nMAB_ZAEY87L4e",
            ribbonCuttingMoment:
              "I can safely say it's a 20 to 30 % time saving when it comes to actual product setup and reporting. Because both of those things used to happen in two different platforms.  Suddenly all of that is just in Salesforce and the reports are out of the box. \n\nWhen you set up your first product always takes half an hour to an hour to two hours.  But then after that, when you need to make it available in the next territory or for the next customer base or at a new price point or any of that stuff, it's almost instantaneous. - Anuj, Head of Innovation, Sustainable Salons",
            redMomentImage: "",
            redMoment: "",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000ArQpxMAF_EC3pf0bJza",
            momentOfTrust:
              "Initially burdened with disparate systems and manual processes, Sustainable Salons turned to StoreConnect for a comprehensive solution. The pivotal moment came when StoreConnect and its implementation partner streamlined Sustainable Salons' operations by migrating their eCommerce, rewards program, and in-person sales onto Salesforce, consolidating their technology stack. Anuj Dhawan, the Innovation Lead at Sustainable Salons, emphasized the significance of this transformation, highlighting a 20-30% time savings in product setup and reporting. This was the beginning of a profound shift in Sustainable Salons' approach, marking the beginning of a transformative partnership that continues to drive sustainable impact and operational excellence.",
            introductionMomentImage: "",
            introductionMoment: "",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000Aro8zMAB_4ZhrHKdso",
            eurekaMoment:
              "After the launch of their rewards store, Sustainable Salons were looking for new ways to onboard customers. The team created a new store specifically for new customers.  Then they launched it by texting the link to people who might be interested in exploring a tiny porthole into the Sustainable Salons ecosystem. \nImmediately, one of the customers went to the link on their mobile phone and purchased the product.  The StoreConnect eCommerce platform did the rest - it created a customer, account, order and payment record in Salesforce immediately – it had everything needed to create a new customer in Salesforce.",
            dealClarityMomentImage: "",
            dealClarityMoment: "",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AHAV3MAP_WrKecmzpX",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "StoreConnect",
              "Salesforce Lightning",
              "Salesforce Experience Cloud",
              "CPQ - Configure, Price, Quote",
              "MuleSoft",
            ],
            Timeline: ["5-7 Months"],
            Budget: [null],
            Industry: ["Manufacturing"],
            Company: ["StoreConnect"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "eCommerce and Point of Sale,\r\nRewards on Salesforce!",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription:
              "Our team are happy to meet with you to see if StoreConnect is a fit.  We offer fully personalised demonstrations of StoreConnect to determine if we can solve your requirements.",
            headshotUrl:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000BGt5TMAT_G0IZfG1mh",
            contactName: "Nick Terrenzi",
            calendlyLink: "https://calendly.com/saar444/30min",
            bannerDescription:
              "to learn how StoreConnect can change your eCommerce game",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00PNu00000AHAV3MAP_WrKecmzpX",
      fav_image: "",
      contact_us: "https://getstoreconnect.com/c/increase-direct-sales",
      account_description:
        "eCommerce and Point of Sale,\r\nRewards on Salesforce!",
    },
    {
      title: "Carabiner Group",
      teamId: "0016g00002ODN5LAAX",
      stories: [
        {
          website: "https://carabinergroup.com/",
          valueSectionsData: [
            {
              heading: "Transeo Culture",
              description:
                "Transeo is an EdTech firm serving North American schools. Their culture values innovation, teamwork, communication, transparency, and partnerships for mutual success.",
            },
            {
              heading: "Why Now",
              description:
                "EdTech platform Transeo sought Carabiner Group's expertise for Salesforce administration as they grew rapidly, expanding their services with Series A funding. Carabiner improved CRM optimization, introduced new systems, and ensured data quality, leading to a successful outbound motion and fundraising. They remain a key partner as Transeo expands and invests in technology, including Salesforce CPQ.",
            },
            {
              heading: "Other Things to Note",
              description: "",
            },
          ],
          trackingData: {
            hubSpotId: "",
            hubSpotDomain: "",
            clientGoogleTrackingId: "",
            campaignName: "",
            campaignLandingPageUrl: "",
            brightrGoogleTrackingId: "",
          },
          topBannerData: {
            title:
              "Rapid Growth Expansion Fueled by Revenue Operations Insights",
            table: [
              {
                valueName: "Transeo",
                keyName: "CLIENT NAME",
              },
              {
                valueName: "High Tech",
                keyName: "INDUSTRY",
              },
              {
                valueName: "Managed Service",
                keyName: "PROJECT LENGTH",
              },
              {
                valueName: "3",
                keyName: "TEAM SIZE",
              },
            ],
            logoSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5cQWEAZ_gf2UPGHuo",
            layout: "Original",
            description:
              "<p>Carabiner Group helped EdTech company Transeo achieve rapid expansion and successful Series-A fundraising by optimizing their CRM systems and implementing Salesforce Pardot/Marketing Cloud Engage. They became a trusted thought partner and systems administrator for Transeo, playing a vital role in their growth and expansion.</p>",
          },
          testimonialsData: [
            {
              industry: "CTO and Cofounder",
              description:
                "“Carabiner is an absolute joy to work with. They are incredibly knowledgeable and responsive and always work with us closely to determine the best solution for the problem at hand. They are our first call when we have Salesforce or Pardot questions.”",
              author: "Jimmy McDermott",
            },
          ],
          technologiesIconSrc: [
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SO08_ORsUSA4Ml",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SOiX_aQ0xr8NqA",
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/0156g000000SNzo_9WG7SLFgB",
          ],
          teamProfilesData: [
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Executive Officer",
              name: "Seamus Ruiz-Earle",
              index: 1,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5cQbEAJ_PYgI4QaEO",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Revenue Officer",
              name: "Cliff Simon",
              index: 2,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5cQgEAJ_p1czWvehw",
            },
            {
              serviceLink: "",
              serviceIcon:
                "https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg",
              role: "Chief Operations Officer",
              name: "Lewis Carney",
              index: 3,
              dpSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5c2pEAB_tYDx4wvNt",
            },
          ],
          storypagebanner:
            "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5Qk4EAF_cVdLx9-B18",
          storyId: "a006g00000o7jbXAAQ",
          storyData: {
            title: "Story By Brightr",
            link: "https://brightr.io/",
          },
          secondaryheaderfontcolor: "#FFFFFF",
          secondaryfontcolor: "#2D487D",
          secondaryfont: "Aileron Heavy",
          secondarycolor: "",
          projectSectionData: {
            videoLink: null,
            title:
              "Rapid Growth Expansion Fueled by Revenue Operations Insights",
            teamSize: null,
            paragraph2:
              "<p>Carabiner Group helped EdTech company Transeo achieve rapid expansion and successful Series-A fundraising by optimizing their CRM systems and implementing Salesforce Pardot/Marketing Cloud Engage. They became a trusted thought partner and systems administrator for Transeo, playing a vital role in their growth and expansion.</p>",
            paragraph1: "",
            listitems: [],
            listHeading: "",
            imgSrc:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5cQqEAJ_XyjjiOOD-",
            imgBanner: "",
            heading: "The Project",
            deepdescription:
              "<p>Carabiner Group&#39;s partnership with Transeo, a seed-funded EdTech startup, drove rapid growth. Initially providing Salesforce admin services, Carabiner&#39;s role became vital as the sole Sales Operations and Revenue Operations influence. They optimized CRM systems, implemented new tools, and provided sales enablement, becoming a trusted partner and systems administrator, playing a vital role in Transeo&#39;s growth and success.</p>",
          },
          projectBoundariesData: {
            rightStatus: null,
            leftStatus: "Project Boundaries",
          },
          primaryfontcolor: "#017dce",
          primaryfont: "Aileron Heavy",
          primarycolor: "#2D487D",
          piHostname: "",
          piCId: "",
          piAId: "",
          missionData: {
            missionRichText:
              "Revolutionary EdTech software platform Transeo caters to elementary and higher education networks across North America. Carabiner Group began working with Transeo when they were still a seed-funded startup of 10 people spread geographically across the United States, bringing an incredible product to market but still in its infancy as a service provider.",
          },
          metadataname:
            "SAAS Case Study: Rapid Growth Expansion Fueled by Revenue Operations Insights",
          metadatadescription:
            "This case study highlights how Carabiner Group helped EdTech software platform Transeo to optimize its CRM systems and implement Salesforce Pardot/Marketing Cloud Engage, resulting in a successful Series-A fundraising effort and commercial success. Carabiner Group became an internal systems administrator and trusted thought partner to internal Sales and Marketing leadership, fueling a successful GTM/Customer Journey revision. Transeo continues to deepen its technology investment with Carabiner Group as a vital partner in their journey.",
          linkedinPartnerId: "",
          linecolor: "",
          LastModifiedDate: "2024-08-27T17:22:05.000Z",
          keyMoments: {
            roiMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QlMEAV_9gVhXEZ1bA",
            roiMoment:
              "The ROI moment in this case study is the successful Series-A fundraising effort directly influenced by the strong outbound motion implemented with the help of Carabiner Group's successful implementation of Salesforce Pardot/Marketing Cloud Engage. The resulting commercial success of the organization and new focus on deepening technology investment, including an expansion into Salesforce CPQ, further highlights the positive return on investment for Transeo.",
            ribbonCuttingMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5Ql7EAF_9exhuWweQ",
            ribbonCuttingMoment:
              "The Ribbon Cutting moment in this case study is the successful implementation of Salesforce as the unified system of record, which directly fueled a successful GTM/Customer Journey revision and the subsequent commercial success of the organization. It allowed Transeo to realize the full capabilities of its technology investment, leading to rapid growth expansion fueled by revenue operations insights. The implementation of Salesforce Pardot/Marketing Cloud Engage also played a crucial role in the successful Series-A fundraising effort, paving the way for further investment in technology and expansion into new markets.",
            redMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5Ql2EAF_OxdLcZDJJV",
            redMoment:
              "The red moment in Transeo's growth story was when Carabiner Group's strategic technical vision, sales enablement focus, and use of automation as a tool for cross-team visibility came together to optimize the CRM systems and implement Salesforce Pardot/Marketing Cloud Engage. This allowed internal marketing resources to roll out a successful outbound motion that influenced the successful Series-A fundraising effort, ultimately fueling the organization's subsequent commercial success.",
            momentOfTrustImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QknEAF_6nBVMIk8x",
            momentOfTrust:
              "The CTO and Co-founder of Transeo, Jimmy McDermott, praises Carabiner Group's knowledge, responsiveness, and collaborative problem-solving approach. Carabiner played a critical role in optimizing Transeo's CRM systems to unlock the full potential of its technology investment, including implementing Salesforce Pardot/Marketing Cloud Engage to drive outbound marketing efforts that influenced a successful Series-A fundraising round. Carabiner's technical vision, sales enablement, and automation expertise enabled Transeo to achieve a successful GTM/Customer Journey revision, leading to commercial success and expanding into new markets with the adoption of Salesforce CPQ.",
            introductionMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QlCEAV_CVqeYGKN7",
            introductionMoment:
              "Transeo, a revolutionary EdTech software platform serving North American elementary and higher education networks, partnered with Carabiner Group during its early stage as a startup. Carabiner initially provided Salesforce administration services, but as the company rapidly grew and aimed for a Series A funding round, their role became essential in optimizing the CRM systems and providing Revenue Operations insights. With Salesforce at the center, Carabiner enabled cross-team visibility through automation and successfully implemented Salesforce Pardot/Marketing Cloud Engage to influence a successful Series-A fundraising effort. The resulting effects included Carabiner becoming an internal systems administrator and trusted thought partner, and an expansion into Salesforce CPQ to enable the organization's growth and expansion into new markets.",
            eurekaMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QksEAF_wXS-wrKJ3",
            eurekaMoment:
              "The Eureka moment came when Carabiner Group conducted a comprehensive evaluation of Transeo's CRM systems, identifying the need for optimization to maximize the platform's capabilities. Through strong sales enablement, automation, and successful implementation of Salesforce Pardot/Marketing Cloud Engage, Carabiner helped fuel a successful GTM/Customer Journey revision and subsequent commercial success, leading to Transeo's expansion into new markets with a focus on deepening their technology investment.",
            dealClarityMomentImage:
              "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QlHEAV_sa1Iz-i86",
            dealClarityMoment:
              "Transeo, an EdTech platform for North American elementary and higher education, partnered with Carabiner Group, a Salesforce administration service provider, during their early stages of growth. As Transeo rapidly expanded and aimed for a Series A funding round, Carabiner helped optimize the company's CRM systems and marketing infrastructure. Carabiner's focus on sales enablement and automation, along with the successful implementation of Salesforce Pardot/Marketing Cloud Engage, directly impacted the organization's successful GTM/Customer Journey revision and subsequent commercial success. Transeo now views Carabiner as a trusted thought partner and internal systems administrator.",
          },
          isfeatured: false,
          header: {
            navbarData: [
              {
                name: "",
                link: "",
              },
            ],
            imagesSrc: {
              logoSrcDark: "",
              logoSrc:
                "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QjzEAF_dPoA7Rj2_",
              homeLogoSrcDark: "",
              homeLogoSrc: "http://simpleicon.com/wp-content/uploads/eye2.png",
            },
          },
          filterValues: {
            Testimonial: ["YES"],
            Technologies: [
              "Salesforce Sales Cloud",
              "Pardot",
              "Marketing Cloud",
            ],
            Timeline: ["Managed Service"],
            Budget: [null],
            Industry: ["High Tech"],
            Company: ["Carabiner Group"],
          },
          faviconimage: "",
          diagramData: {
            diagramList: [],
          },
          description: "",
          calendlyLink: "",
          breadcrumbslabel: "",
          bookMeetingData: {
            title: "",
            modalDescription: "",
            headshotUrl: "",
            contactName: "",
            calendlyLink: "",
            bannerDescription: "",
          },
          bgcolor: "",
        },
      ],
      metadataName: "",
      metadataDescription: "",
      logo: "https://ik.imagekit.io/towzbt87r/salesforce-migrated/00P6g00000E5QjzEAF_dPoA7Rj2_",
      fav_image: "",
      contact_us: "https://carabinergroup.com/contact",
      account_description: "",
    },
  ],
}
